(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./helpers/date.js":
/*!*************************!*\
  !*** ./helpers/date.js ***!
  \*************************/
/*! exports provided: ISO_DATE_FORMAT, PLAIN_DATE_FORMAT, MONTHS, DAYS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ISO_DATE_FORMAT", function() { return ISO_DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAIN_DATE_FORMAT", function() { return PLAIN_DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MONTHS", function() { return MONTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DAYS", function() { return DAYS; });
var ISO_DATE_FORMAT = 'YYYY-MM-DD';
var PLAIN_DATE_FORMAT = 'DD/MM/YYYY';

var MONTHS = [{ name: 'Jan', value: '0' }, { name: 'Feb', value: '1' }, { name: 'Mar', value: '2' }, { name: 'Apr', value: '3' }, { name: 'May', value: '4' }, { name: 'Jun', value: '5' }, { name: 'Jul', value: '6' }, { name: 'Aug', value: '7' }, { name: 'Sep', value: '8' }, { name: 'Oct', value: '9' }, { name: 'Nov', value: '10' }, { name: 'Dec', value: '11' }];

var DAYS = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
};

/***/ }),

/***/ "./helpers/event.js":
/*!**************************!*\
  !*** ./helpers/event.js ***!
  \**************************/
/*! exports provided: triggerClick */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triggerClick", function() { return triggerClick; });
var triggerClick = function triggerClick(element) {
  var event = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  element.dispatchEvent(event);
};

/***/ }),

/***/ "./helpers/nextTick.js":
/*!*****************************!*\
  !*** ./helpers/nextTick.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process) {var nextTick = function nextTick() {
  return new Promise(function (resolve) {
    process.nextTick(resolve);
  });
};

/* harmony default export */ __webpack_exports__["default"] = (nextTick);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node_modules/process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/AuditBar/index.scss":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/AuditBar/index.scss ***!
  \**************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.AuditBar__root___2AKhG {\n  display: flex;\n  align-items: center; }\n  .AuditBar__root___2AKhG:not(:last-child) {\n    margin-bottom: 4px; }\n  .AuditBar__root___2AKhG .AuditBar__text___3OOnz {\n    color: rgba(0, 0, 0, 0.54); }\n  .AuditBar__root___2AKhG .AuditBar__avatar___2xM7Q {\n    height: 24px;\n    width: 24px;\n    font-size: 0.75rem;\n    margin-right: 8px;\n    color: #fff;\n    background-color: #119aab; }\n", ""]);

// exports
exports.locals = {
	"root": "AuditBar__root___2AKhG",
	"text": "AuditBar__text___3OOnz",
	"avatar": "AuditBar__avatar___2xM7Q"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/AuditBarGroup/index.scss":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/AuditBarGroup/index.scss ***!
  \*******************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.AuditBarGroup__root___3wnZe {\n  width: 100%;\n  padding: 8px 24px;\n  border-top: 1px solid #e0e0e0; }\n", ""]);

// exports
exports.locals = {
	"root": "AuditBarGroup__root___3wnZe"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Avatar/index.scss":
/*!************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Avatar/index.scss ***!
  \************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Avatar__root___3yRUz.Avatar__error___22FWM {\n  color: rgba(255, 255, 255, 0.87);\n  background-color: #d32f2f; }\n\n.Avatar__root___3yRUz.Avatar__success___3wnvR {\n  color: rgba(255, 255, 255, 0.87);\n  background-color: #449d51; }\n\n.Avatar__root___3yRUz.Avatar__brandGreen___2ygn- {\n  color: rgba(255, 255, 255, 0.87);\n  background-color: #348e95; }\n\n.Avatar__root___3yRUz.Avatar__warning___1c7k_ {\n  color: rgba(255, 255, 255, 0.87);\n  background-color: #ff9100; }\n", ""]);

// exports
exports.locals = {
	"root": "Avatar__root___3yRUz",
	"error": "Avatar__error___22FWM",
	"success": "Avatar__success___3wnvR",
	"brandGreen": "Avatar__brandGreen___2ygn-",
	"warning": "Avatar__warning___1c7k_"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Badge/inlineBadge.scss":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Badge/inlineBadge.scss ***!
  \*****************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Badge__root___LH5Vw {\n  display: inline-block;\n  background-color: #ff4686;\n  color: #fff;\n  font-size: 12px;\n  height: 18px;\n  min-width: 18px;\n  line-height: 18px;\n  border-radius: 9px;\n  text-align: center;\n  padding: 0px 3px;\n  margin-left: 2px;\n  margin-right: 2px; }\n", ""]);

// exports
exports.locals = {
	"root": "Badge__root___LH5Vw"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Badge/styles.scss":
/*!************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Badge/styles.scss ***!
  \************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Badge__badgeWrapper___1XHsw.Badge__root___1CzRx {\n  padding: 0px 8px; }\n\n.Badge__badgeWrapper___1XHsw .Badge__badge___17_ql {\n  top: -3px;\n  right: 0;\n  width: 18px;\n  height: 18px;\n  position: absolute;\n  margin-right: 0px; }\n\n.Badge__badgeWrapper___1XHsw .Badge__colorSecondary___33rov {\n  background-color: #ff4686; }\n\n.Badge__badgeWrapper___1XHsw.Badge__context-toolbar___Nfmvy .Badge__badge___17_ql {\n  top: -6px;\n  right: -5px; }\n", ""]);

// exports
exports.locals = {
	"badgeWrapper": "Badge__badgeWrapper___1XHsw",
	"root": "Badge__root___1CzRx",
	"badge": "Badge__badge___17_ql",
	"colorSecondary": "Badge__colorSecondary___33rov",
	"context-toolbar": "Badge__context-toolbar___Nfmvy"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Breadcrumb/breadcrumb.scss":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Breadcrumb/breadcrumb.scss ***!
  \*********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Breadcrumb__root___1_7m9 .Breadcrumb__separator___15tNt {\n  display: inline; }\n  .Breadcrumb__root___1_7m9 .Breadcrumb__separator___15tNt:before {\n    content: attr(data-text);\n    margin-left: 12px;\n    margin-right: 12px; }\n", ""]);

// exports
exports.locals = {
	"root": "Breadcrumb__root___1_7m9",
	"separator": "Breadcrumb__separator___15tNt"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Button/slideAction.scss":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Button/slideAction.scss ***!
  \******************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Button__root___2fIlu {\n  min-width: 72px !important; }\n  .Button__root___2fIlu.Button__brandRed___OidRt {\n    background-color: #D82F2F;\n    color: white; }\n    .Button__root___2fIlu.Button__brandRed___OidRt:hover, .Button__root___2fIlu.Button__brandRed___OidRt:focus {\n      background-color: #c82626; }\n", ""]);

// exports
exports.locals = {
	"root": "Button__root___2fIlu",
	"brandRed": "Button__brandRed___OidRt"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Callout/styles.scss":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Callout/styles.scss ***!
  \**************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Callout__root___1nmmd {\n  padding: 16px;\n  position: relative;\n  margin-bottom: 8px;\n  border-radius: 2px; }\n  .Callout__root___1nmmd * + .Callout__content___22qow {\n    margin-left: 8px; }\n  .Callout__root___1nmmd.compact {\n    padding: 8px 16px;\n    margin-bottom: 0px; }\n  .Callout__root___1nmmd.warning {\n    background: #fff2e0; }\n    .Callout__root___1nmmd.warning > svg {\n      color: #ff6200; }\n  .Callout__root___1nmmd.error {\n    background: #fae6e6; }\n    .Callout__root___1nmmd.error > svg {\n      color: #bf1212; }\n  .Callout__root___1nmmd.info {\n    background: #e9f2fc; }\n    .Callout__root___1nmmd.info > svg {\n      color: #2161cf; }\n  .Callout__root___1nmmd.success {\n    background: #eaf5eb; }\n    .Callout__root___1nmmd.success > svg {\n      color: #24862e; }\n  .Callout__root___1nmmd.notice {\n    background: #f5f5f5; }\n    .Callout__root___1nmmd.notice > svg {\n      color: rgba(0, 0, 0, 0.54); }\n  .Callout__root___1nmmd.Callout__light___2E9yF.warning {\n    background: transparent; }\n    .Callout__root___1nmmd.Callout__light___2E9yF.warning > svg {\n      color: #ff9100; }\n  .Callout__root___1nmmd.Callout__light___2E9yF.error {\n    background: transparent; }\n    .Callout__root___1nmmd.Callout__light___2E9yF.error > svg {\n      color: #d32f2f; }\n  .Callout__root___1nmmd.Callout__light___2E9yF.info {\n    background: transparent; }\n    .Callout__root___1nmmd.Callout__light___2E9yF.info > svg {\n      color: #4990e2; }\n  .Callout__root___1nmmd.Callout__light___2E9yF.success {\n    background: transparent; }\n    .Callout__root___1nmmd.Callout__light___2E9yF.success > svg {\n      color: #4caf5a; }\n  .Callout__root___1nmmd.Callout__light___2E9yF.notice {\n    background: transparent; }\n    .Callout__root___1nmmd.Callout__light___2E9yF.notice > svg {\n      color: rgba(0, 0, 0, 0.26); }\n\n.Callout__actions___1U-PB {\n  margin: -8px 0 -8px 8px; }\n", ""]);

// exports
exports.locals = {
	"root": "Callout__root___1nmmd",
	"content": "Callout__content___22qow",
	"light": "Callout__light___2E9yF",
	"actions": "Callout__actions___1U-PB"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Chip/index.scss":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Chip/index.scss ***!
  \**********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Chip__root___3jQhS {\n  max-width: 100%;\n  overflow: hidden; }\n  .Chip__root___3jQhS .Chip__label___3Khup {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    display: block; }\n  .Chip__root___3jQhS svg {\n    fill: currentColor;\n    width: 24px;\n    height: 24px; }\n  .Chip__root___3jQhS.Chip__small___2OOme {\n    height: 24px; }\n    .Chip__root___3jQhS.Chip__small___2OOme .Chip__avatar___3PyB2 {\n      width: 24px;\n      height: 24px; }\n    .Chip__root___3jQhS.Chip__small___2OOme svg {\n      width: 16px;\n      height: 16px; }\n  .Chip__root___3jQhS.Chip__error___1MLre {\n    background-color: #e06e6e;\n    color: rgba(255, 255, 255, 0.87); }\n    .Chip__root___3jQhS.Chip__error___1MLre .gtu-avatar {\n      color: rgba(255, 255, 255, 0.87);\n      background-color: #d32f2f; }\n  .Chip__root___3jQhS.Chip__success___2VZDW {\n    background-color: #5cb869;\n    color: rgba(255, 255, 255, 0.87); }\n    .Chip__root___3jQhS.Chip__success___2VZDW .gtu-avatar {\n      color: rgba(255, 255, 255, 0.87);\n      background-color: #449d51; }\n  .Chip__root___3jQhS.Chip__brandGreen___3mzNO {\n    background-color: #66c2ca;\n    color: rgba(255, 255, 255, 0.87); }\n    .Chip__root___3jQhS.Chip__brandGreen___3mzNO .gtu-avatar {\n      color: rgba(255, 255, 255, 0.87);\n      background-color: #348e95; }\n  .Chip__root___3jQhS.Chip__warning___2cJ_t {\n    background-color: #ffb24d;\n    color: rgba(255, 255, 255, 0.87); }\n    .Chip__root___3jQhS.Chip__warning___2cJ_t .gtu-avatar {\n      color: rgba(255, 255, 255, 0.87);\n      background-color: #ff9100; }\n", ""]);

// exports
exports.locals = {
	"root": "Chip__root___3jQhS",
	"label": "Chip__label___3Khup",
	"small": "Chip__small___2OOme",
	"avatar": "Chip__avatar___3PyB2",
	"error": "Chip__error___1MLre",
	"success": "Chip__success___2VZDW",
	"brandGreen": "Chip__brandGreen___3mzNO",
	"warning": "Chip__warning___2cJ_t"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ChipInput/styles.scss":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ChipInput/styles.scss ***!
  \****************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.ChipInput__root___Sq1lm .ChipInput__readOnly___EepUB input {\n  width: 0px;\n  height: 0px;\n  padding: 0px;\n  position: absolute; }\n\n.ChipInput__root___Sq1lm .ChipInput__control___185GL {\n  padding-top: 6px;\n  padding-bottom: 2px;\n  display: flex;\n  flex-wrap: wrap; }\n  .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__textInput___2TYV9 {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 0;\n    align-items: center; }\n    .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__textInput___2TYV9 input {\n      width: auto;\n      flex-grow: 1; }\n    .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__textInput___2TYV9.ChipInput__empty___30Mgv input {\n      min-height: 24px; }\n    .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__textInput___2TYV9.ChipInput__small___gWEPv {\n      margin-top: -2px; }\n      .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__textInput___2TYV9.ChipInput__small___gWEPv input {\n        margin-top: -4px;\n        min-height: 12px; }\n  .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__chip___2leuP {\n    margin: 2px;\n    margin-left: 0; }\n    .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__chip___2leuP.ChipInput__small___gWEPv {\n      margin: 0; }\n    .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__chip___2leuP.ChipInput__backgroundDisabled___2dg6U {\n      background-color: #f5f5f7; }\n    .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__chip___2leuP .ChipInput__avatarDisabled___18PfT {\n      background-color: #d5d5d5; }\n      .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__chip___2leuP .ChipInput__avatarDisabled___18PfT svg {\n        fill: #f5f5f7; }\n    .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__chip___2leuP .ChipInput__labelDisabled___2phGh > p {\n      color: rgba(0, 0, 0, 0.38); }\n  .ChipInput__root___Sq1lm .ChipInput__control___185GL .ChipInput__chipLabel___3rg_v {\n    display: flex;\n    align-items: center;\n    height: 20px; }\n", ""]);

// exports
exports.locals = {
	"root": "ChipInput__root___Sq1lm",
	"readOnly": "ChipInput__readOnly___EepUB",
	"control": "ChipInput__control___185GL",
	"textInput": "ChipInput__textInput___2TYV9",
	"empty": "ChipInput__empty___30Mgv",
	"small": "ChipInput__small___gWEPv",
	"chip": "ChipInput__chip___2leuP",
	"backgroundDisabled": "ChipInput__backgroundDisabled___2dg6U",
	"avatarDisabled": "ChipInput__avatarDisabled___18PfT",
	"labelDisabled": "ChipInput__labelDisabled___2phGh",
	"chipLabel": "ChipInput__chipLabel___3rg_v"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/CollapsiblePanel/styles.scss":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/CollapsiblePanel/styles.scss ***!
  \***********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.CollapsiblePanel__root___37nzi.CollapsiblePanel__marginDense___OP0dJ {\n  margin: 8px 0; }\n\n.CollapsiblePanel__root___37nzi.CollapsiblePanel__marginNone___B2HZt {\n  margin: 0 0; }\n", ""]);

// exports
exports.locals = {
	"root": "CollapsiblePanel__root___37nzi",
	"marginDense": "CollapsiblePanel__marginDense___OP0dJ",
	"marginNone": "CollapsiblePanel__marginNone___B2HZt"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Colored/index.scss":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Colored/index.scss ***!
  \*************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Colored__root___2rxrP.Colored__white___3W9ol {\n  color: #fff; }\n  .Colored__root___2rxrP.Colored__white___3W9ol a:link, .Colored__root___2rxrP.Colored__white___3W9ol a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__white___3W9ol a:hover, .Colored__root___2rxrP.Colored__white___3W9ol a:active {\n    color: #d9d9d9; }\n\n.Colored__root___2rxrP.Colored__error___33eLD {\n  color: #d32f2f; }\n  .Colored__root___2rxrP.Colored__error___33eLD a:link, .Colored__root___2rxrP.Colored__error___33eLD a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__error___33eLD a:hover, .Colored__root___2rxrP.Colored__error___33eLD a:active {\n    color: #962020; }\n\n.Colored__root___2rxrP.Colored__errorLight___3yhC2 {\n  color: #fae6e6; }\n  .Colored__root___2rxrP.Colored__errorLight___3yhC2 a:link, .Colored__root___2rxrP.Colored__errorLight___3yhC2 a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__errorLight___3yhC2 a:hover, .Colored__root___2rxrP.Colored__errorLight___3yhC2 a:active {\n    color: #eda6a6; }\n\n.Colored__root___2rxrP.Colored__errorDark___3YKI0 {\n  color: #bf1212; }\n  .Colored__root___2rxrP.Colored__errorDark___3YKI0 a:link, .Colored__root___2rxrP.Colored__errorDark___3YKI0 a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__errorDark___3YKI0 a:hover, .Colored__root___2rxrP.Colored__errorDark___3YKI0 a:active {\n    color: #790b0b; }\n\n.Colored__root___2rxrP.Colored__success___sF_A2 {\n  color: #4caf5a; }\n  .Colored__root___2rxrP.Colored__success___sF_A2 a:link, .Colored__root___2rxrP.Colored__success___sF_A2 a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__success___sF_A2 a:hover, .Colored__root___2rxrP.Colored__success___sF_A2 a:active {\n    color: #357a3f; }\n\n.Colored__root___2rxrP.Colored__successLight___3cr_B {\n  color: #eaf5eb; }\n  .Colored__root___2rxrP.Colored__successLight___3cr_B a:link, .Colored__root___2rxrP.Colored__successLight___3cr_B a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__successLight___3cr_B a:hover, .Colored__root___2rxrP.Colored__successLight___3cr_B a:active {\n    color: #b6dcba; }\n\n.Colored__root___2rxrP.Colored__successDark___2wY7Z {\n  color: #24862e; }\n  .Colored__root___2rxrP.Colored__successDark___2wY7Z a:link, .Colored__root___2rxrP.Colored__successDark___2wY7Z a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__successDark___2wY7Z a:hover, .Colored__root___2rxrP.Colored__successDark___2wY7Z a:active {\n    color: #144a19; }\n\n.Colored__root___2rxrP.Colored__warning___1RDW2 {\n  color: #ff9100; }\n  .Colored__root___2rxrP.Colored__warning___1RDW2 a:link, .Colored__root___2rxrP.Colored__warning___1RDW2 a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__warning___1RDW2 a:hover, .Colored__root___2rxrP.Colored__warning___1RDW2 a:active {\n    color: #b36600; }\n\n.Colored__root___2rxrP.Colored__warningLight___3Tfz- {\n  color: #fff2e0; }\n  .Colored__root___2rxrP.Colored__warningLight___3Tfz- a:link, .Colored__root___2rxrP.Colored__warningLight___3Tfz- a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__warningLight___3Tfz- a:hover, .Colored__root___2rxrP.Colored__warningLight___3Tfz- a:active {\n    color: #ffd294; }\n\n.Colored__root___2rxrP.Colored__warningDark___3NfzA {\n  color: #ff6200; }\n  .Colored__root___2rxrP.Colored__warningDark___3NfzA a:link, .Colored__root___2rxrP.Colored__warningDark___3NfzA a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__warningDark___3NfzA a:hover, .Colored__root___2rxrP.Colored__warningDark___3NfzA a:active {\n    color: #b34500; }\n\n.Colored__root___2rxrP.Colored__primary___1nSJj {\n  color: rgba(0, 0, 0, 0.87); }\n  .Colored__root___2rxrP.Colored__primary___1nSJj a:link, .Colored__root___2rxrP.Colored__primary___1nSJj a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__primary___1nSJj a:hover, .Colored__root___2rxrP.Colored__primary___1nSJj a:active {\n    color: rgba(0, 0, 0, 0.87); }\n\n.Colored__root___2rxrP.Colored__primaryDark___3AaI4 {\n  color: white; }\n  .Colored__root___2rxrP.Colored__primaryDark___3AaI4 a:link, .Colored__root___2rxrP.Colored__primaryDark___3AaI4 a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__primaryDark___3AaI4 a:hover, .Colored__root___2rxrP.Colored__primaryDark___3AaI4 a:active {\n    color: #d9d9d9; }\n\n.Colored__root___2rxrP.Colored__secondary___2CRjs {\n  color: rgba(0, 0, 0, 0.54); }\n  .Colored__root___2rxrP.Colored__secondary___2CRjs a:link, .Colored__root___2rxrP.Colored__secondary___2CRjs a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__secondary___2CRjs a:hover, .Colored__root___2rxrP.Colored__secondary___2CRjs a:active {\n    color: rgba(0, 0, 0, 0.54); }\n\n.Colored__root___2rxrP.Colored__secondaryDark___2wF17 {\n  color: rgba(255, 255, 255, 0.7); }\n  .Colored__root___2rxrP.Colored__secondaryDark___2wF17 a:link, .Colored__root___2rxrP.Colored__secondaryDark___2wF17 a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__secondaryDark___2wF17 a:hover, .Colored__root___2rxrP.Colored__secondaryDark___2wF17 a:active {\n    color: rgba(217, 217, 217, 0.7); }\n\n.Colored__root___2rxrP.Colored__disabled___1u1pz {\n  color: rgba(0, 0, 0, 0.38); }\n  .Colored__root___2rxrP.Colored__disabled___1u1pz a:link, .Colored__root___2rxrP.Colored__disabled___1u1pz a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__disabled___1u1pz a:hover, .Colored__root___2rxrP.Colored__disabled___1u1pz a:active {\n    color: rgba(0, 0, 0, 0.38); }\n\n.Colored__root___2rxrP.Colored__disabledDark___2Ypms {\n  color: rgba(255, 255, 255, 0.5); }\n  .Colored__root___2rxrP.Colored__disabledDark___2Ypms a:link, .Colored__root___2rxrP.Colored__disabledDark___2Ypms a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__disabledDark___2Ypms a:hover, .Colored__root___2rxrP.Colored__disabledDark___2Ypms a:active {\n    color: rgba(217, 217, 217, 0.5); }\n\n.Colored__root___2rxrP.Colored__informationalBlue___1FUeS {\n  color: #4990e2; }\n  .Colored__root___2rxrP.Colored__informationalBlue___1FUeS a:link, .Colored__root___2rxrP.Colored__informationalBlue___1FUeS a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__informationalBlue___1FUeS a:hover, .Colored__root___2rxrP.Colored__informationalBlue___1FUeS a:active {\n    color: #1f69c0; }\n\n.Colored__root___2rxrP.Colored__informationalBlueLight___2p0dj {\n  color: #e9f2fc; }\n  .Colored__root___2rxrP.Colored__informationalBlueLight___2p0dj a:link, .Colored__root___2rxrP.Colored__informationalBlueLight___2p0dj a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__informationalBlueLight___2p0dj a:hover, .Colored__root___2rxrP.Colored__informationalBlueLight___2p0dj a:active {\n    color: #a6caf3; }\n\n.Colored__root___2rxrP.Colored__informationalBlueDark___3A8k4 {\n  color: #2161cf; }\n  .Colored__root___2rxrP.Colored__informationalBlueDark___3A8k4 a:link, .Colored__root___2rxrP.Colored__informationalBlueDark___3A8k4 a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__informationalBlueDark___3A8k4 a:hover, .Colored__root___2rxrP.Colored__informationalBlueDark___3A8k4 a:active {\n    color: #16428d; }\n\n.Colored__root___2rxrP.Colored__brandGreen___2DQSX {\n  color: #53bac3; }\n  .Colored__root___2rxrP.Colored__brandGreen___2DQSX a:link, .Colored__root___2rxrP.Colored__brandGreen___2DQSX a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__brandGreen___2DQSX a:hover, .Colored__root___2rxrP.Colored__brandGreen___2DQSX a:active {\n    color: #348e95; }\n\n.Colored__root___2rxrP.Colored__brandPink___3TaxL {\n  color: #ff4686; }\n  .Colored__root___2rxrP.Colored__brandPink___3TaxL a:link, .Colored__root___2rxrP.Colored__brandPink___3TaxL a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__brandPink___3TaxL a:hover, .Colored__root___2rxrP.Colored__brandPink___3TaxL a:active {\n    color: #f90056; }\n\n.Colored__root___2rxrP.Colored__grey____sp1h {\n  color: rgba(0, 0, 0, 0.38); }\n  .Colored__root___2rxrP.Colored__grey____sp1h a:link, .Colored__root___2rxrP.Colored__grey____sp1h a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__grey____sp1h a:hover, .Colored__root___2rxrP.Colored__grey____sp1h a:active {\n    color: rgba(0, 0, 0, 0.38); }\n\n.Colored__root___2rxrP.Colored__lightTextSecondary___1ccXh {\n  color: rgba(0, 0, 0, 0.54); }\n  .Colored__root___2rxrP.Colored__lightTextSecondary___1ccXh a:link, .Colored__root___2rxrP.Colored__lightTextSecondary___1ccXh a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__lightTextSecondary___1ccXh a:hover, .Colored__root___2rxrP.Colored__lightTextSecondary___1ccXh a:active {\n    color: rgba(0, 0, 0, 0.54); }\n\n.Colored__root___2rxrP.Colored__lighterTextSecondary___30MvG {\n  color: rgba(0, 0, 0, 0.26); }\n  .Colored__root___2rxrP.Colored__lighterTextSecondary___30MvG a:link, .Colored__root___2rxrP.Colored__lighterTextSecondary___30MvG a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__lighterTextSecondary___30MvG a:hover, .Colored__root___2rxrP.Colored__lighterTextSecondary___30MvG a:active {\n    color: rgba(0, 0, 0, 0.26); }\n\n.Colored__root___2rxrP.Colored__commonLightBlack___qSTdn {\n  color: rgba(0, 0, 0, 0.54); }\n  .Colored__root___2rxrP.Colored__commonLightBlack___qSTdn a:link, .Colored__root___2rxrP.Colored__commonLightBlack___qSTdn a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__commonLightBlack___qSTdn a:hover, .Colored__root___2rxrP.Colored__commonLightBlack___qSTdn a:active {\n    color: rgba(0, 0, 0, 0.54); }\n\n.Colored__root___2rxrP.Colored__primaryBaseColor___24wlJ {\n  color: #119aab; }\n  .Colored__root___2rxrP.Colored__primaryBaseColor___24wlJ a:link, .Colored__root___2rxrP.Colored__primaryBaseColor___24wlJ a:visited {\n    color: currentColor; }\n  .Colored__root___2rxrP.Colored__primaryBaseColor___24wlJ a:hover, .Colored__root___2rxrP.Colored__primaryBaseColor___24wlJ a:active {\n    color: #0a5b65; }\n", ""]);

// exports
exports.locals = {
	"root": "Colored__root___2rxrP",
	"white": "Colored__white___3W9ol",
	"error": "Colored__error___33eLD",
	"errorLight": "Colored__errorLight___3yhC2",
	"errorDark": "Colored__errorDark___3YKI0",
	"success": "Colored__success___sF_A2",
	"successLight": "Colored__successLight___3cr_B",
	"successDark": "Colored__successDark___2wY7Z",
	"warning": "Colored__warning___1RDW2",
	"warningLight": "Colored__warningLight___3Tfz-",
	"warningDark": "Colored__warningDark___3NfzA",
	"primary": "Colored__primary___1nSJj",
	"primaryDark": "Colored__primaryDark___3AaI4",
	"secondary": "Colored__secondary___2CRjs",
	"secondaryDark": "Colored__secondaryDark___2wF17",
	"disabled": "Colored__disabled___1u1pz",
	"disabledDark": "Colored__disabledDark___2Ypms",
	"informationalBlue": "Colored__informationalBlue___1FUeS",
	"informationalBlueLight": "Colored__informationalBlueLight___2p0dj",
	"informationalBlueDark": "Colored__informationalBlueDark___3A8k4",
	"brandGreen": "Colored__brandGreen___2DQSX",
	"brandPink": "Colored__brandPink___3TaxL",
	"grey": "Colored__grey____sp1h",
	"lightTextSecondary": "Colored__lightTextSecondary___1ccXh",
	"lighterTextSecondary": "Colored__lighterTextSecondary___30MvG",
	"commonLightBlack": "Colored__commonLightBlack___qSTdn",
	"primaryBaseColor": "Colored__primaryBaseColor___24wlJ"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ContextMenu/contextMenu.scss":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ContextMenu/contextMenu.scss ***!
  \***********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.ContextMenu__root___1CSdq .ContextMenu__button___2PnQr {\n  width: 24px;\n  height: 24px;\n  margin-left: 8px;\n  /* Line up with primary icon (on the left) */\n  margin-top: -1px;\n  /* Line up with icon-important/urgent icon */\n  margin-right: -4px; }\n  .ContextMenu__root___1CSdq .ContextMenu__button___2PnQr:hover, .ContextMenu__root___1CSdq .ContextMenu__button___2PnQr:focus {\n    background: none; }\n  .ContextMenu__root___1CSdq .ContextMenu__button___2PnQr span:last-child {\n    display: none; }\n", ""]);

// exports
exports.locals = {
	"root": "ContextMenu__root___1CSdq",
	"button": "ContextMenu__button___2PnQr"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DataList/dataList.scss":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DataList/dataList.scss ***!
  \*****************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.DataList__root___U-Pd6 {\n  width: 100%;\n  height: 100%; }\n  .DataList__root___U-Pd6 ul,\n  .DataList__root___U-Pd6 ol {\n    list-style-type: none;\n    margin: 0;\n    padding: 0; }\n  .DataList__root___U-Pd6 .DataList__mobBtn___ODnZj {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 1px;\n    display: block;\n    border-radius: 0;\n    font-size: 12px;\n    text-transform: capitalize; }\n    .DataList__root___U-Pd6 .DataList__mobBtn___ODnZj span {\n      display: flex;\n      flex-direction: column; }\n  .DataList__root___U-Pd6 .DataList__listItemWrapper___msXVx {\n    position: relative;\n    background-color: white;\n    left: 0; }\n    .DataList__root___U-Pd6 .DataList__listItemWrapper___msXVx.DataList__notPanning___1SusE {\n      transition: left 300ms; }\n    .DataList__root___U-Pd6 .DataList__listItemWrapper___msXVx.DataList__open___3Atb6 {\n      left: -72px !important; }\n  .DataList__root___U-Pd6 .DataList__contextMenu___jLx51 {\n    display: none; }\n  .DataList__root___U-Pd6 .DataList__selected___1YBCN {\n    background-color: #eee; }\n    .DataList__root___U-Pd6 .DataList__selected___1YBCN .DataList__contextMenu___jLx51 {\n      display: flex; }\n  .DataList__root___U-Pd6 .icon {\n    height: auto;\n    width: 24px;\n    margin-left: 8px; }\n  .DataList__root___U-Pd6 .DataList__dataListItem___1iYly {\n    position: relative; }\n    .DataList__root___U-Pd6 .DataList__dataListItem___1iYly:hover .DataList__contextMenu___jLx51 {\n      display: flex; }\n    .DataList__root___U-Pd6 .DataList__dataListItem___1iYly .DataList__divider___3hkkP.DataList__inset___1yxGj {\n      margin-left: 48px; }\n    .DataList__root___U-Pd6 .DataList__dataListItem___1iYly .typography {\n      overflow: hidden;\n      text-overflow: ellipsis; }\n    .DataList__root___U-Pd6 .DataList__dataListItem___1iYly .DataList__listItemPadding___3zCoL {\n      padding: 12px 16px; }\n  .DataList__root___U-Pd6 .DataList__subheader___2d1Vj {\n    background-color: #fafafa;\n    text-transform: uppercase;\n    font-size: 1rem;\n    font-weight: 400;\n    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n    line-height: 1.5em;\n    color: rgba(0, 0, 0, 0.87);\n    font-size: 0.8125rem;\n    padding: 8px 16px;\n    letter-spacing: 0.3px; }\n  .DataList__root___U-Pd6 .DataList__text___PZ8oX {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    word-break: break-all; }\n", ""]);

// exports
exports.locals = {
	"root": "DataList__root___U-Pd6",
	"mobBtn": "DataList__mobBtn___ODnZj",
	"listItemWrapper": "DataList__listItemWrapper___msXVx",
	"notPanning": "DataList__notPanning___1SusE",
	"open": "DataList__open___3Atb6",
	"contextMenu": "DataList__contextMenu___jLx51",
	"selected": "DataList__selected___1YBCN",
	"dataListItem": "DataList__dataListItem___1iYly",
	"divider": "DataList__divider___3hkkP",
	"inset": "DataList__inset___1yxGj",
	"listItemPadding": "DataList__listItemPadding___3zCoL",
	"subheader": "DataList__subheader___2d1Vj",
	"text": "DataList__text___PZ8oX"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DataTable/ColumnFilter/styles.scss":
/*!*****************************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DataTable/ColumnFilter/styles.scss ***!
  \*****************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.ColumnFilter__paper___fYYil {\n  width: 300px;\n  padding: 16px; }\n", ""]);

// exports
exports.locals = {
	"paper": "ColumnFilter__paper___fYYil"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DataTable/dataTable.scss":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DataTable/dataTable.scss ***!
  \*******************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.DataTable__root___1dXh_ {\n  position: relative;\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: stretch; }\n  .DataTable__root___1dXh_ .DataTable__loadingDiv___3g5DY {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 2px;\n    width: 100%;\n    flex: none; }\n  .DataTable__root___1dXh_ .DataTable__tableHeader___1hkf- table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    margin-bottom: 0;\n    overflow: visible; }\n  .DataTable__root___1dXh_ .DataTable__tableContent___3SmfA {\n    flex: auto;\n    overflow: auto; }\n  .DataTable__root___1dXh_ table {\n    table-layout: fixed;\n    margin: 0; }\n  .DataTable__root___1dXh_ .DataTable__autoLayout___1tgVL {\n    table-layout: auto; }\n  .DataTable__root___1dXh_ th {\n    padding-left: 16px;\n    padding-right: 16px; }\n  .DataTable__root___1dXh_ td {\n    overflow: hidden;\n    padding-left: 16px;\n    padding-right: 16px; }\n  .DataTable__root___1dXh_.DataTable__dense___3X940 th, .DataTable__root___1dXh_.DataTable__dense___3X940 td {\n    padding-left: 8px;\n    padding-right: 8px; }\n  .DataTable__root___1dXh_.DataTable__dense___3X940 tr {\n    height: 32px; }\n  .DataTable__root___1dXh_ .DataTable__singleline___MWU7f {\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n  .DataTable__root___1dXh_ .DataTable__multiline___29vWL {\n    white-space: normal; }\n  .DataTable__root___1dXh_ .DataTable__tableCell___1P2ZM {\n    position: relative; }\n    .DataTable__root___1dXh_ .DataTable__tableCell___1P2ZM.DataTable__cellDisabled___2F23r {\n      color: rgba(0, 0, 0, 0.38); }\n      .DataTable__root___1dXh_ .DataTable__tableCell___1P2ZM.DataTable__cellDisabled___2F23r a:link, .DataTable__root___1dXh_ .DataTable__tableCell___1P2ZM.DataTable__cellDisabled___2F23r a:visited {\n        color: currentColor; }\n      .DataTable__root___1dXh_ .DataTable__tableCell___1P2ZM.DataTable__cellDisabled___2F23r a:hover, .DataTable__root___1dXh_ .DataTable__tableCell___1P2ZM.DataTable__cellDisabled___2F23r a:active {\n        color: rgba(0, 0, 0, 0.38); }\n    .DataTable__root___1dXh_ .DataTable__tableCell___1P2ZM .DataTable__tableCellActions___3Xyfh {\n      position: absolute;\n      right: 0;\n      top: 0;\n      height: 100%;\n      opacity: 0;\n      transition: opacity 150ms; }\n  .DataTable__root___1dXh_ .DataTable__fixedHeader___W6bQC {\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 1; }\n  .DataTable__root___1dXh_ tbody {\n    display: table-row-group; }\n    .DataTable__root___1dXh_ tbody tr {\n      height: 40px; }\n      .DataTable__root___1dXh_ tbody tr:hover .DataTable__tableCellActions___3Xyfh {\n        opacity: 1; }\n  .DataTable__root___1dXh_.DataTable__allowSelection___e1rgZ tbody tr {\n    cursor: pointer; }\n  .DataTable__root___1dXh_ .DataTable__titlebar___1zhEF {\n    /* Material UI applies 24px padding to screen size >600, we don't want that*/\n    padding-left: 0px;\n    padding-right: 4px; }\n  .DataTable__root___1dXh_ .DataTable__toolbar___3TGaR {\n    flex: auto;\n    display: flex;\n    justify-content: flex-end;\n    padding-left: 8px;\n    padding-right: 4px; }\n    .DataTable__root___1dXh_ .DataTable__toolbar___3TGaR .DataTable__title___1lRRm {\n      flex: 1; }\n  .DataTable__root___1dXh_ .DataTable__noContentContainer___29YgR {\n    background-color: #fafafa;\n    padding: 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n    .DataTable__root___1dXh_ .DataTable__noContentContainer___29YgR .DataTable__noContentDiv___1Elfn {\n      padding: 20px;\n      line-height: 1em;\n      min-height: 300px;\n      display: flex;\n      direction: column;\n      justify-content: center;\n      align-items: center; }\n  .DataTable__root___1dXh_ .DataTable__addNewDiv___1rkzv {\n    margin-top: 8px; }\n  .DataTable__root___1dXh_ .DataTable__checkboxCell___3b6ne {\n    width: 48px; }\n    .DataTable__root___1dXh_ .DataTable__checkboxCell___3b6ne span {\n      padding: 0px; }\n  .DataTable__root___1dXh_ .DataTable__chevron___2ePs0 {\n    opacity: 0.54;\n    transition: transform 150ms; }\n    .DataTable__root___1dXh_ .DataTable__chevron___2ePs0.DataTable__expandedChevron___aG01K {\n      transform: rotate(180deg); }\n  .DataTable__root___1dXh_ .DataTable__filterCell___C1DbB {\n    width: 48px;\n    padding-left: 0; }\n    .DataTable__root___1dXh_ .DataTable__filterCell___C1DbB:last-child {\n      padding-right: 0; }\n  .DataTable__root___1dXh_ .DataTable__expandedRow___1NYH_ {\n    background-color: #fafafa; }\n", ""]);

// exports
exports.locals = {
	"root": "DataTable__root___1dXh_",
	"loadingDiv": "DataTable__loadingDiv___3g5DY",
	"tableHeader": "DataTable__tableHeader___1hkf-",
	"tableContent": "DataTable__tableContent___3SmfA",
	"autoLayout": "DataTable__autoLayout___1tgVL",
	"dense": "DataTable__dense___3X940",
	"singleline": "DataTable__singleline___MWU7f",
	"multiline": "DataTable__multiline___29vWL",
	"tableCell": "DataTable__tableCell___1P2ZM",
	"cellDisabled": "DataTable__cellDisabled___2F23r",
	"tableCellActions": "DataTable__tableCellActions___3Xyfh",
	"fixedHeader": "DataTable__fixedHeader___W6bQC",
	"allowSelection": "DataTable__allowSelection___e1rgZ",
	"titlebar": "DataTable__titlebar___1zhEF",
	"toolbar": "DataTable__toolbar___3TGaR",
	"title": "DataTable__title___1lRRm",
	"noContentContainer": "DataTable__noContentContainer___29YgR",
	"noContentDiv": "DataTable__noContentDiv___1Elfn",
	"addNewDiv": "DataTable__addNewDiv___1rkzv",
	"checkboxCell": "DataTable__checkboxCell___3b6ne",
	"chevron": "DataTable__chevron___2ePs0",
	"expandedChevron": "DataTable__expandedChevron___aG01K",
	"filterCell": "DataTable__filterCell___C1DbB",
	"expandedRow": "DataTable__expandedRow___1NYH_"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DatePicker/styles.scss":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DatePicker/styles.scss ***!
  \*****************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.DatePicker__header___thEoA {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px; }\n\ndiv.DatePicker__paper___3p67U {\n  max-width: 300px;\n  padding: 8px; }\n  div.DatePicker__paper___3p67U .react-calendar__month-view__weekdays {\n    font-size: 1rem;\n    font-weight: 400;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n    line-height: 1.5em;\n    color: rgba(0, 0, 0, 0.87); }\n  div.DatePicker__paper___3p67U .react-calendar__month-view__weekdays__weekday {\n    text-align: center; }\n  div.DatePicker__paper___3p67U .react-calendar__month-view__days__day {\n    font-size: 0.875rem;\n    font-weight: 400;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n    line-height: 1.46429em;\n    background-color: #fff;\n    color: rgba(0, 0, 0, 0.87);\n    margin: 0;\n    border-radius: 0; }\n    div.DatePicker__paper___3p67U .react-calendar__month-view__days__day.react-calendar__tile[disabled] {\n      cursor: auto;\n      opacity: 1; }\n      div.DatePicker__paper___3p67U .react-calendar__month-view__days__day.react-calendar__tile[disabled] time, div.DatePicker__paper___3p67U .react-calendar__month-view__days__day.react-calendar__tile[disabled] abbr {\n        color: rgba(0, 0, 0, 0.38); }\n      div.DatePicker__paper___3p67U .react-calendar__month-view__days__day.react-calendar__tile[disabled].react-calendar__tile:hover {\n        background-color: #fff; }\n    div.DatePicker__paper___3p67U .react-calendar__month-view__days__day.react-calendar__tile {\n      padding: 0.25em 0.5em;\n      cursor: pointer; }\n      div.DatePicker__paper___3p67U .react-calendar__month-view__days__day.react-calendar__tile:hover {\n        background-color: rgba(0, 0, 0, 0.15); }\n      div.DatePicker__paper___3p67U .react-calendar__month-view__days__day.react-calendar__tile.react-calendar__tile--now {\n        background: #edF8F9;\n        color: rgba(0, 0, 0, 0.87); }\n      div.DatePicker__paper___3p67U .react-calendar__month-view__days__day.react-calendar__tile.react-calendar__tile--active {\n        background-color: #7cc9d3; }\n      div.DatePicker__paper___3p67U .react-calendar__month-view__days__day.react-calendar__tile.DatePicker__selectedDate___2lLph {\n        background: #119aab;\n        color: #fff; }\n  div.DatePicker__paper___3p67U .react-calendar__month-view .react-calendar__tile {\n    border: none;\n    color: rgba(0, 0, 0, 0.87); }\n\n.DatePicker__root___2LsLD .DatePicker__arrow___2rRzn {\n  pointer-events: none;\n  position: absolute;\n  top: 4px;\n  right: 0;\n  color: rgba(0, 0, 0, 0.54); }\n\n.DatePicker__reset___2t5ni input::-webkit-calendar-picker-indicator {\n  display: inline-block; }\n\n.DatePicker__reset___2t5ni input[type=date]::-webkit-inner-spin-button {\n  -webkit-appearance: inner-spin-button;\n  display: inline-block; }\n", ""]);

// exports
exports.locals = {
	"header": "DatePicker__header___thEoA",
	"paper": "DatePicker__paper___3p67U",
	"selectedDate": "DatePicker__selectedDate___2lLph",
	"root": "DatePicker__root___2LsLD",
	"arrow": "DatePicker__arrow___2rRzn",
	"reset": "DatePicker__reset___2t5ni"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DateRangePicker/styles.scss":
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DateRangePicker/styles.scss ***!
  \**********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.DateRangePicker__root___rlVHh .DateRangePicker__presetsBtn___1LZzq {\n  top: 8px; }\n\n.DateRangePicker__root___rlVHh .DateRangePicker__helperText___SQINO {\n  margin-top: 4px; }\n", ""]);

// exports
exports.locals = {
	"root": "DateRangePicker__root___rlVHh",
	"presetsBtn": "DateRangePicker__presetsBtn___1LZzq",
	"helperText": "DateRangePicker__helperText___SQINO"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Dialog/styles.scss":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Dialog/styles.scss ***!
  \*************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Dialog__container___2nKRQ .Dialog__closeBtn___2jJ8Z {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute;\n  top: 8px;\n  right: 16px; }\n\n.Dialog__container___2nKRQ .Dialog__content___2N83S {\n  max-width: 1000px;\n  width: 600px; }\n", ""]);

// exports
exports.locals = {
	"container": "Dialog__container___2nKRQ",
	"closeBtn": "Dialog__closeBtn___2jJ8Z",
	"content": "Dialog__content___2N83S"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DialogContentOverflowHidden/styles.scss":
/*!**********************************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DialogContentOverflowHidden/styles.scss ***!
  \**********************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.DialogContentOverflowHidden__root___1st09.DialogContentOverflowHidden__dialogContent___1Q5qv {\n  padding: 0 24px 8px 24px;\n  overflow-y: hidden;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: 0.875rem;\n  line-height: 1.46429em; }\n\n.DialogContentOverflowHidden__root___1st09.DialogContentOverflowHidden__dialogContentWithBottomPad___3I8wT {\n  padding: 0 24px 24px 24px;\n  overflow-y: hidden; }\n", ""]);

// exports
exports.locals = {
	"root": "DialogContentOverflowHidden__root___1st09",
	"dialogContent": "DialogContentOverflowHidden__dialogContent___1Q5qv",
	"dialogContentWithBottomPad": "DialogContentOverflowHidden__dialogContentWithBottomPad___3I8wT"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DialogTitle/styles.scss":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DialogTitle/styles.scss ***!
  \******************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.DialogTitle__root___3DgRi {\n  margin: 0;\n  padding: 16px 24px;\n  flex: 0 0 auto; }\n  .DialogTitle__root___3DgRi h6 {\n    line-height: 1.4em; }\n", ""]);

// exports
exports.locals = {
	"root": "DialogTitle__root___3DgRi"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Drawer/style.scss":
/*!************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Drawer/style.scss ***!
  \************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Drawer__muiDrawerBugFix___1bGVM {\n  visibility: hidden;\n  transition: visibility 225ms; }\n  .Drawer__muiDrawerBugFix___1bGVM.Drawer__open___LHC0M {\n    visibility: visible; }\n\n.Drawer__root___3Ko3P {\n  width: 400px;\n  margin-top: 54px; }\n\n.Drawer__root___3Ko3P.Drawer__modalVersion___3poSa {\n  width: 87.5vw;\n  margin-top: 0; }\n  .Drawer__root___3Ko3P.Drawer__modalVersion___3poSa .Drawer__header___QPT0t {\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 54px;\n    background-color: #f5f5f5; }\n    .Drawer__root___3Ko3P.Drawer__modalVersion___3poSa .Drawer__header___QPT0t .Drawer__title___2M1Is {\n      line-height: 54px;\n      margin-right: 40px; }\n  .Drawer__root___3Ko3P.Drawer__modalVersion___3poSa .Drawer__content___1zoPs {\n    height: 100vh;\n    flex: 0 0 87.5vw; }\n  .Drawer__root___3Ko3P.Drawer__modalVersion___3poSa .Drawer__body___2jX2e {\n    padding-top: 16px;\n    padding-bottom: 24px; }\n\n.Drawer__content___1zoPs {\n  height: calc(100vh - 54px);\n  width: 100%;\n  flex: 0 0 400px;\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  position: relative; }\n  .Drawer__content___1zoPs .Drawer__header___QPT0t {\n    flex-grow: 0;\n    flex-shrink: 0;\n    padding: 16px 16px 8px 24px; }\n    .Drawer__content___1zoPs .Drawer__header___QPT0t .Drawer__closeBtn___2oOqN {\n      position: absolute;\n      top: 8px;\n      right: 16px; }\n  .Drawer__content___1zoPs .Drawer__body___2jX2e {\n    flex-grow: 1;\n    flex-shrink: 1;\n    padding: 16px 24px;\n    padding: 0px 24px 54px 24px;\n    overflow: auto;\n    display: flex;\n    flex-direction: column; }\n    .Drawer__content___1zoPs .Drawer__body___2jX2e.Drawer__disableBodyGutter___3IyKx {\n      padding-left: 0px;\n      padding-right: 0px; }\n  .Drawer__content___1zoPs .Drawer__stickyFooter___1Ko2O {\n    box-sizing: border-box;\n    overflow-y: auto;\n    flex-grow: 0;\n    flex-shrink: 0;\n    border: 1px solid #e1e1e1;\n    padding: 16px;\n    height: 58px;\n    text-align: center;\n    z-index: 2;\n    position: fixed;\n    bottom: 0;\n    width: 400px;\n    background: white; }\n", ""]);

// exports
exports.locals = {
	"muiDrawerBugFix": "Drawer__muiDrawerBugFix___1bGVM",
	"open": "Drawer__open___LHC0M",
	"root": "Drawer__root___3Ko3P",
	"modalVersion": "Drawer__modalVersion___3poSa",
	"header": "Drawer__header___QPT0t",
	"title": "Drawer__title___2M1Is",
	"content": "Drawer__content___1zoPs",
	"body": "Drawer__body___2jX2e",
	"closeBtn": "Drawer__closeBtn___2oOqN",
	"disableBodyGutter": "Drawer__disableBodyGutter___3IyKx",
	"stickyFooter": "Drawer__stickyFooter___1Ko2O"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/FormControlLabel/styles.scss":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/FormControlLabel/styles.scss ***!
  \***********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.FormControlLabel__root___lR1MR span {\n  font-weight: 400; }\n\n.FormControlLabel__root___lR1MR.FormControlLabel__noVerticalMargin___24aJv {\n  margin-top: -12px;\n  margin-bottom: -12px; }\n\n.FormControlLabel__root___lR1MR.FormControlLabel__noHorizontalMargin___1qTbc {\n  margin-right: 0;\n  margin-left: -12px; }\n", ""]);

// exports
exports.locals = {
	"root": "FormControlLabel__root___lR1MR",
	"noVerticalMargin": "FormControlLabel__noVerticalMargin___24aJv",
	"noHorizontalMargin": "FormControlLabel__noHorizontalMargin___1qTbc"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/FormHelperText/styles.scss":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/FormHelperText/styles.scss ***!
  \*********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.FormHelperText__root___IOLAC.FormHelperText__helperText___1Bekq {\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n  white-space: pre-wrap; }\n  .FormHelperText__root___IOLAC.FormHelperText__helperText___1Bekq svg {\n    margin-right: 4px; }\n\n.FormHelperText__root___IOLAC.FormHelperText__alignRight___2qAnw {\n  justify-content: flex-end; }\n\n.FormHelperText__root___IOLAC.FormHelperText__warning___3jsD4 {\n  color: #ff9100; }\n\n.FormHelperText__root___IOLAC.FormHelperText__info___1hjfo {\n  color: rgba(0, 0, 0, 0.38); }\n", ""]);

// exports
exports.locals = {
	"root": "FormHelperText__root___IOLAC",
	"helperText": "FormHelperText__helperText___1Bekq",
	"alignRight": "FormHelperText__alignRight___2qAnw",
	"warning": "FormHelperText__warning___3jsD4",
	"info": "FormHelperText__info___1hjfo"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Icon/styles.scss":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Icon/styles.scss ***!
  \***********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Icon__root___3A58o {\n  fill: currentColor; }\n  .Icon__root___3A58o.Icon__error___3_oo- {\n    fill: #d32f2f; }\n  .Icon__root___3A58o.Icon__success___3IBsi {\n    fill: #4caf5a; }\n  .Icon__root___3A58o.Icon__brandGreen___1nQ9E {\n    fill: #53bac3; }\n  .Icon__root___3A58o.Icon__warning___3VMDm {\n    fill: #ff9100; }\n  .Icon__root___3A58o.Icon__grey___2lJvh {\n    fill: rgba(0, 0, 0, 0.54); }\n  .Icon__root___3A58o.Icon__size-regular___3fGrS {\n    height: 24px;\n    width: 24px; }\n  .Icon__root___3A58o.Icon__size-small___1Xqon {\n    height: 16px;\n    width: 16px; }\n  .Icon__root___3A58o.Icon__size-large___krfcq {\n    height: 32px;\n    width: 32px; }\n", ""]);

// exports
exports.locals = {
	"root": "Icon__root___3A58o",
	"error": "Icon__error___3_oo-",
	"success": "Icon__success___3IBsi",
	"brandGreen": "Icon__brandGreen___1nQ9E",
	"warning": "Icon__warning___3VMDm",
	"grey": "Icon__grey___2lJvh",
	"size-regular": "Icon__size-regular___3fGrS",
	"size-small": "Icon__size-small___1Xqon",
	"size-large": "Icon__size-large___krfcq"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/IconButton/style.scss":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/IconButton/style.scss ***!
  \****************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\nbutton.IconButton__root___21vkK {\n  padding: 0px; }\n\n.IconButton__root___21vkK.IconButton__inputAdornment___24A4u {\n  padding: 0px;\n  border-radius: 0%;\n  margin: 0;\n  height: 24px;\n  width: 24px;\n  right: 4px;\n  background-color: transparent;\n  font-size: 1em;\n  border-width: 0; }\n  .IconButton__root___21vkK.IconButton__inputAdornment___24A4u:hover {\n    background-color: transparent; }\n  .IconButton__root___21vkK.IconButton__inputAdornment___24A4u svg {\n    width: 100%;\n    height: 100%; }\n", ""]);

// exports
exports.locals = {
	"root": "IconButton__root___21vkK",
	"inputAdornment": "IconButton__inputAdornment___24A4u"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/InfoBox/styles.scss":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/InfoBox/styles.scss ***!
  \**************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.InfoBox__root___3Ubgg .InfoBox__paper___3AJOo {\n  background-color: #fafafa;\n  padding: 16px; }\n\n.InfoBox__root___3Ubgg .InfoBox__closeBtn___3_TND {\n  float: right;\n  margin-top: -9px;\n  margin-right: -8px; }\n\n.InfoBox__root___3Ubgg .InfoBox__title___2-FS3 {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 14px; }\n\n.InfoBox__root___3Ubgg .InfoBox__content___2_n5- {\n  font-size: 12px; }\n", ""]);

// exports
exports.locals = {
	"root": "InfoBox__root___3Ubgg",
	"paper": "InfoBox__paper___3AJOo",
	"closeBtn": "InfoBox__closeBtn___3_TND",
	"title": "InfoBox__title___2-FS3",
	"content": "InfoBox__content___2_n5-"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Input/adornmentHOCs/styles.scss":
/*!**************************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Input/adornmentHOCs/styles.scss ***!
  \**************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.adornmentHOCs__adornment___1bnwm {\n  white-space: nowrap;\n  margin-right: 20px;\n  margin-bottom: -5px; }\n", ""]);

// exports
exports.locals = {
	"adornment": "adornmentHOCs__adornment___1bnwm"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Input/checkbox.scss":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Input/checkbox.scss ***!
  \**************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Input__root___1LTqm.Input__item___1oxkQ {\n  margin-right: -10px; }\n  .Input__root___1LTqm.Input__item___1oxkQ.Input__compact___3J7U_ {\n    width: auto;\n    height: auto;\n    margin-right: 0px; }\n\n.Input__root___1LTqm.Input__mini___3rt6S {\n  width: 24px;\n  height: 24px; }\n  .Input__root___1LTqm.Input__mini___3rt6S.Input__item___1oxkQ {\n    margin-right: 0px; }\n\n.Input__root___1LTqm svg.Input__mini___3rt6S {\n  font-size: 16px; }\n\n.Input__label___1vUBt {\n  position: relative;\n  top: 8px; }\n  .Input__label___1vUBt .Input__errorLabel___2LPz3 {\n    position: absolute;\n    left: 38px;\n    bottom: 0;\n    font-weight: normal; }\n  .Input__label___1vUBt.Input__noVerticalMargin___2jNi4 {\n    top: 0; }\n  .Input__label___1vUBt .Input__mini___3rt6S {\n    font-size: 12px; }\n  .Input__label___1vUBt .Input__disabled___P_xQX {\n    color: rgba(0, 0, 0, 0.26); }\n\nspan.Input__mini___3rt6S {\n  padding: 0px; }\n", ""]);

// exports
exports.locals = {
	"root": "Input__root___1LTqm",
	"item": "Input__item___1oxkQ",
	"compact": "Input__compact___3J7U_",
	"mini": "Input__mini___3rt6S",
	"label": "Input__label___1vUBt",
	"errorLabel": "Input__errorLabel___2LPz3",
	"noVerticalMargin": "Input__noVerticalMargin___2jNi4",
	"disabled": "Input__disabled___P_xQX"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Input/styles.scss":
/*!************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Input/styles.scss ***!
  \************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Input__reset___2qb2Z.Input__noMargin___2M1FV {\n  margin: 0; }\n\n.Input__reset___2qb2Z input[type='text'],\n.Input__reset___2qb2Z input[type='password'],\n.Input__reset___2qb2Z input[type='date'],\n.Input__reset___2qb2Z input[type='number'],\n.Input__reset___2qb2Z input[type='email'],\n.Input__reset___2qb2Z .Input__select___w0DYB {\n  border: none;\n  box-shadow: none;\n  height: 1em;\n  width: 100%;\n  line-height: 1;\n  display: block;\n  box-sizing: content-box;\n  background: none;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  padding: 8px 0 4px 0;\n  min-height: auto; }\n  .Input__reset___2qb2Z input[type='text'][readonly],\n  .Input__reset___2qb2Z input[type='password'][readonly],\n  .Input__reset___2qb2Z input[type='date'][readonly],\n  .Input__reset___2qb2Z input[type='number'][readonly],\n  .Input__reset___2qb2Z input[type='email'][readonly],\n  .Input__reset___2qb2Z .Input__select___w0DYB[readonly] {\n    -webkit-text-fill-color: inherit; }\n\n.Input__reset___2qb2Z .Input__select___w0DYB {\n  padding-right: 24px; }\n\n.Input__reset___2qb2Z input::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  line-height: initial; }\n\n.Input__reset___2qb2Z input::-moz-placeholder {\n  /* Firefox 19+ */\n  line-height: 1; }\n\n.Input__reset___2qb2Z input:-ms-input-placeholder {\n  /* IE 10+ */\n  line-height: 1; }\n\n.Input__reset___2qb2Z input:-moz-placeholder {\n  /* Firefox 18- */\n  line-height: 1; }\n\n.Input__reset___2qb2Z label {\n  font-weight: normal;\n  font-size: 1em; }\n\n.Input__reset___2qb2Z textarea {\n  border-radius: 0 !important; }\n\n.Input__reset___2qb2Z .Input__multiline___2_qSu {\n  padding-bottom: 0; }\n  .Input__reset___2qb2Z .Input__multiline___2_qSu.Input__canResize___2Jjsv textarea {\n    resize: vertical; }\n\n.Input__container___15X8s textarea, .Input__input___lNhFJ textarea {\n  border: 1px solid rgba(10, 10, 10, 0.42);\n  padding: 8px;\n  width: calc(100% - 18px); }\n  .Input__container___15X8s textarea::before, .Input__input___lNhFJ textarea::before {\n    height: 0; }\n  .Input__container___15X8s textarea:focus, .Input__input___lNhFJ textarea:focus {\n    border-color: #119aab; }\n  .Input__container___15X8s textarea[aria-invalid=\"true\"], .Input__input___lNhFJ textarea[aria-invalid=\"true\"] {\n    border-color: #d32f2f; }\n\n.Input__container___15X8s.Input__reset___2qb2Z {\n  margin-top: 8px;\n  padding-bottom: 0; }\n  .Input__container___15X8s.Input__reset___2qb2Z.Input__noMargin___2M1FV {\n    margin: 0; }\n\n.Input__container___15X8s textarea {\n  line-height: 1.3; }\n\n.Input__container___15X8s .Input__input___lNhFJ {\n  margin-top: 8px; }\n\n.Input__container___15X8s.Input__compact___13b5A .Input__input___lNhFJ {\n  margin-top: 0; }\n\n.Input__input___lNhFJ {\n  width: 100%; }\n  .Input__input___lNhFJ.Input__valueIsDisabled___2mcZd {\n    color: rgba(0, 0, 0, 0.38); }\n  .Input__input___lNhFJ.Input__multilineNoLabel___2K8NR {\n    padding: 0; }\n    .Input__input___lNhFJ.Input__multilineNoLabel___2K8NR .Input__multilineRoot___1rPU8 {\n      margin-top: 0; }\n  .Input__input___lNhFJ textarea {\n    height: calc(100% - 18px);\n    min-height: calc(38px + 16px); }\n  .Input__input___lNhFJ .Input__multilineShadow___2u1iW {\n    height: auto;\n    min-height: auto; }\n  .Input__input___lNhFJ.Input__compact___13b5A input {\n    padding: 4px; }\n\n.Input__label___3FX6t {\n  z-index: 1;\n  white-space: nowrap; }\n  .Input__label___3FX6t.Input__allowShrink___3d-lu {\n    top: -6px; }\n  .Input__label___3FX6t.Input__shrink___3nvbo {\n    top: 0; }\n\n.Input__selectContainer___qu3Gg {\n  display: flex; }\n\n.Input__selectRoot___29OC0 {\n  padding-right: 24px; }\n\n.Input__multilineRoot___1rPU8 {\n  margin-top: 4px;\n  min-height: 75px; }\n\n.Input__fieldLabel___1MBhB {\n  height: 64px;\n  padding-top: 26px; }\n\n.Input__selectPaper___2hmUb li {\n  padding: 8px 16px;\n  height: 19px;\n  font-size: 13px; }\n\n.Input__radioControl___2hUCm.Input__noMargin___2M1FV {\n  margin-top: 0; }\n\n.Input__radioControl___2hUCm label {\n  margin-bottom: 0;\n  font-weight: normal; }\n\n.Input__radioControl___2hUCm .Input__helperText___KEVMb {\n  margin-top: 4px; }\n\n.Input__group___347Q6.Input__horizontal___g_1uw {\n  flex-direction: row; }\n\n.Input__group___347Q6.Input__multiLineLabel___34DSE label {\n  align-items: flex-start; }\n  .Input__group___347Q6.Input__multiLineLabel___34DSE label > span {\n    margin-bottom: 16px;\n    top: 18px; }\n    .Input__group___347Q6.Input__multiLineLabel___34DSE label > span:first-child {\n      margin-top: -10px; }\n\n.Input__group___347Q6 label {\n  position: relative;\n  margin-right: 24px; }\n  .Input__group___347Q6 label > span {\n    position: relative;\n    top: 8px; }\n    .Input__group___347Q6 label > span:first-child {\n      height: 40px; }\n\n.Input__group___347Q6.Input__disableLabelTop___3E1LZ label > span {\n  top: unset; }\n", ""]);

// exports
exports.locals = {
	"reset": "Input__reset___2qb2Z",
	"noMargin": "Input__noMargin___2M1FV",
	"select": "Input__select___w0DYB",
	"multiline": "Input__multiline___2_qSu",
	"canResize": "Input__canResize___2Jjsv",
	"container": "Input__container___15X8s",
	"input": "Input__input___lNhFJ",
	"compact": "Input__compact___13b5A",
	"valueIsDisabled": "Input__valueIsDisabled___2mcZd",
	"multilineNoLabel": "Input__multilineNoLabel___2K8NR",
	"multilineRoot": "Input__multilineRoot___1rPU8",
	"multilineShadow": "Input__multilineShadow___2u1iW",
	"label": "Input__label___3FX6t",
	"allowShrink": "Input__allowShrink___3d-lu",
	"shrink": "Input__shrink___3nvbo",
	"selectContainer": "Input__selectContainer___qu3Gg",
	"selectRoot": "Input__selectRoot___29OC0",
	"fieldLabel": "Input__fieldLabel___1MBhB",
	"selectPaper": "Input__selectPaper___2hmUb",
	"radioControl": "Input__radioControl___2hUCm",
	"helperText": "Input__helperText___KEVMb",
	"group": "Input__group___347Q6",
	"horizontal": "Input__horizontal___g_1uw",
	"multiLineLabel": "Input__multiLineLabel___34DSE",
	"disableLabelTop": "Input__disableLabelTop___3E1LZ"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ListItemPrimaryText/index.scss":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ListItemPrimaryText/index.scss ***!
  \*************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.ListItemPrimaryText__root___JdPMC {\n  width: 100%; }\n  .ListItemPrimaryText__root___JdPMC .ListItemPrimaryText__title___3pudH {\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n  .ListItemPrimaryText__root___JdPMC .ListItemPrimaryText__text___2Qeb7 {\n    width: 100%;\n    display: block;\n    /* Fallback for non-webkit */\n    display: -webkit-box;\n    line-height: 1rem;\n    max-height: 3rem;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: normal;\n    color: rgba(0, 0, 0, 0.54); }\n", ""]);

// exports
exports.locals = {
	"root": "ListItemPrimaryText__root___JdPMC",
	"title": "ListItemPrimaryText__title___3pudH",
	"text": "ListItemPrimaryText__text___2Qeb7"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ListItemText/index.scss":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ListItemText/index.scss ***!
  \******************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".ListItemText__root___3Pc49.ListItemText__text___3Zah9 {\n  padding: 0; }\n  .ListItemText__root___3Pc49.ListItemText__text___3Zah9 h3,\n  .ListItemText__root___3Pc49.ListItemText__text___3Zah9 p {\n    overflow: hidden;\n    text-overflow: ellipsis; }\n", ""]);

// exports
exports.locals = {
	"root": "ListItemText__root___3Pc49",
	"text": "ListItemText__text___3Zah9"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/NakedDatePicker/styles.scss":
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/NakedDatePicker/styles.scss ***!
  \**********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.NakedDatePicker__header___31yMy {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px; }\n  .NakedDatePicker__header___31yMy div {\n    font-size: 14px; }\n  .NakedDatePicker__header___31yMy.NakedDatePicker__compactWidth___3Z5Pg {\n    margin-bottom: 8px; }\n\ndiv.NakedDatePicker__root___3Bz9q button:focus {\n  outline: 0; }\n\ndiv.NakedDatePicker__root___3Bz9q .react-calendar__tile {\n  font-size: 0px;\n  margin: 0px;\n  padding: 0px;\n  border: none; }\n\ndiv.NakedDatePicker__root___3Bz9q.NakedDatePicker__normalWidth___1nGin {\n  max-width: 300px; }\n  div.NakedDatePicker__root___3Bz9q.NakedDatePicker__normalWidth___1nGin .react-calendar__month-view__weekdays__weekday, div.NakedDatePicker__root___3Bz9q.NakedDatePicker__normalWidth___1nGin .NakedDatePicker__date___vZwIW {\n    height: 27px;\n    font-size: 16px; }\n  div.NakedDatePicker__root___3Bz9q.NakedDatePicker__normalWidth___1nGin .NakedDatePicker__today___2kDOd {\n    width: 100%;\n    height: 100%; }\n\ndiv.NakedDatePicker__root___3Bz9q.NakedDatePicker__compactWidth___3Z5Pg {\n  width: 224px; }\n  div.NakedDatePicker__root___3Bz9q.NakedDatePicker__compactWidth___3Z5Pg .react-calendar__month-view__weekdays__weekday, div.NakedDatePicker__root___3Bz9q.NakedDatePicker__compactWidth___3Z5Pg .NakedDatePicker__date___vZwIW {\n    height: 24px;\n    font-size: 12px; }\n  div.NakedDatePicker__root___3Bz9q.NakedDatePicker__compactWidth___3Z5Pg .NakedDatePicker__today___2kDOd {\n    width: 24px;\n    height: 24px; }\n\ndiv.NakedDatePicker__root___3Bz9q .react-calendar__month-view__weekdays {\n  text-align: center;\n  font-weight: 400;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  line-height: 1.5em;\n  color: rgba(0, 0, 0, 0.38);\n  margin-bottom: 6px; }\n\ndiv.NakedDatePicker__root___3Bz9q .NakedDatePicker__dateCell___1k32y {\n  justify-content: center;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  font-weight: 400;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  line-height: 1.46429em;\n  background-color: #fff;\n  color: rgba(0, 0, 0, 0.87);\n  cursor: pointer; }\n  div.NakedDatePicker__root___3Bz9q .NakedDatePicker__dateCell___1k32y div {\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  div.NakedDatePicker__root___3Bz9q .NakedDatePicker__dateCell___1k32y.NakedDatePicker__unclickable___3Bz8H {\n    cursor: auto; }\n\ndiv.NakedDatePicker__root___3Bz9q .NakedDatePicker__today___2kDOd {\n  background: #119aab;\n  color: #fff;\n  border-radius: 13px; }\n  div.NakedDatePicker__root___3Bz9q .NakedDatePicker__today___2kDOd:hover {\n    background-color: #0f8594; }\n\ndiv.NakedDatePicker__root___3Bz9q .NakedDatePicker__date___vZwIW {\n  margin: 2px 4px;\n  width: 100%;\n  border: none;\n  color: rgba(0, 0, 0, 0.87); }\n  div.NakedDatePicker__root___3Bz9q .NakedDatePicker__date___vZwIW:hover {\n    background-color: rgba(0, 0, 0, 0.15);\n    border-radius: 13px; }\n  div.NakedDatePicker__root___3Bz9q .NakedDatePicker__date___vZwIW.NakedDatePicker__selected___1Qwlm {\n    margin-left: 0;\n    margin-right: 0;\n    background: rgba(17, 154, 171, 0.1);\n    color: #119aab;\n    pointer-events: none; }\n    div.NakedDatePicker__root___3Bz9q .NakedDatePicker__date___vZwIW.NakedDatePicker__selected___1Qwlm.NakedDatePicker__startSelectedDate___2iPjI {\n      margin-left: 4px;\n      border-bottom-left-radius: 13px;\n      border-top-left-radius: 13px; }\n    div.NakedDatePicker__root___3Bz9q .NakedDatePicker__date___vZwIW.NakedDatePicker__selected___1Qwlm.NakedDatePicker__endSelectedDate___3wWLT {\n      margin-right: 4px;\n      border-bottom-right-radius: 13px;\n      border-top-right-radius: 13px; }\n    div.NakedDatePicker__root___3Bz9q .NakedDatePicker__date___vZwIW.NakedDatePicker__selected___1Qwlm .NakedDatePicker__today___2kDOd {\n      background: rgba(17, 154, 171, 0.85); }\n  div.NakedDatePicker__root___3Bz9q .NakedDatePicker__date___vZwIW.NakedDatePicker__notCurrentMonth___3opGX {\n    color: rgba(0, 0, 0, 0.38); }\n    div.NakedDatePicker__root___3Bz9q .NakedDatePicker__date___vZwIW.NakedDatePicker__notCurrentMonth___3opGX .NakedDatePicker__today___2kDOd {\n      background-color: rgba(17, 154, 171, 0.5); }\n\ndiv.NakedDatePicker__root___3Bz9q button.NakedDatePicker__leftNavigate___2RwCn {\n  margin-left: -4px; }\n\ndiv.NakedDatePicker__root___3Bz9q button.NakedDatePicker__rightNavigate___1HhWK {\n  margin-right: -4px; }\n", ""]);

// exports
exports.locals = {
	"header": "NakedDatePicker__header___31yMy",
	"compactWidth": "NakedDatePicker__compactWidth___3Z5Pg",
	"root": "NakedDatePicker__root___3Bz9q",
	"normalWidth": "NakedDatePicker__normalWidth___1nGin",
	"date": "NakedDatePicker__date___vZwIW",
	"today": "NakedDatePicker__today___2kDOd",
	"dateCell": "NakedDatePicker__dateCell___1k32y",
	"unclickable": "NakedDatePicker__unclickable___3Bz8H",
	"selected": "NakedDatePicker__selected___1Qwlm",
	"startSelectedDate": "NakedDatePicker__startSelectedDate___2iPjI",
	"endSelectedDate": "NakedDatePicker__endSelectedDate___3wWLT",
	"notCurrentMonth": "NakedDatePicker__notCurrentMonth___3opGX",
	"leftNavigate": "NakedDatePicker__leftNavigate___2RwCn",
	"rightNavigate": "NakedDatePicker__rightNavigate___1HhWK"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Notice/styles.scss":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Notice/styles.scss ***!
  \*************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Notice__root___3Mjpp {\n  position: relative;\n  margin-bottom: 8px; }\n  .Notice__root___3Mjpp.warning, .Notice__root___3Mjpp .warning {\n    color: #ff9100; }\n  .Notice__root___3Mjpp.error, .Notice__root___3Mjpp .error {\n    color: #d32f2f; }\n  .Notice__root___3Mjpp.info, .Notice__root___3Mjpp .info {\n    color: #4990e2; }\n  .Notice__root___3Mjpp svg {\n    margin-top: 4.8px;\n    position: absolute; }\n  .Notice__root___3Mjpp h6 {\n    font-size: 16px;\n    vertical-align: middle;\n    line-height: 32px;\n    margin: 0 0 0 32px; }\n  .Notice__root___3Mjpp.Notice__smallFont___1PGwO h6 {\n    font-size: 12px; }\n", ""]);

// exports
exports.locals = {
	"root": "Notice__root___3Mjpp",
	"smallFont": "Notice__smallFont___1PGwO"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/PDFViewer/styles.scss":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/PDFViewer/styles.scss ***!
  \****************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n#root,\n#modal_root,\n#popover,\n.PDFViewer__container___3ahDt {\n  /* padding */\n  /* padding */\n  /* paddingTop */\n  /* paddingTop */\n  /* paddingRight */\n  /* paddingRight */\n  /* paddingBottom */\n  /* paddingBottom */\n  /* paddingLeft */\n  /* paddingLeft */\n  /* paddingHorizontal */\n  /* paddingHorizontal */\n  /* paddingVertical */\n  /* paddingVertical */\n  /* margin */\n  /* margin */\n  /* marginLeft */\n  /* marginLeft */\n  /* marginRight */\n  /* marginRight */\n  /* marginTop */\n  /* marginTop */\n  /* marginBottom */\n  /* marginBottom */\n  /* align */\n  /* align */\n  /* divder */\n  /* divder */ }\n  #root .PDFViewer__flexNone___KTp8f,\n  #modal_root .PDFViewer__flexNone___KTp8f,\n  #popover .PDFViewer__flexNone___KTp8f,\n  .PDFViewer__container___3ahDt .PDFViewer__flexNone___KTp8f {\n    flex: none; }\n  #root .PDFViewer__flexAuto___yFoqE,\n  #modal_root .PDFViewer__flexAuto___yFoqE,\n  #popover .PDFViewer__flexAuto___yFoqE,\n  .PDFViewer__container___3ahDt .PDFViewer__flexAuto___yFoqE {\n    flex: auto; }\n  #root .PDFViewer__flex___3Ljr0,\n  #modal_root .PDFViewer__flex___3Ljr0,\n  #popover .PDFViewer__flex___3Ljr0,\n  .PDFViewer__container___3ahDt .PDFViewer__flex___3Ljr0 {\n    display: flex; }\n  #root .PDFViewer__hidden___7PQS1,\n  #modal_root .PDFViewer__hidden___7PQS1,\n  #popover .PDFViewer__hidden___7PQS1,\n  .PDFViewer__container___3ahDt .PDFViewer__hidden___7PQS1 {\n    display: none; }\n  #root .PDFViewer__inlineFlex___1k6mF,\n  #modal_root .PDFViewer__inlineFlex___1k6mF,\n  #popover .PDFViewer__inlineFlex___1k6mF,\n  .PDFViewer__container___3ahDt .PDFViewer__inlineFlex___1k6mF {\n    display: inline-flex; }\n  #root .PDFViewer__block___2zK-2,\n  #modal_root .PDFViewer__block___2zK-2,\n  #popover .PDFViewer__block___2zK-2,\n  .PDFViewer__container___3ahDt .PDFViewer__block___2zK-2 {\n    display: block; }\n  #root .PDFViewer__inlineBlock___CV4pP,\n  #modal_root .PDFViewer__inlineBlock___CV4pP,\n  #popover .PDFViewer__inlineBlock___CV4pP,\n  .PDFViewer__container___3ahDt .PDFViewer__inlineBlock___CV4pP {\n    display: inline-block; }\n  #root .PDFViewer__inline___2SVBO,\n  #modal_root .PDFViewer__inline___2SVBO,\n  #popover .PDFViewer__inline___2SVBO,\n  .PDFViewer__container___3ahDt .PDFViewer__inline___2SVBO {\n    display: inline; }\n  #root .PDFViewer__relative___1gVnS,\n  #modal_root .PDFViewer__relative___1gVnS,\n  #popover .PDFViewer__relative___1gVnS,\n  .PDFViewer__container___3ahDt .PDFViewer__relative___1gVnS {\n    position: relative; }\n  #root .PDFViewer__absolute___3pGU6,\n  #modal_root .PDFViewer__absolute___3pGU6,\n  #popover .PDFViewer__absolute___3pGU6,\n  .PDFViewer__container___3ahDt .PDFViewer__absolute___3pGU6 {\n    position: absolute; }\n  #root .PDFViewer__fitAbsolute___1rjCf,\n  #modal_root .PDFViewer__fitAbsolute___1rjCf,\n  #popover .PDFViewer__fitAbsolute___1rjCf,\n  .PDFViewer__container___3ahDt .PDFViewer__fitAbsolute___1rjCf {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0; }\n  #root .PDFViewer__floatLeft___2GgsU,\n  #modal_root .PDFViewer__floatLeft___2GgsU,\n  #popover .PDFViewer__floatLeft___2GgsU,\n  .PDFViewer__container___3ahDt .PDFViewer__floatLeft___2GgsU {\n    float: left; }\n  #root .PDFViewer__floatRight___2dIGa,\n  #modal_root .PDFViewer__floatRight___2dIGa,\n  #popover .PDFViewer__floatRight___2dIGa,\n  .PDFViewer__container___3ahDt .PDFViewer__floatRight___2dIGa {\n    float: right; }\n  #root .PDFViewer__clearBoth___1yCWG,\n  #modal_root .PDFViewer__clearBoth___1yCWG,\n  #popover .PDFViewer__clearBoth___1yCWG,\n  .PDFViewer__container___3ahDt .PDFViewer__clearBoth___1yCWG {\n    clear: both; }\n  #root .PDFViewer__flexBasis0___36T9P,\n  #modal_root .PDFViewer__flexBasis0___36T9P,\n  #popover .PDFViewer__flexBasis0___36T9P,\n  .PDFViewer__container___3ahDt .PDFViewer__flexBasis0___36T9P {\n    flex-basis: 0; }\n  #root .PDFViewer__flexBasisAuto___1Ed39,\n  #modal_root .PDFViewer__flexBasisAuto___1Ed39,\n  #popover .PDFViewer__flexBasisAuto___1Ed39,\n  .PDFViewer__container___3ahDt .PDFViewer__flexBasisAuto___1Ed39 {\n    flex-basis: auto; }\n  #root .PDFViewer__fullWidth___3t_i4,\n  #modal_root .PDFViewer__fullWidth___3t_i4,\n  #popover .PDFViewer__fullWidth___3t_i4,\n  .PDFViewer__container___3ahDt .PDFViewer__fullWidth___3t_i4 {\n    width: 100%; }\n  #root .PDFViewer__minWidthNone___37ZG_,\n  #modal_root .PDFViewer__minWidthNone___37ZG_,\n  #popover .PDFViewer__minWidthNone___37ZG_,\n  .PDFViewer__container___3ahDt .PDFViewer__minWidthNone___37ZG_ {\n    min-width: 0; }\n  #root .PDFViewer__resetWidth___1fz2o,\n  #modal_root .PDFViewer__resetWidth___1fz2o,\n  #popover .PDFViewer__resetWidth___1fz2o,\n  .PDFViewer__container___3ahDt .PDFViewer__resetWidth___1fz2o {\n    width: auto;\n    min-width: auto; }\n  #root .PDFViewer__flexGrow___2rYI8,\n  #modal_root .PDFViewer__flexGrow___2rYI8,\n  #popover .PDFViewer__flexGrow___2rYI8,\n  .PDFViewer__container___3ahDt .PDFViewer__flexGrow___2rYI8 {\n    flex-grow: 1; }\n  #root .PDFViewer__flexGrowNone___101mg,\n  #modal_root .PDFViewer__flexGrowNone___101mg,\n  #popover .PDFViewer__flexGrowNone___101mg,\n  .PDFViewer__container___3ahDt .PDFViewer__flexGrowNone___101mg {\n    flex-grow: 0; }\n  #root .PDFViewer__flexShrink___1vnbC,\n  #modal_root .PDFViewer__flexShrink___1vnbC,\n  #popover .PDFViewer__flexShrink___1vnbC,\n  .PDFViewer__container___3ahDt .PDFViewer__flexShrink___1vnbC {\n    flex-shrink: 1; }\n  #root .PDFViewer__flexShrinkNone___L7Li9, #root .PDFViewer__flexNoShrink___5GLYI,\n  #modal_root .PDFViewer__flexShrinkNone___L7Li9,\n  #modal_root .PDFViewer__flexNoShrink___5GLYI,\n  #popover .PDFViewer__flexShrinkNone___L7Li9,\n  #popover .PDFViewer__flexNoShrink___5GLYI,\n  .PDFViewer__container___3ahDt .PDFViewer__flexShrinkNone___L7Li9,\n  .PDFViewer__container___3ahDt .PDFViewer__flexNoShrink___5GLYI {\n    flex-shrink: 0; }\n  #root .PDFViewer__centerContent___9C5xW,\n  #modal_root .PDFViewer__centerContent___9C5xW,\n  #popover .PDFViewer__centerContent___9C5xW,\n  .PDFViewer__container___3ahDt .PDFViewer__centerContent___9C5xW {\n    align-items: baseline;\n    align-content: center;\n    justify-content: center; }\n  #root .PDFViewer__spaceContentBetween___gUiLK,\n  #modal_root .PDFViewer__spaceContentBetween___gUiLK,\n  #popover .PDFViewer__spaceContentBetween___gUiLK,\n  .PDFViewer__container___3ahDt .PDFViewer__spaceContentBetween___gUiLK {\n    justify-content: space-between; }\n  #root .PDFViewer__spaceContentAround___1SOkX,\n  #modal_root .PDFViewer__spaceContentAround___1SOkX,\n  #popover .PDFViewer__spaceContentAround___1SOkX,\n  .PDFViewer__container___3ahDt .PDFViewer__spaceContentAround___1SOkX {\n    justify-content: space-around; }\n  #root .PDFViewer__centerVertically___igaMC,\n  #modal_root .PDFViewer__centerVertically___igaMC,\n  #popover .PDFViewer__centerVertically___igaMC,\n  .PDFViewer__container___3ahDt .PDFViewer__centerVertically___igaMC {\n    align-items: center; }\n  #root .PDFViewer__centerHorizontally___2uRRS,\n  #modal_root .PDFViewer__centerHorizontally___2uRRS,\n  #popover .PDFViewer__centerHorizontally___2uRRS,\n  .PDFViewer__container___3ahDt .PDFViewer__centerHorizontally___2uRRS {\n    justify-content: center; }\n  #root .PDFViewer__topAlign___tKDKr,\n  #modal_root .PDFViewer__topAlign___tKDKr,\n  #popover .PDFViewer__topAlign___tKDKr,\n  .PDFViewer__container___3ahDt .PDFViewer__topAlign___tKDKr {\n    align-items: flex-start;\n    padding-top: 36px; }\n  #root .PDFViewer__alignItemsFlexStart___VNaYm,\n  #modal_root .PDFViewer__alignItemsFlexStart___VNaYm,\n  #popover .PDFViewer__alignItemsFlexStart___VNaYm,\n  .PDFViewer__container___3ahDt .PDFViewer__alignItemsFlexStart___VNaYm {\n    align-items: flex-start; }\n  #root .PDFViewer__alignItemsFlexEnd___2QeIw,\n  #modal_root .PDFViewer__alignItemsFlexEnd___2QeIw,\n  #popover .PDFViewer__alignItemsFlexEnd___2QeIw,\n  .PDFViewer__container___3ahDt .PDFViewer__alignItemsFlexEnd___2QeIw {\n    align-items: flex-end; }\n  #root .PDFViewer__flexColumnContainer___2v1Gx,\n  #modal_root .PDFViewer__flexColumnContainer___2v1Gx,\n  #popover .PDFViewer__flexColumnContainer___2v1Gx,\n  .PDFViewer__container___3ahDt .PDFViewer__flexColumnContainer___2v1Gx {\n    display: flex;\n    flex-direction: column; }\n  #root .PDFViewer__flexRowContainer___1zClf,\n  #modal_root .PDFViewer__flexRowContainer___1zClf,\n  #popover .PDFViewer__flexRowContainer___1zClf,\n  .PDFViewer__container___3ahDt .PDFViewer__flexRowContainer___1zClf {\n    display: flex;\n    flex-direction: row; }\n  #root .PDFViewer__scroll___37iSU,\n  #modal_root .PDFViewer__scroll___37iSU,\n  #popover .PDFViewer__scroll___37iSU,\n  .PDFViewer__container___3ahDt .PDFViewer__scroll___37iSU {\n    overflow: auto;\n    -webkit-overflow-scrolling: touch; }\n  #root .PDFViewer__listStyleDisc___1oYns,\n  #modal_root .PDFViewer__listStyleDisc___1oYns,\n  #popover .PDFViewer__listStyleDisc___1oYns,\n  .PDFViewer__container___3ahDt .PDFViewer__listStyleDisc___1oYns {\n    list-style-type: disc; }\n  #root .PDFViewer__standardPanelPadding___2pd5S,\n  #modal_root .PDFViewer__standardPanelPadding___2pd5S,\n  #popover .PDFViewer__standardPanelPadding___2pd5S,\n  .PDFViewer__container___3ahDt .PDFViewer__standardPanelPadding___2pd5S {\n    padding: 16px 24px 24px 24px; }\n  #root .PDFViewer__paddingNone___209UR,\n  #modal_root .PDFViewer__paddingNone___209UR,\n  #popover .PDFViewer__paddingNone___209UR,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingNone___209UR {\n    padding: 0; }\n  #root .PDFViewer__paddingXS___1wWNd,\n  #modal_root .PDFViewer__paddingXS___1wWNd,\n  #popover .PDFViewer__paddingXS___1wWNd,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingXS___1wWNd {\n    padding: 4px; }\n  #root .PDFViewer__paddingSmall___nJq_y,\n  #modal_root .PDFViewer__paddingSmall___nJq_y,\n  #popover .PDFViewer__paddingSmall___nJq_y,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingSmall___nJq_y {\n    padding: 8px; }\n  #root .PDFViewer__padding___3TT_D,\n  #modal_root .PDFViewer__padding___3TT_D,\n  #popover .PDFViewer__padding___3TT_D,\n  .PDFViewer__container___3ahDt .PDFViewer__padding___3TT_D {\n    padding: 16px; }\n  #root .PDFViewer__paddingLarge___QrbQ-,\n  #modal_root .PDFViewer__paddingLarge___QrbQ-,\n  #popover .PDFViewer__paddingLarge___QrbQ-,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingLarge___QrbQ- {\n    padding: 24px; }\n  #root .PDFViewer__paddingTopNone___1InI6,\n  #modal_root .PDFViewer__paddingTopNone___1InI6,\n  #popover .PDFViewer__paddingTopNone___1InI6,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingTopNone___1InI6 {\n    padding-top: 0; }\n  #root .PDFViewer__paddingTopXS___B_UQL,\n  #modal_root .PDFViewer__paddingTopXS___B_UQL,\n  #popover .PDFViewer__paddingTopXS___B_UQL,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingTopXS___B_UQL {\n    padding-top: 4px; }\n  #root .PDFViewer__paddingTopSmall___3c-Vn,\n  #modal_root .PDFViewer__paddingTopSmall___3c-Vn,\n  #popover .PDFViewer__paddingTopSmall___3c-Vn,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingTopSmall___3c-Vn {\n    padding-top: 8px; }\n  #root .PDFViewer__paddingTop___1NQTK,\n  #modal_root .PDFViewer__paddingTop___1NQTK,\n  #popover .PDFViewer__paddingTop___1NQTK,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingTop___1NQTK {\n    padding-top: 16px; }\n  #root .PDFViewer__paddingTopLarge___2lLl5,\n  #modal_root .PDFViewer__paddingTopLarge___2lLl5,\n  #popover .PDFViewer__paddingTopLarge___2lLl5,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingTopLarge___2lLl5 {\n    padding-top: 24px; }\n  #root .PDFViewer__paddingRightNone___MLB9_,\n  #modal_root .PDFViewer__paddingRightNone___MLB9_,\n  #popover .PDFViewer__paddingRightNone___MLB9_,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingRightNone___MLB9_ {\n    padding-right: 0; }\n  #root .PDFViewer__paddingRightXS___2OxIn,\n  #modal_root .PDFViewer__paddingRightXS___2OxIn,\n  #popover .PDFViewer__paddingRightXS___2OxIn,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingRightXS___2OxIn {\n    padding-right: 6px; }\n  #root .PDFViewer__paddingRightSmall___2azZg,\n  #modal_root .PDFViewer__paddingRightSmall___2azZg,\n  #popover .PDFViewer__paddingRightSmall___2azZg,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingRightSmall___2azZg {\n    padding-right: 8px; }\n  #root .PDFViewer__paddingRight___3i0yr,\n  #modal_root .PDFViewer__paddingRight___3i0yr,\n  #popover .PDFViewer__paddingRight___3i0yr,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingRight___3i0yr {\n    padding-right: 16px; }\n  #root .PDFViewer__paddingRightLarge___2sx6f,\n  #modal_root .PDFViewer__paddingRightLarge___2sx6f,\n  #popover .PDFViewer__paddingRightLarge___2sx6f,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingRightLarge___2sx6f {\n    padding-right: 24px; }\n  #root .PDFViewer__paddingBottomNone___A2ccv,\n  #modal_root .PDFViewer__paddingBottomNone___A2ccv,\n  #popover .PDFViewer__paddingBottomNone___A2ccv,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingBottomNone___A2ccv {\n    padding-bottom: 0; }\n  #root .PDFViewer__paddingBottomXS___3yUnS,\n  #modal_root .PDFViewer__paddingBottomXS___3yUnS,\n  #popover .PDFViewer__paddingBottomXS___3yUnS,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingBottomXS___3yUnS {\n    padding-bottom: 4px; }\n  #root .PDFViewer__paddingBottomSmall___W86GP,\n  #modal_root .PDFViewer__paddingBottomSmall___W86GP,\n  #popover .PDFViewer__paddingBottomSmall___W86GP,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingBottomSmall___W86GP {\n    padding-bottom: 8px; }\n  #root .PDFViewer__paddingBottom___k8xbD,\n  #modal_root .PDFViewer__paddingBottom___k8xbD,\n  #popover .PDFViewer__paddingBottom___k8xbD,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingBottom___k8xbD {\n    padding-bottom: 16px; }\n  #root .PDFViewer__paddingBottomLarge___2paSB,\n  #modal_root .PDFViewer__paddingBottomLarge___2paSB,\n  #popover .PDFViewer__paddingBottomLarge___2paSB,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingBottomLarge___2paSB {\n    padding-bottom: 24px; }\n  #root .PDFViewer__paddingLeftNone___3Lpg5,\n  #modal_root .PDFViewer__paddingLeftNone___3Lpg5,\n  #popover .PDFViewer__paddingLeftNone___3Lpg5,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingLeftNone___3Lpg5 {\n    padding-left: 0; }\n  #root .PDFViewer__paddingLeftXS___3kv1y,\n  #modal_root .PDFViewer__paddingLeftXS___3kv1y,\n  #popover .PDFViewer__paddingLeftXS___3kv1y,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingLeftXS___3kv1y {\n    padding-left: 4px; }\n  #root .PDFViewer__paddingLeftSmall___2LNBm,\n  #modal_root .PDFViewer__paddingLeftSmall___2LNBm,\n  #popover .PDFViewer__paddingLeftSmall___2LNBm,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingLeftSmall___2LNBm {\n    padding-left: 8px; }\n  #root .PDFViewer__paddingLeft___1_uYf,\n  #modal_root .PDFViewer__paddingLeft___1_uYf,\n  #popover .PDFViewer__paddingLeft___1_uYf,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingLeft___1_uYf {\n    padding-left: 16px; }\n  #root .PDFViewer__paddingLeftLarge___2nICe,\n  #modal_root .PDFViewer__paddingLeftLarge___2nICe,\n  #popover .PDFViewer__paddingLeftLarge___2nICe,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingLeftLarge___2nICe {\n    padding-left: 24px; }\n  #root .PDFViewer__paddingHorizontalSmall___2x4QF,\n  #modal_root .PDFViewer__paddingHorizontalSmall___2x4QF,\n  #popover .PDFViewer__paddingHorizontalSmall___2x4QF,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingHorizontalSmall___2x4QF {\n    padding-left: 8px;\n    padding-right: 8px; }\n  #root .PDFViewer__paddingHorizontal___9zL4L,\n  #modal_root .PDFViewer__paddingHorizontal___9zL4L,\n  #popover .PDFViewer__paddingHorizontal___9zL4L,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingHorizontal___9zL4L {\n    padding-left: 16px;\n    padding-right: 16px; }\n  #root .PDFViewer__paddingHorizontalLarge___mHQOj,\n  #modal_root .PDFViewer__paddingHorizontalLarge___mHQOj,\n  #popover .PDFViewer__paddingHorizontalLarge___mHQOj,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingHorizontalLarge___mHQOj {\n    padding-left: 24px;\n    padding-right: 24px; }\n  #root .PDFViewer__paddingVerticalSmall___1mRNn,\n  #modal_root .PDFViewer__paddingVerticalSmall___1mRNn,\n  #popover .PDFViewer__paddingVerticalSmall___1mRNn,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingVerticalSmall___1mRNn {\n    padding-top: 8px;\n    padding-bottom: 8px; }\n  #root .PDFViewer__paddingVertical___2Nal0,\n  #modal_root .PDFViewer__paddingVertical___2Nal0,\n  #popover .PDFViewer__paddingVertical___2Nal0,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingVertical___2Nal0 {\n    padding-top: 16px;\n    padding-bottom: 16px; }\n  #root .PDFViewer__paddingVerticalLarge___1vLCV,\n  #modal_root .PDFViewer__paddingVerticalLarge___1vLCV,\n  #popover .PDFViewer__paddingVerticalLarge___1vLCV,\n  .PDFViewer__container___3ahDt .PDFViewer__paddingVerticalLarge___1vLCV {\n    padding-top: 24px;\n    padding-bottom: 24px; }\n  #root .PDFViewer__marginNone___3swN_,\n  #modal_root .PDFViewer__marginNone___3swN_,\n  #popover .PDFViewer__marginNone___3swN_,\n  .PDFViewer__container___3ahDt .PDFViewer__marginNone___3swN_ {\n    margin: 0; }\n  #root .PDFViewer__marginSmall___1nR_m,\n  #modal_root .PDFViewer__marginSmall___1nR_m,\n  #popover .PDFViewer__marginSmall___1nR_m,\n  .PDFViewer__container___3ahDt .PDFViewer__marginSmall___1nR_m {\n    margin: 8px; }\n  #root .PDFViewer__marginLeftNone___23-V3,\n  #modal_root .PDFViewer__marginLeftNone___23-V3,\n  #popover .PDFViewer__marginLeftNone___23-V3,\n  .PDFViewer__container___3ahDt .PDFViewer__marginLeftNone___23-V3 {\n    margin-left: 0; }\n  #root .PDFViewer__marginLeftXS___1RbiZ,\n  #modal_root .PDFViewer__marginLeftXS___1RbiZ,\n  #popover .PDFViewer__marginLeftXS___1RbiZ,\n  .PDFViewer__container___3ahDt .PDFViewer__marginLeftXS___1RbiZ {\n    margin-left: 4px; }\n  #root .PDFViewer__marginLeftSmall___QGs93,\n  #modal_root .PDFViewer__marginLeftSmall___QGs93,\n  #popover .PDFViewer__marginLeftSmall___QGs93,\n  .PDFViewer__container___3ahDt .PDFViewer__marginLeftSmall___QGs93 {\n    margin-left: 8px; }\n  #root .PDFViewer__marginLeft___2rBYU,\n  #modal_root .PDFViewer__marginLeft___2rBYU,\n  #popover .PDFViewer__marginLeft___2rBYU,\n  .PDFViewer__container___3ahDt .PDFViewer__marginLeft___2rBYU {\n    margin-left: 16px; }\n  #root .PDFViewer__marginLeftLarge___32Xt3,\n  #modal_root .PDFViewer__marginLeftLarge___32Xt3,\n  #popover .PDFViewer__marginLeftLarge___32Xt3,\n  .PDFViewer__container___3ahDt .PDFViewer__marginLeftLarge___32Xt3 {\n    margin-left: 24px; }\n  #root .PDFViewer__marginRightNone___2_oHy,\n  #modal_root .PDFViewer__marginRightNone___2_oHy,\n  #popover .PDFViewer__marginRightNone___2_oHy,\n  .PDFViewer__container___3ahDt .PDFViewer__marginRightNone___2_oHy {\n    margin-right: 0; }\n  #root .PDFViewer__marginRightXS___1LjaA,\n  #modal_root .PDFViewer__marginRightXS___1LjaA,\n  #popover .PDFViewer__marginRightXS___1LjaA,\n  .PDFViewer__container___3ahDt .PDFViewer__marginRightXS___1LjaA {\n    margin-right: 4px; }\n  #root .PDFViewer__marginRightSmall___13D-Y, #root .PDFViewer__marginRightLeft___2TtFO,\n  #modal_root .PDFViewer__marginRightSmall___13D-Y,\n  #modal_root .PDFViewer__marginRightLeft___2TtFO,\n  #popover .PDFViewer__marginRightSmall___13D-Y,\n  #popover .PDFViewer__marginRightLeft___2TtFO,\n  .PDFViewer__container___3ahDt .PDFViewer__marginRightSmall___13D-Y,\n  .PDFViewer__container___3ahDt .PDFViewer__marginRightLeft___2TtFO {\n    margin-right: 8px; }\n  #root .PDFViewer__marginRight___2IWKm,\n  #modal_root .PDFViewer__marginRight___2IWKm,\n  #popover .PDFViewer__marginRight___2IWKm,\n  .PDFViewer__container___3ahDt .PDFViewer__marginRight___2IWKm {\n    margin-right: 16px; }\n  #root .PDFViewer__marginRightLarge___ctPcw,\n  #modal_root .PDFViewer__marginRightLarge___ctPcw,\n  #popover .PDFViewer__marginRightLarge___ctPcw,\n  .PDFViewer__container___3ahDt .PDFViewer__marginRightLarge___ctPcw {\n    margin-right: 24px; }\n  #root .PDFViewer__marginTopNone___1PVxv,\n  #modal_root .PDFViewer__marginTopNone___1PVxv,\n  #popover .PDFViewer__marginTopNone___1PVxv,\n  .PDFViewer__container___3ahDt .PDFViewer__marginTopNone___1PVxv {\n    margin-top: 0; }\n  #root .PDFViewer__marginTopXS___Z4NFq,\n  #modal_root .PDFViewer__marginTopXS___Z4NFq,\n  #popover .PDFViewer__marginTopXS___Z4NFq,\n  .PDFViewer__container___3ahDt .PDFViewer__marginTopXS___Z4NFq {\n    margin-top: 4px; }\n  #root .PDFViewer__marginTopSmall___91kN5,\n  #modal_root .PDFViewer__marginTopSmall___91kN5,\n  #popover .PDFViewer__marginTopSmall___91kN5,\n  .PDFViewer__container___3ahDt .PDFViewer__marginTopSmall___91kN5 {\n    margin-top: 8px; }\n  #root .PDFViewer__marginTop___28cwO,\n  #modal_root .PDFViewer__marginTop___28cwO,\n  #popover .PDFViewer__marginTop___28cwO,\n  .PDFViewer__container___3ahDt .PDFViewer__marginTop___28cwO {\n    margin-top: 16px; }\n  #root .PDFViewer__marginTopLarge___2sb5S,\n  #modal_root .PDFViewer__marginTopLarge___2sb5S,\n  #popover .PDFViewer__marginTopLarge___2sb5S,\n  .PDFViewer__container___3ahDt .PDFViewer__marginTopLarge___2sb5S {\n    margin-top: 24px; }\n  #root .PDFViewer__marginBottomNone___2GeFH,\n  #modal_root .PDFViewer__marginBottomNone___2GeFH,\n  #popover .PDFViewer__marginBottomNone___2GeFH,\n  .PDFViewer__container___3ahDt .PDFViewer__marginBottomNone___2GeFH {\n    margin-bottom: 0; }\n  #root .PDFViewer__marginBottomXS___1Qdmw,\n  #modal_root .PDFViewer__marginBottomXS___1Qdmw,\n  #popover .PDFViewer__marginBottomXS___1Qdmw,\n  .PDFViewer__container___3ahDt .PDFViewer__marginBottomXS___1Qdmw {\n    margin-bottom: 4px; }\n  #root .PDFViewer__marginBottomSmall___3ISFu,\n  #modal_root .PDFViewer__marginBottomSmall___3ISFu,\n  #popover .PDFViewer__marginBottomSmall___3ISFu,\n  .PDFViewer__container___3ahDt .PDFViewer__marginBottomSmall___3ISFu {\n    margin-bottom: 8px; }\n  #root .PDFViewer__marginBottom___1hQxl,\n  #modal_root .PDFViewer__marginBottom___1hQxl,\n  #popover .PDFViewer__marginBottom___1hQxl,\n  .PDFViewer__container___3ahDt .PDFViewer__marginBottom___1hQxl {\n    margin-bottom: 16px; }\n  #root .PDFViewer__marginBottomLarge___2WeD3,\n  #modal_root .PDFViewer__marginBottomLarge___2WeD3,\n  #popover .PDFViewer__marginBottomLarge___2WeD3,\n  .PDFViewer__container___3ahDt .PDFViewer__marginBottomLarge___2WeD3 {\n    margin-bottom: 24px; }\n  #root .PDFViewer__alignLeft___19ksX,\n  #modal_root .PDFViewer__alignLeft___19ksX,\n  #popover .PDFViewer__alignLeft___19ksX,\n  .PDFViewer__container___3ahDt .PDFViewer__alignLeft___19ksX {\n    text-align: left; }\n  #root .PDFViewer__alignCenter___24D04,\n  #modal_root .PDFViewer__alignCenter___24D04,\n  #popover .PDFViewer__alignCenter___24D04,\n  .PDFViewer__container___3ahDt .PDFViewer__alignCenter___24D04 {\n    text-align: center; }\n  #root .PDFViewer__alignRight___fs9Jr,\n  #modal_root .PDFViewer__alignRight___fs9Jr,\n  #popover .PDFViewer__alignRight___fs9Jr,\n  .PDFViewer__container___3ahDt .PDFViewer__alignRight___fs9Jr {\n    text-align: right; }\n  #root .PDFViewer__dividerLeft___3nc4c,\n  #modal_root .PDFViewer__dividerLeft___3nc4c,\n  #popover .PDFViewer__dividerLeft___3nc4c,\n  .PDFViewer__container___3ahDt .PDFViewer__dividerLeft___3nc4c {\n    border-left: 1px solid rgba(0, 0, 0, 0.15); }\n  #root .PDFViewer__dividerRight___1nfJ3,\n  #modal_root .PDFViewer__dividerRight___1nfJ3,\n  #popover .PDFViewer__dividerRight___1nfJ3,\n  .PDFViewer__container___3ahDt .PDFViewer__dividerRight___1nfJ3 {\n    border-right: 1px solid rgba(0, 0, 0, 0.15); }\n  #root .PDFViewer__dividerTop___2FMpw,\n  #modal_root .PDFViewer__dividerTop___2FMpw,\n  #popover .PDFViewer__dividerTop___2FMpw,\n  .PDFViewer__container___3ahDt .PDFViewer__dividerTop___2FMpw {\n    border-top: 1px solid rgba(0, 0, 0, 0.15); }\n  #root .PDFViewer__dividerBottom___3cBJt,\n  #modal_root .PDFViewer__dividerBottom___3cBJt,\n  #popover .PDFViewer__dividerBottom___3cBJt,\n  .PDFViewer__container___3ahDt .PDFViewer__dividerBottom___3cBJt {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  #root .PDFViewer__warning___3sszk,\n  #modal_root .PDFViewer__warning___3sszk,\n  #popover .PDFViewer__warning___3sszk,\n  .PDFViewer__container___3ahDt .PDFViewer__warning___3sszk {\n    color: #ff9101;\n    font-size: 12px; }\n  #root .PDFViewer__error___2wLB-,\n  #modal_root .PDFViewer__error___2wLB-,\n  #popover .PDFViewer__error___2wLB-,\n  .PDFViewer__container___3ahDt .PDFViewer__error___2wLB- {\n    color: #d32f2f;\n    font-size: 12px; }\n  #root .PDFViewer__maxWidth100___jBdkw,\n  #modal_root .PDFViewer__maxWidth100___jBdkw,\n  #popover .PDFViewer__maxWidth100___jBdkw,\n  .PDFViewer__container___3ahDt .PDFViewer__maxWidth100___jBdkw {\n    max-width: 100%; }\n  #root .PDFViewer__fitHeight___3mqxd,\n  #modal_root .PDFViewer__fitHeight___3mqxd,\n  #popover .PDFViewer__fitHeight___3mqxd,\n  .PDFViewer__container___3ahDt .PDFViewer__fitHeight___3mqxd {\n    height: fit-content; }\n  #root .PDFViewer__fullHeight___3j7rg,\n  #modal_root .PDFViewer__fullHeight___3j7rg,\n  #popover .PDFViewer__fullHeight___3j7rg,\n  .PDFViewer__container___3ahDt .PDFViewer__fullHeight___3j7rg {\n    height: 100%; }\n  #root .PDFViewer__clickable___27UW9,\n  #modal_root .PDFViewer__clickable___27UW9,\n  #popover .PDFViewer__clickable___27UW9,\n  .PDFViewer__container___3ahDt .PDFViewer__clickable___27UW9 {\n    cursor: pointer; }\n  #root .PDFViewer__mobilePaper___ZnCEC,\n  #modal_root .PDFViewer__mobilePaper___ZnCEC,\n  #popover .PDFViewer__mobilePaper___ZnCEC,\n  .PDFViewer__container___3ahDt .PDFViewer__mobilePaper___ZnCEC {\n    background-color: white;\n    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12); }\n  #root .PDFViewer__selectedPanel___3GVQ7,\n  #modal_root .PDFViewer__selectedPanel___3GVQ7,\n  #popover .PDFViewer__selectedPanel___3GVQ7,\n  .PDFViewer__container___3ahDt .PDFViewer__selectedPanel___3GVQ7 {\n    background-color: #fcfefc;\n    border: 1px solid #4caf5a; }\n  #root .PDFViewer__unselectedPanel___3Yszn,\n  #modal_root .PDFViewer__unselectedPanel___3Yszn,\n  #popover .PDFViewer__unselectedPanel___3Yszn,\n  .PDFViewer__container___3ahDt .PDFViewer__unselectedPanel___3Yszn {\n    background-color: inherit;\n    border: 1px solid transparent; }\n  #root .PDFViewer__noTextTransform___L6Jq1,\n  #modal_root .PDFViewer__noTextTransform___L6Jq1,\n  #popover .PDFViewer__noTextTransform___L6Jq1,\n  .PDFViewer__container___3ahDt .PDFViewer__noTextTransform___L6Jq1 {\n    text-transform: none; }\n  #root .PDFViewer__noWrap___yJE0H,\n  #modal_root .PDFViewer__noWrap___yJE0H,\n  #popover .PDFViewer__noWrap___yJE0H,\n  .PDFViewer__container___3ahDt .PDFViewer__noWrap___yJE0H {\n    white-space: nowrap; }\n  #root .PDFViewer__preWrap___giU7d,\n  #modal_root .PDFViewer__preWrap___giU7d,\n  #popover .PDFViewer__preWrap___giU7d,\n  .PDFViewer__container___3ahDt .PDFViewer__preWrap___giU7d {\n    white-space: pre-wrap; }\n  #root .PDFViewer__buttonSizeRegular___1h6YH,\n  #modal_root .PDFViewer__buttonSizeRegular___1h6YH,\n  #popover .PDFViewer__buttonSizeRegular___1h6YH,\n  .PDFViewer__container___3ahDt .PDFViewer__buttonSizeRegular___1h6YH {\n    height: 24px;\n    width: 24px; }\n  #root .PDFViewer__buttonSizeSmall___bCom2,\n  #modal_root .PDFViewer__buttonSizeSmall___bCom2,\n  #popover .PDFViewer__buttonSizeSmall___bCom2,\n  .PDFViewer__container___3ahDt .PDFViewer__buttonSizeSmall___bCom2 {\n    height: 16px;\n    width: 16px; }\n  #root .PDFViewer__buttonSizeLarge___2dvXU,\n  #modal_root .PDFViewer__buttonSizeLarge___2dvXU,\n  #popover .PDFViewer__buttonSizeLarge___2dvXU,\n  .PDFViewer__container___3ahDt .PDFViewer__buttonSizeLarge___2dvXU {\n    height: 32px;\n    width: 32px; }\n  #root .PDFViewer__clippedOverflow___UrMD3 > *,\n  #modal_root .PDFViewer__clippedOverflow___UrMD3 > *,\n  #popover .PDFViewer__clippedOverflow___UrMD3 > *,\n  .PDFViewer__container___3ahDt .PDFViewer__clippedOverflow___UrMD3 > * {\n    overflow: hidden;\n    text-overflow: ellipsis; }\n\n.PDFViewer__fluid___3CjeF {\n  display: flex; }\n  .PDFViewer__fluid___3CjeF > * {\n    align-self: baseline; }\n    .PDFViewer__fluid___3CjeF > * ~ * {\n      margin-left: 16px; }\n\n.PDFViewer__pdfContainer___Y3aUH {\n  height: 100%;\n  overflow: hidden;\n  position: relative; }\n\n.PDFViewer__pdfScroll___Sb42y {\n  overflow: auto;\n  background-image: linear-gradient(#616161, #424242); }\n\ndiv.PDFViewer__pageContainer___3nopu {\n  padding: 4px 8px;\n  width: fit-content;\n  margin: auto; }\n  div.PDFViewer__pageContainer___3nopu .PDFViewer__page___3iOXu {\n    display: inline-block; }\n\ndiv.PDFViewer__paper___vuR0S {\n  border-radius: 0px; }\n\ndiv.PDFViewer__buttonBar___25c80 {\n  background: white;\n  padding: 4px 8px;\n  width: 100%;\n  z-index: 1; }\n  div.PDFViewer__buttonBar___25c80 .PDFViewer__pageNumInput___1NxR- {\n    width: 40px; }\n  div.PDFViewer__buttonBar___25c80 .PDFViewer__totalPageNum___tbFkd {\n    font-size: 16px;\n    margin-bottom: -4px; }\n  div.PDFViewer__buttonBar___25c80 .PDFViewer__zoomSelect___5z8Ys {\n    width: 75px; }\n", ""]);

// exports
exports.locals = {
	"container": "PDFViewer__container___3ahDt",
	"flexNone": "PDFViewer__flexNone___KTp8f",
	"flexAuto": "PDFViewer__flexAuto___yFoqE",
	"flex": "PDFViewer__flex___3Ljr0",
	"hidden": "PDFViewer__hidden___7PQS1",
	"inlineFlex": "PDFViewer__inlineFlex___1k6mF",
	"block": "PDFViewer__block___2zK-2",
	"inlineBlock": "PDFViewer__inlineBlock___CV4pP",
	"inline": "PDFViewer__inline___2SVBO",
	"relative": "PDFViewer__relative___1gVnS",
	"absolute": "PDFViewer__absolute___3pGU6",
	"fitAbsolute": "PDFViewer__fitAbsolute___1rjCf",
	"floatLeft": "PDFViewer__floatLeft___2GgsU",
	"floatRight": "PDFViewer__floatRight___2dIGa",
	"clearBoth": "PDFViewer__clearBoth___1yCWG",
	"flexBasis0": "PDFViewer__flexBasis0___36T9P",
	"flexBasisAuto": "PDFViewer__flexBasisAuto___1Ed39",
	"fullWidth": "PDFViewer__fullWidth___3t_i4",
	"minWidthNone": "PDFViewer__minWidthNone___37ZG_",
	"resetWidth": "PDFViewer__resetWidth___1fz2o",
	"flexGrow": "PDFViewer__flexGrow___2rYI8",
	"flexGrowNone": "PDFViewer__flexGrowNone___101mg",
	"flexShrink": "PDFViewer__flexShrink___1vnbC",
	"flexShrinkNone": "PDFViewer__flexShrinkNone___L7Li9",
	"flexNoShrink": "PDFViewer__flexNoShrink___5GLYI",
	"centerContent": "PDFViewer__centerContent___9C5xW",
	"spaceContentBetween": "PDFViewer__spaceContentBetween___gUiLK",
	"spaceContentAround": "PDFViewer__spaceContentAround___1SOkX",
	"centerVertically": "PDFViewer__centerVertically___igaMC",
	"centerHorizontally": "PDFViewer__centerHorizontally___2uRRS",
	"topAlign": "PDFViewer__topAlign___tKDKr",
	"alignItemsFlexStart": "PDFViewer__alignItemsFlexStart___VNaYm",
	"alignItemsFlexEnd": "PDFViewer__alignItemsFlexEnd___2QeIw",
	"flexColumnContainer": "PDFViewer__flexColumnContainer___2v1Gx",
	"flexRowContainer": "PDFViewer__flexRowContainer___1zClf",
	"scroll": "PDFViewer__scroll___37iSU",
	"listStyleDisc": "PDFViewer__listStyleDisc___1oYns",
	"standardPanelPadding": "PDFViewer__standardPanelPadding___2pd5S",
	"paddingNone": "PDFViewer__paddingNone___209UR",
	"paddingXS": "PDFViewer__paddingXS___1wWNd",
	"paddingSmall": "PDFViewer__paddingSmall___nJq_y",
	"padding": "PDFViewer__padding___3TT_D",
	"paddingLarge": "PDFViewer__paddingLarge___QrbQ-",
	"paddingTopNone": "PDFViewer__paddingTopNone___1InI6",
	"paddingTopXS": "PDFViewer__paddingTopXS___B_UQL",
	"paddingTopSmall": "PDFViewer__paddingTopSmall___3c-Vn",
	"paddingTop": "PDFViewer__paddingTop___1NQTK",
	"paddingTopLarge": "PDFViewer__paddingTopLarge___2lLl5",
	"paddingRightNone": "PDFViewer__paddingRightNone___MLB9_",
	"paddingRightXS": "PDFViewer__paddingRightXS___2OxIn",
	"paddingRightSmall": "PDFViewer__paddingRightSmall___2azZg",
	"paddingRight": "PDFViewer__paddingRight___3i0yr",
	"paddingRightLarge": "PDFViewer__paddingRightLarge___2sx6f",
	"paddingBottomNone": "PDFViewer__paddingBottomNone___A2ccv",
	"paddingBottomXS": "PDFViewer__paddingBottomXS___3yUnS",
	"paddingBottomSmall": "PDFViewer__paddingBottomSmall___W86GP",
	"paddingBottom": "PDFViewer__paddingBottom___k8xbD",
	"paddingBottomLarge": "PDFViewer__paddingBottomLarge___2paSB",
	"paddingLeftNone": "PDFViewer__paddingLeftNone___3Lpg5",
	"paddingLeftXS": "PDFViewer__paddingLeftXS___3kv1y",
	"paddingLeftSmall": "PDFViewer__paddingLeftSmall___2LNBm",
	"paddingLeft": "PDFViewer__paddingLeft___1_uYf",
	"paddingLeftLarge": "PDFViewer__paddingLeftLarge___2nICe",
	"paddingHorizontalSmall": "PDFViewer__paddingHorizontalSmall___2x4QF",
	"paddingHorizontal": "PDFViewer__paddingHorizontal___9zL4L",
	"paddingHorizontalLarge": "PDFViewer__paddingHorizontalLarge___mHQOj",
	"paddingVerticalSmall": "PDFViewer__paddingVerticalSmall___1mRNn",
	"paddingVertical": "PDFViewer__paddingVertical___2Nal0",
	"paddingVerticalLarge": "PDFViewer__paddingVerticalLarge___1vLCV",
	"marginNone": "PDFViewer__marginNone___3swN_",
	"marginSmall": "PDFViewer__marginSmall___1nR_m",
	"marginLeftNone": "PDFViewer__marginLeftNone___23-V3",
	"marginLeftXS": "PDFViewer__marginLeftXS___1RbiZ",
	"marginLeftSmall": "PDFViewer__marginLeftSmall___QGs93",
	"marginLeft": "PDFViewer__marginLeft___2rBYU",
	"marginLeftLarge": "PDFViewer__marginLeftLarge___32Xt3",
	"marginRightNone": "PDFViewer__marginRightNone___2_oHy",
	"marginRightXS": "PDFViewer__marginRightXS___1LjaA",
	"marginRightSmall": "PDFViewer__marginRightSmall___13D-Y",
	"marginRightLeft": "PDFViewer__marginRightLeft___2TtFO",
	"marginRight": "PDFViewer__marginRight___2IWKm",
	"marginRightLarge": "PDFViewer__marginRightLarge___ctPcw",
	"marginTopNone": "PDFViewer__marginTopNone___1PVxv",
	"marginTopXS": "PDFViewer__marginTopXS___Z4NFq",
	"marginTopSmall": "PDFViewer__marginTopSmall___91kN5",
	"marginTop": "PDFViewer__marginTop___28cwO",
	"marginTopLarge": "PDFViewer__marginTopLarge___2sb5S",
	"marginBottomNone": "PDFViewer__marginBottomNone___2GeFH",
	"marginBottomXS": "PDFViewer__marginBottomXS___1Qdmw",
	"marginBottomSmall": "PDFViewer__marginBottomSmall___3ISFu",
	"marginBottom": "PDFViewer__marginBottom___1hQxl",
	"marginBottomLarge": "PDFViewer__marginBottomLarge___2WeD3",
	"alignLeft": "PDFViewer__alignLeft___19ksX",
	"alignCenter": "PDFViewer__alignCenter___24D04",
	"alignRight": "PDFViewer__alignRight___fs9Jr",
	"dividerLeft": "PDFViewer__dividerLeft___3nc4c",
	"dividerRight": "PDFViewer__dividerRight___1nfJ3",
	"dividerTop": "PDFViewer__dividerTop___2FMpw",
	"dividerBottom": "PDFViewer__dividerBottom___3cBJt",
	"warning": "PDFViewer__warning___3sszk",
	"error": "PDFViewer__error___2wLB-",
	"maxWidth100": "PDFViewer__maxWidth100___jBdkw",
	"fitHeight": "PDFViewer__fitHeight___3mqxd",
	"fullHeight": "PDFViewer__fullHeight___3j7rg",
	"clickable": "PDFViewer__clickable___27UW9",
	"mobilePaper": "PDFViewer__mobilePaper___ZnCEC",
	"selectedPanel": "PDFViewer__selectedPanel___3GVQ7",
	"unselectedPanel": "PDFViewer__unselectedPanel___3Yszn",
	"noTextTransform": "PDFViewer__noTextTransform___L6Jq1",
	"noWrap": "PDFViewer__noWrap___yJE0H",
	"preWrap": "PDFViewer__preWrap___giU7d",
	"buttonSizeRegular": "PDFViewer__buttonSizeRegular___1h6YH",
	"buttonSizeSmall": "PDFViewer__buttonSizeSmall___bCom2",
	"buttonSizeLarge": "PDFViewer__buttonSizeLarge___2dvXU",
	"clippedOverflow": "PDFViewer__clippedOverflow___UrMD3",
	"fluid": "PDFViewer__fluid___3CjeF",
	"pdfContainer": "PDFViewer__pdfContainer___Y3aUH",
	"pdfScroll": "PDFViewer__pdfScroll___Sb42y",
	"pageContainer": "PDFViewer__pageContainer___3nopu",
	"page": "PDFViewer__page___3iOXu",
	"paper": "PDFViewer__paper___vuR0S",
	"buttonBar": "PDFViewer__buttonBar___25c80",
	"pageNumInput": "PDFViewer__pageNumInput___1NxR-",
	"totalPageNum": "PDFViewer__totalPageNum___tbFkd",
	"zoomSelect": "PDFViewer__zoomSelect___5z8Ys"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Panel/styles.scss":
/*!************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Panel/styles.scss ***!
  \************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Panel__root___2bE8v {\n  position: relative;\n  /* Base header styles */\n  /* Base header styles */\n  /* Types */\n  /* Types */\n  /* Variants */\n  /* Variants */ }\n  .Panel__root___2bE8v .Panel__header___19Yeh {\n    min-height: auto; }\n    .Panel__root___2bE8v .Panel__header___19Yeh .Panel__icon___3-Eed {\n      vertical-align: bottom;\n      margin-right: 4px; }\n    .Panel__root___2bE8v .Panel__header___19Yeh .Panel__headerActions___6CJYJ {\n      display: flex;\n      height: 24px;\n      min-height: 24px;\n      align-self: flex-start;\n      align-items: center; }\n  .Panel__root___2bE8v.Panel__primary___3AuuM .Panel__header___19Yeh {\n    padding: 16px 24px; }\n  .Panel__root___2bE8v.Panel__secondary___32Pyq .Panel__header___19Yeh {\n    padding: 12px 16px; }\n    .Panel__root___2bE8v.Panel__secondary___32Pyq .Panel__header___19Yeh .Panel__title___18N_1 {\n      font-size: 1rem;\n      font-weight: 500;\n      font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n      line-height: 1.5rem;\n      color: rgba(0, 0, 0, 0.87); }\n  .Panel__root___2bE8v.Panel__secondary___32Pyq .Panel__content___1zndv {\n    padding: 16px; }\n    .Panel__root___2bE8v.Panel__secondary___32Pyq .Panel__content___1zndv:empty {\n      padding-top: 0;\n      padding-bottom: 0; }\n  .Panel__root___2bE8v.Panel__tertiary___4uddz .Panel__header___19Yeh {\n    padding: 8px 16px; }\n  .Panel__root___2bE8v.Panel__tertiary___4uddz .Panel__expandButton___3J9ai {\n    margin-left: -16px;\n    margin-top: -16px;\n    margin-bottom: -16px; }\n    .Panel__root___2bE8v.Panel__tertiary___4uddz .Panel__expandButton___3J9ai:hover {\n      background-color: transparent; }\n  .Panel__root___2bE8v.Panel__tertiary___4uddz .Panel__title___18N_1 {\n    text-transform: uppercase;\n    font-size: 1rem;\n    font-weight: 400;\n    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n    line-height: 1.5em;\n    color: rgba(0, 0, 0, 0.87);\n    font-size: 0.8125rem;\n    letter-spacing: 0.3px; }\n  .Panel__root___2bE8v.Panel__plain___124fE.Panel__expandable___LTT6z .Panel__content___1zndv {\n    border-top: 1px solid #e0e0e0; }\n    .Panel__root___2bE8v.Panel__plain___124fE.Panel__expandable___LTT6z .Panel__content___1zndv:empty {\n      border-top: none; }\n  .Panel__root___2bE8v.Panel__brandGreen___3lyRH > .Panel__header___19Yeh {\n    background: #53bac3; }\n    .Panel__root___2bE8v.Panel__brandGreen___3lyRH > .Panel__header___19Yeh h1, .Panel__root___2bE8v.Panel__brandGreen___3lyRH > .Panel__header___19Yeh h2, .Panel__root___2bE8v.Panel__brandGreen___3lyRH > .Panel__header___19Yeh h3, .Panel__root___2bE8v.Panel__brandGreen___3lyRH > .Panel__header___19Yeh h4 {\n      color: #fff; }\n  .Panel__root___2bE8v.Panel__brandGreen___3lyRH.Panel__secondary___32Pyq .Panel__header___19Yeh h1, .Panel__root___2bE8v.Panel__brandGreen___3lyRH.Panel__secondary___32Pyq .Panel__header___19Yeh h2, .Panel__root___2bE8v.Panel__brandGreen___3lyRH.Panel__secondary___32Pyq .Panel__header___19Yeh h3, .Panel__root___2bE8v.Panel__brandGreen___3lyRH.Panel__secondary___32Pyq .Panel__header___19Yeh h4 {\n    color: #fff; }\n  .Panel__root___2bE8v.Panel__brandGreen___3lyRH .Panel__expandButton___3J9ai:hover {\n    color: #023c44; }\n  .Panel__root___2bE8v.Panel__grey___Q7d1h > .Panel__header___19Yeh {\n    background: #f5f5f5; }\n  .Panel__root___2bE8v.Panel__lightGrey___1eKi1 > .Panel__header___19Yeh {\n    background: #fafafa; }\n  .Panel__root___2bE8v .Panel__lastButtonIsIcon___2LGu8 {\n    margin-right: -4px; }\n  .Panel__root___2bE8v .Panel__bodyWTitle___3UbQt {\n    padding-top: 0; }\n  .Panel__root___2bE8v .Panel__content___1zndv {\n    padding-left: 24px;\n    padding-right: 24px; }\n  .Panel__root___2bE8v .Panel__fullWidthContent___3Qj-9 {\n    padding: 0; }\n    .Panel__root___2bE8v .Panel__fullWidthContent___3Qj-9:last-child {\n      padding: 0; }\n  .Panel__root___2bE8v .Panel__expandButton___3J9ai {\n    transition: transform 150ms;\n    transform: rotate(0deg);\n    margin-left: -8px;\n    margin-top: -8px;\n    margin-bottom: -8px; }\n  .Panel__root___2bE8v .Panel__expanded___3oGl4 {\n    transform: rotate(180deg); }\n  .Panel__root___2bE8v .Panel__panelActions___2YVY2 {\n    padding: 24px;\n    padding-top: 0; }\n  @media screen and (max-width: 600px) {\n    .Panel__root___2bE8v .Panel__header___19Yeh {\n      padding: 8px 16px; }\n    .Panel__root___2bE8v .Panel__content___1zndv {\n      padding-left: 16px;\n      padding-right: 16px; }\n    .Panel__root___2bE8v .Panel__panelActions___2YVY2 {\n      padding: 0 16px 8px 16px; } }\n", ""]);

// exports
exports.locals = {
	"root": "Panel__root___2bE8v",
	"header": "Panel__header___19Yeh",
	"icon": "Panel__icon___3-Eed",
	"headerActions": "Panel__headerActions___6CJYJ",
	"primary": "Panel__primary___3AuuM",
	"secondary": "Panel__secondary___32Pyq",
	"title": "Panel__title___18N_1",
	"content": "Panel__content___1zndv",
	"tertiary": "Panel__tertiary___4uddz",
	"expandButton": "Panel__expandButton___3J9ai",
	"plain": "Panel__plain___124fE",
	"expandable": "Panel__expandable___LTT6z",
	"brandGreen": "Panel__brandGreen___3lyRH",
	"grey": "Panel__grey___Q7d1h",
	"lightGrey": "Panel__lightGrey___1eKi1",
	"lastButtonIsIcon": "Panel__lastButtonIsIcon___2LGu8",
	"bodyWTitle": "Panel__bodyWTitle___3UbQt",
	"fullWidthContent": "Panel__fullWidthContent___3Qj-9",
	"expanded": "Panel__expanded___3oGl4",
	"panelActions": "Panel__panelActions___2YVY2"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Popper/styles.scss":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Popper/styles.scss ***!
  \*************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Popper__popper___1p6Ab {\n  z-index: 1500; }\n", ""]);

// exports
exports.locals = {
	"popper": "Popper__popper___1p6Ab"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/PreviewList/styles.scss":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/PreviewList/styles.scss ***!
  \******************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.PreviewList__root___3MzJz {\n  height: 100%; }\n  .PreviewList__root___3MzJz .PreviewList__list___3BnMx {\n    height: 100%; }\n  .PreviewList__root___3MzJz .PreviewList__secondaryAction___H2gVD {\n    top: 8px;\n    transform: none; }\n    .PreviewList__root___3MzJz .PreviewList__secondaryAction___H2gVD .PreviewList__contextButton___3BZyJ {\n      font-size: inherit; }\n  .PreviewList__root___3MzJz .PreviewList__listHeader___1xuDL {\n    height: 56px; }\n  .PreviewList__root___3MzJz .PreviewList__tabLabel___2W5UJ {\n    text-transform: none; }\n  .PreviewList__root___3MzJz .PreviewList__listItem___2ESEl {\n    align-items: flex-start;\n    padding: 12px 24px 12px 16px; }\n  .PreviewList__root___3MzJz .PreviewList__preview___3lpc1 {\n    height: 100%; }\n  .PreviewList__root___3MzJz .PreviewList__previewHeader___fPNFh {\n    height: 56px; }\n    .PreviewList__root___3MzJz .PreviewList__previewHeader___fPNFh svg {\n      margin-left: 2px;\n      margin-top: 2px; }\n  .PreviewList__root___3MzJz .PreviewList__statusIcon___1_uzi {\n    position: relative;\n    padding-left: 24px; }\n  .PreviewList__root___3MzJz .PreviewList__statusWrapper___1dxnp {\n    position: relative;\n    padding-top: 4px; }\n  .PreviewList__root___3MzJz .PreviewList__icon___3KHiH {\n    margin-top: 2px; }\n  .PreviewList__root___3MzJz div.PreviewList__listTextPad___3vPYi {\n    padding-left: 8px; }\n\n.PreviewList__headerIcon___1cCjf {\n  margin-right: 4px; }\n\n.PreviewList__pagedRoot___2BDuY {\n  flex: auto;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  overflow: auto; }\n  .PreviewList__pagedRoot___2BDuY .PreviewList__loadingDiv___2yXyf {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 2px;\n    width: 100%; }\n  .PreviewList__pagedRoot___2BDuY .PreviewList__pagination___2WZfF {\n    flex: none;\n    overflow: auto;\n    margin: 0; }\n\nspan.PreviewList__secondaryText___5-VD0 {\n  letter-spacing: normal; }\n", ""]);

// exports
exports.locals = {
	"root": "PreviewList__root___3MzJz",
	"list": "PreviewList__list___3BnMx",
	"secondaryAction": "PreviewList__secondaryAction___H2gVD",
	"contextButton": "PreviewList__contextButton___3BZyJ",
	"listHeader": "PreviewList__listHeader___1xuDL",
	"tabLabel": "PreviewList__tabLabel___2W5UJ",
	"listItem": "PreviewList__listItem___2ESEl",
	"preview": "PreviewList__preview___3lpc1",
	"previewHeader": "PreviewList__previewHeader___fPNFh",
	"statusIcon": "PreviewList__statusIcon___1_uzi",
	"statusWrapper": "PreviewList__statusWrapper___1dxnp",
	"icon": "PreviewList__icon___3KHiH",
	"listTextPad": "PreviewList__listTextPad___3vPYi",
	"headerIcon": "PreviewList__headerIcon___1cCjf",
	"pagedRoot": "PreviewList__pagedRoot___2BDuY",
	"loadingDiv": "PreviewList__loadingDiv___2yXyf",
	"pagination": "PreviewList__pagination___2WZfF",
	"secondaryText": "PreviewList__secondaryText___5-VD0"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/RichTextEditor/styles.scss":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/RichTextEditor/styles.scss ***!
  \*********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.RichTextEditor__root___Mggh2 ul {\n  list-style-type: disc; }\n\n.RichTextEditor__root___Mggh2 ol {\n  list-style-type: decimal; }\n\n.RichTextEditor__editor___2mwOb {\n  border: 1px solid rgba(0, 0, 0, 0.54);\n  min-height: 6em;\n  max-height: 300px;\n  padding: 8px;\n  overflow: auto; }\n  .RichTextEditor__editor___2mwOb.RichTextEditor__readOnly___2MUGw {\n    border: 1px solid rgba(10, 10, 10, 0.42);\n    opacity: 0.54; }\n\n.RichTextEditor__toolbar___q6TF0 {\n  padding-top: 8px; }\n\n.RichTextEditor__image___34Oqk.RichTextEditor__focus___2PlAh {\n  box-shadow: 0 0 0 2px #53bac3; }\n\n.RichTextEditor__imgSizeInput___S9Uja {\n  width: 80px; }\n", ""]);

// exports
exports.locals = {
	"root": "RichTextEditor__root___Mggh2",
	"editor": "RichTextEditor__editor___2mwOb",
	"readOnly": "RichTextEditor__readOnly___2MUGw",
	"toolbar": "RichTextEditor__toolbar___q6TF0",
	"image": "RichTextEditor__image___34Oqk",
	"focus": "RichTextEditor__focus___2PlAh",
	"imgSizeInput": "RichTextEditor__imgSizeInput___S9Uja"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/SearchInput/searchInput.scss":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/SearchInput/searchInput.scss ***!
  \***********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.SearchInput__root___3_x8g {\n  position: relative; }\n  .SearchInput__root___3_x8g .SearchInput__inputContainer___2_ccS {\n    width: 100%; }\n    .SearchInput__root___3_x8g .SearchInput__inputContainer___2_ccS .SearchInput__input___jgbi_ {\n      width: 100%; }\n      .SearchInput__root___3_x8g .SearchInput__inputContainer___2_ccS .SearchInput__input___jgbi_ .SearchInput__icon___2Fl2i {\n        margin-top: 4px; }\n      .SearchInput__root___3_x8g .SearchInput__inputContainer___2_ccS .SearchInput__input___jgbi_ input {\n        padding: 8px 0px; }\n\n.SearchInput__searchResult___Lam6W {\n  position: absolute;\n  z-index: 10;\n  width: 100%;\n  top: 100%; }\n", ""]);

// exports
exports.locals = {
	"root": "SearchInput__root___3_x8g",
	"inputContainer": "SearchInput__inputContainer___2_ccS",
	"input": "SearchInput__input___jgbi_",
	"icon": "SearchInput__icon___2Fl2i",
	"searchResult": "SearchInput__searchResult___Lam6W"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/SearchSelectInput/styles.scss":
/*!************************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/SearchSelectInput/styles.scss ***!
  \************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.SearchSelectInput__root___2V7Py {\n  max-height: 300px;\n  max-width: 700px;\n  min-width: 300px;\n  position: unset;\n  overflow: auto; }\n  .SearchSelectInput__root___2V7Py .SearchSelectInput__selected___301UG {\n    background-color: #eee; }\n  .SearchSelectInput__root___2V7Py .SearchSelectInput__not_found___3sK1U {\n    padding: 8px 16px;\n    text-transform: none; }\n  .SearchSelectInput__root___2V7Py li:hover .flow-control,\n  .SearchSelectInput__root___2V7Py .SearchSelectInput__selected___301UG .flow-control {\n    white-space: normal; }\n\n.SearchSelectInput__container___QUuyC {\n  display: flex;\n  flex-wrap: wrap; }\n\n.SearchSelectInput__icon___1VsBs {\n  display: flex;\n  align-self: flex-end;\n  order: -1;\n  color: rgba(0, 0, 0, 0.54); }\n\n.SearchSelectInput__loader___34mOQ {\n  margin: 2px 2px 2px 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  order: -1; }\n", ""]);

// exports
exports.locals = {
	"root": "SearchSelectInput__root___2V7Py",
	"selected": "SearchSelectInput__selected___301UG",
	"not_found": "SearchSelectInput__not_found___3sK1U",
	"container": "SearchSelectInput__container___QUuyC",
	"icon": "SearchSelectInput__icon___1VsBs",
	"loader": "SearchSelectInput__loader___34mOQ"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/SearchSelectPopperInput/styles.scss":
/*!******************************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/SearchSelectPopperInput/styles.scss ***!
  \******************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.SearchSelectPopperInput__root___ck__B {\n  max-height: 300px;\n  max-width: 700px;\n  min-width: 300px;\n  position: unset;\n  overflow: auto; }\n  .SearchSelectPopperInput__root___ck__B .SearchSelectPopperInput__selected___fhMee {\n    background-color: #eee; }\n  .SearchSelectPopperInput__root___ck__B .SearchSelectPopperInput__not_found___Eadyw {\n    padding: 8px 16px;\n    text-transform: none; }\n  .SearchSelectPopperInput__root___ck__B li:hover .flow-control,\n  .SearchSelectPopperInput__root___ck__B .SearchSelectPopperInput__selected___fhMee .flow-control {\n    white-space: normal; }\n\n.SearchSelectPopperInput__container___3w-G0 {\n  display: flex;\n  flex-wrap: wrap; }\n\n.SearchSelectPopperInput__icon___20qJy {\n  display: flex;\n  align-self: flex-end;\n  order: -1;\n  color: rgba(0, 0, 0, 0.54); }\n\n.SearchSelectPopperInput__loader___3QpYt {\n  margin: 2px 2px 2px 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  order: -1; }\n", ""]);

// exports
exports.locals = {
	"root": "SearchSelectPopperInput__root___ck__B",
	"selected": "SearchSelectPopperInput__selected___fhMee",
	"not_found": "SearchSelectPopperInput__not_found___Eadyw",
	"container": "SearchSelectPopperInput__container___3w-G0",
	"icon": "SearchSelectPopperInput__icon___20qJy",
	"loader": "SearchSelectPopperInput__loader___3QpYt"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/StatusBadge/styles.scss":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/StatusBadge/styles.scss ***!
  \******************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.StatusBadge__root___1b6iO {\n  padding: 4px;\n  border-radius: 3px; }\n  .StatusBadge__root___1b6iO .StatusBadge__icon___35d2I {\n    margin-right: 4px; }\n  .StatusBadge__root___1b6iO.red {\n    background: #fae6e6; }\n    .StatusBadge__root___1b6iO.red .StatusBadge__label___QecPT {\n      color: #bf1212;\n      white-space: nowrap; }\n    .StatusBadge__root___1b6iO.red svg {\n      color: #bf1212; }\n  .StatusBadge__root___1b6iO.orange {\n    background: #fff2e0; }\n    .StatusBadge__root___1b6iO.orange .StatusBadge__label___QecPT {\n      color: #ff6200;\n      white-space: nowrap; }\n    .StatusBadge__root___1b6iO.orange svg {\n      color: #ff6200; }\n  .StatusBadge__root___1b6iO.yellow {\n    background: #fff9c1; }\n    .StatusBadge__root___1b6iO.yellow .StatusBadge__label___QecPT {\n      color: #B9BA00;\n      white-space: nowrap; }\n    .StatusBadge__root___1b6iO.yellow svg {\n      color: #B9BA00; }\n  .StatusBadge__root___1b6iO.blue {\n    background: #e9f2fc; }\n    .StatusBadge__root___1b6iO.blue .StatusBadge__label___QecPT {\n      color: #2161cf;\n      white-space: nowrap; }\n    .StatusBadge__root___1b6iO.blue svg {\n      color: #2161cf; }\n  .StatusBadge__root___1b6iO.green {\n    background: #eaf5eb; }\n    .StatusBadge__root___1b6iO.green .StatusBadge__label___QecPT {\n      color: #24862e;\n      white-space: nowrap; }\n    .StatusBadge__root___1b6iO.green svg {\n      color: #24862e; }\n  .StatusBadge__root___1b6iO.grey {\n    background: #f5f5f5; }\n    .StatusBadge__root___1b6iO.grey .StatusBadge__label___QecPT {\n      color: rgba(0, 0, 0, 0.54);\n      white-space: nowrap; }\n    .StatusBadge__root___1b6iO.grey svg {\n      color: rgba(0, 0, 0, 0.54); }\n", ""]);

// exports
exports.locals = {
	"root": "StatusBadge__root___1b6iO",
	"icon": "StatusBadge__icon___35d2I",
	"label": "StatusBadge__label___QecPT"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tabs/Tab.scss":
/*!********************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tabs/Tab.scss ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Tabs__root___2aCre .Tabs__labelContainer___bsSI3 {\n  line-height: 36px;\n  letter-spacing: 0px;\n  padding: 8px 16px;\n  font-weight: 500; }\n", ""]);

// exports
exports.locals = {
	"root": "Tabs__root___2aCre",
	"labelContainer": "Tabs__labelContainer___bsSI3"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tabs/Tabs.scss":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tabs/Tabs.scss ***!
  \*********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Tabs__root___dcgMS.Tabs__reset___3N-aT {\n  margin-bottom: 0;\n  position: relative; }\n  .Tabs__root___dcgMS.Tabs__reset___3N-aT.Tabs__divider___3Fx8f {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  .Tabs__root___dcgMS.Tabs__reset___3N-aT.Tabs__withMargin___27ROO {\n    margin-top: 8px;\n    margin-bottom: 12px; }\n  .Tabs__root___dcgMS.Tabs__reset___3N-aT .gtu-tab {\n    opacity: 1;\n    text-transform: none;\n    font-size: 13px;\n    padding: 2px;\n    min-height: 56px;\n    min-width: unset;\n    max-width: none;\n    margin: 0px;\n    flex-shrink: 0; }\n    .Tabs__root___dcgMS.Tabs__reset___3N-aT .gtu-tab.selected-true {\n      color: #119aab; }\n    .Tabs__root___dcgMS.Tabs__reset___3N-aT .gtu-tab.selected-false {\n      color: rgba(0, 0, 0, 0.54); }\n      .Tabs__root___dcgMS.Tabs__reset___3N-aT .gtu-tab.selected-false:hover {\n        background-color: transparent;\n        color: #119aab; }\n\n.Tabs__root___dcgMS.Tabs__fullWidth___EY_8E button[role='tab'] {\n  flex-grow: 1; }\n\n.Tabs__root___dcgMS.Tabs__secondary___2knA5 .gtu-tab {\n  min-width: 50px; }\n  .Tabs__root___dcgMS.Tabs__secondary___2knA5 .gtu-tab.selected-true {\n    background-color: #edF8F9; }\n\n.Tabs__root___dcgMS div.Tabs__scrollButtons___Wi_sX {\n  display: none; }\n\n.Tabs__root___dcgMS button.Tabs__scrollButtons___Wi_sX {\n  position: absolute;\n  color: rgba(0, 0, 0, 0.54);\n  z-index: 1;\n  height: 100%;\n  padding: 0 8px;\n  width: auto; }\n  .Tabs__root___dcgMS button.Tabs__scrollButtons___Wi_sX:first-child {\n    left: 0;\n    background: linear-gradient(to right, #fff 75%, rgba(255, 255, 255, 0)); }\n  .Tabs__root___dcgMS button.Tabs__scrollButtons___Wi_sX:last-child {\n    right: 0;\n    background: linear-gradient(to left, #fff 75%, rgba(255, 255, 255, 0)); }\n\n.Tabs__root___dcgMS span.Tabs__indicator___dxOmb {\n  background-color: #119aab; }\n", ""]);

// exports
exports.locals = {
	"root": "Tabs__root___dcgMS",
	"reset": "Tabs__reset___3N-aT",
	"divider": "Tabs__divider___3Fx8f",
	"withMargin": "Tabs__withMargin___27ROO",
	"fullWidth": "Tabs__fullWidth___EY_8E",
	"secondary": "Tabs__secondary___2knA5",
	"scrollButtons": "Tabs__scrollButtons___Wi_sX",
	"indicator": "Tabs__indicator___dxOmb"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tabs/TabsAndButtons.scss":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tabs/TabsAndButtons.scss ***!
  \*******************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Tabs__root___jzEJF {\n  margin-top: 8px;\n  margin-bottom: 12px;\n  position: relative;\n  /*\n    we draw a fixed positioned bottom border when use the tabsAndButtons\n    since we want the underline on the buttons as well\n    but we want to hide the underline when buttons wrap to the next line\n  */ }\n  .Tabs__root___jzEJF.Tabs__dense___hxaP3 {\n    margin-top: 0;\n    margin-bottom: 0; }\n  .Tabs__root___jzEJF:after {\n    content: '';\n    width: 100%;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    position: absolute;\n    left: 0;\n    margin-top: 56px; }\n  .Tabs__root___jzEJF .Tabs__tabs___3_MFP .gtu-tabs {\n    border-bottom: 1px solid transparent;\n    /* force tabs to not show a divider */\n    margin-top: 0px;\n    /* force tabs to not have margin */\n    margin-bottom: 0px;\n    /* force tabs to not have margin */ }\n  .Tabs__root___jzEJF .Tabs__buttons___2m5Ca {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 56px; }\n", ""]);

// exports
exports.locals = {
	"root": "Tabs__root___jzEJF",
	"dense": "Tabs__dense___hxaP3",
	"tabs": "Tabs__tabs___3_MFP",
	"buttons": "Tabs__buttons___2m5Ca"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tooltip/styles.scss":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tooltip/styles.scss ***!
  \**************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.Tooltip__root___36E0b .Tooltip__tooltip___23r95 {\n  max-width: 600px;\n  padding: 8px;\n  font-size: 0.75rem;\n  line-height: 16px; }\n\n.Tooltip__root___36E0b.Tooltip__maxLines10___1bSMR {\n  overflow: hidden;\n  white-space: normal;\n  text-overflow: ellipsis;\n  display: block;\n  /* Fallback for non-webkit */\n  display: -webkit-box;\n  -webkit-line-clamp: 10;\n  -webkit-box-orient: vertical; }\n  .Tooltip__root___36E0b.Tooltip__maxLines10___1bSMR .Tooltip__tooltip___23r95 {\n    max-height: calc(10 * 0.75rem);\n    line-height: 16px;\n    max-width: 300px;\n    padding: 4px; }\n\n.Tooltip__root___36E0b.Tooltip__maxLines5___4yEPA {\n  overflow: hidden;\n  white-space: normal;\n  text-overflow: ellipsis;\n  display: block;\n  /* Fallback for non-webkit */\n  display: -webkit-box;\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: vertical; }\n  .Tooltip__root___36E0b.Tooltip__maxLines5___4yEPA .Tooltip__tooltip___23r95 {\n    max-height: calc(5 * 0.75rem);\n    line-height: 16px;\n    max-width: 300px;\n    padding: 4px; }\n\n.Tooltip__root___36E0b.Tooltip__small___1lPnr .Tooltip__tooltip___23r95 {\n  max-width: 300px; }\n", ""]);

// exports
exports.locals = {
	"root": "Tooltip__root___36E0b",
	"tooltip": "Tooltip__tooltip___23r95",
	"maxLines10": "Tooltip__maxLines10___1bSMR",
	"maxLines5": "Tooltip__maxLines5___4yEPA",
	"small": "Tooltip__small___1lPnr"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/TypeableSelect/styles.scss":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/TypeableSelect/styles.scss ***!
  \*********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n.TypeableSelect__root___3wVIv .TypeableSelect__selected___oYFUa {\n  background: rgba(0, 20, 0, 0.12); }\n\n.TypeableSelect__root___3wVIv .TypeableSelect__popper___1eDEC {\n  margin-top: -20px; }\n\n.TypeableSelect__root___3wVIv .TypeableSelect__paper____UXpf {\n  max-height: 300px;\n  overflow: auto; }\n\n.TypeableSelect__root___3wVIv .TypeableSelect__arrow___Zc47D {\n  pointer-events: none;\n  position: absolute;\n  top: 4px;\n  right: 0;\n  color: rgba(0, 0, 0, 0.54); }\n", ""]);

// exports
exports.locals = {
	"root": "TypeableSelect__root___3wVIv",
	"selected": "TypeableSelect__selected___oYFUa",
	"popper": "TypeableSelect__popper___1eDEC",
	"paper": "TypeableSelect__paper____UXpf",
	"arrow": "TypeableSelect__arrow___Zc47D"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Typography/index.scss":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Typography/index.scss ***!
  \****************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\nspan.Typography__root___1Cfjj {\n  letter-spacing: 0; }\n\n.Typography__root___1Cfjj.Typography__subheading2___2uQ-q, .Typography__root___1Cfjj.Typography__subtitle2___RleUt {\n  font-size: 1rem;\n  font-weight: 500;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  line-height: 1.5rem;\n  color: rgba(0, 0, 0, 0.87); }\n  .Typography__root___1Cfjj.Typography__subheading2___2uQ-q.Typography__inheritColor___2YwOr, .Typography__root___1Cfjj.Typography__subtitle2___RleUt.Typography__inheritColor___2YwOr {\n    color: inherit; }\n\n.Typography__root___1Cfjj.Typography__underlined-title___2vLgT, .Typography__root___1Cfjj.Typography__underlined-h6___3NDGp {\n  font-size: 1.25rem;\n  font-weight: 500;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  line-height: 1.5rem;\n  color: rgba(0, 0, 0, 0.87);\n  padding-bottom: 8px;\n  margin-bottom: 0.7em;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  .Typography__root___1Cfjj.Typography__underlined-title___2vLgT.Typography__inheritColor___2YwOr, .Typography__root___1Cfjj.Typography__underlined-h6___3NDGp.Typography__inheritColor___2YwOr {\n    color: inherit; }\n\n.Typography__root___1Cfjj.Typography__inheritColor___2YwOr {\n  color: inherit; }\n\n.Typography__root___1Cfjj.Typography__maxLines1___1UVZp {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.Typography__root___1Cfjj.Typography__maxLines2___1d-Qb {\n  overflow: hidden;\n  white-space: normal;\n  text-overflow: ellipsis;\n  display: block;\n  /* Fallback for non-webkit */\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical; }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__body2___1tP2O {\n    max-height: calc(2 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__body1___3WOYq {\n    max-height: calc(2 * 1.46429em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__caption___Ja-IW {\n    max-height: calc(2 * 1.375em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__button___2EwON {\n    max-height: calc(2 * ); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__display4___22rqD {\n    max-height: calc(2 * 1.2); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__display3___1jJjY {\n    max-height: calc(2 * 1.2); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__display2___3h0F0 {\n    max-height: calc(2 * 1.06667em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__display1___qkBPf {\n    max-height: calc(2 * 1.2em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__headline___39DE- {\n    max-height: calc(2 * 1.35417em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__title___1QHEL {\n    max-height: calc(2 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__underlined-title___2vLgT {\n    max-height: calc(2 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__subheading___38VcI {\n    max-height: calc(2 * 1.5em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__subheading2___2uQ-q {\n    max-height: calc(2 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__h1___Ivkt0 {\n    max-height: calc(2 * 1.2); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__h2___bYR9s {\n    max-height: calc(2 * 1.2); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__h3___3rVRX {\n    max-height: calc(2 * 1.06667em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__h4___1hTdc {\n    max-height: calc(2 * 1.2em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__h5___18OKt {\n    max-height: calc(2 * 1.35417em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__h6___2xSb3 {\n    max-height: calc(2 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__underlined-h6___3NDGp {\n    max-height: calc(2 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__subtitle1___qbc09 {\n    max-height: calc(2 * 1.5em); }\n  .Typography__root___1Cfjj.Typography__maxLines2___1d-Qb.Typography__subtitle2___RleUt {\n    max-height: calc(2 * 1.5rem); }\n\n.Typography__root___1Cfjj.Typography__maxLines3___13QYa {\n  overflow: hidden;\n  white-space: normal;\n  text-overflow: ellipsis;\n  display: block;\n  /* Fallback for non-webkit */\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical; }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__body2___1tP2O {\n    max-height: calc(3 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__body1___3WOYq {\n    max-height: calc(3 * 1.46429em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__caption___Ja-IW {\n    max-height: calc(3 * 1.375em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__button___2EwON {\n    max-height: calc(3 * ); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__display4___22rqD {\n    max-height: calc(3 * 1.2); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__display3___1jJjY {\n    max-height: calc(3 * 1.2); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__display2___3h0F0 {\n    max-height: calc(3 * 1.06667em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__display1___qkBPf {\n    max-height: calc(3 * 1.2em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__headline___39DE- {\n    max-height: calc(3 * 1.35417em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__title___1QHEL {\n    max-height: calc(3 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__underlined-title___2vLgT {\n    max-height: calc(3 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__subheading___38VcI {\n    max-height: calc(3 * 1.5em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__subheading2___2uQ-q {\n    max-height: calc(3 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__h1___Ivkt0 {\n    max-height: calc(3 * 1.2); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__h2___bYR9s {\n    max-height: calc(3 * 1.2); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__h3___3rVRX {\n    max-height: calc(3 * 1.06667em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__h4___1hTdc {\n    max-height: calc(3 * 1.2em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__h5___18OKt {\n    max-height: calc(3 * 1.35417em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__h6___2xSb3 {\n    max-height: calc(3 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__underlined-h6___3NDGp {\n    max-height: calc(3 * 1.5rem); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__subtitle1___qbc09 {\n    max-height: calc(3 * 1.5em); }\n  .Typography__root___1Cfjj.Typography__maxLines3___13QYa.Typography__subtitle2___RleUt {\n    max-height: calc(3 * 1.5rem); }\n\n.Typography__root___1Cfjj.Typography__clip___mwEBQ {\n  text-overflow: clip; }\n\n.Typography__root___1Cfjj.Typography__ellipsis___2J-WU {\n  text-overflow: ellipsis; }\n", ""]);

// exports
exports.locals = {
	"root": "Typography__root___1Cfjj",
	"subheading2": "Typography__subheading2___2uQ-q",
	"subtitle2": "Typography__subtitle2___RleUt",
	"inheritColor": "Typography__inheritColor___2YwOr",
	"underlined-title": "Typography__underlined-title___2vLgT",
	"underlined-h6": "Typography__underlined-h6___3NDGp",
	"maxLines1": "Typography__maxLines1___1UVZp",
	"maxLines2": "Typography__maxLines2___1d-Qb",
	"body2": "Typography__body2___1tP2O",
	"body1": "Typography__body1___3WOYq",
	"caption": "Typography__caption___Ja-IW",
	"button": "Typography__button___2EwON",
	"display4": "Typography__display4___22rqD",
	"display3": "Typography__display3___1jJjY",
	"display2": "Typography__display2___3h0F0",
	"display1": "Typography__display1___qkBPf",
	"headline": "Typography__headline___39DE-",
	"title": "Typography__title___1QHEL",
	"subheading": "Typography__subheading___38VcI",
	"h1": "Typography__h1___Ivkt0",
	"h2": "Typography__h2___bYR9s",
	"h3": "Typography__h3___3rVRX",
	"h4": "Typography__h4___1hTdc",
	"h5": "Typography__h5___18OKt",
	"h6": "Typography__h6___2xSb3",
	"subtitle1": "Typography__subtitle1___qbc09",
	"maxLines3": "Typography__maxLines3___13QYa",
	"clip": "Typography__clip___mwEBQ",
	"ellipsis": "Typography__ellipsis___2J-WU"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/layout.scss":
/*!******************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/layout.scss ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n#root,\n#modal_root,\n#popover,\n.src__container___yABcm {\n  /* padding */\n  /* padding */\n  /* paddingTop */\n  /* paddingTop */\n  /* paddingRight */\n  /* paddingRight */\n  /* paddingBottom */\n  /* paddingBottom */\n  /* paddingLeft */\n  /* paddingLeft */\n  /* paddingHorizontal */\n  /* paddingHorizontal */\n  /* paddingVertical */\n  /* paddingVertical */\n  /* margin */\n  /* margin */\n  /* marginLeft */\n  /* marginLeft */\n  /* marginRight */\n  /* marginRight */\n  /* marginTop */\n  /* marginTop */\n  /* marginBottom */\n  /* marginBottom */\n  /* align */\n  /* align */\n  /* divder */\n  /* divder */ }\n  #root .src__flexNone___tem53,\n  #modal_root .src__flexNone___tem53,\n  #popover .src__flexNone___tem53,\n  .src__container___yABcm .src__flexNone___tem53 {\n    flex: none; }\n  #root .src__flexAuto___f4mLu,\n  #modal_root .src__flexAuto___f4mLu,\n  #popover .src__flexAuto___f4mLu,\n  .src__container___yABcm .src__flexAuto___f4mLu {\n    flex: auto; }\n  #root .src__flex___YBccX,\n  #modal_root .src__flex___YBccX,\n  #popover .src__flex___YBccX,\n  .src__container___yABcm .src__flex___YBccX {\n    display: flex; }\n  #root .src__hidden___1WYdT,\n  #modal_root .src__hidden___1WYdT,\n  #popover .src__hidden___1WYdT,\n  .src__container___yABcm .src__hidden___1WYdT {\n    display: none; }\n  #root .src__inlineFlex___30AlN,\n  #modal_root .src__inlineFlex___30AlN,\n  #popover .src__inlineFlex___30AlN,\n  .src__container___yABcm .src__inlineFlex___30AlN {\n    display: inline-flex; }\n  #root .src__block___JPf-r,\n  #modal_root .src__block___JPf-r,\n  #popover .src__block___JPf-r,\n  .src__container___yABcm .src__block___JPf-r {\n    display: block; }\n  #root .src__inlineBlock___3ulWS,\n  #modal_root .src__inlineBlock___3ulWS,\n  #popover .src__inlineBlock___3ulWS,\n  .src__container___yABcm .src__inlineBlock___3ulWS {\n    display: inline-block; }\n  #root .src__inline___264NH,\n  #modal_root .src__inline___264NH,\n  #popover .src__inline___264NH,\n  .src__container___yABcm .src__inline___264NH {\n    display: inline; }\n  #root .src__relative___3iwGA,\n  #modal_root .src__relative___3iwGA,\n  #popover .src__relative___3iwGA,\n  .src__container___yABcm .src__relative___3iwGA {\n    position: relative; }\n  #root .src__absolute___21qPN,\n  #modal_root .src__absolute___21qPN,\n  #popover .src__absolute___21qPN,\n  .src__container___yABcm .src__absolute___21qPN {\n    position: absolute; }\n  #root .src__fitAbsolute___DPUAH,\n  #modal_root .src__fitAbsolute___DPUAH,\n  #popover .src__fitAbsolute___DPUAH,\n  .src__container___yABcm .src__fitAbsolute___DPUAH {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0; }\n  #root .src__floatLeft___2-WcU,\n  #modal_root .src__floatLeft___2-WcU,\n  #popover .src__floatLeft___2-WcU,\n  .src__container___yABcm .src__floatLeft___2-WcU {\n    float: left; }\n  #root .src__floatRight___2TPtx,\n  #modal_root .src__floatRight___2TPtx,\n  #popover .src__floatRight___2TPtx,\n  .src__container___yABcm .src__floatRight___2TPtx {\n    float: right; }\n  #root .src__clearBoth___tbsMs,\n  #modal_root .src__clearBoth___tbsMs,\n  #popover .src__clearBoth___tbsMs,\n  .src__container___yABcm .src__clearBoth___tbsMs {\n    clear: both; }\n  #root .src__flexBasis0___2OLwj,\n  #modal_root .src__flexBasis0___2OLwj,\n  #popover .src__flexBasis0___2OLwj,\n  .src__container___yABcm .src__flexBasis0___2OLwj {\n    flex-basis: 0; }\n  #root .src__flexBasisAuto___hNEtt,\n  #modal_root .src__flexBasisAuto___hNEtt,\n  #popover .src__flexBasisAuto___hNEtt,\n  .src__container___yABcm .src__flexBasisAuto___hNEtt {\n    flex-basis: auto; }\n  #root .src__fullWidth___3Yl02,\n  #modal_root .src__fullWidth___3Yl02,\n  #popover .src__fullWidth___3Yl02,\n  .src__container___yABcm .src__fullWidth___3Yl02 {\n    width: 100%; }\n  #root .src__minWidthNone___Mu2-J,\n  #modal_root .src__minWidthNone___Mu2-J,\n  #popover .src__minWidthNone___Mu2-J,\n  .src__container___yABcm .src__minWidthNone___Mu2-J {\n    min-width: 0; }\n  #root .src__resetWidth___zV44L,\n  #modal_root .src__resetWidth___zV44L,\n  #popover .src__resetWidth___zV44L,\n  .src__container___yABcm .src__resetWidth___zV44L {\n    width: auto;\n    min-width: auto; }\n  #root .src__flexGrow___2CZg7,\n  #modal_root .src__flexGrow___2CZg7,\n  #popover .src__flexGrow___2CZg7,\n  .src__container___yABcm .src__flexGrow___2CZg7 {\n    flex-grow: 1; }\n  #root .src__flexGrowNone___3drwB,\n  #modal_root .src__flexGrowNone___3drwB,\n  #popover .src__flexGrowNone___3drwB,\n  .src__container___yABcm .src__flexGrowNone___3drwB {\n    flex-grow: 0; }\n  #root .src__flexShrink___1cvy8,\n  #modal_root .src__flexShrink___1cvy8,\n  #popover .src__flexShrink___1cvy8,\n  .src__container___yABcm .src__flexShrink___1cvy8 {\n    flex-shrink: 1; }\n  #root .src__flexShrinkNone___3JvWv, #root .src__flexNoShrink___28YKn,\n  #modal_root .src__flexShrinkNone___3JvWv,\n  #modal_root .src__flexNoShrink___28YKn,\n  #popover .src__flexShrinkNone___3JvWv,\n  #popover .src__flexNoShrink___28YKn,\n  .src__container___yABcm .src__flexShrinkNone___3JvWv,\n  .src__container___yABcm .src__flexNoShrink___28YKn {\n    flex-shrink: 0; }\n  #root .src__centerContent___1ALm-,\n  #modal_root .src__centerContent___1ALm-,\n  #popover .src__centerContent___1ALm-,\n  .src__container___yABcm .src__centerContent___1ALm- {\n    align-items: baseline;\n    align-content: center;\n    justify-content: center; }\n  #root .src__spaceContentBetween___5K9sw,\n  #modal_root .src__spaceContentBetween___5K9sw,\n  #popover .src__spaceContentBetween___5K9sw,\n  .src__container___yABcm .src__spaceContentBetween___5K9sw {\n    justify-content: space-between; }\n  #root .src__spaceContentAround___22N6_,\n  #modal_root .src__spaceContentAround___22N6_,\n  #popover .src__spaceContentAround___22N6_,\n  .src__container___yABcm .src__spaceContentAround___22N6_ {\n    justify-content: space-around; }\n  #root .src__centerVertically___3PZyh,\n  #modal_root .src__centerVertically___3PZyh,\n  #popover .src__centerVertically___3PZyh,\n  .src__container___yABcm .src__centerVertically___3PZyh {\n    align-items: center; }\n  #root .src__centerHorizontally___3n-C1,\n  #modal_root .src__centerHorizontally___3n-C1,\n  #popover .src__centerHorizontally___3n-C1,\n  .src__container___yABcm .src__centerHorizontally___3n-C1 {\n    justify-content: center; }\n  #root .src__topAlign___1tVuh,\n  #modal_root .src__topAlign___1tVuh,\n  #popover .src__topAlign___1tVuh,\n  .src__container___yABcm .src__topAlign___1tVuh {\n    align-items: flex-start;\n    padding-top: 36px; }\n  #root .src__alignItemsFlexStart___23iym,\n  #modal_root .src__alignItemsFlexStart___23iym,\n  #popover .src__alignItemsFlexStart___23iym,\n  .src__container___yABcm .src__alignItemsFlexStart___23iym {\n    align-items: flex-start; }\n  #root .src__alignItemsFlexEnd___32XfF,\n  #modal_root .src__alignItemsFlexEnd___32XfF,\n  #popover .src__alignItemsFlexEnd___32XfF,\n  .src__container___yABcm .src__alignItemsFlexEnd___32XfF {\n    align-items: flex-end; }\n  #root .src__flexColumnContainer___3BasN,\n  #modal_root .src__flexColumnContainer___3BasN,\n  #popover .src__flexColumnContainer___3BasN,\n  .src__container___yABcm .src__flexColumnContainer___3BasN {\n    display: flex;\n    flex-direction: column; }\n  #root .src__flexRowContainer___3dy6I,\n  #modal_root .src__flexRowContainer___3dy6I,\n  #popover .src__flexRowContainer___3dy6I,\n  .src__container___yABcm .src__flexRowContainer___3dy6I {\n    display: flex;\n    flex-direction: row; }\n  #root .src__scroll___327gz,\n  #modal_root .src__scroll___327gz,\n  #popover .src__scroll___327gz,\n  .src__container___yABcm .src__scroll___327gz {\n    overflow: auto;\n    -webkit-overflow-scrolling: touch; }\n  #root .src__listStyleDisc___33bA8,\n  #modal_root .src__listStyleDisc___33bA8,\n  #popover .src__listStyleDisc___33bA8,\n  .src__container___yABcm .src__listStyleDisc___33bA8 {\n    list-style-type: disc; }\n  #root .src__standardPanelPadding___1WjgH,\n  #modal_root .src__standardPanelPadding___1WjgH,\n  #popover .src__standardPanelPadding___1WjgH,\n  .src__container___yABcm .src__standardPanelPadding___1WjgH {\n    padding: 16px 24px 24px 24px; }\n  #root .src__paddingNone___2jAKf,\n  #modal_root .src__paddingNone___2jAKf,\n  #popover .src__paddingNone___2jAKf,\n  .src__container___yABcm .src__paddingNone___2jAKf {\n    padding: 0; }\n  #root .src__paddingXS___2eRni,\n  #modal_root .src__paddingXS___2eRni,\n  #popover .src__paddingXS___2eRni,\n  .src__container___yABcm .src__paddingXS___2eRni {\n    padding: 4px; }\n  #root .src__paddingSmall___dRcx8,\n  #modal_root .src__paddingSmall___dRcx8,\n  #popover .src__paddingSmall___dRcx8,\n  .src__container___yABcm .src__paddingSmall___dRcx8 {\n    padding: 8px; }\n  #root .src__padding___2zet3,\n  #modal_root .src__padding___2zet3,\n  #popover .src__padding___2zet3,\n  .src__container___yABcm .src__padding___2zet3 {\n    padding: 16px; }\n  #root .src__paddingLarge___1StRi,\n  #modal_root .src__paddingLarge___1StRi,\n  #popover .src__paddingLarge___1StRi,\n  .src__container___yABcm .src__paddingLarge___1StRi {\n    padding: 24px; }\n  #root .src__paddingTopNone___3eK_Y,\n  #modal_root .src__paddingTopNone___3eK_Y,\n  #popover .src__paddingTopNone___3eK_Y,\n  .src__container___yABcm .src__paddingTopNone___3eK_Y {\n    padding-top: 0; }\n  #root .src__paddingTopXS___uAnv_,\n  #modal_root .src__paddingTopXS___uAnv_,\n  #popover .src__paddingTopXS___uAnv_,\n  .src__container___yABcm .src__paddingTopXS___uAnv_ {\n    padding-top: 4px; }\n  #root .src__paddingTopSmall___3ZwcY,\n  #modal_root .src__paddingTopSmall___3ZwcY,\n  #popover .src__paddingTopSmall___3ZwcY,\n  .src__container___yABcm .src__paddingTopSmall___3ZwcY {\n    padding-top: 8px; }\n  #root .src__paddingTop___342HK,\n  #modal_root .src__paddingTop___342HK,\n  #popover .src__paddingTop___342HK,\n  .src__container___yABcm .src__paddingTop___342HK {\n    padding-top: 16px; }\n  #root .src__paddingTopLarge___1hkRy,\n  #modal_root .src__paddingTopLarge___1hkRy,\n  #popover .src__paddingTopLarge___1hkRy,\n  .src__container___yABcm .src__paddingTopLarge___1hkRy {\n    padding-top: 24px; }\n  #root .src__paddingRightNone___YbNkL,\n  #modal_root .src__paddingRightNone___YbNkL,\n  #popover .src__paddingRightNone___YbNkL,\n  .src__container___yABcm .src__paddingRightNone___YbNkL {\n    padding-right: 0; }\n  #root .src__paddingRightXS___uQjTU,\n  #modal_root .src__paddingRightXS___uQjTU,\n  #popover .src__paddingRightXS___uQjTU,\n  .src__container___yABcm .src__paddingRightXS___uQjTU {\n    padding-right: 6px; }\n  #root .src__paddingRightSmall___1ff4Y,\n  #modal_root .src__paddingRightSmall___1ff4Y,\n  #popover .src__paddingRightSmall___1ff4Y,\n  .src__container___yABcm .src__paddingRightSmall___1ff4Y {\n    padding-right: 8px; }\n  #root .src__paddingRight___WzmKe,\n  #modal_root .src__paddingRight___WzmKe,\n  #popover .src__paddingRight___WzmKe,\n  .src__container___yABcm .src__paddingRight___WzmKe {\n    padding-right: 16px; }\n  #root .src__paddingRightLarge___3vucq,\n  #modal_root .src__paddingRightLarge___3vucq,\n  #popover .src__paddingRightLarge___3vucq,\n  .src__container___yABcm .src__paddingRightLarge___3vucq {\n    padding-right: 24px; }\n  #root .src__paddingBottomNone___3yrpU,\n  #modal_root .src__paddingBottomNone___3yrpU,\n  #popover .src__paddingBottomNone___3yrpU,\n  .src__container___yABcm .src__paddingBottomNone___3yrpU {\n    padding-bottom: 0; }\n  #root .src__paddingBottomXS___lEmgv,\n  #modal_root .src__paddingBottomXS___lEmgv,\n  #popover .src__paddingBottomXS___lEmgv,\n  .src__container___yABcm .src__paddingBottomXS___lEmgv {\n    padding-bottom: 4px; }\n  #root .src__paddingBottomSmall___13g56,\n  #modal_root .src__paddingBottomSmall___13g56,\n  #popover .src__paddingBottomSmall___13g56,\n  .src__container___yABcm .src__paddingBottomSmall___13g56 {\n    padding-bottom: 8px; }\n  #root .src__paddingBottom___XK7b0,\n  #modal_root .src__paddingBottom___XK7b0,\n  #popover .src__paddingBottom___XK7b0,\n  .src__container___yABcm .src__paddingBottom___XK7b0 {\n    padding-bottom: 16px; }\n  #root .src__paddingBottomLarge___18e_D,\n  #modal_root .src__paddingBottomLarge___18e_D,\n  #popover .src__paddingBottomLarge___18e_D,\n  .src__container___yABcm .src__paddingBottomLarge___18e_D {\n    padding-bottom: 24px; }\n  #root .src__paddingLeftNone___3HVYC,\n  #modal_root .src__paddingLeftNone___3HVYC,\n  #popover .src__paddingLeftNone___3HVYC,\n  .src__container___yABcm .src__paddingLeftNone___3HVYC {\n    padding-left: 0; }\n  #root .src__paddingLeftXS___L8BFd,\n  #modal_root .src__paddingLeftXS___L8BFd,\n  #popover .src__paddingLeftXS___L8BFd,\n  .src__container___yABcm .src__paddingLeftXS___L8BFd {\n    padding-left: 4px; }\n  #root .src__paddingLeftSmall___3umRg,\n  #modal_root .src__paddingLeftSmall___3umRg,\n  #popover .src__paddingLeftSmall___3umRg,\n  .src__container___yABcm .src__paddingLeftSmall___3umRg {\n    padding-left: 8px; }\n  #root .src__paddingLeft___1B8ue,\n  #modal_root .src__paddingLeft___1B8ue,\n  #popover .src__paddingLeft___1B8ue,\n  .src__container___yABcm .src__paddingLeft___1B8ue {\n    padding-left: 16px; }\n  #root .src__paddingLeftLarge___3qZDv,\n  #modal_root .src__paddingLeftLarge___3qZDv,\n  #popover .src__paddingLeftLarge___3qZDv,\n  .src__container___yABcm .src__paddingLeftLarge___3qZDv {\n    padding-left: 24px; }\n  #root .src__paddingHorizontalSmall___11gjm,\n  #modal_root .src__paddingHorizontalSmall___11gjm,\n  #popover .src__paddingHorizontalSmall___11gjm,\n  .src__container___yABcm .src__paddingHorizontalSmall___11gjm {\n    padding-left: 8px;\n    padding-right: 8px; }\n  #root .src__paddingHorizontal___3ruT1,\n  #modal_root .src__paddingHorizontal___3ruT1,\n  #popover .src__paddingHorizontal___3ruT1,\n  .src__container___yABcm .src__paddingHorizontal___3ruT1 {\n    padding-left: 16px;\n    padding-right: 16px; }\n  #root .src__paddingHorizontalLarge___1Jkmm,\n  #modal_root .src__paddingHorizontalLarge___1Jkmm,\n  #popover .src__paddingHorizontalLarge___1Jkmm,\n  .src__container___yABcm .src__paddingHorizontalLarge___1Jkmm {\n    padding-left: 24px;\n    padding-right: 24px; }\n  #root .src__paddingVerticalSmall___x7YvJ,\n  #modal_root .src__paddingVerticalSmall___x7YvJ,\n  #popover .src__paddingVerticalSmall___x7YvJ,\n  .src__container___yABcm .src__paddingVerticalSmall___x7YvJ {\n    padding-top: 8px;\n    padding-bottom: 8px; }\n  #root .src__paddingVertical___3uYVs,\n  #modal_root .src__paddingVertical___3uYVs,\n  #popover .src__paddingVertical___3uYVs,\n  .src__container___yABcm .src__paddingVertical___3uYVs {\n    padding-top: 16px;\n    padding-bottom: 16px; }\n  #root .src__paddingVerticalLarge___9CTC9,\n  #modal_root .src__paddingVerticalLarge___9CTC9,\n  #popover .src__paddingVerticalLarge___9CTC9,\n  .src__container___yABcm .src__paddingVerticalLarge___9CTC9 {\n    padding-top: 24px;\n    padding-bottom: 24px; }\n  #root .src__marginNone___3vlMN,\n  #modal_root .src__marginNone___3vlMN,\n  #popover .src__marginNone___3vlMN,\n  .src__container___yABcm .src__marginNone___3vlMN {\n    margin: 0; }\n  #root .src__marginSmall___3h_4O,\n  #modal_root .src__marginSmall___3h_4O,\n  #popover .src__marginSmall___3h_4O,\n  .src__container___yABcm .src__marginSmall___3h_4O {\n    margin: 8px; }\n  #root .src__marginLeftNone___mJuos,\n  #modal_root .src__marginLeftNone___mJuos,\n  #popover .src__marginLeftNone___mJuos,\n  .src__container___yABcm .src__marginLeftNone___mJuos {\n    margin-left: 0; }\n  #root .src__marginLeftXS___ibpI6,\n  #modal_root .src__marginLeftXS___ibpI6,\n  #popover .src__marginLeftXS___ibpI6,\n  .src__container___yABcm .src__marginLeftXS___ibpI6 {\n    margin-left: 4px; }\n  #root .src__marginLeftSmall___31D6m,\n  #modal_root .src__marginLeftSmall___31D6m,\n  #popover .src__marginLeftSmall___31D6m,\n  .src__container___yABcm .src__marginLeftSmall___31D6m {\n    margin-left: 8px; }\n  #root .src__marginLeft___3qg_v,\n  #modal_root .src__marginLeft___3qg_v,\n  #popover .src__marginLeft___3qg_v,\n  .src__container___yABcm .src__marginLeft___3qg_v {\n    margin-left: 16px; }\n  #root .src__marginLeftLarge___26tLP,\n  #modal_root .src__marginLeftLarge___26tLP,\n  #popover .src__marginLeftLarge___26tLP,\n  .src__container___yABcm .src__marginLeftLarge___26tLP {\n    margin-left: 24px; }\n  #root .src__marginRightNone___2pJRr,\n  #modal_root .src__marginRightNone___2pJRr,\n  #popover .src__marginRightNone___2pJRr,\n  .src__container___yABcm .src__marginRightNone___2pJRr {\n    margin-right: 0; }\n  #root .src__marginRightXS___BfmTF,\n  #modal_root .src__marginRightXS___BfmTF,\n  #popover .src__marginRightXS___BfmTF,\n  .src__container___yABcm .src__marginRightXS___BfmTF {\n    margin-right: 4px; }\n  #root .src__marginRightSmall___2lse7, #root .src__marginRightLeft___CTCQU,\n  #modal_root .src__marginRightSmall___2lse7,\n  #modal_root .src__marginRightLeft___CTCQU,\n  #popover .src__marginRightSmall___2lse7,\n  #popover .src__marginRightLeft___CTCQU,\n  .src__container___yABcm .src__marginRightSmall___2lse7,\n  .src__container___yABcm .src__marginRightLeft___CTCQU {\n    margin-right: 8px; }\n  #root .src__marginRight___3j1Sp,\n  #modal_root .src__marginRight___3j1Sp,\n  #popover .src__marginRight___3j1Sp,\n  .src__container___yABcm .src__marginRight___3j1Sp {\n    margin-right: 16px; }\n  #root .src__marginRightLarge___lEizN,\n  #modal_root .src__marginRightLarge___lEizN,\n  #popover .src__marginRightLarge___lEizN,\n  .src__container___yABcm .src__marginRightLarge___lEizN {\n    margin-right: 24px; }\n  #root .src__marginTopNone___3jNmk,\n  #modal_root .src__marginTopNone___3jNmk,\n  #popover .src__marginTopNone___3jNmk,\n  .src__container___yABcm .src__marginTopNone___3jNmk {\n    margin-top: 0; }\n  #root .src__marginTopXS___yrLsf,\n  #modal_root .src__marginTopXS___yrLsf,\n  #popover .src__marginTopXS___yrLsf,\n  .src__container___yABcm .src__marginTopXS___yrLsf {\n    margin-top: 4px; }\n  #root .src__marginTopSmall___20Jis,\n  #modal_root .src__marginTopSmall___20Jis,\n  #popover .src__marginTopSmall___20Jis,\n  .src__container___yABcm .src__marginTopSmall___20Jis {\n    margin-top: 8px; }\n  #root .src__marginTop___4DfMA,\n  #modal_root .src__marginTop___4DfMA,\n  #popover .src__marginTop___4DfMA,\n  .src__container___yABcm .src__marginTop___4DfMA {\n    margin-top: 16px; }\n  #root .src__marginTopLarge___3uMvi,\n  #modal_root .src__marginTopLarge___3uMvi,\n  #popover .src__marginTopLarge___3uMvi,\n  .src__container___yABcm .src__marginTopLarge___3uMvi {\n    margin-top: 24px; }\n  #root .src__marginBottomNone___unng7,\n  #modal_root .src__marginBottomNone___unng7,\n  #popover .src__marginBottomNone___unng7,\n  .src__container___yABcm .src__marginBottomNone___unng7 {\n    margin-bottom: 0; }\n  #root .src__marginBottomXS___2pLyY,\n  #modal_root .src__marginBottomXS___2pLyY,\n  #popover .src__marginBottomXS___2pLyY,\n  .src__container___yABcm .src__marginBottomXS___2pLyY {\n    margin-bottom: 4px; }\n  #root .src__marginBottomSmall___3-QY7,\n  #modal_root .src__marginBottomSmall___3-QY7,\n  #popover .src__marginBottomSmall___3-QY7,\n  .src__container___yABcm .src__marginBottomSmall___3-QY7 {\n    margin-bottom: 8px; }\n  #root .src__marginBottom___14_bi,\n  #modal_root .src__marginBottom___14_bi,\n  #popover .src__marginBottom___14_bi,\n  .src__container___yABcm .src__marginBottom___14_bi {\n    margin-bottom: 16px; }\n  #root .src__marginBottomLarge___15E9X,\n  #modal_root .src__marginBottomLarge___15E9X,\n  #popover .src__marginBottomLarge___15E9X,\n  .src__container___yABcm .src__marginBottomLarge___15E9X {\n    margin-bottom: 24px; }\n  #root .src__alignLeft___1SUoC,\n  #modal_root .src__alignLeft___1SUoC,\n  #popover .src__alignLeft___1SUoC,\n  .src__container___yABcm .src__alignLeft___1SUoC {\n    text-align: left; }\n  #root .src__alignCenter___ZbHQ3,\n  #modal_root .src__alignCenter___ZbHQ3,\n  #popover .src__alignCenter___ZbHQ3,\n  .src__container___yABcm .src__alignCenter___ZbHQ3 {\n    text-align: center; }\n  #root .src__alignRight___1MLqP,\n  #modal_root .src__alignRight___1MLqP,\n  #popover .src__alignRight___1MLqP,\n  .src__container___yABcm .src__alignRight___1MLqP {\n    text-align: right; }\n  #root .src__dividerLeft___30Ny4,\n  #modal_root .src__dividerLeft___30Ny4,\n  #popover .src__dividerLeft___30Ny4,\n  .src__container___yABcm .src__dividerLeft___30Ny4 {\n    border-left: 1px solid rgba(0, 0, 0, 0.15); }\n  #root .src__dividerRight___1lZ5x,\n  #modal_root .src__dividerRight___1lZ5x,\n  #popover .src__dividerRight___1lZ5x,\n  .src__container___yABcm .src__dividerRight___1lZ5x {\n    border-right: 1px solid rgba(0, 0, 0, 0.15); }\n  #root .src__dividerTop___1-lcI,\n  #modal_root .src__dividerTop___1-lcI,\n  #popover .src__dividerTop___1-lcI,\n  .src__container___yABcm .src__dividerTop___1-lcI {\n    border-top: 1px solid rgba(0, 0, 0, 0.15); }\n  #root .src__dividerBottom___3mOlF,\n  #modal_root .src__dividerBottom___3mOlF,\n  #popover .src__dividerBottom___3mOlF,\n  .src__container___yABcm .src__dividerBottom___3mOlF {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  #root .src__warning___1IxDW,\n  #modal_root .src__warning___1IxDW,\n  #popover .src__warning___1IxDW,\n  .src__container___yABcm .src__warning___1IxDW {\n    color: #ff9101;\n    font-size: 12px; }\n  #root .src__error___2pOHg,\n  #modal_root .src__error___2pOHg,\n  #popover .src__error___2pOHg,\n  .src__container___yABcm .src__error___2pOHg {\n    color: #d32f2f;\n    font-size: 12px; }\n  #root .src__maxWidth100___3Wtky,\n  #modal_root .src__maxWidth100___3Wtky,\n  #popover .src__maxWidth100___3Wtky,\n  .src__container___yABcm .src__maxWidth100___3Wtky {\n    max-width: 100%; }\n  #root .src__fitHeight___1k_Wp,\n  #modal_root .src__fitHeight___1k_Wp,\n  #popover .src__fitHeight___1k_Wp,\n  .src__container___yABcm .src__fitHeight___1k_Wp {\n    height: fit-content; }\n  #root .src__fullHeight___2mJgh,\n  #modal_root .src__fullHeight___2mJgh,\n  #popover .src__fullHeight___2mJgh,\n  .src__container___yABcm .src__fullHeight___2mJgh {\n    height: 100%; }\n  #root .src__clickable___2_erx,\n  #modal_root .src__clickable___2_erx,\n  #popover .src__clickable___2_erx,\n  .src__container___yABcm .src__clickable___2_erx {\n    cursor: pointer; }\n  #root .src__mobilePaper___awlYf,\n  #modal_root .src__mobilePaper___awlYf,\n  #popover .src__mobilePaper___awlYf,\n  .src__container___yABcm .src__mobilePaper___awlYf {\n    background-color: white;\n    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12); }\n  #root .src__selectedPanel___2Uqbs,\n  #modal_root .src__selectedPanel___2Uqbs,\n  #popover .src__selectedPanel___2Uqbs,\n  .src__container___yABcm .src__selectedPanel___2Uqbs {\n    background-color: #fcfefc;\n    border: 1px solid #4caf5a; }\n  #root .src__unselectedPanel___RmVhL,\n  #modal_root .src__unselectedPanel___RmVhL,\n  #popover .src__unselectedPanel___RmVhL,\n  .src__container___yABcm .src__unselectedPanel___RmVhL {\n    background-color: inherit;\n    border: 1px solid transparent; }\n  #root .src__noTextTransform___3uRkI,\n  #modal_root .src__noTextTransform___3uRkI,\n  #popover .src__noTextTransform___3uRkI,\n  .src__container___yABcm .src__noTextTransform___3uRkI {\n    text-transform: none; }\n  #root .src__noWrap___20Ds2,\n  #modal_root .src__noWrap___20Ds2,\n  #popover .src__noWrap___20Ds2,\n  .src__container___yABcm .src__noWrap___20Ds2 {\n    white-space: nowrap; }\n  #root .src__preWrap___1lS1l,\n  #modal_root .src__preWrap___1lS1l,\n  #popover .src__preWrap___1lS1l,\n  .src__container___yABcm .src__preWrap___1lS1l {\n    white-space: pre-wrap; }\n  #root .src__buttonSizeRegular___3IAqB,\n  #modal_root .src__buttonSizeRegular___3IAqB,\n  #popover .src__buttonSizeRegular___3IAqB,\n  .src__container___yABcm .src__buttonSizeRegular___3IAqB {\n    height: 24px;\n    width: 24px; }\n  #root .src__buttonSizeSmall___3KRfi,\n  #modal_root .src__buttonSizeSmall___3KRfi,\n  #popover .src__buttonSizeSmall___3KRfi,\n  .src__container___yABcm .src__buttonSizeSmall___3KRfi {\n    height: 16px;\n    width: 16px; }\n  #root .src__buttonSizeLarge___2_r_5,\n  #modal_root .src__buttonSizeLarge___2_r_5,\n  #popover .src__buttonSizeLarge___2_r_5,\n  .src__container___yABcm .src__buttonSizeLarge___2_r_5 {\n    height: 32px;\n    width: 32px; }\n  #root .src__clippedOverflow___1i6YK > *,\n  #modal_root .src__clippedOverflow___1i6YK > *,\n  #popover .src__clippedOverflow___1i6YK > *,\n  .src__container___yABcm .src__clippedOverflow___1i6YK > * {\n    overflow: hidden;\n    text-overflow: ellipsis; }\n\n.src__fluid___PSQpH {\n  display: flex; }\n  .src__fluid___PSQpH > * {\n    align-self: baseline; }\n    .src__fluid___PSQpH > * ~ * {\n      margin-left: 16px; }\n", ""]);

// exports
exports.locals = {
	"container": "src__container___yABcm",
	"flexNone": "src__flexNone___tem53",
	"flexAuto": "src__flexAuto___f4mLu",
	"flex": "src__flex___YBccX",
	"hidden": "src__hidden___1WYdT",
	"inlineFlex": "src__inlineFlex___30AlN",
	"block": "src__block___JPf-r",
	"inlineBlock": "src__inlineBlock___3ulWS",
	"inline": "src__inline___264NH",
	"relative": "src__relative___3iwGA",
	"absolute": "src__absolute___21qPN",
	"fitAbsolute": "src__fitAbsolute___DPUAH",
	"floatLeft": "src__floatLeft___2-WcU",
	"floatRight": "src__floatRight___2TPtx",
	"clearBoth": "src__clearBoth___tbsMs",
	"flexBasis0": "src__flexBasis0___2OLwj",
	"flexBasisAuto": "src__flexBasisAuto___hNEtt",
	"fullWidth": "src__fullWidth___3Yl02",
	"minWidthNone": "src__minWidthNone___Mu2-J",
	"resetWidth": "src__resetWidth___zV44L",
	"flexGrow": "src__flexGrow___2CZg7",
	"flexGrowNone": "src__flexGrowNone___3drwB",
	"flexShrink": "src__flexShrink___1cvy8",
	"flexShrinkNone": "src__flexShrinkNone___3JvWv",
	"flexNoShrink": "src__flexNoShrink___28YKn",
	"centerContent": "src__centerContent___1ALm-",
	"spaceContentBetween": "src__spaceContentBetween___5K9sw",
	"spaceContentAround": "src__spaceContentAround___22N6_",
	"centerVertically": "src__centerVertically___3PZyh",
	"centerHorizontally": "src__centerHorizontally___3n-C1",
	"topAlign": "src__topAlign___1tVuh",
	"alignItemsFlexStart": "src__alignItemsFlexStart___23iym",
	"alignItemsFlexEnd": "src__alignItemsFlexEnd___32XfF",
	"flexColumnContainer": "src__flexColumnContainer___3BasN",
	"flexRowContainer": "src__flexRowContainer___3dy6I",
	"scroll": "src__scroll___327gz",
	"listStyleDisc": "src__listStyleDisc___33bA8",
	"standardPanelPadding": "src__standardPanelPadding___1WjgH",
	"paddingNone": "src__paddingNone___2jAKf",
	"paddingXS": "src__paddingXS___2eRni",
	"paddingSmall": "src__paddingSmall___dRcx8",
	"padding": "src__padding___2zet3",
	"paddingLarge": "src__paddingLarge___1StRi",
	"paddingTopNone": "src__paddingTopNone___3eK_Y",
	"paddingTopXS": "src__paddingTopXS___uAnv_",
	"paddingTopSmall": "src__paddingTopSmall___3ZwcY",
	"paddingTop": "src__paddingTop___342HK",
	"paddingTopLarge": "src__paddingTopLarge___1hkRy",
	"paddingRightNone": "src__paddingRightNone___YbNkL",
	"paddingRightXS": "src__paddingRightXS___uQjTU",
	"paddingRightSmall": "src__paddingRightSmall___1ff4Y",
	"paddingRight": "src__paddingRight___WzmKe",
	"paddingRightLarge": "src__paddingRightLarge___3vucq",
	"paddingBottomNone": "src__paddingBottomNone___3yrpU",
	"paddingBottomXS": "src__paddingBottomXS___lEmgv",
	"paddingBottomSmall": "src__paddingBottomSmall___13g56",
	"paddingBottom": "src__paddingBottom___XK7b0",
	"paddingBottomLarge": "src__paddingBottomLarge___18e_D",
	"paddingLeftNone": "src__paddingLeftNone___3HVYC",
	"paddingLeftXS": "src__paddingLeftXS___L8BFd",
	"paddingLeftSmall": "src__paddingLeftSmall___3umRg",
	"paddingLeft": "src__paddingLeft___1B8ue",
	"paddingLeftLarge": "src__paddingLeftLarge___3qZDv",
	"paddingHorizontalSmall": "src__paddingHorizontalSmall___11gjm",
	"paddingHorizontal": "src__paddingHorizontal___3ruT1",
	"paddingHorizontalLarge": "src__paddingHorizontalLarge___1Jkmm",
	"paddingVerticalSmall": "src__paddingVerticalSmall___x7YvJ",
	"paddingVertical": "src__paddingVertical___3uYVs",
	"paddingVerticalLarge": "src__paddingVerticalLarge___9CTC9",
	"marginNone": "src__marginNone___3vlMN",
	"marginSmall": "src__marginSmall___3h_4O",
	"marginLeftNone": "src__marginLeftNone___mJuos",
	"marginLeftXS": "src__marginLeftXS___ibpI6",
	"marginLeftSmall": "src__marginLeftSmall___31D6m",
	"marginLeft": "src__marginLeft___3qg_v",
	"marginLeftLarge": "src__marginLeftLarge___26tLP",
	"marginRightNone": "src__marginRightNone___2pJRr",
	"marginRightXS": "src__marginRightXS___BfmTF",
	"marginRightSmall": "src__marginRightSmall___2lse7",
	"marginRightLeft": "src__marginRightLeft___CTCQU",
	"marginRight": "src__marginRight___3j1Sp",
	"marginRightLarge": "src__marginRightLarge___lEizN",
	"marginTopNone": "src__marginTopNone___3jNmk",
	"marginTopXS": "src__marginTopXS___yrLsf",
	"marginTopSmall": "src__marginTopSmall___20Jis",
	"marginTop": "src__marginTop___4DfMA",
	"marginTopLarge": "src__marginTopLarge___3uMvi",
	"marginBottomNone": "src__marginBottomNone___unng7",
	"marginBottomXS": "src__marginBottomXS___2pLyY",
	"marginBottomSmall": "src__marginBottomSmall___3-QY7",
	"marginBottom": "src__marginBottom___14_bi",
	"marginBottomLarge": "src__marginBottomLarge___15E9X",
	"alignLeft": "src__alignLeft___1SUoC",
	"alignCenter": "src__alignCenter___ZbHQ3",
	"alignRight": "src__alignRight___1MLqP",
	"dividerLeft": "src__dividerLeft___30Ny4",
	"dividerRight": "src__dividerRight___1lZ5x",
	"dividerTop": "src__dividerTop___1-lcI",
	"dividerBottom": "src__dividerBottom___3mOlF",
	"warning": "src__warning___1IxDW",
	"error": "src__error___2pOHg",
	"maxWidth100": "src__maxWidth100___3Wtky",
	"fitHeight": "src__fitHeight___1k_Wp",
	"fullHeight": "src__fullHeight___2mJgh",
	"clickable": "src__clickable___2_erx",
	"mobilePaper": "src__mobilePaper___awlYf",
	"selectedPanel": "src__selectedPanel___2Uqbs",
	"unselectedPanel": "src__unselectedPanel___RmVhL",
	"noTextTransform": "src__noTextTransform___3uRkI",
	"noWrap": "src__noWrap___20Ds2",
	"preWrap": "src__preWrap___1lS1l",
	"buttonSizeRegular": "src__buttonSizeRegular___3IAqB",
	"buttonSizeSmall": "src__buttonSizeSmall___3KRfi",
	"buttonSizeLarge": "src__buttonSizeLarge___2_r_5",
	"clippedOverflow": "src__clippedOverflow___1i6YK",
	"fluid": "src__fluid___PSQpH"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/theme_export.scss":
/*!************************************************************************************************************!*\
  !*** ./node_modules/css-loader??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/theme_export.scss ***!
  \************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/**\n * This is the main theme file for Gentu.\n * Modifying these values will affect the Material UI components\n * as well as our custom components.\n *\n * Ideally you should use existing Material UI components\n * but if you need to use these styles directly you can.\n *\n * To use these styles in your own SCSS:\n *\n * @import \"../theme.scss\";\n *\n * .mybutton {\n *   background-color: get-theme-style('palettePrimaryMain');\n *   box-shadow: get-theme-style('shadows4');\n * }\n */\n/**\n * Helper function to get theme styles\n * @param $key {string} theme property name e.g. 'paletteCommonBlack'\n * @returns CSS value\n */\n/**\n/// [typography-styles gets base typography styles from a given key]\n/// @param  {string} $key e.g. Display4, Headline, Body2\n*/\n", ""]);

// exports
exports.locals = {
	"paletteCommonBlack": "#000",
	"paletteCommonWhite": "#fff",
	"paletteCommonTransparent": "rgba(0, 0, 0, 0)",
	"paletteCommonFullBlack": "black",
	"paletteCommonDarkBlack": "rgba(0, 0, 0, 0.87)",
	"paletteCommonLightBlack": "rgba(0, 0, 0, 0.54)",
	"paletteCommonMinBlack": "rgba(0, 0, 0, 0.26)",
	"paletteCommonFaintBlack": "rgba(0, 20, 0, 0.12)",
	"paletteCommonFullWhite": "white",
	"paletteCommonDarkWhite": "rgba(255, 255, 255, 0.87)",
	"paletteCommonLightWhite": "rgba(255, 255, 255, 0.54)",
	"palettePrimary50": "#edF8F9",
	"palettePrimary100": "#d2ecf0",
	"palettePrimary200": "#aadce3",
	"palettePrimary300": "#7cc9d3",
	"palettePrimary400": "#44b3c1",
	"palettePrimary500": "#119aab",
	"palettePrimary600": "#008392",
	"palettePrimary700": "#006a77",
	"palettePrimary800": "#0a5761",
	"palettePrimary900": "#023c44",
	"palettePrimaryA100": "#bde4e8",
	"palettePrimaryA200": "#9fd8dd",
	"palettePrimaryA400": "#80ccd3",
	"palettePrimaryA700": "#53bac3",
	"palettePrimaryLight": "#EDF8F9",
	"palettePrimaryMain": "#119aab",
	"palettePrimaryDark": "#023c44",
	"paletteSecondary50": "#f2faf9",
	"paletteSecondary100": "#d8f0ee",
	"paletteSecondary200": "#c8f0f2",
	"paletteSecondary300": "#76dade",
	"paletteSecondary400": "#38c9d0",
	"paletteSecondary500": "#249297",
	"paletteSecondary600": "#1c7276",
	"paletteSecondary700": "#145255",
	"paletteSecondary800": "#0c3234",
	"paletteSecondary900": "#051313",
	"paletteSecondaryA100": "#119ca8",
	"paletteSecondaryA200": "#0e7a83",
	"paletteSecondaryA400": "#0a575e",
	"paletteSecondaryA700": "#17cfe0",
	"paletteSecondaryA800": "#DFF2F2",
	"paletteSecondaryLight": "#76dade",
	"paletteSecondaryMain": "#249297",
	"paletteSecondaryDark": "#0a575e",
	"paletteBrandPink50": "#FFF1F6",
	"paletteBrandPink100": "#FFDDE9",
	"paletteBrandPink200": "#FFBED5",
	"paletteBrandPink300": "#FF9ABE",
	"paletteBrandPink400": "#FF71A3",
	"paletteBrandPink500": "#ff4686",
	"paletteBrandPink600": "#DB3771",
	"paletteBrandPink700": "#B22D5B",
	"paletteBrandPink800": "#8E2448",
	"paletteBrandPink900": "#651934",
	"paletteBrandPinkLight": "#FFF1F6",
	"paletteBrandPinkMain": "#ff4686",
	"paletteBrandPinkDark": "#651934",
	"paletteErrorLight": "#fae6e6",
	"paletteErrorMain": "#d32f2f",
	"paletteErrorDark": "#bf1212",
	"paletteInformationalLight": "#e9f2fc",
	"paletteInformationalMain": "#4990e2",
	"paletteInformationalDark": "#2161cf",
	"paletteSuccessLight": "#eaf5eb",
	"paletteSuccessMain": "#4caf5a",
	"paletteSuccessDark": "#24862e",
	"paletteWarningLight": "#fff2e0",
	"paletteWarningMain": "#ff9100",
	"paletteWarningDark": "#ff6200",
	"paletteGrey50": "#fafafa",
	"paletteGrey100": "#f5f5f5",
	"paletteGrey200": "#eee",
	"paletteGrey300": "#e0e0e0",
	"paletteGrey400": "#bdbdbd",
	"paletteGrey500": "#9e9e9e",
	"paletteGrey600": "#757575",
	"paletteGrey700": "#616161",
	"paletteGrey800": "#424242",
	"paletteGrey900": "#212121",
	"paletteGreyA100": "#d5d5d5",
	"paletteGreyA200": "#aaa",
	"paletteGreyA400": "#303030",
	"paletteGreyA700": "#616161",
	"paletteShadesDarkTextPrimary": "white",
	"paletteShadesDarkTextSecondary": "rgba(255, 255, 255, 0.7)",
	"paletteShadesDarkTextDisabled": "rgba(255, 255, 255, 0.5)",
	"paletteShadesDarkTextHint": "rgba(255, 255, 255, 0.5)",
	"paletteShadesDarkTextIcon": "rgba(255, 255, 255, 0.5)",
	"paletteShadesDarkTextDivider": "rgba(255, 255, 255, 0.15)",
	"paletteShadesDarkTextLightDivider": "rgba(255, 255, 255, 0.075)",
	"paletteShadesDarkInputBottomLine": "rgba(255, 255, 255, 0.7)",
	"paletteShadesDarkInputHelperText": "rgba(255, 255, 255, 0.7)",
	"paletteShadesDarkInputLabelText": "rgba(255, 255, 255, 0.7)",
	"paletteShadesDarkInputInputText": "white",
	"paletteShadesDarkInputDisabled": "rgba(255, 255, 255, 0.5)",
	"paletteShadesDarkActionActive": "white",
	"paletteShadesDarkActionDisabled": "rgba(255, 255, 255, 0.3)",
	"paletteShadesDarkBackgroundDefault": "#303030",
	"paletteShadesDarkBackgroundPaper": "#424242",
	"paletteShadesDarkBackgroundAppBar": "#212121",
	"paletteShadesDarkBackgroundContentFrame": "#212121",
	"paletteShadesLightTextPrimary": "rgba(0, 0, 0, 0.87)",
	"paletteShadesLightTextSecondary": "rgba(0, 0, 0, 0.54)",
	"paletteShadesLightTextDisabled": "rgba(0, 0, 0, 0.38)",
	"paletteShadesLightTextHint": "rgba(0, 0, 0, 0.38)",
	"paletteShadesLightTextIcon": "rgba(0, 0, 0, 0.54)",
	"paletteShadesLightTextDivider": "rgba(0, 0, 0, 0.15)",
	"paletteShadesLightTextLightDivider": "rgba(0, 0, 0, 0.075)",
	"paletteShadesLightInputBottomLine": "rgba(10, 10, 10, 0.42)",
	"paletteShadesLightInputHelperText": "rgba(0, 0, 0, 0.54)",
	"paletteShadesLightInputLabelText": "rgba(0, 0, 0, 0.54)",
	"paletteShadesLightInputInputText": "rgba(0, 0, 0, 0.87)",
	"paletteShadesLightInputDisabled": "rgba(0, 0, 0, 0.42)",
	"paletteShadesLightActionActive": "rgba(0, 0, 0, 0.54)",
	"paletteShadesLightActionDisabled": "rgba(0, 0, 0, 0.26)",
	"paletteShadesLightBackgroundDefault": "#fafafa",
	"paletteShadesLightBackgroundPaper": "#fff",
	"paletteShadesLightBackgroundAppBar": "#f5f5f5",
	"paletteShadesLightBackgroundContentFrame": "#eee",
	"paletteTextPrimary": "rgba(0, 0, 0, 0.87)",
	"paletteTextSecondary": "rgba(0, 0, 0, 0.54)",
	"paletteTextDisabled": "rgba(0, 0, 0, 0.38)",
	"paletteTextHint": "rgba(0, 0, 0, 0.38)",
	"paletteTextIcon": "rgba(0, 0, 0, 0.38)",
	"paletteTextDivider": "rgba(0, 0, 0, 0.15)",
	"paletteTextLightDivider": "rgba(0, 0, 0, 0.075)",
	"paletteInputBottomLine": "rgba(0, 0, 0, 0.42)",
	"paletteInputHelperText": "rgba(0, 0, 0, 0.54)",
	"paletteInputLabelText": "rgba(0, 0, 0, 0.54)",
	"paletteInputInputText": "rgba(0, 0, 0, 0.87)",
	"paletteInputDisabled": "rgba(0, 0, 0, 0.42)",
	"paletteActionActive": "rgba(0, 0, 0, 0.54)",
	"paletteActionDisabled": "rgba(0, 0, 0, 0.26)",
	"paletteBackgroundDefault": "#f5f5f7",
	"paletteBackgroundPaper": "#fff",
	"paletteBackgroundAppBar": "#f5f5f5",
	"paletteBackgroundContentFrame": "#eee",
	"typographyFontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyFontSize": "14",
	"typographyFontWeightLight": "300",
	"typographyFontWeightRegular": "400",
	"typographyFontWeightMedium": "500",
	"typographyBody2FontSize": "0.875rem",
	"typographyBody2FontWeight": "500",
	"typographyBody2FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyBody2LineHeight": "1.5rem",
	"typographyBody2Color": "rgba(0, 0, 0, 0.87)",
	"typographyBody1FontSize": "0.875rem",
	"typographyBody1FontWeight": "400",
	"typographyBody1FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyBody1LineHeight": "1.46429em",
	"typographyBody1Color": "rgba(0, 0, 0, 0.87)",
	"typographyCaptionFontSize": "0.75rem",
	"typographyCaptionFontWeight": "400",
	"typographyCaptionFontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyCaptionLineHeight": "1.375em",
	"typographyCaptionColor": "rgba(0, 0, 0, 0.87)",
	"typographyButtonFontSize": "14",
	"typographyButtonTextTransform": "uppercase",
	"typographyButtonFontWeight": "400",
	"typographyButtonFontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyDisplay4FontSize": "7rem",
	"typographyDisplay4FontWeight": "300",
	"typographyDisplay4FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyDisplay4LetterSpacing": "-0.04em",
	"typographyDisplay4LineHeight": "1.2",
	"typographyDisplay4MarginLeft": "-0.06em",
	"typographyDisplay4Color": "rgba(0, 0, 0, 0.54)",
	"typographyDisplay3FontSize": "3.5rem",
	"typographyDisplay3FontWeight": "400",
	"typographyDisplay3FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyDisplay3LetterSpacing": "-0.02em",
	"typographyDisplay3LineHeight": "1.2",
	"typographyDisplay3MarginLeft": "-0.04em",
	"typographyDisplay3Color": "rgba(0, 0, 0, 0.54)",
	"typographyDisplay2FontSize": "2.8125rem",
	"typographyDisplay2FontWeight": "400",
	"typographyDisplay2FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyDisplay2LineHeight": "1.06667em",
	"typographyDisplay2MarginLeft": "-0.04em",
	"typographyDisplay2Color": "rgba(0, 0, 0, 0.54)",
	"typographyDisplay1FontSize": "2.125rem",
	"typographyDisplay1FontWeight": "400",
	"typographyDisplay1FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyDisplay1LineHeight": "1.2em",
	"typographyDisplay1MarginLeft": "0em",
	"typographyDisplay1Color": "rgba(0, 0, 0, 0.54)",
	"typographyHeadlineFontSize": "1.5rem",
	"typographyHeadlineFontWeight": "400",
	"typographyHeadlineFontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyHeadlineLineHeight": "1.35417em",
	"typographyHeadlineColor": "rgba(0, 0, 0, 0.87)",
	"typographyTitleFontSize": "1.25rem",
	"typographyTitleFontWeight": "500",
	"typographyTitleFontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyTitleLineHeight": "1.5rem",
	"typographyTitleColor": "rgba(0, 0, 0, 0.87)",
	"typographySubheading2FontSize": "1rem",
	"typographySubheading2FontWeight": "500",
	"typographySubheading2FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographySubheading2LineHeight": "1.5rem",
	"typographySubheading2Color": "rgba(0, 0, 0, 0.87)",
	"typographySubheadingFontSize": "1rem",
	"typographySubheadingFontWeight": "400",
	"typographySubheadingFontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographySubheadingLineHeight": "1.5em",
	"typographySubheadingColor": "rgba(0, 0, 0, 0.87)",
	"typographyH1FontSize": "7rem",
	"typographyH1FontWeight": "300",
	"typographyH1FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyH1LetterSpacing": "-0.04em",
	"typographyH1LineHeight": "1.2",
	"typographyH1MarginLeft": "-0.06em",
	"typographyH1Color": "rgba(0, 0, 0, 0.54)",
	"typographyH2FontSize": "3.5rem",
	"typographyH2FontWeight": "400",
	"typographyH2FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyH2LetterSpacing": "-0.02em",
	"typographyH2LineHeight": "1.2",
	"typographyH2MarginLeft": "-0.04em",
	"typographyH2Color": "rgba(0, 0, 0, 0.54)",
	"typographyH3FontSize": "2.8125rem",
	"typographyH3FontWeight": "400",
	"typographyH3FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyH3LineHeight": "1.06667em",
	"typographyH3MarginLeft": "-0.04em",
	"typographyH3Color": "rgba(0, 0, 0, 0.54)",
	"typographyH4FontSize": "2.125rem",
	"typographyH4FontWeight": "400",
	"typographyH4FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyH4LineHeight": "1.2em",
	"typographyH4MarginLeft": "0em",
	"typographyH4Color": "rgba(0, 0, 0, 0.54)",
	"typographyH5FontSize": "1.5rem",
	"typographyH5FontWeight": "400",
	"typographyH5FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyH5LineHeight": "1.35417em",
	"typographyH5Color": "rgba(0, 0, 0, 0.87)",
	"typographyH6FontSize": "1.25rem",
	"typographyH6FontWeight": "500",
	"typographyH6FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographyH6LineHeight": "1.5rem",
	"typographyH6Color": "rgba(0, 0, 0, 0.87)",
	"typographySubtitle1FontSize": "1rem",
	"typographySubtitle1FontWeight": "400",
	"typographySubtitle1FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographySubtitle1LineHeight": "1.5em",
	"typographySubtitle1Color": "rgba(0, 0, 0, 0.87)",
	"typographySubtitle2FontSize": "1rem",
	"typographySubtitle2FontWeight": "500",
	"typographySubtitle2FontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
	"typographySubtitle2LineHeight": "1.5rem",
	"typographySubtitle2Color": "rgba(0, 0, 0, 0.87)",
	"mixinsToolbarMinHeight": "56",
	"breakpointsValuesXS": "360",
	"breakpointsValuesSM": "600",
	"breakpointsValuesMD": "960",
	"breakpointsValuesLG": "1280",
	"breakpointsValuesXL": "1920",
	"shadows0": "none",
	"shadows1": "0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12)",
	"shadows2": "0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)",
	"shadows3": "0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.12)",
	"shadows4": "0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12)",
	"shadows5": "0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14), 0 1px 14px 0 rgba(0, 0, 0, 0.12)",
	"shadows6": "0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12)",
	"shadows7": "0 4px 5px -2px rgba(0, 0, 0, 0.2), 0 7px 10px 1px rgba(0, 0, 0, 0.14), 0 2px 16px 1px rgba(0, 0, 0, 0.12)",
	"shadows8": "0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)",
	"shadows9": "0 5px 6px -3px rgba(0, 0, 0, 0.2), 0 9px 12px 1px rgba(0, 0, 0, 0.14), 0 3px 16px 2px rgba(0, 0, 0, 0.12)",
	"shadows10": "0 6px 6px -3px rgba(0, 0, 0, 0.2), 0 10px 14px 1px rgba(0, 0, 0, 0.14), 0 4px 18px 3px rgba(0, 0, 0, 0.12)",
	"shadows11": "0 6px 7px -4px rgba(0, 0, 0, 0.2), 0 11px 15px 1px rgba(0, 0, 0, 0.14), 0 4px 20px 3px rgba(0, 0, 0, 0.12)",
	"shadows12": "0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12)",
	"shadows13": "0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 13px 19px 2px rgba(0, 0, 0, 0.14), 0 5px 24px 4px rgba(0, 0, 0, 0.12)",
	"shadows14": "0 7px 9px -4px rgba(0, 0, 0, 0.2), 0 14px 21px 2px rgba(0, 0, 0, 0.14), 0 5px 26px 4px rgba(0, 0, 0, 0.12)",
	"shadows15": "0 8px 9px -5px rgba(0, 0, 0, 0.2), 0 15px 22px 2px rgba(0, 0, 0, 0.14), 0 6px 28px 5px rgba(0, 0, 0, 0.12)",
	"shadows16": "0 8px 10px -5px rgba(0, 0, 0, 0.2), 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12)",
	"shadows17": "0 8px 11px -5px rgba(0, 0, 0, 0.2), 0 17px 26px 2px rgba(0, 0, 0, 0.14), 0 6px 32px 5px rgba(0, 0, 0, 0.12)",
	"shadows18": "0 9px 11px -5px rgba(0, 0, 0, 0.2), 0 18px 28px 2px rgba(0, 0, 0, 0.14), 0 7px 34px 6px rgba(0, 0, 0, 0.12)",
	"shadows19": "0 9px 12px -6px rgba(0, 0, 0, 0.2), 0 19px 29px 2px rgba(0, 0, 0, 0.14), 0 7px 36px 6px rgba(0, 0, 0, 0.12)",
	"shadows20": "0 10px 13px -6px rgba(0, 0, 0, 0.2), 0 20px 31px 3px rgba(0, 0, 0, 0.14), 0 8px 38px 7px rgba(0, 0, 0, 0.12)",
	"shadows21": "0 10px 13px -6px rgba(0, 0, 0, 0.2), 0 21px 33px 3px rgba(0, 0, 0, 0.14), 0 8px 40px 7px rgba(0, 0, 0, 0.12)",
	"shadows22": "0 10px 14px -6px rgba(0, 0, 0, 0.2), 0 22px 35px 3px rgba(0, 0, 0, 0.14), 0 8px 42px 7px rgba(0, 0, 0, 0.12)",
	"shadows23": "0 11px 14px -7px rgba(0, 0, 0, 0.2), 0 23px 36px 3px rgba(0, 0, 0, 0.14), 0 9px 44px 8px rgba(0, 0, 0, 0.12)",
	"shadows24": "0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12)",
	"shapeBorderRadius": "4",
	"transitionsEasingEaseInOut": "cubic-bezier(0.4, 0, 0.2, 1)",
	"transitionsEasingEaseOut": "cubic-bezier(0, 0, 0.2, 1)",
	"transitionsEasingEaseIn": "cubic-bezier(0.4, 0, 1, 1)",
	"transitionsEasingSharp": "cubic-bezier(0.4, 0, 0.6, 1)",
	"transitionsDurationShortest": "150",
	"transitionsDurationShorter": "200",
	"transitionsDurationShort": "250",
	"transitionsDurationStandard": "300",
	"transitionsDurationComplex": "375",
	"transitionsDurationEnteringScreen": "225",
	"transitionsDurationLeavingScreen": "195",
	"spacingUnitClose": "5",
	"spacingUnit": "8",
	"zIndexMobileStepper": "900",
	"zIndexMenu": "1000",
	"zIndexAppBar": "1100",
	"zIndexDrawerOverlay": "1200",
	"zIndexPopover": "1250",
	"zIndexNavDrawer": "1300",
	"zIndexDialogOverlay": "1400",
	"zIndexDialog": "1500",
	"zIndexLoginModal": "1501",
	"zIndexLayer": "2000",
	"zIndexSnackbar": "2900",
	"zIndexTooltip": "3000",
	"backgroundColor": "#f5f7f8",
	"secondaryBaseColor": "#249297",
	"brandPink": "#ff4686",
	"brandRed": "#D82F2F",
	"brandGreen": "#53bac3",
	"informationalBlue": "#4990e2",
	"success": "#4caf5a",
	"warning": "#ff9100",
	"navBarWidth": "53",
	"titleBarHeight": "54",
	"mobileTitleBarHeight": "64",
	"collapsiblePanelTitleHeight": "56",
	"primaryBaseColor": "#119aab"
};

/***/ }),

/***/ "./node_modules/css-loader/lib/css-base.js":
/*!*************************************************!*\
  !*** ./node_modules/css-loader/lib/css-base.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/setimmediate/setImmediate.js":
/*!***************************************************!*\
  !*** ./node_modules/setimmediate/setImmediate.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/style-loader/lib/addStyles.js":
/*!****************************************************!*\
  !*** ./node_modules/style-loader/lib/addStyles.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(/*! ./urls */ "./node_modules/style-loader/lib/urls.js");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "./node_modules/style-loader/lib/urls.js":
/*!***********************************************!*\
  !*** ./node_modules/style-loader/lib/urls.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "./node_modules/timers-browserify/main.js":
/*!************************************************!*\
  !*** ./node_modules/timers-browserify/main.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(/*! setimmediate */ "./node_modules/setimmediate/setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/AuditBar/index.jsx":
/*!********************************!*\
  !*** ./src/AuditBar/index.jsx ***!
  \********************************/
/*! exports provided: avatarLetters, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "avatarLetters", function() { return avatarLetters; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _Avatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Avatar */ "./src/Avatar/index.jsx");
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Icon */ "./src/Icon/index.js");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./index.scss */ "./src/AuditBar/index.scss");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_6__);








var actionMessages = {
  create: 'Created on',
  complete: 'Completed on',
  update: 'Updated on',
  delete: 'Deleted on',
  restrict: 'Restricted on'
};

var avatarLetters = function avatarLetters() {
  var userName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var names = userName.split(' ').slice(-2); // get last two names
  if (names.length === 0) {
    return '';
  }
  if (names.length === 1) {
    return names[0].slice(0, 1).toUpperCase();
  }
  return (names[0].slice(0, 1) + names[1].slice(0, 1)).toUpperCase();
};

var AuditBar = function AuditBar(_ref) {
  var className = _ref.className,
      userName = _ref.userName,
      action = _ref.action,
      date = _ref.date,
      message = _ref.message,
      icon = _ref.icon,
      noIcon = _ref.noIcon;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, _index_scss__WEBPACK_IMPORTED_MODULE_6___default.a.root)
    },
    !noIcon && (icon || userName) && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Avatar__WEBPACK_IMPORTED_MODULE_4__["default"],
      { classes: { colorDefault: _index_scss__WEBPACK_IMPORTED_MODULE_6___default.a.avatar } },
      icon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_5__["default"], { component: icon, size: 'small' }) || avatarLetters(userName)
    ),
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Typography__WEBPACK_IMPORTED_MODULE_3__["default"],
      { className: _index_scss__WEBPACK_IMPORTED_MODULE_6___default.a.text, variant: 'caption' },
      message || (action ? actionMessages[action] : '') + (date ? ' ' + date : '') + (userName ? ' by ' + userName : '')
    )
  );
};

AuditBar.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** name of the user userd in avatar and message */
  userName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** audit action */
  action: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf([undefined, 'create', 'complete', 'update', 'delete', 'restrict']),
  /** audit date */
  date: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** if message specified, action and date will be ignored */
  message: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** avatar icon */
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** if set, the audit bar will not include an avatar */
  noIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};
AuditBar.defaultProps = {
  className: undefined,
  userName: undefined,
  action: undefined,
  date: undefined,
  message: undefined,
  icon: undefined,
  noIcon: false
};

/* harmony default export */ __webpack_exports__["default"] = (AuditBar);

/***/ }),

/***/ "./src/AuditBar/index.scss":
/*!*********************************!*\
  !*** ./src/AuditBar/index.scss ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./index.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/AuditBar/index.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/AuditBarGroup/index.jsx":
/*!*************************************!*\
  !*** ./src/AuditBarGroup/index.jsx ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./index.scss */ "./src/AuditBarGroup/index.scss");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_3__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var AuditBarGroup = function AuditBarGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ['className', 'children']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    _extends({
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, _index_scss__WEBPACK_IMPORTED_MODULE_3___default.a.root)
    }, other),
    children
  );
};

AuditBarGroup.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};

AuditBarGroup.defaultProps = {
  className: undefined,
  children: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (AuditBarGroup);

/***/ }),

/***/ "./src/AuditBarGroup/index.scss":
/*!**************************************!*\
  !*** ./src/AuditBarGroup/index.scss ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./index.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/AuditBarGroup/index.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Avatar/index.jsx":
/*!******************************!*\
  !*** ./src/Avatar/index.jsx ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Avatar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Avatar */ "@material-ui/core/Avatar");
/* harmony import */ var _material_ui_core_Avatar__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Avatar__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./index.scss */ "./src/Avatar/index.scss");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var Avatar = function Avatar(_ref) {
  var color = _ref.color,
      className = _ref.className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ['color', 'className', 'children']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Avatar__WEBPACK_IMPORTED_MODULE_1___default.a,
    _extends({
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_index_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, className, 'gtu-avatar', _index_scss__WEBPACK_IMPORTED_MODULE_4___default.a[color])
    }, other),
    children
  );
};
Avatar.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  color: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(['error', 'warning', 'success', 'brandGreen', 'default'])
};
Avatar.defaultProps = {
  children: undefined,
  className: undefined,
  color: 'default'
};

// const Avatar = "test";
/* harmony default export */ __webpack_exports__["default"] = (Avatar);

/***/ }),

/***/ "./src/Avatar/index.scss":
/*!*******************************!*\
  !*** ./src/Avatar/index.scss ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./index.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Avatar/index.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Badge/InlineBadge.jsx":
/*!***********************************!*\
  !*** ./src/Badge/InlineBadge.jsx ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _inlineBadge_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./inlineBadge.scss */ "./src/Badge/inlineBadge.scss");
/* harmony import */ var _inlineBadge_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_inlineBadge_scss__WEBPACK_IMPORTED_MODULE_3__);





var InlineBadge = function InlineBadge(_ref) {
  var badgeContent = _ref.badgeContent,
      className = _ref.className;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'span',
    { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_inlineBadge_scss__WEBPACK_IMPORTED_MODULE_3___default.a.root, 'gtu-Badge', className) },
    badgeContent
  );
};

InlineBadge.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  badgeContent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};

InlineBadge.defaultProps = {
  className: undefined,
  badgeContent: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (InlineBadge);

/***/ }),

/***/ "./src/Badge/component.jsx":
/*!*********************************!*\
  !*** ./src/Badge/component.jsx ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_Badge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/Badge */ "@material-ui/core/Badge");
/* harmony import */ var _material_ui_core_Badge__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Badge__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.scss */ "./src/Badge/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var defaultClasses = {
  root: _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root,
  badge: _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.badge,
  colorSecondary: _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.colorSecondary
};

var Badge = function Badge(_ref) {
  var className = _ref.className,
      context = _ref.context,
      classes = _ref.classes,
      rest = _objectWithoutProperties(_ref, ['className', 'context', 'classes']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_Badge__WEBPACK_IMPORTED_MODULE_2___default.a, _extends({
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('gtu-Badge', className, _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.badgeWrapper, _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a['context-' + context]),
    classes: _extends({}, defaultClasses, classes)
  }, rest));
};

Badge.propTypes = {
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  context: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['default', 'toolbar'])
};

Badge.defaultProps = {
  className: undefined,
  context: 'default',
  classes: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (Badge);

/***/ }),

/***/ "./src/Badge/index.js":
/*!****************************!*\
  !*** ./src/Badge/index.js ***!
  \****************************/
/*! exports provided: default, InlineBadge */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Badge/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _InlineBadge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./InlineBadge */ "./src/Badge/InlineBadge.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InlineBadge", function() { return _InlineBadge__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),

/***/ "./src/Badge/inlineBadge.scss":
/*!************************************!*\
  !*** ./src/Badge/inlineBadge.scss ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./inlineBadge.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Badge/inlineBadge.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Badge/styles.scss":
/*!*******************************!*\
  !*** ./src/Badge/styles.scss ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Badge/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Breadcrumb/breadcrumb.jsx":
/*!***************************************!*\
  !*** ./src/Breadcrumb/breadcrumb.jsx ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _breadcrumb_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./breadcrumb.scss */ "./src/Breadcrumb/breadcrumb.scss");
/* harmony import */ var _breadcrumb_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_breadcrumb_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils */ "./src/utils.js");







var Breadcrumb = function Breadcrumb(_ref) {
  var className = _ref.className,
      children = _ref.children,
      separator = _ref.separator;

  var sep = function sep() {
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Typography__WEBPACK_IMPORTED_MODULE_3__["default"], { key: 'sep_' + Object(_utils__WEBPACK_IMPORTED_MODULE_5__["randomString"])(8), className: _breadcrumb_scss__WEBPACK_IMPORTED_MODULE_4___default.a.separator, 'data-text': separator });
  };
  var crumbItems = react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.toArray(children).map(function (child) {
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["cloneElement"])(child, { key: 'crumb_' + Object(_utils__WEBPACK_IMPORTED_MODULE_5__["randomString"])(8) });
  });
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, _breadcrumb_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root) },
    Object(_utils__WEBPACK_IMPORTED_MODULE_5__["makeLasagna"])(sep, crumbItems)
  );
};

Breadcrumb.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  separator: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.element)
};

Breadcrumb.defaultProps = {
  className: undefined,
  separator: '>',
  children: []
};

/* harmony default export */ __webpack_exports__["default"] = (Breadcrumb);

/***/ }),

/***/ "./src/Breadcrumb/breadcrumb.scss":
/*!****************************************!*\
  !*** ./src/Breadcrumb/breadcrumb.scss ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./breadcrumb.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Breadcrumb/breadcrumb.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Breadcrumb/index.js":
/*!*********************************!*\
  !*** ./src/Breadcrumb/index.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _breadcrumb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./breadcrumb */ "./src/Breadcrumb/breadcrumb.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _breadcrumb__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),

/***/ "./src/Button/_iconSpacer.jsx":
/*!************************************!*\
  !*** ./src/Button/_iconSpacer.jsx ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var styles = function styles(theme) {
  return {
    size: {
      width: '24px',
      height: '24px'
    },
    left: {
      'margin-right': theme.spacing.unit * 0.5
    },
    right: {
      'margin-left': theme.spacing.unit * 0.5
    }
  };
};

var IconSpacer = function IconSpacer(props) {
  var _classnames;

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    { className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(props.classes.size, (_classnames = {}, _defineProperty(_classnames, props.classes.left, props.left), _defineProperty(_classnames, props.classes.right, props.right), _classnames)) },
    props.children
  );
};

IconSpacer.defaultProps = {
  left: false,
  right: false
};

IconSpacer.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,
  left: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  right: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object.isRequired // eslint-disable-line react/forbid-prop-types
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__["withStyles"])(styles)(IconSpacer));

/***/ }),

/***/ "./src/Button/baseButton.jsx":
/*!***********************************!*\
  !*** ./src/Button/baseButton.jsx ***!
  \***********************************/
/*! exports provided: buttonStates, propTypes, defaultProps, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buttonStates", function() { return buttonStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Button */ "@material-ui/core/Button");
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/Button/Button */ "@material-ui/core/Button/Button");
/* harmony import */ var _material_ui_core_Button_Button__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/styles/colorManipulator */ "@material-ui/core/styles/colorManipulator");
/* harmony import */ var _material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _iconOverlay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./iconOverlay */ "./src/Button/iconOverlay.jsx");
/* harmony import */ var _iconSpacer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./_iconSpacer */ "./src/Button/_iconSpacer.jsx");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var buttonStates = {
  default: 'default',
  busy: 'busy',
  error: 'error',
  success: 'success',
  busyDeterminate: 'busyDeterminate'
};

// We use our own style for the disabled button
// Same style also applied in
var disabledButtonStyle = function disabledButtonStyle(theme) {
  return {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.disabled,
    fontWeight: 500
  };
};

var styles = function styles(theme) {
  var root = {
    padding: '5px 16px',
    minWidth: '64px',
    boxShadow: 'none',
    textTransform: 'initial',
    color: theme.palette.primary[500],
    letterSpacing: 'initial',
    fontWeight: theme.typography.fontWeightMedium,
    transition: 'none',
    '&:focus': {
      'background-color': Object(_material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__["fade"])(theme.palette.primary.main, 0.1),
      boxShadow: theme.palette.primary.main + ' 0px 0px 0px 2px'

    },
    '&:hover': {
      'background-color': theme.palette.primary.A800,
      color: theme.palette.primary[500]
    },
    '&:active': {
      'background-color': theme.palette.primary.A100,
      'box-shadow': 'none'
    },
    '&$disabled': disabledButtonStyle(theme)
  };

  return {
    rootWithoutBorder: Object.assign({}, root, {
      '&$disabled': _extends({}, root['&$disabled'], {
        backgroundColor: 'transparent',
        color: theme.palette.text.disabled,
        border: 'none' // @todo remove this once gtu-legacy.css is not loaded for website
      }),
      '&:hover': _extends({}, root['&:hover'], {
        backgroundColor: Object(_material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__["fade"])(theme.palette.primary.main, 0.1)
      })
    }),
    rootWithBorder: Object.assign({}, root, {
      border: '1px solid ' + theme.palette.primary.main,
      '&$disabled': _extends({}, root['&$disabled'], {
        backgroundColor: 'transparent',
        color: theme.palette.text.disabled,
        borderColor: theme.palette.grey[300]
      }),
      '&:hover': _extends({}, root['&:hover'], {
        backgroundColor: Object(_material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__["fade"])(theme.palette.primary.main, 0.1)
      })
    }),
    containedPrimary: {
      color: Object(_material_ui_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__["styles"])(theme).containedPrimary.color,
      border: 'none',
      '&:focus': {
        color: Object(_material_ui_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__["styles"])(theme).containedPrimary.color,
        'background-color': theme.palette.primary[700]
      },
      '&:hover': _extends({}, root['&:hover'], {
        color: Object(_material_ui_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__["styles"])(theme).containedPrimary.color,
        'background-color': theme.palette.primary[400]
      }),
      '&:active': {
        backgroundColor: theme.palette.primary[700]
      },
      '&$disabled': disabledButtonStyle(theme)
    },
    disabled: disabledButtonStyle(theme),
    paddingLeftSmall: { paddingLeft: theme.spacing.unit },
    paddingRightSmall: { paddingRight: theme.spacing.unit },
    overlay: {
      '&$disabled': {
        opacity: 0.65,
        borderWidth: '0'
      }
    }
  };
};

// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var ButtonWithActionState = function (_React$PureComponent) {
  _inherits(ButtonWithActionState, _React$PureComponent);

  function ButtonWithActionState() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ButtonWithActionState);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonWithActionState.__proto__ || Object.getPrototypeOf(ButtonWithActionState)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fakeDefault: false
    }, _this.componentWillUnmount = function () {
      clearTimeout(_this.timer);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ButtonWithActionState, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if ((this.props.state === buttonStates.busy || this.props.state === buttonStates.busyDeterminate) && (nextProps.state === buttonStates.error || nextProps.state === buttonStates.success)) {
        // if moving from busy->error or busy->success go back to a fake default after a sec
        this.timer = setTimeout(function () {
          _this2.setState({
            fakeDefault: true
          });
        }, 1000);
      } else if (this.props.state !== nextProps.state) {
        // if there is any other transition, remove the fakeDefault
        this.setState({
          fakeDefault: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var isDefaultView = this.props.state === buttonStates.default || this.state.fakeDefault;
      var disabled = this.props.disabled || !isDefaultView;

      var _props = this.props,
          state = _props.state,
          children = _props.children,
          label = _props.label,
          iconLeft = _props.iconLeft,
          iconRight = _props.iconRight,
          noBorder = _props.noBorder,
          classes = _props.classes,
          progressPercent = _props.progressPercent,
          other = _objectWithoutProperties(_props, ['state', 'children', 'label', 'iconLeft', 'iconRight', 'noBorder', 'classes', 'progressPercent']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3___default.a,
        _extends({}, other, {
          disableTouchRipple: true,
          disableFocusRipple: true,
          disableRipple: true,
          disabled: disabled,
          classes: {
            containedPrimary: classes.containedPrimary,
            root: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes['root' + (noBorder && !this.props.variant !== 'contained' ? 'Without' : 'With') + 'Border'], (_classNames = {}, _defineProperty(_classNames, classes.paddingLeftSmall, !!this.props.iconLeft), _defineProperty(_classNames, classes.paddingRightSmall, !!this.props.iconRight), _defineProperty(_classNames, classes.overlay, !isDefaultView), _classNames)),
            disabled: classes.disabled
          }
        }),
        this.props.iconLeft && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _iconSpacer__WEBPACK_IMPORTED_MODULE_8__["default"],
          { left: true },
          this.props.iconLeft
        ),
        this.props.children,
        this.props.label,
        this.props.iconRight && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _iconSpacer__WEBPACK_IMPORTED_MODULE_8__["default"],
          { right: true },
          this.props.iconRight
        ),
        isDefaultView ? null : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_iconOverlay__WEBPACK_IMPORTED_MODULE_7__["default"], { type: this.props.state, progressPercent: progressPercent })
      );
    }
  }]);

  return ButtonWithActionState;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

var propTypes = {
  /** Button is disabled in the busy, error and success states.
   *  Possible values: default | busy | error | success.  */
  state: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['default', 'error', 'success', 'busy', 'busyDeterminate']),

  /* Percentage complete to show when in busyDeterminate state. */
  progressPercent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,

  /** children will be passed to underling button */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node), prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node]),

  /** Set disabled state of the button */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /** Button label */
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** If button is contained, it is ignored if color!=='primary' */
  variant: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Color of button */
  color: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['primary', 'default']),

  /** Icon to appear left of the child nodes */
  iconLeft: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Icon to appear right of the child nodes */
  iconRight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Hide border around button, effectively making it a tertiary button */
  // sorry for the double negative here, but I think users of the
  // button will enjoy simply including `noBorder` as an attributes
  // instead of `showBorder={false}`.
  noBorder: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object.isRequired // eslint-disable-line react/forbid-prop-types
};

ButtonWithActionState.propTypes = propTypes;

var defaultProps = {
  disabled: false,
  children: undefined,
  label: undefined,
  state: buttonStates.default,
  variant: undefined,
  color: 'default',
  iconLeft: undefined,
  iconRight: undefined,
  noBorder: false,
  progressPercent: null
};

ButtonWithActionState.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__["withStyles"])(styles)(ButtonWithActionState));

/***/ }),

/***/ "./src/Button/iconOverlay.jsx":
/*!************************************!*\
  !*** ./src/Button/iconOverlay.jsx ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/CircularProgress */ "@material-ui/core/CircularProgress");
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_Done__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/icons/Done */ "@material-ui/icons/Done");
/* harmony import */ var _material_ui_icons_Done__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Done__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/icons/Close */ "@material-ui/icons/Close");
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_5__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var containerBase = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  'align-items': 'center',
  'justify-content': 'center'
};

var ICON_SIZE = 16;

var styles = function styles(theme) {
  return {
    iconRoot: {
      color: 'white',
      fontSize: ICON_SIZE
    },
    errorContainer: _extends({}, containerBase, {
      borderRadius: theme.shape.borderRadius,
      'background-color': theme.palette.error.main
    }),
    successContainer: _extends({}, containerBase, {
      borderRadius: theme.shape.borderRadius,
      'background-color': theme.success
    }),
    busyContainer: _extends({}, containerBase, {
      borderRadius: theme.shape.borderRadius,
      'background-color': theme.palette.primary.main
    })
  };
};

var variations = {
  error: {
    styleClass: 'errorContainer',
    iconComponent: _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_5___default.a,
    iconExtraProps: function iconExtraProps() {
      return {};
    }
  },
  success: {
    styleClass: 'successContainer',
    iconComponent: _material_ui_icons_Done__WEBPACK_IMPORTED_MODULE_4___default.a,
    iconExtraProps: function iconExtraProps() {
      return {};
    }
  },
  busy: {
    styleClass: 'busyContainer',
    iconComponent: _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_3___default.a,
    iconExtraProps: function iconExtraProps() {
      return {};
    }
  },
  busyDeterminate: {
    styleClass: 'busyContainer',
    iconComponent: _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_3___default.a,
    iconExtraProps: function iconExtraProps(props) {
      return {
        variant: 'determinate',
        min: 0,
        max: 100,
        value: props.progressPercent
      };
    }
  }
};

var IconOverlay = function IconOverlay(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    { className: props.classes[variations[props.type].styleClass] },
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(variations[props.type].iconComponent, _extends({
      size: props.iconSize,
      classes: { root: props.classes.iconRoot }
    }, variations[props.type].iconExtraProps(props)))
  );
};

IconOverlay.defaultProps = {
  type: 'busy',
  iconSize: ICON_SIZE,
  progressPercent: null
};

IconOverlay.propTypes = {
  type: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['error', 'success', 'busy', 'busyDeterminate']),
  iconSize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object.isRequired, // eslint-disable-line react/forbid-prop-types
  progressPercent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number // eslint-disable-line react/no-unused-prop-types
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__["withStyles"])(styles)(IconOverlay));

/***/ }),

/***/ "./src/Button/index.jsx":
/*!******************************!*\
  !*** ./src/Button/index.jsx ***!
  \******************************/
/*! exports provided: buttonStates, default, PrimaryButton, primaryButtonPropTypes, primaryButtonDefaultProps, SecondaryButton, secondaryButtonPropTypes, secondaryButtonDefaultProps, TertiaryButton, tertiaryButtonPropTypes, tertiaryButtonDefaultProps, SlideActionButton */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _baseButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./baseButton */ "./src/Button/baseButton.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "buttonStates", function() { return _baseButton__WEBPACK_IMPORTED_MODULE_0__["buttonStates"]; });

/* harmony import */ var _primary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./primary */ "./src/Button/primary.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PrimaryButton", function() { return _primary__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "primaryButtonPropTypes", function() { return _primary__WEBPACK_IMPORTED_MODULE_1__["propTypes"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "primaryButtonDefaultProps", function() { return _primary__WEBPACK_IMPORTED_MODULE_1__["defaultProps"]; });

/* harmony import */ var _secondary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./secondary */ "./src/Button/secondary.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SecondaryButton", function() { return _secondary__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "secondaryButtonPropTypes", function() { return _secondary__WEBPACK_IMPORTED_MODULE_2__["propTypes"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "secondaryButtonDefaultProps", function() { return _secondary__WEBPACK_IMPORTED_MODULE_2__["defaultProps"]; });

/* harmony import */ var _tertiary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./tertiary */ "./src/Button/tertiary.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TertiaryButton", function() { return _tertiary__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "tertiaryButtonPropTypes", function() { return _tertiary__WEBPACK_IMPORTED_MODULE_3__["propTypes"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "tertiaryButtonDefaultProps", function() { return _tertiary__WEBPACK_IMPORTED_MODULE_3__["defaultProps"]; });

/* harmony import */ var _slideAction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./slideAction */ "./src/Button/slideAction.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SlideActionButton", function() { return _slideAction__WEBPACK_IMPORTED_MODULE_4__["default"]; });





// Remove this once everyone has moved onto the new exports below.
/* harmony default export */ __webpack_exports__["default"] = (_baseButton__WEBPACK_IMPORTED_MODULE_0__["default"]);

// Use these instead of BaseButton.
















/***/ }),

/***/ "./src/Button/primary.jsx":
/*!********************************!*\
  !*** ./src/Button/primary.jsx ***!
  \********************************/
/*! exports provided: propTypes, defaultProps, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _baseButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./baseButton */ "./src/Button/baseButton.jsx");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils */ "./src/utils.js");




var PrimaryButton = function PrimaryButton(props) {
  var newProps = Object.assign({}, props, {
    color: 'primary',
    variant: 'contained'
  });
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_baseButton__WEBPACK_IMPORTED_MODULE_1__["default"], newProps);
};

var propTypes = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["removeProps"])(_baseButton__WEBPACK_IMPORTED_MODULE_1__["propTypes"], ['classes']);
PrimaryButton.propTypes = propTypes;

var defaultProps = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["removeProps"])(_baseButton__WEBPACK_IMPORTED_MODULE_1__["defaultProps"], ['classes']);
PrimaryButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["default"] = (PrimaryButton);

/***/ }),

/***/ "./src/Button/secondary.jsx":
/*!**********************************!*\
  !*** ./src/Button/secondary.jsx ***!
  \**********************************/
/*! exports provided: propTypes, defaultProps, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _baseButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./baseButton */ "./src/Button/baseButton.jsx");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils */ "./src/utils.js");




var SecondaryButton = function SecondaryButton(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_baseButton__WEBPACK_IMPORTED_MODULE_1__["default"], props);
};

var propTypes = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["removeProps"])(_baseButton__WEBPACK_IMPORTED_MODULE_1__["propTypes"], ['classes']);
SecondaryButton.propTypes = propTypes;
var defaultProps = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["removeProps"])(_baseButton__WEBPACK_IMPORTED_MODULE_1__["defaultProps"], ['classes']);
SecondaryButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["default"] = (SecondaryButton);

/***/ }),

/***/ "./src/Button/slideAction.jsx":
/*!************************************!*\
  !*** ./src/Button/slideAction.jsx ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Button */ "@material-ui/core/Button");
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _slideAction_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./slideAction.scss */ "./src/Button/slideAction.scss");
/* harmony import */ var _slideAction_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_slideAction_scss__WEBPACK_IMPORTED_MODULE_4__);







var SlideActionButton = function SlideActionButton(_ref) {
  var className = _ref.className,
      label = _ref.label,
      onClick = _ref.onClick,
      color = _ref.color,
      iconTop = _ref.iconTop;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3___default.a,
    { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, _slideAction_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, _slideAction_scss__WEBPACK_IMPORTED_MODULE_4___default.a[color]), onClick: onClick },
    iconTop,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      null,
      label
    )
  );
};

SlideActionButton.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Button label */
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Button action */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,

  /** Color of button */
  color: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['brandRed']).isRequired,

  /** Icon to appear top of the child nodes */
  iconTop: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};

SlideActionButton.defaultProps = {
  className: undefined,
  label: undefined,
  onClick: undefined,
  iconTop: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (SlideActionButton);

/***/ }),

/***/ "./src/Button/slideAction.scss":
/*!*************************************!*\
  !*** ./src/Button/slideAction.scss ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./slideAction.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Button/slideAction.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Button/tertiary.jsx":
/*!*********************************!*\
  !*** ./src/Button/tertiary.jsx ***!
  \*********************************/
/*! exports provided: propTypes, defaultProps, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _baseButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./baseButton */ "./src/Button/baseButton.jsx");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TertiaryButton = function TertiaryButton(props) {
  var newProps = _extends({}, props, { noBorder: true });
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_baseButton__WEBPACK_IMPORTED_MODULE_1__["default"], newProps);
};

var propTypes = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["removeProps"])(_baseButton__WEBPACK_IMPORTED_MODULE_1__["propTypes"], ['classes']);
TertiaryButton.propTypes = propTypes;
var defaultProps = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["removeProps"])(_baseButton__WEBPACK_IMPORTED_MODULE_1__["defaultProps"], ['classes']);
TertiaryButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["default"] = (TertiaryButton);

/***/ }),

/***/ "./src/ButtonGroup/component.jsx":
/*!***************************************!*\
  !*** ./src/ButtonGroup/component.jsx ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/icons/ArrowDropDown */ "@material-ui/icons/ArrowDropDown");
/* harmony import */ var _material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Button */ "./src/Button/index.jsx");
/* harmony import */ var _SplitButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../SplitButton */ "./src/SplitButton/index.js");
/* harmony import */ var _ButtonMenu__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../ButtonMenu */ "./src/ButtonMenu/index.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var ButtonGroup = function ButtonGroup(_ref) {
  var className = _ref.className,
      blockingActions = _ref.blockingActions,
      destructive = _ref.destructive,
      tertiary = _ref.tertiary,
      secondary = _ref.secondary,
      primary = _ref.primary;

  var destructiveButtonConfigs = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["castArray"])(destructive);
  var tertiaryButtonConfigs = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["castArray"])(tertiary);
  var secondaryButtonConfigs = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["castArray"])(secondary);
  var primaryButtonConfigs = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["castArray"])(primary);

  var allButtonConfigs = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["flatten"])([destructiveButtonConfigs, tertiaryButtonConfigs, secondaryButtonConfigs, primaryButtonConfigs]);

  var anyBlockingActionInFlight = allButtonConfigs.find(function (buttonConfig) {
    var isBlockingAction = 'blockingAction' in buttonConfig ? buttonConfig.blockingAction : blockingActions;
    var isBusy = buttonConfig.state === _Button__WEBPACK_IMPORTED_MODULE_5__["buttonStates"].busy || buttonConfig.state === _Button__WEBPACK_IMPORTED_MODULE_5__["buttonStates"].busyDeterminate;

    return isBlockingAction && isBusy;
  }) !== undefined;

  var leftMostButton = function leftMostButton(_ref2) {
    var key = _ref2.key;

    if (destructiveButtonConfigs.findIndex(function (config) {
      return config.key === key;
    }) > -1) {
      return true;
    }
    if (tertiaryButtonConfigs.length > 0) {
      return key === tertiaryButtonConfigs[0].key;
    }
    if (secondaryButtonConfigs.length > 0) {
      return key === secondaryButtonConfigs[0].key;
    }
    if (primaryButtonConfigs.length > 0) {
      return key === primaryButtonConfigs[0].key;
    }
    return false;
  };

  var buttonProps = function buttonProps(buttonConfig, buttonClassName) {
    var _classNames;

    var isBlockingAction = 'blockingAction' in buttonConfig ? buttonConfig.blockingAction : blockingActions;

    return _extends({}, Object(lodash__WEBPACK_IMPORTED_MODULE_3__["omit"])(_extends({}, buttonConfig, {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_classNames = {}, _defineProperty(_classNames, buttonConfig.className, !!buttonConfig.className), _defineProperty(_classNames, buttonClassName, !!buttonClassName), _classNames)),
      disabled: isBlockingAction && anyBlockingActionInFlight || buttonConfig.disabled
    }), ['blockingAction', 'split', 'menuItems', 'menu']));
  };

  var handleOnClick = function handleOnClick(config, submit) {
    return config.onClick && submit ? Object(_utils__WEBPACK_IMPORTED_MODULE_9__["preventDefault"])(config.onClick) : config.onClick;
  };

  var renderButton = function renderButton(Component, config, order) {
    var submit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // eslint-disable-line
    var extraClassName = leftMostButton(config) ? undefined : classnames__WEBPACK_IMPORTED_MODULE_2___default()([___WEBPACK_IMPORTED_MODULE_8__["layout"].marginLeftSmall]);

    if (config.split) {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_SplitButton__WEBPACK_IMPORTED_MODULE_6__["default"], _extends({
        buttonComponent: Component,
        style: { order: order },
        menuItems: config.menuItems
      }, buttonProps(config, extraClassName)));
    }
    if (config.menu) {
      var state = config.state,
          buttonMenuConfig = _objectWithoutProperties(config, ['state']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _ButtonMenu__WEBPACK_IMPORTED_MODULE_7__["default"],
        _extends({
          alignRight: Component !== _Button__WEBPACK_IMPORTED_MODULE_5__["TertiaryButton"],
          style: { order: order },
          buttonComponent: Component,
          buttonProps: {
            iconRight: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_4___default.a, null),
            state: state
          }
        }, buttonProps(buttonMenuConfig, extraClassName)),
        config.label
      );
    }

    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({
      style: { order: order },
      type: submit ? 'submit' : ''
    }, buttonProps(config, extraClassName), {
      onClick: handleOnClick(config, submit)
    }));
  };

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    {
      id: 'dialog_action_buttons',
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([___WEBPACK_IMPORTED_MODULE_8__["layout"].flexRowContainer, ___WEBPACK_IMPORTED_MODULE_8__["layout"].spaceContentBetween, ___WEBPACK_IMPORTED_MODULE_8__["layout"].fullWidth, className])
    },
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { style: { order: 2 }, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('right', ___WEBPACK_IMPORTED_MODULE_8__["layout"].flexRowContainer) },
      primaryButtonConfigs.map(function (props, i) {
        return renderButton(_Button__WEBPACK_IMPORTED_MODULE_5__["PrimaryButton"], props, 20 + i, primaryButtonConfigs.length === 1);
      }),
      secondaryButtonConfigs.map(function (props, i) {
        return renderButton(_Button__WEBPACK_IMPORTED_MODULE_5__["SecondaryButton"], props, 10 + i);
      }),
      tertiaryButtonConfigs.map(function (props, i) {
        return renderButton(_Button__WEBPACK_IMPORTED_MODULE_5__["TertiaryButton"], props, i);
      })
    ),
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { style: { order: 1 }, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('left', ___WEBPACK_IMPORTED_MODULE_8__["layout"].flexRowContainer) },
      destructiveButtonConfigs.map(function (props, i) {
        return renderButton(_Button__WEBPACK_IMPORTED_MODULE_5__["TertiaryButton"], _extends({}, props, {
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(props.className, ___WEBPACK_IMPORTED_MODULE_8__["layout"].marginRightSmall)
        }), 30 + i);
      })
    )
  );
};

var updatedTertiaryButtonPropTypes = _extends({}, _Button__WEBPACK_IMPORTED_MODULE_5__["tertiaryButtonPropTypes"], {
  blockingAction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  key: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  split: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
});

var updatedSecondaryButtonPropTypes = _extends({}, _Button__WEBPACK_IMPORTED_MODULE_5__["secondaryButtonPropTypes"], {
  blockingAction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  key: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  split: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
});

var updatedPrimaryButtonPropTypes = _extends({}, _Button__WEBPACK_IMPORTED_MODULE_5__["primaryButtonPropTypes"], {
  blockingAction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  key: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  split: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
});

ButtonGroup.propTypes = {
  /** The style to be added to Button group container */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Whether buttons in this group are blocking by default. */
  blockingActions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * Destructive actions are justified to the left side of the group.
   *
   * These values will (with the exception of `blockingAction`) will be supplied
   * to the underlaying button component.
   *
   * These props include (denoted by the "...") the base tertiary button props.
   */
  destructive: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape(updatedTertiaryButtonPropTypes), prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape(updatedTertiaryButtonPropTypes))]),
  /**
   * Tertiary buttons are first in the list of buttons justified to the right
   * side of the group.
   *
   * These values will (with the exception of `blockingAction`) will be supplied
   * to the underlaying button component.
   *
   * These props include (denoted by the "...") the base tertiary button props.
   */
  tertiary: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape(updatedTertiaryButtonPropTypes), prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape(updatedTertiaryButtonPropTypes))]),
  /**
   * Secondary buttons are second in the list of buttons justified to the right
   * side of the group.
   *
   * These values will (with the exception of `blockingAction`) will be supplied
   * to the underlaying button component.
   *
   * These props include (denoted by the "...") the base secondary button props.
   */
  secondary: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape(updatedSecondaryButtonPropTypes), prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape(updatedSecondaryButtonPropTypes))]),
  /**
   * Primary buttons are second in the list of buttons justified to the right
   * side of the group.
   *
   * These values will (with the exception of `blockingAction`) will be supplied
   * to the underlaying button component.
   *
   * These props include (denoted by the "...") the base primary button props.
   */
  primary: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape(updatedPrimaryButtonPropTypes), prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape(updatedPrimaryButtonPropTypes))])
};

ButtonGroup.defaultProps = {
  className: undefined,
  blockingActions: true,
  destructive: [],
  tertiary: [],
  secondary: [],
  primary: []
};

/* harmony default export */ __webpack_exports__["default"] = (ButtonGroup);

/***/ }),

/***/ "./src/ButtonGroup/index.jsx":
/*!***********************************!*\
  !*** ./src/ButtonGroup/index.jsx ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/ButtonGroup/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/ButtonList/component.jsx":
/*!**************************************!*\
  !*** ./src/ButtonList/component.jsx ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/List */ "@material-ui/core/List");
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_List__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/MenuItem */ "@material-ui/core/MenuItem");
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/ListItemIcon */ "@material-ui/core/ListItemIcon");
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/core/ListItemText */ "@material-ui/core/ListItemText");
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @material-ui/core/ListSubheader */ "@material-ui/core/ListSubheader");
/* harmony import */ var _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! uuid */ "uuid");
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../theme_export.scss */ "./src/theme_export.scss");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_theme_export_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_14__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var StyledListSubheader = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9__["withStyles"])({
  root: {
    backgroundColor: '#fff',
    height: '36px',
    lineHeight: '40px',
    paddingTop: _theme_export_scss__WEBPACK_IMPORTED_MODULE_12__["spacingUnit"] * 1.4 + 'px'
  }
})(_material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_8___default.a);

var ButtonList = function (_React$PureComponent) {
  _inherits(ButtonList, _React$PureComponent);

  function ButtonList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ButtonList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonList.__proto__ || Object.getPrototypeOf(ButtonList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false,
      uniqueId: uuid__WEBPACK_IMPORTED_MODULE_10___default()()
    }, _this.closeList = function () {
      _this.setState({ open: false });
    }, _this.handleButtonClick = function () {
      _this.setState({
        open: true
      });
    }, _this.handleWrapperRef = function (node) {
      _this.wrapper = node;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ButtonList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-find-dom-node
      this.anchorEl = Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["findDOMNode"])(this.wrapper);
    }
  }, {
    key: 'handleItemClick',
    value: function handleItemClick(clickedItem, onClick, closeOnClick) {
      var _this2 = this;

      return clickedItem && onClick && function () {
        if (closeOnClick) _this2.closeList();
        if (onClick) onClick(clickedItem);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          disabled = _props.disabled,
          alignRight = _props.alignRight,
          ButtonComponent = _props.buttonComponent,
          children = _props.children,
          buttonProps = _props.buttonProps,
          items = _props.items,
          render = _props.render,
          dataCy = _props.dataCy,
          maxHeight = _props.maxHeight,
          closeOnClick = _props.closeOnClick,
          onClick = _props.onClick,
          rest = _objectWithoutProperties(_props, ['id', 'className', 'disabled', 'alignRight', 'buttonComponent', 'children', 'buttonProps', 'items', 'render', 'dataCy', 'maxHeight', 'closeOnClick', 'onClick']);

      var _state = this.state,
          open = _state.open,
          uniqueId = _state.uniqueId;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        _extends({
          className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, _defineProperty({}, _layout_scss__WEBPACK_IMPORTED_MODULE_14___default.a.flex, !children)),
          ref: this.handleWrapperRef,
          'data-cy': dataCy
        }, rest),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ButtonComponent,
          _extends({
            id: id,
            'aria-owns': open ? 'button-list-' + uniqueId : null,
            'aria-haspopup': 'true',
            onClick: this.handleButtonClick,
            disabled: disabled
          }, buttonProps),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'span',
            { style: { pointerEvents: 'none' } },
            children
          )
        ),
        open && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ___WEBPACK_IMPORTED_MODULE_13__["Popover"],
          {
            id: id ? id + '_popover' : undefined,
            disableRestoreFocus: true,
            disableEnforceFocus: true,
            onClose: this.closeList,
            horizontalAlign: alignRight ? 'right' : 'left',
            open: true,
            anchorEl: this.anchorEl,
            PaperProps: {
              style: {
                maxHeight: maxHeight,
                width: 300
              }
            }
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_List__WEBPACK_IMPORTED_MODULE_4___default.a,
            {
              role: 'list',
              dense: true,
              classes: { root: _layout_scss__WEBPACK_IMPORTED_MODULE_14___default.a.alignLeft },
              id: 'button-list-' + uniqueId,
              key: 'button-list-' + uniqueId,
              'data-cy': dataCy
            },
            this.content
          )
        )
      );
    }
  }, {
    key: 'content',
    get: function get() {
      var _this3 = this;

      var renderItem = function renderItem(item) {
        var onClick = item.onClick,
            label = item.label,
            key = item.key,
            icon = item.icon,
            dataCy = item.dataCy,
            link = item.link,
            rest = _objectWithoutProperties(item, ['onClick', 'label', 'key', 'icon', 'dataCy', 'link']);

        var miComponent = link ? 'a' : undefined;
        var href = link || undefined;

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_5___default.a,
          _extends({
            key: key || label,
            onClick: _this3.handleItemClick(item, _this3.props.onClick, _this3.props.closeOnClick),
            component: miComponent,
            href: href,
            'data-cy': dataCy
          }, rest),
          icon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_6___default.a,
            null,
            icon
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_7___default.a, { primary: label })
        );
      };

      var renderSubItems = function renderSubItems(subItems) {
        return subItems.map(function (item) {
          return renderItem(item);
        });
      };

      return this.props.items.map(function (item) {
        var label = item.label,
            items = item.items,
            key = item.key,
            dataCy = item.dataCy,
            rest = _objectWithoutProperties(item, ['label', 'items', 'key', 'dataCy']);

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          _extends({
            key: key || label
          }, rest),
          items && item && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            StyledListSubheader,
            null,
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              _Typography__WEBPACK_IMPORTED_MODULE_11__["default"],
              {
                color: 'secondary',
                variant: 'caption'
              },
              label
            )
          ),
          items && item && renderSubItems(items),
          !items && item && renderItem(item)
        );
      });
    }
  }]);

  return ButtonList;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

ButtonList.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  items: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    label: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
  })).isRequired,
  render: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  alignRight: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  buttonComponent: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  buttonProps: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object, //eslint-disable-line react/forbid-prop-types
  dataCy: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  closeOnClick: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  maxHeight: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired
};

ButtonList.defaultProps = {
  id: undefined,
  className: undefined,
  disabled: false,
  render: undefined,
  children: null,
  alignRight: false,
  buttonComponent: ___WEBPACK_IMPORTED_MODULE_13__["PrimaryButton"],
  buttonProps: {},
  dataCy: 'button-list',
  closeOnClick: true,
  maxHeight: 300
};

/* harmony default export */ __webpack_exports__["default"] = (ButtonList);

/***/ }),

/***/ "./src/ButtonList/index.jsx":
/*!**********************************!*\
  !*** ./src/ButtonList/index.jsx ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/ButtonList/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/ButtonMenu/component.jsx":
/*!**************************************!*\
  !*** ./src/ButtonMenu/component.jsx ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_MenuList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/MenuList */ "@material-ui/core/MenuList");
/* harmony import */ var _material_ui_core_MenuList__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_MenuList__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/MenuItem */ "@material-ui/core/MenuItem");
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/ListItemIcon */ "@material-ui/core/ListItemIcon");
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! uuid */ "uuid");
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_9__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ButtonMenu = function (_React$PureComponent) {
  _inherits(ButtonMenu, _React$PureComponent);

  function ButtonMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ButtonMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonMenu.__proto__ || Object.getPrototypeOf(ButtonMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false,
      uniqueId: uuid__WEBPACK_IMPORTED_MODULE_7___default()()
    }, _this.setMenuOpen = function () {
      var onMenuStateChanged = _this.props.onMenuStateChanged;
      var open = _this.state.open;


      onMenuStateChanged && onMenuStateChanged(open);
    }, _this.closeMenu = function () {
      _this.setState({ open: false }, _this.setMenuOpen);
    }, _this.handleButtonClick = function () {
      _this.setState({
        open: true
      }, _this.setMenuOpen);
    }, _this.handleWrapperRef = function (node) {
      _this.wrapper = node;
    }, _this.stopPropagation = function (event) {
      event.nativeEvent.stopImmediatePropagation();
      event.preventDefault();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ButtonMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-find-dom-node
      this.anchorEl = Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["findDOMNode"])(this.wrapper);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var onMenuStateChanged = this.props.onMenuStateChanged;

      onMenuStateChanged && onMenuStateChanged(false);
    }
  }, {
    key: 'handleItemClick',
    value: function handleItemClick(itemOnClick, clickable) {
      var _this2 = this;

      // if item is not clickable (e.g. a divider, ignore click event)
      return (itemOnClick || clickable) && function (event) {
        _this2.closeMenu();
        if (itemOnClick) itemOnClick(event);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          disabled = _props.disabled,
          alignRight = _props.alignRight,
          ButtonComponent = _props.buttonComponent,
          children = _props.children,
          buttonProps = _props.buttonProps,
          items = _props.items,
          render = _props.render,
          dataCy = _props.dataCy,
          onMenuStateChanged = _props.onMenuStateChanged,
          other = _objectWithoutProperties(_props, ['id', 'className', 'disabled', 'alignRight', 'buttonComponent', 'children', 'buttonProps', 'items', 'render', 'dataCy', 'onMenuStateChanged']);

      var _state = this.state,
          open = _state.open,
          uniqueId = _state.uniqueId;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        _extends({ className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, _defineProperty({}, _layout_scss__WEBPACK_IMPORTED_MODULE_9___default.a.flex, !children)), ref: this.handleWrapperRef, 'data-cy': dataCy }, other),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ButtonComponent,
          _extends({
            id: id,
            'aria-owns': open ? 'button-menu-' + uniqueId : null,
            'aria-haspopup': 'true',
            onClick: this.handleButtonClick,
            onMouseDown: this.stopPropagation,
            disabled: disabled
          }, buttonProps),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'span',
            { style: { pointerEvents: 'none' } },
            children
          )
        ),
        open &&
        // we have use cases that render ButtonMenu in data list rows,
        // avoid always render popover since too many ClickAwayHandler cause slowness
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ___WEBPACK_IMPORTED_MODULE_8__["Popover"],
          {
            id: id ? id + '_popover' : undefined,
            disableRestoreFocus: true,
            disableEnforceFocus: true,
            onClose: this.closeMenu,
            horizontalAlign: alignRight ? 'right' : 'left',
            open: true,
            anchorEl: this.anchorEl
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_MenuList__WEBPACK_IMPORTED_MODULE_4___default.a,
            { role: 'menu', dense: true, classes: { root: _layout_scss__WEBPACK_IMPORTED_MODULE_9___default.a.alignLeft }, id: 'button-menu-' + uniqueId },
            this.content
          )
        )
      );
    }
  }, {
    key: 'content',
    get: function get() {
      var _this3 = this;

      var render = this.props.render;


      return this.props.items.map(function (item) {
        var onClick = item.onClick,
            clickable = item.clickable,
            link = item.link,
            label = item.label,
            key = item.key,
            icon = item.icon,
            scrollToTop = item.scrollToTop,
            dataCy = item.dataCy,
            rest = _objectWithoutProperties(item, ['onClick', 'clickable', 'link', 'label', 'key', 'icon', 'scrollToTop', 'dataCy']);

        var miComponent = link ? 'a' : undefined;
        var href = link || undefined;

        if (render) {
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_5___default.a,
            _extends({
              onClick: _this3.handleItemClick(onClick, clickable),
              onMouseDown: _this3.stopPropogation,
              key: key || label,
              'data-cy': dataCy
            }, rest),
            render(item)
          );
        }

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_5___default.a,
          _extends({
            onClick: _this3.handleItemClick(onClick, clickable),
            onMouseDown: _this3.stopPropogation,
            key: key || label,
            component: miComponent,
            href: href,
            'data-cy': dataCy
          }, rest),
          icon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_6___default.a,
            null,
            icon
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["ListItemText"], { primary: label })
        );
      });
    }
  }]);

  return ButtonMenu;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

ButtonMenu.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  /** className added to the root div element */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  /** Is the trigger button disabled. */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** Array of menu items. Any extra props are spread to the MenuItem component (e.g. disabled) */
  items: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    // component key, if not provided, label string will be used as key
    key: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
    label: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
    icon: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
    // Must be true for clickable items if onClick function not provided
    clickable: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
    dataCy: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
  })).isRequired,
  // custom render method for items
  render: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  /** Children nodes become the button label */
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  /** Align the right edge of the menu with the right edge of the button. */
  alignRight: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** The component used for the trigger button. */
  buttonComponent: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  /** Props to pass down to the trigger button */
  buttonProps: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object, // eslint-disable-line react/forbid-prop-types
  dataCy: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  onMenuStateChanged: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func
};

ButtonMenu.defaultProps = {
  id: undefined,
  className: undefined,
  disabled: false,
  render: undefined,
  children: null,
  alignRight: false,
  buttonComponent: ___WEBPACK_IMPORTED_MODULE_8__["PrimaryButton"],
  buttonProps: {},
  dataCy: 'button_menu',
  onMenuStateChanged: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (ButtonMenu);

/***/ }),

/***/ "./src/ButtonMenu/index.js":
/*!*********************************!*\
  !*** ./src/ButtonMenu/index.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/ButtonMenu/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/ButtonSet/component.jsx":
/*!*************************************!*\
  !*** ./src/ButtonSet/component.jsx ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ButtonMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../ButtonMenu */ "./src/ButtonMenu/index.js");
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Button */ "./src/Button/index.jsx");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var styles = function styles(theme) {
  return {
    root: {
      display: 'flex'
    },
    button: {
      display: 'inline-block',
      borderRadius: 0,
      borderLeftWidth: 0,
      borderRightWidth: 1,
      '&$firstChild': {
        borderLeftWidth: 1,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius
      },
      '&$lastChild': {
        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius
      }
    },
    firstChild: {},
    lastChild: {},
    primaryButton: {
      borderStyle: 'solid',
      borderColor: theme.palette.common.lightWhite,
      borderBottomWidth: 'inherit',
      borderTopWidth: 'inherit',
      '&$firstChild': {
        borderLeftWidth: 0
      },
      '&$lastChild': {
        borderRightWidth: 0
      }
    }
  };
};

var ButtonSet = function ButtonSet(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['className', 'classes', 'children']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    _extends({ className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, classes.root) }, rest),
    react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.map(children, function (child, index) {
      var _classNames;

      var newProps = {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(child.props.className, classes.button, (_classNames = {}, _defineProperty(_classNames, classes.firstChild, index === 0), _defineProperty(_classNames, classes.lastChild, index === children.length - 1), _defineProperty(_classNames, classes.primaryButton, child.type === _Button__WEBPACK_IMPORTED_MODULE_5__["PrimaryButton"]), _classNames))
      };

      // ButtonMenu needs to pass the className down to the button, not the wrapper
      if (child.type === _ButtonMenu__WEBPACK_IMPORTED_MODULE_4__["default"]) {
        var _classNames2;

        newProps.className = child.props.className; // reset
        newProps.buttonProps = _extends({}, child.props.buttonProps, {
          className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(child.props.buttonProps.className, classes.button, (_classNames2 = {}, _defineProperty(_classNames2, classes.firstChild, index === 0), _defineProperty(_classNames2, classes.lastChild, index === children.length - 1), _defineProperty(_classNames2, classes.primaryButton, child.type === _Button__WEBPACK_IMPORTED_MODULE_5__["PrimaryButton"]), _classNames2))
        });
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.cloneElement(child, newProps);
    })
  );
};

ButtonSet.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};

ButtonSet.defaultProps = {
  className: undefined,
  classes: {},
  children: null
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__["withStyles"])(styles)(ButtonSet));

/***/ }),

/***/ "./src/ButtonSet/index.js":
/*!********************************!*\
  !*** ./src/ButtonSet/index.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/ButtonSet/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/ButtonToolbar/buttonToolbar.jsx":
/*!*********************************************!*\
  !*** ./src/ButtonToolbar/buttonToolbar.jsx ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__);





var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      minHeight: 36, // maintain the same height when empty
      marginLeft: theme.spacing.unit * -0.5,
      marginRight: theme.spacing.unit * -0.5
    },
    button: {
      marginLeft: theme.spacing.unit * 0.5,
      marginRight: theme.spacing.unit * 0.5
    }
  };
};

var buttonToolbar = function buttonToolbar(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      children = _ref.children;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, classes.root) },
    react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.map(children, function (child) {
      return child && react__WEBPACK_IMPORTED_MODULE_0___default.a.cloneElement(child, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(child.props.className, classes.button)
      });
    })
  );
};

buttonToolbar.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};

buttonToolbar.defaultProps = {
  className: undefined,
  classes: undefined,
  children: null
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__["withStyles"])(styles)(buttonToolbar));

/***/ }),

/***/ "./src/ButtonToolbar/index.js":
/*!************************************!*\
  !*** ./src/ButtonToolbar/index.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _buttonToolbar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./buttonToolbar */ "./src/ButtonToolbar/buttonToolbar.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _buttonToolbar__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Callout/Buttons/StyledCheckButton.jsx":
/*!***************************************************!*\
  !*** ./src/Callout/Buttons/StyledCheckButton.jsx ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_icons_Check__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/icons/Check */ "@material-ui/icons/Check");
/* harmony import */ var _material_ui_icons_Check__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Check__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../IconButton */ "./src/IconButton/index.jsx");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../theme_export.scss */ "./src/theme_export.scss");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_theme_export_scss__WEBPACK_IMPORTED_MODULE_4__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var styles = {
  root: {
    color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteCommonFullWhite"],
    backgroundColor: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["palettePrimaryMain"],
    '&:hover': {
      color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteCommonFullWhite"],
      backgroundColor: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["palettePrimary700"]
    },
    '&:focus': {
      color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteCommonFullWhite"],
      backgroundColor: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["palettePrimary700"]
    },
    '&:disabled': {
      color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteShadesLightTextDisabled"],
      backgroundColor: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteGrey300"]
    }
  }
};

var StyledButton = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__["withStyles"])(styles)(_IconButton__WEBPACK_IMPORTED_MODULE_3__["default"]);

var StyledCheckButton = function StyledCheckButton(_ref) {
  var other = _objectWithoutProperties(_ref, []);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    StyledButton,
    other,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Check__WEBPACK_IMPORTED_MODULE_1___default.a, null)
  );
};

/* harmony default export */ __webpack_exports__["default"] = (StyledCheckButton);

/***/ }),

/***/ "./src/Callout/Buttons/StyledCloseButton.jsx":
/*!***************************************************!*\
  !*** ./src/Callout/Buttons/StyledCloseButton.jsx ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/icons/Close */ "@material-ui/icons/Close");
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../IconButton */ "./src/IconButton/index.jsx");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../theme_export.scss */ "./src/theme_export.scss");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_theme_export_scss__WEBPACK_IMPORTED_MODULE_4__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var styles = {
  root: {
    color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteSecondaryMain"],
    border: '1px solid ' + _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteSecondaryMain"],
    '&:hover': {
      color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteSecondaryMain"],
      backgroundColor: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteSecondaryA800"]
    },
    '&:focus': {
      color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteSecondaryMain"],
      backgroundColor: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteSecondaryA800"]
    },
    '&:disabled': {
      color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteShadesLightTextDisabled"],
      border: '1px solid ' + _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteGrey300"],
      backgroundColor: _theme_export_scss__WEBPACK_IMPORTED_MODULE_4__["paletteCommonTransparent"]
    }
  }
};

var StyledButton = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__["withStyles"])(styles)(_IconButton__WEBPACK_IMPORTED_MODULE_3__["default"]);

var StyledCloseButton = function StyledCloseButton(_ref) {
  var other = _objectWithoutProperties(_ref, []);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    StyledButton,
    other,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_1___default.a, null)
  );
};

/* harmony default export */ __webpack_exports__["default"] = (StyledCloseButton);

/***/ }),

/***/ "./src/Callout/Buttons/index.js":
/*!**************************************!*\
  !*** ./src/Callout/Buttons/index.js ***!
  \**************************************/
/*! exports provided: StyledCloseButton, StyledCheckButton */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _StyledCloseButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StyledCloseButton */ "./src/Callout/Buttons/StyledCloseButton.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StyledCloseButton", function() { return _StyledCloseButton__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _StyledCheckButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./StyledCheckButton */ "./src/Callout/Buttons/StyledCheckButton.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StyledCheckButton", function() { return _StyledCheckButton__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),

/***/ "./src/Callout/component.jsx":
/*!***********************************!*\
  !*** ./src/Callout/component.jsx ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./styles.scss */ "./src/Callout/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var calloutTypeToTextColor = function calloutTypeToTextColor(type, theme) {
  var colorTheme = theme === 'light' ? '' : Object(_utils__WEBPACK_IMPORTED_MODULE_6__["capitalize"])(theme);

  switch (type) {
    case 'notice':
      return theme === 'light' ? 'lighterTextSecondary' : 'lightTextSecondary';
    case 'info':
      return 'informationalBlue' + colorTheme;
    default:
      return '' + type + colorTheme;
  }
};

var Callout = function Callout(_ref) {
  var id = _ref.id,
      children = _ref.children,
      icon = _ref.icon,
      title = _ref.title,
      type = _ref.type,
      theme = _ref.theme,
      actions = _ref.actions,
      actionAlignment = _ref.actionAlignment,
      compact = _ref.compact,
      dataCy = _ref.dataCy,
      titleProps = _ref.titleProps;

  var alignment = actionAlignment === 'top' ? _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.topAlign : _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.centerVertically;
  var color = calloutTypeToTextColor(type, theme);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    { id: id, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.root, _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.flex, type, _defineProperty({ compact: compact }, _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.light, theme === 'light')), 'data-cy': dataCy },
    icon,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.flexGrow, _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.content) },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Typography__WEBPACK_IMPORTED_MODULE_3__["default"],
        _extends({ variant: 'subtitle2', color: color }, titleProps),
        title
      ),
      children
    ),
    !!actions && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.flex, alignment, _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.flexShrinkNone, _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.actions) },
      actions
    )
  );
};

Callout.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /* Callout type: notice, info, success, warning, or error */
  type: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['notice', 'info', 'success', 'warning', 'error']),
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['dark', 'light']),
  /* Callout main title */
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /* Callout actions */
  actions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  actionAlignment: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['top', 'center']),
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /* 24px x 24px Icon Node for display on left */
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  compact: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  dataCy: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** props to pass to the Typography component */
  titleProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)
};

Callout.defaultProps = {
  id: undefined,
  type: 'info',
  theme: 'dark',
  children: null,
  actions: null,
  actionAlignment: 'center',
  title: '',
  icon: null,
  compact: false,
  dataCy: 'callout',
  titleProps: {}
};

/* harmony default export */ __webpack_exports__["default"] = (Callout);

/***/ }),

/***/ "./src/Callout/index.js":
/*!******************************!*\
  !*** ./src/Callout/index.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Callout/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Callout/styles.scss":
/*!*********************************!*\
  !*** ./src/Callout/styles.scss ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Callout/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/CheckboxGroup/index.jsx":
/*!*************************************!*\
  !*** ./src/CheckboxGroup/index.jsx ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/Typography */ "@material-ui/core/Typography");
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/FormControl */ "@material-ui/core/FormControl");
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_FormGroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/FormGroup */ "@material-ui/core/FormGroup");
/* harmony import */ var _material_ui_core_FormGroup__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormGroup__WEBPACK_IMPORTED_MODULE_4__);







var CheckboxGroup = function CheckboxGroup(_ref) {
  var label = _ref.label,
      children = _ref.children;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3___default.a,
    { fullWidth: true },
    label && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2___default.a,
      { variant: 'subtitle1' },
      label
    ),
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _material_ui_core_FormGroup__WEBPACK_IMPORTED_MODULE_4___default.a,
      null,
      children
    )
  );
};

CheckboxGroup.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};

CheckboxGroup.defaultProps = {
  label: '',
  children: null
};

/* harmony default export */ __webpack_exports__["default"] = (CheckboxGroup);

/***/ }),

/***/ "./src/Chip/index.jsx":
/*!****************************!*\
  !*** ./src/Chip/index.jsx ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Chip */ "@material-ui/core/Chip");
/* harmony import */ var _material_ui_core_Chip__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Chip__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./index.scss */ "./src/Chip/index.scss");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var Chip = function Chip(_ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes,
      className = _ref.className,
      color = _ref.color,
      children = _ref.children,
      small = _ref.small,
      other = _objectWithoutProperties(_ref, ['classes', 'className', 'color', 'children', 'small']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Chip__WEBPACK_IMPORTED_MODULE_1___default.a,
    _extends({
      classes: _extends({}, classes, {
        label: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_index_scss__WEBPACK_IMPORTED_MODULE_4___default.a.label, classes.label),
        avatar: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_index_scss__WEBPACK_IMPORTED_MODULE_4___default.a.avatar, classes.avatar)
      }),
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, _index_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, _defineProperty({}, _index_scss__WEBPACK_IMPORTED_MODULE_4___default.a.small, small), color && _index_scss__WEBPACK_IMPORTED_MODULE_4___default.a[color])
    }, other),
    children
  );
};
Chip.propTypes = {
  color: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf([undefined, 'error', 'success', 'warning', 'brandGreen']),
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  // MUI component style API
  classes: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.instanceOf(Object),
  small: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool
};
Chip.defaultProps = {
  color: undefined,
  children: undefined,
  className: undefined,
  classes: {},
  small: false
};
/* harmony default export */ __webpack_exports__["default"] = (Chip);

/***/ }),

/***/ "./src/Chip/index.scss":
/*!*****************************!*\
  !*** ./src/Chip/index.scss ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./index.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Chip/index.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/ChipInput/component.jsx":
/*!*************************************!*\
  !*** ./src/ChipInput/component.jsx ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/FormControl */ "@material-ui/core/FormControl");
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/InputLabel */ "@material-ui/core/InputLabel");
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _Input_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Input/utils */ "./src/Input/utils.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./styles.scss */ "./src/ChipInput/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _SearchSelectPopperInput__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../SearchSelectPopperInput */ "./src/SearchSelectPopperInput/index.js");
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Tooltip */ "./src/Tooltip/index.js");
/* harmony import */ var _Colored__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Colored */ "./src/Colored/index.jsx");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var ChipInput = function (_React$PureComponent) {
  _inherits(ChipInput, _React$PureComponent);

  function ChipInput(props, context) {
    var _this2 = this;

    _classCallCheck(this, ChipInput);

    var _this = _possibleConstructorReturn(this, (ChipInput.__proto__ || Object.getPrototypeOf(ChipInput)).call(this, props, context));

    _this.onChange = function () {
      if (!_this.props.onChange) return;

      _this.props.onChange({ target: { value: _this.state.items } });
    };

    _this.showItemCheckbox = function (item, index) {
      var showCheckboxes = _this.props.showCheckboxes;

      return typeof showCheckboxes === 'function' ? showCheckboxes(item, index) : showCheckboxes;
    };

    _this.deleteChip = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(index) {
        var saveValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var onChipRemove, items, item, newState, cancelChange;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                onChipRemove = _this.props.onChipRemove;
                items = _this.state.items;
                item = items[index];
                newState = {
                  items: [].concat(_toConsumableArray(items.slice(0, index)), _toConsumableArray(items.slice(index + 1)))
                };


                if (saveValue && item && item.name) {
                  newState.inputValue = item.name;
                }

                cancelChange = false;

                // callback for when removing chip

                if (!onChipRemove) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return onChipRemove(item, {
                  cancel: function cancel() {
                    cancelChange = true;
                  }
                });

              case 9:

                if (!cancelChange) {
                  _this.setState(newState);
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.createDeleteChipHandler = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return function () {
        return _this.deleteChip.apply(_this, args);
      };
    };

    _this.createClickChipHandler = function (item, index) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (item.disabled) {
          return;
        }

        var onItemClick = _this.props.onItemClick;

        if (onItemClick) {
          onItemClick({ target: { value: item, index: index }, currentTarget: e.currentTarget });
        } else {
          _this.handleCheckboxClick(index)(e);
        }
      };
    };

    _this.handleCheckboxClick = function (index) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();

        var item = _this.state.items[index];
        var showCheckbox = _this.showItemCheckbox(item, index);
        if (!showCheckbox) {
          return;
        }

        if (item.disableCheckbox) {
          return;
        }

        _this.setState({
          items: [].concat(_toConsumableArray(_this.state.items.slice(0, index)), [_extends({}, item, { optional: !item.optional })], _toConsumableArray(_this.state.items.slice(index + 1)))
        });
      };
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          selectOnly = _this$props.selectOnly,
          listLocked = _this$props.listLocked,
          onEmptyResult = _this$props.onEmptyResult,
          convertChipToText = _this$props.convertChipToText;
      var _this$state = _this.state,
          items = _this$state.items,
          inputValue = _this$state.inputValue;

      // If ENTER and provided a onEmptyResult function

      if (e.keyCode === _Input_utils__WEBPACK_IMPORTED_MODULE_8__["asciiCodes"].ENTER && _this.state.results && _this.state.results.length < 1 && onEmptyResult) {
        onEmptyResult(inputValue);
        return;
      }

      // Ignore this keydown if key = ENTER
      if (_this.ignoreNextKeyDownIfEnter) {
        _this.ignoreNextKeyDownIfEnter = false;
        if (e.keyCode === _Input_utils__WEBPACK_IMPORTED_MODULE_8__["asciiCodes"].ENTER) {
          return;
        }
      }

      switch (e.keyCode) {
        case _Input_utils__WEBPACK_IMPORTED_MODULE_8__["asciiCodes"].DELETE:
        case _Input_utils__WEBPACK_IMPORTED_MODULE_8__["asciiCodes"].BACKSPACE:
          if (items.length < 1 || inputValue) return;

          e.preventDefault();
          if (listLocked || items[items.length - 1].disabled) break;

          _this.deleteChip(items.length - 1, !selectOnly || convertChipToText && convertChipToText(items[items.length - 1]));
          break;
        case _Input_utils__WEBPACK_IMPORTED_MODULE_8__["asciiCodes"].ENTER:
          if (!inputValue || selectOnly) return;

          _this.setState({
            items: [].concat(_toConsumableArray(items), [{ name: inputValue, value: inputValue, label: inputValue }]),
            inputValue: ''
          });
          break;

        default:
          break; // nothing to do :)
      }
    };

    _this.handleInputSelect = function (selectedItem) {
      _this.ignoreNextKeyDownIfEnter = true;
      if (_this.searchSelectInput) _this.searchSelectInput.handleClose();
      if (_this.props.onItemSelect) _this.props.onItemSelect(selectedItem);
      return _this.setState({
        items: [].concat(_toConsumableArray(_this.state.items), [selectedItem]),
        inputValue: ''
      });
    };

    _this.handleInputChange = function (e) {
      return _this.setState({
        inputValue: e.target.value
      });
    };

    _this.handleInputBlur = function (e) {
      if (_this.props.onBlur) _this.props.onBlur(e);

      if (_this.state.inputValue && _this.props.convertTextToChipOnBlur) {
        var inputValue = _this.state.inputValue;

        _this.setState({
          inputValue: '',
          items: [].concat(_toConsumableArray(_this.state.items), [{
            label: inputValue,
            name: inputValue,
            value: inputValue
          }])
        });
      }
    };

    _this.focusInput = function () {
      if (typeof document === 'undefined') return;

      var elem = document.querySelector('#' + _this.props.id);
      if (elem) elem.focus();
    };

    _this.handleDuplicates = function (searchResults) {
      var preventDuplicates = _this.props.preventDuplicates;

      if (!preventDuplicates) {
        return searchResults;
      }

      if (typeof preventDuplicates === 'function') {
        return preventDuplicates(_this.state.items, searchResults);
      }

      // currently selected values (or name if there is no value)
      var currentValues = _this.state.items.map(function (item) {
        return item.value ? item.value : item.name;
      });
      return searchResults.filter(function (item) {
        return !currentValues.includes(item.value);
      });
    };

    _this.filterSuggestedItems = function (items) {
      return _this.handleDuplicates(items);
    };

    _this.performRequest = function (query) {
      return _this.props.performRequest(query).then(function (results) {
        _this.setState({
          results: results && results.data ? results.data : []
        });

        if (!results) return null;
        return _extends({}, results, {
          data: _this.handleDuplicates(results.data)
        });
      });
    };

    _this.handleSearchSelectPopperInputRef = function (node) {
      _this.searchSelectInput = node;
    };

    _this.renderChips = function () {
      return _this.state.items.map(_this.renderChip);
    };

    _this.renderChipCheckbox = function (item, index) {
      var checkboxProps = _this.props.checkboxProps;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        react__WEBPACK_IMPORTED_MODULE_0__["Fragment"],
        null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_7__["Checkbox"], _extends({ value: item.optional, key: 'chip-check-' + index, disabled: item.disableCheckbox }, checkboxProps, { onClick: _this.handleCheckboxClick(index) })),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _Typography__WEBPACK_IMPORTED_MODULE_6__["default"],
          { variant: 'caption', key: 'chip-check-caption-' + index, onClick: _this.handleCheckboxClick(index) },
          _this.props.checkboxCaption
        )
      );
    };

    _this.renderChip = function (item, index) {
      var _classNames;

      var _this$props2 = _this.props,
          small = _this$props2.small,
          listLocked = _this$props2.listLocked;

      var showCheckbox = _this.showItemCheckbox(item, index);
      var baseKey = item.value ? item.value : item.name;
      var key = '' + baseKey + (_this.props.preventDuplicates ? '' : index);
      var label = item.label || item.name;
      var disabled = listLocked || item.disabled;

      var LabelInnerComponent = function LabelInnerComponent() {
        if (typeof label === 'function') {
          return label(item, index);
        }
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _Typography__WEBPACK_IMPORTED_MODULE_6__["default"],
          { 'data-cy': 'chip_name', variant: 'body1' },
          disabled ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _Colored__WEBPACK_IMPORTED_MODULE_12__["default"],
            { color: 'disabled' },
            label
          ) : label
        );
      };

      var labelComponent = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Tooltip__WEBPACK_IMPORTED_MODULE_11__["default"],
        { title: item.tooltip || '', placement: 'bottom' },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.chipLabel },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(LabelInnerComponent, null),
          showCheckbox && _this.renderChipCheckbox(item, index)
        )
      );

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_7__["Chip"], {
        avatar: item.avatar ? item.avatar(item, index) : null,
        key: key,
        title: item.tooltip ? '' : item.name,
        'data-cy': 'chip',
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.chip, (_classNames = {}, _defineProperty(_classNames, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.small, small), _defineProperty(_classNames, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.backgroundDisabled, disabled), _classNames)),
        classes: {
          avatar: _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.avatarDisabled, disabled),
          label: _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.labelDisabled, disabled)
        },
        label: labelComponent,
        onDelete: !disabled ? _this.createDeleteChipHandler(index) : null,
        onClick: !listLocked ? _this.createClickChipHandler(item, index) : null,
        small: small
      });
    };

    _this.state = {
      items: props.value || [],
      inputValue: '',
      results: []
    };
    return _this;
  }

  _createClass(ChipInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!Object(lodash__WEBPACK_IMPORTED_MODULE_4__["isEqual"])(nextProps.value, this.props.value)) {
        this.setState({
          items: nextProps.value || []
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // eslint-disable-line no-unused-vars
      if (!Object(lodash__WEBPACK_IMPORTED_MODULE_4__["isEqual"])(prevState.items, this.state.items)) {
        this.onChange();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props = this.props,
          id = _props.id,
          placeholder = _props.placeholder,
          label = _props.label,
          startAdornment = _props.startAdornment,
          error = _props.error,
          helperText = _props.helperText,
          suggestedItems = _props.suggestedItems,
          renderItem = _props.renderItem,
          isItemDisabled = _props.isItemDisabled,
          minLetters = _props.minLetters,
          small = _props.small,
          resultsListProps = _props.resultsListProps,
          highlightedIndex = _props.highlightedIndex,
          searchSelectProps = _props.searchSelectProps,
          performRequest = _props.performRequest,
          onCancelSearch = _props.onCancelSearch,
          inputProps = _props.inputProps,
          listLocked = _props.listLocked;


      var searchInputStartAdornment = startAdornment ? [react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { key: 'startAdornment' },
        startAdornment
      )].concat(this.renderChips()) : this.renderChips();

      var locked = listLocked || this.maxItemsReached;
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(___WEBPACK_IMPORTED_MODULE_7__["inputStyles"].reset, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.root) },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_2___default.a,
          {
            fullWidth: true,
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([___WEBPACK_IMPORTED_MODULE_7__["inputStyles"].reset, ___WEBPACK_IMPORTED_MODULE_7__["inputStyles"].container, ___WEBPACK_IMPORTED_MODULE_7__["inputStyles"].noMargin, ___WEBPACK_IMPORTED_MODULE_7__["inputStyles"].gentu, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.control]),
            onClick: this.focusInput
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_5___default.a,
            { error: error, htmlFor: 'chip-input', shrink: true, 'data-cy': 'chip_label' },
            label
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_SearchSelectPopperInput__WEBPACK_IMPORTED_MODULE_10__["default"], _extends({
            id: id,
            name: 'chip-input',
            ref: this.handleSearchSelectPopperInputRef,
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(___WEBPACK_IMPORTED_MODULE_7__["inputStyles"].input, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.textInput, (_classNames2 = {}, _defineProperty(_classNames2, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.empty, this.state.items.length < 1), _defineProperty(_classNames2, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.readOnly, locked), _defineProperty(_classNames2, _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.small, small), _classNames2)),
            onSelect: this.handleInputSelect,
            onChange: this.handleInputChange,
            onKeyDown: this.handleKeyDown,
            onBlur: this.handleInputBlur,
            value: this.state.inputValue,
            items: locked ? [] : this.searchResults,
            performRequest: performRequest ? this.performRequest : undefined,
            onCancelSearch: onCancelSearch,
            renderItem: renderItem,
            isItemDisabled: isItemDisabled,
            suggestedItems: locked ? [] : suggestedItems,
            suggestedItemsFilter: this.filterSuggestedItems,
            highlightedIndex: highlightedIndex
          }, searchSelectProps, {
            searchInputProps: _extends({
              hideSearchIcon: true,
              readOnly: locked,
              disabled: locked,
              placeholder: locked ? '' : placeholder,
              error: error,
              helperText: helperText,
              minLetters: minLetters,
              hideHelperText: false,
              inputClassName: _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.textInput,
              inputProps: { className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.textInput, _defineProperty({}, ___WEBPACK_IMPORTED_MODULE_7__["layout"].hidden, locked)) }
            }, inputProps, {
              startAdornment: searchInputStartAdornment
            }),
            resultsListProps: resultsListProps
          }))
        )
      );
    }
  }, {
    key: 'maxItemsReached',
    get: function get() {
      var maxItems = this.props.maxItems;
      var items = this.state.items;

      if (maxItems <= 0) return false;
      return items.length >= maxItems;
    }
  }, {
    key: 'searchResults',
    get: function get() {
      if (this.props.preventDuplicates) {
        // currently selected values (or name if there is no value)
        var currentValues = this.state.items.map(function (item) {
          return item.value ? item.value : item.name;
        });
        return this.props.searchResults.filter(function (result) {
          return !currentValues.includes(result.value);
        });
      }
      return this.props.searchResults;
    }
  }]);

  return ChipInput;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

/* harmony default export */ __webpack_exports__["default"] = (ChipInput);


ChipInput.propTypes = {
  /** onChange callback to be triggered for new value available */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Shows a checkbox on each chip (except for the first one) */
  showCheckboxes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]),
  /** Text to be displayed as the checkbox caption */
  checkboxCaption: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Value (array of objects containing at least a name and an "optional" property) */
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    name: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    optional: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
    disableCheckbox: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
    disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
    tooltip: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
  })),
  /** ID for the DOM element */
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Placehold for the input element */
  placeholder: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Input label */
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Input startAdornment. */
  startAdornment: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** Convert input text into a chip on blur */
  convertTextToChipOnBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Maximum number of items can add, if <=0 there is no limit, if reach limit input will be set to readonly */
  maxItems: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** determine if the field has validation error */
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** allow listent to onBlur event */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** display helper or message below input */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** function that accepts a query, and returns a promise resolving with { data: { results: [] } } */
  performRequest: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * onCancelSearch is the callback will be triggered when currently inSearching
   * but search is not required anymore or searchText changed
   */
  onCancelSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** custom render function for items in the list */
  renderItem: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Function that returns true if item is disabled, false otherwise.
    * If undefined, all items are enabled.
    */
  isItemDisabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Suggested items are shown before any search takes place. */
  suggestedItems: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    name: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
    value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    optional: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
  })),
  /** Block any current value from appearing in the popup menu */
  preventDuplicates: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]),
  /** Only accept list selections, not free text input */
  selectOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Calls the function from the parent and expects a bool to instruct whether to convert the chip to text or not */
  convertChipToText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** (optional) pass search results in directly, useful for data from Redux */
  searchResults: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    name: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    optional: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
  })),
  /** (optional) minimum number of letters before searching starts */
  minLetters: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  inputProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** props for search select input component */
  searchSelectProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** (optional) show a smaller chip input */
  small: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (optional) checkbox props */
  checkboxProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** props to pass to ResultsList component */
  resultsListProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  highlightedIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  onItemClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,

  /** callback to fire when an item is selected from search list, parses selected item */
  onItemSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** callback to fire when a chip is removed via the x icon, parses the item being removed */
  onChipRemove: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** prevents any items being added or removed from the list */
  listLocked: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  onEmptyResult: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

ChipInput.defaultProps = {
  onChange: null,
  error: false,
  value: [],
  showCheckboxes: function showCheckboxes(item, index) {
    return index > 0;
  }, // by default the first chip does not have a checkbox
  checkboxCaption: '(+/-)',
  id: 'chip-input',
  label: '',
  startAdornment: undefined,
  placeholder: '',
  convertTextToChipOnBlur: true,
  maxItems: -1,
  onBlur: undefined,
  helperText: '',
  performRequest: undefined,
  onCancelSearch: undefined,
  renderItem: undefined,
  isItemDisabled: undefined,
  suggestedItems: [],
  selectOnly: false,
  convertChipToText: undefined,
  preventDuplicates: false,
  searchResults: [],
  minLetters: undefined, // this will fallback to SearchSelectPopperInput's default of 2
  inputProps: {},
  searchSelectProps: {},
  small: false,
  checkboxProps: {},
  resultsListProps: undefined,
  highlightedIndex: 0,
  onItemClick: undefined,
  onItemSelect: undefined,
  onChipRemove: undefined,
  listLocked: false,
  onEmptyResult: undefined
};

/***/ }),

/***/ "./src/ChipInput/index.js":
/*!********************************!*\
  !*** ./src/ChipInput/index.js ***!
  \********************************/
/*! exports provided: default, dontReturnResults */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dontReturnResults", function() { return dontReturnResults; });
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/ChipInput/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/*
  ChipInput's performRequest prop is a function that accepts a query and returns
  a Promise which resolves with { data : results: [] }.
  ChipInput also accepts search result items directly, (useful with Redux), so use this function if
  you are supplying a performRequest function, but want to pass in the results via props:
  e.g.
  <ChipInput
    performRequest={query => searchManifestations(query).then(dontReturnResults)}
    searchResults={manifestationsOptions}
  />
 */

var dontReturnResults = function dontReturnResults() {
  return null;
};

/***/ }),

/***/ "./src/ChipInput/spec-helper.js":
/*!**************************************!*\
  !*** ./src/ChipInput/spec-helper.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Input_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Input/utils */ "./src/Input/utils.js");
/* harmony import */ var _helpers_nextTick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helpers/nextTick */ "./helpers/nextTick.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ChipInputHelper = function () {
  function ChipInputHelper(wrapper, id) {
    var _this = this;

    _classCallCheck(this, ChipInputHelper);

    this.wrapper = wrapper;
    this.id = id;
    this.el = function () {
      return _this.wrapper.find(id);
    };
    this.type = 'ChipInput';
  }

  _createClass(ChipInputHelper, [{
    key: 'getSearchInput',
    value: function getSearchInput() {
      return this.el().find('SearchSelectPopperInput').find('input[autoComplete="search-input-text"]');
    }
  }, {
    key: 'setSearchText',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var event;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event = { target: { value: value.toString() } };

                this.getSearchInput().simulate('change', event);
                _context.next = 4;
                return Object(_helpers_nextTick__WEBPACK_IMPORTED_MODULE_1__["default"])();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setSearchText(_x) {
        return _ref.apply(this, arguments);
      }

      return setSearchText;
    }()
  }, {
    key: 'simulateEnter',
    value: function simulateEnter() {
      this.getSearchInput().simulate('keydown', { keyCode: _Input_utils__WEBPACK_IMPORTED_MODULE_0__["asciiCodes"].ENTER });
    }
  }, {
    key: 'simulateTab',
    value: function simulateTab() {
      this.getSearchInput().simulate('keydown', { keyCode: _Input_utils__WEBPACK_IMPORTED_MODULE_0__["asciiCodes"].TAB });
    }
  }]);

  return ChipInputHelper;
}();

/* harmony default export */ __webpack_exports__["default"] = (ChipInputHelper);

/***/ }),

/***/ "./src/ChipInput/styles.scss":
/*!***********************************!*\
  !*** ./src/ChipInput/styles.scss ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ChipInput/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/CollapsiblePanel/index.jsx":
/*!****************************************!*\
  !*** ./src/CollapsiblePanel/index.jsx ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_ExpansionPanel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/ExpansionPanel */ "@material-ui/core/ExpansionPanel");
/* harmony import */ var _material_ui_core_ExpansionPanel__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ExpansionPanel__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_ExpansionPanelDetails__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/ExpansionPanelDetails */ "@material-ui/core/ExpansionPanelDetails");
/* harmony import */ var _material_ui_core_ExpansionPanelDetails__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ExpansionPanelDetails__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_ExpansionPanelSummary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/ExpansionPanelSummary */ "@material-ui/core/ExpansionPanelSummary");
/* harmony import */ var _material_ui_core_ExpansionPanelSummary__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ExpansionPanelSummary__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_ExpansionPanelActions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/ExpansionPanelActions */ "@material-ui/core/ExpansionPanelActions");
/* harmony import */ var _material_ui_core_ExpansionPanelActions__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ExpansionPanelActions__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/icons/ExpandMore */ "@material-ui/icons/ExpandMore");
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash/get */ "lodash/get");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./styles.scss */ "./src/CollapsiblePanel/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../theme_export.scss */ "./src/theme_export.scss");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_theme_export_scss__WEBPACK_IMPORTED_MODULE_12__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















var summaryStyles = function summaryStyles(theme) {
  return {
    root: {
      margin: '0',
      '&$expanded': {
        minHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_12___default.a.collapsiblePanelTitleHeight + 'px'
      }
    },
    expanded: {
      // this must be defined, so the '&$expanded' works
    },
    content: {
      margin: theme.spacing.unit * 0.5 + 'px 0',
      'padding-left': theme.spacing.unit * 4,
      '&$expanded': {
        margin: theme.spacing.unit * 0.5 + 'px 0'
      }
    },
    expandIcon: {
      left: theme.spacing.unit * 0.5,
      right: 'auto'
    }
  };
};

var actionStyles = function actionStyles(theme) {
  return {
    root: {
      padding: theme.spacing.unit * 2 + 'px',
      'padding-top': 0
    }
  };
};

var StyledExpansionPanelSummary = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__["withStyles"])(summaryStyles)(_material_ui_core_ExpansionPanelSummary__WEBPACK_IMPORTED_MODULE_4___default.a);
var StyledExpansionPanelActions = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__["withStyles"])(actionStyles)(_material_ui_core_ExpansionPanelActions__WEBPACK_IMPORTED_MODULE_5___default.a);

var detailsStyles = function detailsStyles(theme) {
  return {
    root: {
      paddingTop: theme.spacing.unit * 3,
      borderTop: '1px solid ' + theme.palette.background.contentFrame
    }
  };
};

var StyledExpansionPanelDetails = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__["withStyles"])(detailsStyles)(_material_ui_core_ExpansionPanelDetails__WEBPACK_IMPORTED_MODULE_3___default.a);

var CollapsiblePanel = function CollapsiblePanel(_ref) {
  var _classNames, _classNames2;

  var children = _ref.children,
      title = _ref.title,
      onChange = _ref.onChange,
      expanded = _ref.expanded,
      margin = _ref.margin,
      className = _ref.className,
      elevation = _ref.elevation,
      actions = _ref.actions,
      detailDirection = _ref.detailDirection,
      panelSummaryProps = _ref.panelSummaryProps,
      panelDetailProps = _ref.panelDetailProps;

  var panelClasses = {
    root: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.root, className, (_classNames = {}, _defineProperty(_classNames, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.marginDense, margin === 'dense'), _defineProperty(_classNames, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.marginNone, margin === 'none'), _classNames)),
    expanded: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.expanded, (_classNames2 = {}, _defineProperty(_classNames2, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.marginDense, margin === 'dense'), _defineProperty(_classNames2, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.marginNone, margin === 'none'), _classNames2))
  };

  var detailClasses = _extends({}, lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(panelDetailProps, 'classes', undefined), {
    root: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_defineProperty({}, _layout_scss__WEBPACK_IMPORTED_MODULE_11___default.a.flexColumnContainer, detailDirection === 'column'), lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(panelDetailProps, 'classes.root', undefined))
  });

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_ExpansionPanel__WEBPACK_IMPORTED_MODULE_2___default.a,
    { onChange: onChange, expanded: expanded, classes: panelClasses, elevation: elevation },
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      StyledExpansionPanelSummary,
      _extends({
        expandIcon: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_7___default.a, null)
      }, panelSummaryProps),
      title
    ),
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      StyledExpansionPanelDetails,
      _extends({}, panelDetailProps, { classes: detailClasses }),
      children
    ),
    actions && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      StyledExpansionPanelActions,
      null,
      actions
    )
  );
};

CollapsiblePanel.propTypes = {
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  expanded: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  margin: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['', 'dense', 'none']),
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  elevation: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** The action element to display in the panel */
  actions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** The flex direction the content should flow in */
  detailDirection: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['column', 'row']),
  /** extra props passed to the ExpansionPanelSummary */
  panelSummaryProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** extra props passed to the ExpansionPanelDetail */
  panelDetailProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)
};

CollapsiblePanel.defaultProps = {
  title: null,
  children: null,
  onChange: undefined,
  expanded: true,
  margin: '',
  className: null,
  elevation: undefined,
  actions: undefined,
  detailDirection: 'row',
  panelSummaryProps: undefined,
  panelDetailProps: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (CollapsiblePanel);

/***/ }),

/***/ "./src/CollapsiblePanel/styles.scss":
/*!******************************************!*\
  !*** ./src/CollapsiblePanel/styles.scss ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/CollapsiblePanel/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Colored/colors.js":
/*!*******************************!*\
  !*** ./src/Colored/colors.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var availableTextColors = ['error', 'errorLight', 'errorDark', 'success', 'successLight', 'successDark', 'warning', 'warningLight', 'warningDark', 'primary', 'primaryDark', 'secondary', 'secondaryDark', 'disabled', 'disabledDark', 'informationalBlue', 'informationalBlueLight', 'informationalBlueDark', 'brandGreen', 'brandPink', 'grey', 'white', 'textSecondary', 'lightTextSecondary', 'lighterTextSecondary', 'primaryBaseColor', 'commonLightBlack'];

/* harmony default export */ __webpack_exports__["default"] = (availableTextColors);

/***/ }),

/***/ "./src/Colored/index.jsx":
/*!*******************************!*\
  !*** ./src/Colored/index.jsx ***!
  \*******************************/
/*! exports provided: colors, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return colors; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./colors */ "./src/Colored/colors.js");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./index.scss */ "./src/Colored/index.scss");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







/**
 * This is to allow set text color of a component to one of gentu color
 */
var Colored = function Colored(props) {
  var className = props.className,
      color = props.color,
      Component = props.component,
      children = props.children,
      rest = _objectWithoutProperties(props, ['className', 'color', 'component', 'children']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    Component,
    _extends({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_index_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, className, _index_scss__WEBPACK_IMPORTED_MODULE_4___default.a[color]) }),
    children
  );
};

Colored.propTypes = {
  /**
   * Only preset gentu color allowed here, when add a new gentu color, need to add to this array and  index.scss file
   */
  color: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(_colors__WEBPACK_IMPORTED_MODULE_3__["default"]).isRequired,
  /**
   * Component the color style will be applied to, if not specified will add a <span> wrapper to children
   */
  component: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]),
  /**
   * Content to be colored
   */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
Colored.defaultProps = {
  component: 'span',
  children: undefined,
  className: undefined
};

var colors = _colors__WEBPACK_IMPORTED_MODULE_3__["default"];

/* harmony default export */ __webpack_exports__["default"] = (Colored);

/***/ }),

/***/ "./src/Colored/index.scss":
/*!********************************!*\
  !*** ./src/Colored/index.scss ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./index.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Colored/index.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/ContextMenu/contextMenu.jsx":
/*!*****************************************!*\
  !*** ./src/ContextMenu/contextMenu.jsx ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_icons_Delete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/icons/Delete */ "@material-ui/icons/Delete");
/* harmony import */ var _material_ui_icons_Delete__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Delete__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../IconButton */ "./src/IconButton/index.jsx");
/* harmony import */ var _contextMenu_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./contextMenu.scss */ "./src/ContextMenu/contextMenu.scss");
/* harmony import */ var _contextMenu_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_contextMenu_scss__WEBPACK_IMPORTED_MODULE_5__);








var ContextMenu = function ContextMenu(props) {
  var className = props.className,
      onDelete = props.onDelete;


  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    { className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, _contextMenu_scss__WEBPACK_IMPORTED_MODULE_5___default.a.root) },
    onDelete && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _IconButton__WEBPACK_IMPORTED_MODULE_4__["default"],
      { className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('delete', _contextMenu_scss__WEBPACK_IMPORTED_MODULE_5___default.a.button), onClick: onDelete },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Delete__WEBPACK_IMPORTED_MODULE_2___default.a, null)
    )
  );
};

ContextMenu.propTypes = {
  /** className added to the root div element */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** callback function(event, listItem) called when delete button is clicked */
  onDelete: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

ContextMenu.defaultProps = {
  className: undefined,
  onDelete: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (ContextMenu);

/***/ }),

/***/ "./src/ContextMenu/contextMenu.scss":
/*!******************************************!*\
  !*** ./src/ContextMenu/contextMenu.scss ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./contextMenu.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ContextMenu/contextMenu.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/ContextMenu/index.js":
/*!**********************************!*\
  !*** ./src/ContextMenu/index.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _contextMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./contextMenu */ "./src/ContextMenu/contextMenu.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _contextMenu__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/DataList/dataList.jsx":
/*!***********************************!*\
  !*** ./src/DataList/dataList.jsx ***!
  \***********************************/
/*! exports provided: listItemProp, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listItemProp", function() { return listItemProp; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/Divider */ "@material-ui/core/Divider");
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/List */ "@material-ui/core/List");
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_List__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/ListSubheader */ "@material-ui/core/ListSubheader");
/* harmony import */ var _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _dataList_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./dataList.scss */ "./src/DataList/dataList.scss");
/* harmony import */ var _dataList_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_dataList_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _dataListItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./dataListItem */ "./src/DataList/dataListItem.jsx");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var DataList = function (_React$PureComponent) {
  _inherits(DataList, _React$PureComponent);

  function DataList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DataList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataList.__proto__ || Object.getPrototypeOf(DataList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      openListItemId: undefined
    }, _this.getOrderedListItems = function () {
      return _this.props.list.concat(_this.props.groups.reduce(function (acc, group) {
        return acc.concat(group.list);
      }, []));
    }, _this.getSelectionAfterDelete = function (listItem) {
      if (Object(_utils__WEBPACK_IMPORTED_MODULE_8__["isMobile"])()) return null;

      var orderedListItems = _this.getOrderedListItems();
      var deleteIndex = orderedListItems.findIndex(function (_ref2) {
        var id = _ref2.id;
        return id === listItem.id;
      });
      var isFirstItem = deleteIndex === 0;
      var isLastItem = deleteIndex === orderedListItems.length - 1;
      if (!isLastItem) {
        return orderedListItems[deleteIndex + 1];
      } else if (!isFirstItem) {
        return orderedListItems[deleteIndex - 1];
      }
      return null;
    }, _this.getOnDelete = function (listItem, performDelete) {
      var _this$props = _this.props,
          getDataType = _this$props.getDataType,
          onSelect = _this$props.onSelect,
          onUnselect = _this$props.onUnselect;


      if (performDelete) {
        return function () {
          return _this.context.confirm({
            message: 'Are you sure you want to delete this ' + getDataType(listItem) + '?'
          }).then(function (confirmed) {
            if (confirmed) {
              var newSelection = _this.getSelectionAfterDelete(listItem);
              performDelete().then(function () {
                if (newSelection) {
                  if (onSelect) {
                    onSelect(null, newSelection);
                  }
                } else if (onUnselect) {
                  onUnselect();
                }
              });
            }
          });
        };
      }
      return undefined;
    }, _this.handleSelect = function (event, item) {
      if (_this.props.onSelect) _this.props.onSelect(event, item);
    }, _this.handleOpen = function (item) {
      _this.setState({ openListItemId: item.id });
    }, _this.handleClose = function () {
      _this.setState({ openListItemId: undefined });
    }, _this.renderListItems = function (list) {
      if (!list) return undefined;

      var _this$props2 = _this.props,
          divider = _this$props2.divider,
          _this$props2$dividerP = _this$props2.dividerProps,
          inset = _this$props2$dividerP.inset,
          remainingDividerProps = _objectWithoutProperties(_this$props2$dividerP, ['inset']);

      return list.map(function (listItem, index) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'li',
          { key: listItem.id, className: _dataList_scss__WEBPACK_IMPORTED_MODULE_6___default.a.dataListItem },
          _this.renderListItem(listItem),
          divider && index < list.length - 1 && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_2___default.a, _extends({
            className: _dataList_scss__WEBPACK_IMPORTED_MODULE_6___default.a.divider,
            classes: { inset: _dataList_scss__WEBPACK_IMPORTED_MODULE_6___default.a.inset },
            variant: inset ? 'inset' : null
          }, remainingDividerProps))
        );
      });
    }, _this.renderListItem = function (listItem) {
      var _classNames;

      if (!listItem) return undefined;

      var _ref3 = listItem.props || {},
          className = _ref3.className;

      var _this$props3 = _this.props,
          itemRender = _this$props3.itemRender,
          selectedId = _this$props3.selectedId,
          deletable = _this$props3.deletable,
          renderEndAdornment = _this$props3.renderEndAdornment;


      var handleTap = function handleTap(event) {
        if (_this.state.openListItemId) {
          // In the case when handleTap is triggered by the user tapping on an open list item, we want to delay
          // setting openListItemId to undefined until after handleClick has finished running, so that handleClick won't
          // call this.handleSelect. We only want this.handleSelect to be called when the user taps or intentionally clicks
          // a closed list item. We have this problem because a click event is fired after a swipe is complete, and tap events
          // are always fired before click events.
          setTimeout(function () {
            return _this.setState({ openListItemId: undefined });
          }, 100);
        }

        _this.handleSelect(event, listItem);
      };

      var handleClick = function handleClick(event) {
        if (!Object(_utils__WEBPACK_IMPORTED_MODULE_8__["isMobile"])() || !_this.state.openListItemId) {
          _this.handleSelect(event, listItem);
        }
      };
      var handleOpen = function handleOpen() {
        return _this.handleOpen(listItem);
      };

      var performDelete = deletable && deletable(listItem);
      var onDelete = _this.getOnDelete(listItem, performDelete);
      var selected = selectedId && selectedId === listItem.id;
      var extraProps = {
        key: listItem.id,
        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(className, 'dataListItem', (_classNames = {}, _defineProperty(_classNames, _dataList_scss__WEBPACK_IMPORTED_MODULE_6___default.a.selected, selected), _defineProperty(_classNames, 'selected', selected), _classNames))
      };
      if (itemRender) {
        return itemRender(listItem, extraProps);
      }

      var endAdornment = renderEndAdornment && renderEndAdornment(listItem.data);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_dataListItem__WEBPACK_IMPORTED_MODULE_7__["default"], _extends({
        button: true,
        component: 'div',
        primaryText: listItem.primaryText,
        secondaryText: listItem.secondaryText,
        primaryIcon: listItem.primaryIcon,
        endAdornment: endAdornment,
        onClick: handleClick,
        onTap: handleTap,
        onDelete: onDelete,
        onOpen: handleOpen,
        onClose: _this.handleClose,
        isOpen: _this.state.openListItemId === listItem.id,
        contextMenuClassName: _dataList_scss__WEBPACK_IMPORTED_MODULE_6___default.a.contextMenu
      }, listItem.props, extraProps));
    }, _this.renderListGroup = function (listGroup) {
      var header = listGroup.header,
          list = listGroup.list;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'li',
        { key: header.id, className: 'listGroup' },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'ul',
          null,
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_4___default.a,
            {
              className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('listSubheader', _dataList_scss__WEBPACK_IMPORTED_MODULE_6___default.a.subheader),
              id: header.id
            },
            header.primaryText
          ),
          _this.renderListItems(list)
        )
      );
    }, _this.renderListGroups = function () {
      return _this.props.groups.map(_this.renderListGroup);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Returns the list of items in the order in which they're rendered in the page


  // Note: Item must not have already been deleted


  // Render an array of list items


  // Render a single list item


  // Render a list group (i.e. a header and a list of items)


  // Render all list groups


  _createClass(DataList, [{
    key: 'render',


    // Order of this.props.list and this.props.groups rendering must be kept in sync with this.getSelectionAfterDelete function.
    value: function render() {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_List__WEBPACK_IMPORTED_MODULE_3___default.a,
        {
          disablePadding: true,
          id: this.props.id,
          dense: this.props.dense,
          className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(this.props.className, _dataList_scss__WEBPACK_IMPORTED_MODULE_6___default.a.root)
        },
        this.renderListItems(this.props.list),
        this.renderListGroups()
      );
    }
  }]);

  return DataList;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

var listItemProp = prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
  /** ID of the list item, this is also used as component key when render */
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
  /** primary text of the item */
  primaryText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** secondary text of the item */
  secondaryText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** primaryIcon rendered on left */
  primaryIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /**
   * this will be passed to <ListItem> at last
   * i.e. it will override any default props passed to the rendered list item
   */
  props: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** data of the list item, this is to allow read extra info of a list item in onSelect */
  data: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)
});

var listProp = prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(listItemProp);

DataList.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Render a divider between items */
  divider: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** function(listItem) must return a human-readable name for the data type of the listItem. */
  getDataType: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** render an array of list items, this is rendered before groups if groups also provided */
  list: listProp,
  /** render groups of list items */
  groups: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    /** sticky header item of the group */
    header: listItemProp,
    /** array of list items in the group */
    list: listProp
  })),
  /** className will be applied to root element <List> */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** id of current selected list item */
  selectedId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** callback function(event, listitem) to allow listen to item selection */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** callback function() that's called when an item becomes unselected without another item being selected in the process */
  onUnselect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** function(listItem) responsible for returning a callback function to delete the item if it can be deleted, otherwise returning undefined. */
  deletable: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * if itemRender specified, itemRender(listItem, {key, onClick, className}) will be called
   * - id must still be specified
   * - key, onClick and className will be append to props and should be handled in render
   */
  itemRender: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** trailing component rendered on right - use this for menus, secondary icons, etc.. */
  renderEndAdornment: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Display the list in dense mode */
  dense: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Props to be passed to the divider component */
  dividerProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    inset: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
  })
};

DataList.defaultProps = {
  id: undefined,
  divider: true,
  getDataType: function getDataType() {
    return 'item';
  },
  list: [],
  groups: [],
  className: undefined,
  selectedId: undefined,
  onSelect: undefined,
  onUnselect: undefined,
  deletable: undefined,
  itemRender: undefined,
  renderEndAdornment: undefined,
  dense: false,
  dividerProps: { inset: true }
};

DataList.contextTypes = {
  confirm: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

/* harmony default export */ __webpack_exports__["default"] = (DataList);

/***/ }),

/***/ "./src/DataList/dataList.scss":
/*!************************************!*\
  !*** ./src/DataList/dataList.scss ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./dataList.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DataList/dataList.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/DataList/dataListItem.jsx":
/*!***************************************!*\
  !*** ./src/DataList/dataListItem.jsx ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/ListItemIcon */ "@material-ui/core/ListItemIcon");
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_icons_Delete__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/icons/Delete */ "@material-ui/icons/Delete");
/* harmony import */ var _material_ui_icons_Delete__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Delete__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_hammerjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react-hammerjs */ "react-hammerjs");
/* harmony import */ var react_hammerjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_hammerjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _PreviewList_listItemText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../PreviewList/listItemText */ "./src/PreviewList/listItemText.jsx");
/* harmony import */ var _dataList_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./dataList.scss */ "./src/DataList/dataList.scss");
/* harmony import */ var _dataList_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_dataList_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../theme_export.scss */ "./src/theme_export.scss");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_theme_export_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var DataListItem = function (_React$PureComponent) {
  _inherits(DataListItem, _React$PureComponent);

  function DataListItem(props) {
    _classCallCheck(this, DataListItem);

    // The following two lines make this component work in storybook.
    var _this = _possibleConstructorReturn(this, (DataListItem.__proto__ || Object.getPrototypeOf(DataListItem)).call(this, props));

    _this.state = {
      left: 0, // the left css value while panning
      startLeft: 0, // the left css value at the start of a pan
      isPanning: false // whether or not it's currently being panned
    };

    _this.componentWillReceiveProps = function (newProps) {
      var isOpen = newProps.isOpen;


      if (!isOpen && _this.state.left) {
        _this.setState({ left: 0 });
      }
    };

    _this.onPanStart = function (e) {
      if (_this.tryingToScroll(e) || !_this.swipingWithinRange(e)) return;
      _this.setState({ isPanning: true });

      var onOpen = _this.props.onOpen;

      if (onOpen) {
        onOpen();
      }

      _this.setState({ startLeft: _this.state.left });
    };

    _this.onPan = function (e) {
      var isOpen = _this.props.isOpen;


      if (!isOpen || _this.tryingToScroll(e)) return;

      var newLeft = _this.state.startLeft + e.deltaX;

      if (newLeft < _this.maxLeftOffset) {
        newLeft = _this.maxLeftOffset;
      } else if (newLeft > 0) {
        newLeft = 0;
      }
      _this.setState({ left: newLeft });
    };

    _this.onPanEnd = function (e) {
      _this.setState({ isPanning: false });

      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          onOpen = _this$props.onOpen,
          onClose = _this$props.onClose;

      if (!isOpen) return;

      // The absolute speed that's considered to be the minimum speed for travelling faster than what's considered to be "slow".
      var slowThreshold = 0.03;
      var velocity = e.velocityX;
      var inRightHalf = _this.state.left > _this.maxLeftOffset / 2;
      var still = velocity === 0;
      var movingToLeft = velocity < 0;
      var movingSlowlyToLeft = movingToLeft && Math.abs(velocity) < slowThreshold;
      var movingToRight = velocity > 0;
      var movingQuicklyToRight = movingToRight && Math.abs(velocity) >= slowThreshold;
      var shouldClose = inRightHalf && (still || movingSlowlyToLeft) || movingQuicklyToRight;
      if (onClose && shouldClose) {
        // Prevent isOpen from becoming false, before the onClick handler is triggered.
        // We have to use onClick instead of just onTap, in order to be able to test the code properly.
        setTimeout(onClose, 0);
      } else if (onOpen) {
        onOpen();
      }
    };

    _this.tryingToScroll = function (e) {
      // Absolute threshold to determine whether or not user is trying to scroll the list. This is used to prevent sliding on scroll.
      var scrollThreshold = 100;
      return Math.abs(e.deltaY) > scrollThreshold;
    };

    _this.swipingWithinRange = function (e) {
      var arcRadius = 40;
      return Math.abs(e.angle) < arcRadius || Math.abs(e.angle) > 180 - arcRadius;
    };

    _this.maxLeftOffset = -_theme_export_scss__WEBPACK_IMPORTED_MODULE_9__["spacingUnit"] * 9;
    _this.onPanStart = _this.onPanStart.bind(_this);
    _this.onPan = _this.onPan.bind(_this);
    return _this;
  }

  // Limit in px of left css property of list item.
  // This should match the total width of the button(s).


  _createClass(DataListItem, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          primaryText = _props.primaryText,
          secondaryText = _props.secondaryText,
          primaryIcon = _props.primaryIcon,
          endAdornment = _props.endAdornment,
          onClick = _props.onClick,
          onTap = _props.onTap,
          onDelete = _props.onDelete,
          contextMenuClassName = _props.contextMenuClassName,
          onOpen = _props.onOpen,
          onClose = _props.onClose,
          isOpen = _props.isOpen,
          rest = _objectWithoutProperties(_props, ['primaryText', 'secondaryText', 'primaryIcon', 'endAdornment', 'onClick', 'onTap', 'onDelete', 'contextMenuClassName', 'onOpen', 'onClose', 'isOpen']);

      var handleMobileDelete = function handleMobileDelete() {
        onDelete().then(function (confirmed) {
          if (!confirmed) {
            onClose();
          }
        });
      };

      var handleMobileClick = function handleMobileClick() {
        if (onClick && !isOpen) {
          onClick();
        }
      };

      return Object(_utils__WEBPACK_IMPORTED_MODULE_10__["isMobile"])() && onDelete ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_6__["SlideActionButton"], { color: 'brandRed', className: _dataList_scss__WEBPACK_IMPORTED_MODULE_8___default.a.mobBtn, iconTop: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_6__["Icon"], { component: _material_ui_icons_Delete__WEBPACK_IMPORTED_MODULE_3___default.a }), label: 'Delete', onClick: handleMobileDelete }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          react_hammerjs__WEBPACK_IMPORTED_MODULE_4___default.a,
          { onTap: onTap, onPanStart: this.onPanStart, onPan: this.onPan, onPanEnd: this.onPanEnd },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            {
              className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_dataList_scss__WEBPACK_IMPORTED_MODULE_8___default.a.listItemWrapper, (_classnames = {}, _defineProperty(_classnames, _dataList_scss__WEBPACK_IMPORTED_MODULE_8___default.a.notPanning, !this.state.isPanning), _defineProperty(_classnames, _dataList_scss__WEBPACK_IMPORTED_MODULE_8___default.a.open, isOpen && !this.state.isPanning), _classnames)),
              style: { left: this.state.left + 'px' }
            },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              ___WEBPACK_IMPORTED_MODULE_6__["ListItem"],
              _extends({
                onClick: handleMobileClick,
                classes: { root: _dataList_scss__WEBPACK_IMPORTED_MODULE_8___default.a.listItemPadding }
              }, rest, {
                button: false
              }),
              primaryIcon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_2___default.a,
                null,
                primaryIcon
              ),
              react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_PreviewList_listItemText__WEBPACK_IMPORTED_MODULE_7__["default"], {
                className: _dataList_scss__WEBPACK_IMPORTED_MODULE_8___default.a.text,
                primary: primaryText,
                secondary: secondaryText
              }),
              endAdornment
            )
          )
        )
      ) : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        ___WEBPACK_IMPORTED_MODULE_6__["ListItem"],
        _extends({
          onClick: onClick,
          classes: { root: _dataList_scss__WEBPACK_IMPORTED_MODULE_8___default.a.listItemPadding }
        }, rest),
        primaryIcon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_2___default.a,
          null,
          primaryIcon
        ),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_PreviewList_listItemText__WEBPACK_IMPORTED_MODULE_7__["default"], {
          className: _dataList_scss__WEBPACK_IMPORTED_MODULE_8___default.a.text,
          primary: primaryText,
          secondary: secondaryText
        }),
        endAdornment,
        onDelete && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_6__["ContextMenu"], { className: contextMenuClassName, onDelete: onDelete })
      );
    }
  }]);

  return DataListItem;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

DataListItem.propTypes = {
  /** primary text of the item */
  primaryText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,
  /** secondary text of the item */
  secondaryText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** primaryIcon rendered on left */
  primaryIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** endAdornment component rendered on right - use this for menus, secondary icons, etc.. */
  endAdornment: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** callback function() triggered when the list item is tapped or clicked. */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** callback function() triggered when the list item is tapped. */
  onTap: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** callback function() responsible for deleting the list item if it can be deleted, otherwise undefined. */
  onDelete: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** callback function() responsible for declaring that a specific list item has opened at least partially. */
  onOpen: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** callback function() responsible for declaring that a specific list item has closed or should close. */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** whether or not the list item is open */
  isOpen: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** className to use for ContextMenu. */
  contextMenuClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
DataListItem.defaultProps = {
  secondaryText: undefined,
  primaryIcon: undefined,
  endAdornment: undefined,
  onClick: undefined,
  onTap: undefined,
  onDelete: undefined,
  onOpen: undefined,
  onClose: undefined,
  isOpen: false,
  contextMenuClassName: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (DataListItem);

/***/ }),

/***/ "./src/DataList/index.js":
/*!*******************************!*\
  !*** ./src/DataList/index.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _dataList__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dataList */ "./src/DataList/dataList.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _dataList__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/DataTable/ColumnFilter/component.jsx":
/*!**************************************************!*\
  !*** ./src/DataTable/ColumnFilter/component.jsx ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Popover */ "@material-ui/core/Popover");
/* harmony import */ var _material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/Grid */ "@material-ui/core/Grid");
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_Settings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/icons/Settings */ "@material-ui/icons/Settings");
/* harmony import */ var _material_ui_icons_Settings__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Settings__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../ */ "./src/index.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./styles.scss */ "./src/DataTable/ColumnFilter/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_7__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ColumnFilter = function (_React$PureComponent) {
  _inherits(ColumnFilter, _React$PureComponent);

  function ColumnFilter(props) {
    _classCallCheck(this, ColumnFilter);

    var _this = _possibleConstructorReturn(this, (ColumnFilter.__proto__ || Object.getPrototypeOf(ColumnFilter)).call(this, props));

    _this.isVisibleColumn = function (_ref) {
      var id = _ref.id;
      return !_this.props.hiddenColumnIds.includes(id);
    };

    _this.isUnfilterableColumn = function (_ref2) {
      var id = _ref2.id,
          label = _ref2.label;
      return _this.props.unfilterableColumnIds.includes(id) || label === '';
    };

    _this.isLastFilterableColumn = function (c) {
      return _this.isVisibleColumn(c) && _this.filterableColumns.filter(_this.isVisibleColumn).length === 1;
    };

    _this.handleClick = function (event) {
      _this.setState({ anchorEl: event.currentTarget });
    };

    _this.handleClose = function () {
      _this.setState({ anchorEl: null });
    };

    _this.handleToggle = function (_ref3) {
      var id = _ref3.id;
      return function (_ref4) {
        var target = _ref4.target;
        var _this$props = _this.props,
            hiddenColumnIds = _this$props.hiddenColumnIds,
            onToggleColumn = _this$props.onToggleColumn;

        var hiddenColumns = target.checked ? hiddenColumnIds.filter(function (col) {
          return col !== id;
        }) : Object(lodash__WEBPACK_IMPORTED_MODULE_2__["uniq"])([].concat(_toConsumableArray(hiddenColumnIds), [id]));
        if (onToggleColumn) onToggleColumn(hiddenColumns);
      };
    };

    _this.state = { anchorEl: null };
    return _this;
  }

  _createClass(ColumnFilter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var anchorEl = this.state.anchorEl;

      var open = Boolean(anchorEl);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        react__WEBPACK_IMPORTED_MODULE_0__["Fragment"],
        null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ___WEBPACK_IMPORTED_MODULE_6__["IconButton"],
          { onClick: this.handleClick },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Settings__WEBPACK_IMPORTED_MODULE_5___default.a, null)
        ),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_3___default.a,
          {
            anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
            transformOrigin: { vertical: 'top', horizontal: 'right' },
            open: open,
            anchorEl: anchorEl,
            onClose: this.handleClose,
            classes: { paper: _styles_scss__WEBPACK_IMPORTED_MODULE_7___default.a.paper }
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            ___WEBPACK_IMPORTED_MODULE_6__["Typography"],
            { variant: 'subtitle1' },
            'Show/Hide Columns'
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4___default.a,
            { container: true },
            this.filterableColumns.map(function (c) {
              return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4___default.a,
                { item: true, xs: 6, key: c.id },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_6__["LabelCheckbox"], {
                  label: c.label,
                  value: _this2.isVisibleColumn(c),
                  onChange: _this2.handleToggle(c),
                  disabled: _this2.isLastFilterableColumn(c)
                })
              );
            })
          )
        )
      );
    }
  }, {
    key: 'filterableColumns',
    get: function get() {
      var _this3 = this;

      return this.props.columns.filter(function (c) {
        return !_this3.isUnfilterableColumn(c);
      });
    }
  }]);

  return ColumnFilter;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

ColumnFilter.propTypes = {
  columns: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
  })),
  hiddenColumnIds: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string),
  unfilterableColumnIds: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string),
  onToggleColumn: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

ColumnFilter.defaultProps = {
  columns: [],
  hiddenColumnIds: [],
  unfilterableColumnIds: [],
  onToggleColumn: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (ColumnFilter);

/***/ }),

/***/ "./src/DataTable/ColumnFilter/index.js":
/*!*********************************************!*\
  !*** ./src/DataTable/ColumnFilter/index.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/DataTable/ColumnFilter/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),

/***/ "./src/DataTable/ColumnFilter/styles.scss":
/*!************************************************!*\
  !*** ./src/DataTable/ColumnFilter/styles.scss ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../node_modules/css-loader??ref--5-1!../../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DataTable/ColumnFilter/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/DataTable/ColumnHeaderCell/index.jsx":
/*!**************************************************!*\
  !*** ./src/DataTable/ColumnHeaderCell/index.jsx ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_TableSortLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/TableSortLabel */ "@material-ui/core/TableSortLabel");
/* harmony import */ var _material_ui_core_TableSortLabel__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TableSortLabel__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _propTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../propTypes */ "./src/DataTable/propTypes.js");






var ColumnHeaderCell = function ColumnHeaderCell(_ref) {
  var column = _ref.column,
      sortDirection = _ref.sortDirection,
      onSortChange = _ref.onSortChange;

  if (!column.sortable) {
    return column.label;
  }
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_TableSortLabel__WEBPACK_IMPORTED_MODULE_2___default.a,
    {
      active: !!sortDirection,
      direction: sortDirection,
      onClick: function onClick() {
        if (onSortChange) {
          onSortChange(column);
        } // FMP
      }
    },
    column.label
  );
};

ColumnHeaderCell.propTypes = {
  column: _propTypes__WEBPACK_IMPORTED_MODULE_3__["columnPropType"],
  sortDirection: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['asc', 'desc']),
  onSortChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

ColumnHeaderCell.defaultProps = {
  column: undefined,
  sortDirection: undefined,
  onSortChange: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (ColumnHeaderCell);

/***/ }),

/***/ "./src/DataTable/dataTable.jsx":
/*!*************************************!*\
  !*** ./src/DataTable/dataTable.jsx ***!
  \*************************************/
/*! exports provided: idsFor, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "idsFor", function() { return idsFor; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_icons_KeyboardArrowUp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/icons/KeyboardArrowUp */ "@material-ui/icons/KeyboardArrowUp");
/* harmony import */ var _material_ui_icons_KeyboardArrowUp__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_KeyboardArrowUp__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/icons/KeyboardArrowDown */ "@material-ui/icons/KeyboardArrowDown");
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/icons/Clear */ "@material-ui/icons/Clear");
/* harmony import */ var _material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_Table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/Table */ "@material-ui/core/Table");
/* harmony import */ var _material_ui_core_Table__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Table__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_TableBody__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/core/TableBody */ "@material-ui/core/TableBody");
/* harmony import */ var _material_ui_core_TableBody__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TableBody__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @material-ui/core/TableCell */ "@material-ui/core/TableCell");
/* harmony import */ var _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _material_ui_core_TableHead__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @material-ui/core/TableHead */ "@material-ui/core/TableHead");
/* harmony import */ var _material_ui_core_TableHead__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TableHead__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @material-ui/core/TableRow */ "@material-ui/core/TableRow");
/* harmony import */ var _material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @material-ui/core/Typography */ "@material-ui/core/Typography");
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _material_ui_core_Toolbar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @material-ui/core/Toolbar */ "@material-ui/core/Toolbar");
/* harmony import */ var _material_ui_core_Toolbar__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Toolbar__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @material-ui/core/LinearProgress */ "@material-ui/core/LinearProgress");
/* harmony import */ var _material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @material-ui/core/CircularProgress */ "@material-ui/core/CircularProgress");
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _dataTable_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./dataTable.scss */ "./src/DataTable/dataTable.scss");
/* harmony import */ var _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_dataTable_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _propTypes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./propTypes */ "./src/DataTable/propTypes.js");
/* harmony import */ var _dataTableRow__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./dataTableRow */ "./src/DataTable/dataTableRow.jsx");
/* harmony import */ var _ColumnHeaderCell__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./ColumnHeaderCell */ "./src/DataTable/ColumnHeaderCell/index.jsx");
/* harmony import */ var _ColumnFilter__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./ColumnFilter */ "./src/DataTable/ColumnFilter/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var idsFor = function idsFor(root) {
  return {
    root: root,
    noContent: root + '_no_content',
    newButton: root + '_new_button',
    clearChecks: root + '_clear_checks'
  };
};

var defaultClasses = {
  root: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.root,
  noContentContainer: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.noContentContainer,
  noContentDiv: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.noContentDiv,
  addNewDiv: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.addNewDiv,
  tableContainer: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.tableContainer,
  table: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.table,
  tableHeader: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.tableHeader,
  tableContent: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.tableContent,
  titlebar: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.titlebar,
  toolbar: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.toolbar,
  loadingDiv: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.loadingDiv
};

// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var DataTable = function (_React$PureComponent) {
  _inherits(DataTable, _React$PureComponent);

  function DataTable(props) {
    _classCallCheck(this, DataTable);

    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));

    _this.getTestAttributes = function () {
      return {
        'data-cy': _this.props['data-cy'] || _this.props.title,
        'data-component': 'DataTable'
      };
    };

    _this.mergeLastColumn = function () {
      var visibleColumns = _this.visibleColumns;

      return _this.props.columnVisibility.enabled && visibleColumns[visibleColumns.length - 1].label === '';
    };

    _this.compoundId = function (row, subrow) {
      var getRowId = _this.props.getRowId;

      return '' + getRowId(row) + (subrow ? '-' + getRowId(subrow) : '');
    };

    _this.updateSelectedIds = function (hasSelected, row, subrow) {
      var compoundId = _this.compoundId(row, subrow);

      var newSelectedIds = void 0;
      if (_this.props.allowMultipleSelection) {
        newSelectedIds = hasSelected ? _this.state.selectedIds.filter(function (id) {
          return id !== compoundId;
        }) : [].concat(_toConsumableArray(_this.state.selectedIds), [compoundId]);
      } else {
        newSelectedIds = hasSelected ? [] : [compoundId];
      }
      _this.setState({ selectedIds: newSelectedIds });
    };

    _this.handleSelectRow = function (event, row) {
      var _this$props = _this.props,
          allowSelection = _this$props.allowSelection,
          isLoading = _this$props.isLoading;

      if (!allowSelection || isLoading) {
        return;
      }
      var hasSelected = _this.state.selectedIds.includes(_this.compoundId(row));

      _this.updateSelectedIds(hasSelected, row);

      var onSelectRow = _this.props.onSelectRow;

      if (onSelectRow) {
        onSelectRow(row, !hasSelected);
      }
    };

    _this.handleSelectSubrow = function (event, row, subrow) {
      event.stopPropagation();
      var _this$props2 = _this.props,
          allowSubrowSelection = _this$props2.allowSubrowSelection,
          isLoading = _this$props2.isLoading;

      if (!allowSubrowSelection || isLoading) {
        return;
      }
      var hasSelected = _this.state.selectedIds.includes(_this.compoundId(row, subrow));

      _this.updateSelectedIds(hasSelected, row, subrow);

      var onSelectSubrow = _this.props.onSelectSubrow;

      if (onSelectSubrow) {
        onSelectSubrow(subrow, !hasSelected);
      }
    };

    _this.toggleExpanded = function () {
      var newExpanded = !_this.state.expanded;
      _this.setState({
        expanded: newExpanded
      });
      var onExpandedChanged = _this.props.onExpandedChanged;

      if (onExpandedChanged) {
        onExpandedChanged(newExpanded);
      }
    };

    _this.handleColumnVisibility = function (hiddenColumnIds) {
      _this.setState({ hiddenColumnIds: hiddenColumnIds });
      var onVisibilityChange = _this.props.columnVisibility.onVisibilityChange;

      if (onVisibilityChange) {
        onVisibilityChange(hiddenColumnIds);
      }
    };

    _this.selected = function (row, subrow) {
      return _this.state.selectedIds.includes(_this.compoundId(row, subrow));
    };

    _this.renderTableHeader = function () {
      var _this$props3 = _this.props,
          id = _this$props3.id,
          columns = _this$props3.columns,
          enableCheck = _this$props3.enableCheck,
          preventClearChecks = _this$props3.preventClearChecks,
          onClearChecks = _this$props3.onClearChecks,
          checkedIDs = _this$props3.checkedIDs,
          _this$props3$sort = _this$props3.sort,
          sort = _this$props3$sort === undefined ? {} : _this$props3$sort,
          onSortChange = _this$props3.onSortChange,
          columnVisibility = _this$props3.columnVisibility,
          classes = _this$props3.classes,
          expandableRows = _this$props3.expandableRows;
      var hiddenColumnIds = _this.state.hiddenColumnIds;

      var ids = idsFor(id);
      var showClearIcon = checkedIDs.length > 0 && !preventClearChecks;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_TableHead__WEBPACK_IMPORTED_MODULE_9___default.a,
        null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_10___default.a,
          null,
          enableCheck && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_8___default.a,
            { className: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.checkboxCell, key: 'checkbox', padding: 'none' },
            showClearIcon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_5___default.a, { className: ___WEBPACK_IMPORTED_MODULE_16__["layout"].clickable, id: ids.clearChecks, onClick: onClearChecks })
          ),
          expandableRows && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_8___default.a, { className: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.checkboxCell, key: 'expand', padding: 'none' }),
          _this.visibleColumnHeaders.map(function (column) {
            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_8___default.a,
              _extends({
                key: column.id,
                align: column.align,
                padding: column.disablePadding ? 'none' : 'default'
              }, column.cellProps),
              react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ColumnHeaderCell__WEBPACK_IMPORTED_MODULE_20__["default"], { column: column, sortDirection: sort[column.id], onSortChange: onSortChange })
            );
          }),
          columnVisibility.enabled && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_8___default.a,
            {
              key: 'column_filter',
              className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.filterCell, classes.filterCell),
              colSpan: _this.mergeLastColumn() ? 2 : 1
            },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ColumnFilter__WEBPACK_IMPORTED_MODULE_21__["default"], {
              columns: columns,
              hiddenColumnIds: hiddenColumnIds,
              unfilterableColumnIds: columnVisibility.untoggleableIds,
              onToggleColumn: _this.handleColumnVisibility
            })
          )
        )
      );
    };

    _this.renderExpandIcon = function () {
      var expanded = _this.state.expanded;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        ___WEBPACK_IMPORTED_MODULE_16__["IconButton"],
        { onClick: _this.toggleExpanded },
        expanded ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_KeyboardArrowUp__WEBPACK_IMPORTED_MODULE_3___default.a
        // class name icon-chevron-? required by e2e test
        , { className: 'icon-chevron-up'
        }) : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_4___default.a
        // class name icon-chevron-? required by e2e test
        , { className: 'icon-chevron-down'
        })
      );
    };

    _this.renderTitleBar = function () {
      var _this$props4 = _this.props,
          title = _this$props4.title,
          titleVariant = _this$props4.titleVariant,
          toolbar = _this$props4.toolbar,
          expandable = _this$props4.expandable,
          expandIconPosition = _this$props4.expandIconPosition,
          classes = _this$props4.classes;

      if (!title && !toolbar) return undefined;
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Toolbar__WEBPACK_IMPORTED_MODULE_12___default.a,
        { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(defaultClasses.titlebar, classes.titlebar) },
        expandable && expandIconPosition === 'left' ? _this.renderExpandIcon() : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('span', { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(___WEBPACK_IMPORTED_MODULE_16__["layout"].paddingLeft) }) // provide padding if no icon
        ,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_11___default.a,
          { className: _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.title, variant: titleVariant },
          title || ''
        ),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(defaultClasses.toolbar, classes.toolbar) },
          toolbar,
          expandable && expandIconPosition === 'right' && _this.renderExpandIcon()
        )
      );
    };

    _this.renderTableRows = function () {
      var _this$props5 = _this.props,
          items = _this$props5.items,
          RowComponent = _this$props5.RowComponent,
          RowActionsComponent = _this$props5.RowActionsComponent,
          checkedIDs = _this$props5.checkedIDs,
          rowProps = _this$props5.rowProps,
          enableCheck = _this$props5.enableCheck,
          onCheckRow = _this$props5.onCheckRow,
          emptyCellContent = _this$props5.emptyCellContent,
          multiline = _this$props5.multiline,
          hover = _this$props5.hover,
          rowItemActions = _this$props5.rowItemActions,
          expandableRows = _this$props5.expandableRows,
          onExpandToggled = _this$props5.onExpandToggled,
          expandedRowIds = _this$props5.expandedRowIds,
          disableOnSelectRowForExpandableRows = _this$props5.disableOnSelectRowForExpandableRows,
          getRowId = _this$props5.getRowId,
          checkBoxDisabledProp = _this$props5.checkBoxDisabledProp;


      return items.map(function (row, index) {
        var checked = checkedIDs.includes(getRowId(row));
        var expandedRow = expandedRowIds.includes(getRowId(row));
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(RowComponent, _extends({
          key: getRowId(row),
          row: _extends({}, row, { index: index }),
          columns: _this.visibleDataColumns,
          selected: _this.selected,
          checked: checked && !row[checkBoxDisabledProp],
          onSelect: function onSelect(e) {
            _this.handleSelectRow(e, row);
          } // FMP
          , disableOnSelectRowForExpandableRows: disableOnSelectRowForExpandableRows,
          onSelectSubrow: function onSelectSubrow(e, subrow) {
            _this.handleSelectSubrow(e, row, subrow);
          },
          enableCheck: enableCheck,
          expandable: expandableRows,
          expanded: expandedRow,
          onExpandToggled: onExpandToggled,
          onCheck: onCheckRow,
          emptyCellContent: emptyCellContent,
          multiline: multiline,
          hover: hover,
          getRowId: getRowId
        }, rowProps, {
          rowItemActions: rowItemActions,
          RowActionsComponent: RowActionsComponent,
          checkBoxDisabled: !!row[checkBoxDisabledProp]
        }));
      });
    };

    _this.renderNoContentPanel = function () {
      var _this$props6 = _this.props,
          id = _this$props6.id,
          isLoading = _this$props6.isLoading,
          noContentText = _this$props6.noContentText,
          addNewText = _this$props6.addNewText,
          onAddNewClick = _this$props6.onAddNewClick,
          classes = _this$props6.classes,
          hideColumnHeads = _this$props6.hideColumnHeads;

      var ids = idsFor(id);
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        react__WEBPACK_IMPORTED_MODULE_0__["Fragment"],
        null,
        !hideColumnHeads && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Table__WEBPACK_IMPORTED_MODULE_6___default.a,
          null,
          _this.renderTableHeader()
        ),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { id: ids.noContent, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(defaultClasses.noContentContainer, classes.noContentContainer) },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(defaultClasses.noContentDiv, classes.noContentDiv) },
            isLoading ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_14___default.a, null) : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_16__["EmptyState"], {
              className: ___WEBPACK_IMPORTED_MODULE_16__["layout"].flexGrow,
              title: noContentText,
              actions: onAddNewClick && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                ___WEBPACK_IMPORTED_MODULE_16__["Button"],
                { id: ids.newButton, onClick: onAddNewClick, color: 'primary', variant: 'contained' },
                addNewText
              )
            })
          )
        )
      );
    };

    _this.state = {
      selectedIds: props.selectedIds || [],
      expanded: props.expanded,
      hiddenColumnIds: props.columnVisibility.hidden || []
    };
    return _this;
  }

  _createClass(DataTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var newState = {};
      if (nextProps.expanded !== undefined && nextProps.expanded !== this.state.expanded) {
        newState.expanded = nextProps.expanded;
      }

      if (nextProps.selectedIds !== undefined) {
        newState.selectedIds = nextProps.selectedIds;
      }

      var nextPropHiddenColumns = nextProps.columnVisibility && nextProps.columnVisibility.hidden;
      if (nextPropHiddenColumns && !Object(lodash__WEBPACK_IMPORTED_MODULE_15__["isEqual"])(nextPropHiddenColumns.sort(), this.state.hiddenColumnIds.sort())) {
        newState.hiddenColumnIds = nextPropHiddenColumns;
      }
      this.setState(newState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          id = _props.id,
          classes = _props.classes,
          className = _props.className,
          items = _props.items,
          isLoading = _props.isLoading,
          fixedHeader = _props.fixedHeader,
          hideColumnHeads = _props.hideColumnHeads,
          collapseOnEmpty = _props.collapseOnEmpty,
          tableLayout = _props.layout,
          allowSelection = _props.allowSelection,
          dense = _props.dense;

      var ids = idsFor(id);
      var expanded = this.state.expanded;

      var rowCount = !items ? 0 : items.length;
      var appliedClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()('genie-table', (_classNames = {}, _defineProperty(_classNames, _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.allowSelection, allowSelection), _defineProperty(_classNames, _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.dense, dense), _classNames), defaultClasses.root, classes.root, _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.hack, className);
      var showHeaders = !hideColumnHeads && expanded && rowCount > 0;
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        _extends({
          id: ids.root,
          className: appliedClassName
        }, this.getTestAttributes()),
        this.renderTitleBar(),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(___WEBPACK_IMPORTED_MODULE_16__["layout"].flexColumnContainer, ___WEBPACK_IMPORTED_MODULE_16__["layout"].flexGrow, defaultClasses.tableContainer, classes.tableContainer) },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(___WEBPACK_IMPORTED_MODULE_16__["layout"].flexColumnContainer, ___WEBPACK_IMPORTED_MODULE_16__["layout"].flexGrow, defaultClasses.table, classes.table) },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              'div',
              { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(defaultClasses.tableContent, classes.tableContent) },
              fixedHeader && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                'div',
                { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(defaultClasses.tableHeader, classes.tableHeader, fixedHeader && _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.fixedHeader) },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                  _material_ui_core_Table__WEBPACK_IMPORTED_MODULE_6___default.a,
                  null,
                  showHeaders && this.renderTableHeader()
                )
              ),
              react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                _material_ui_core_Table__WEBPACK_IMPORTED_MODULE_6___default.a,
                { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({}, _dataTable_scss__WEBPACK_IMPORTED_MODULE_17___default.a.autoLayout, !fixedHeader && tableLayout === 'auto')) },
                !fixedHeader && showHeaders && this.renderTableHeader(),
                expanded && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                  _material_ui_core_TableBody__WEBPACK_IMPORTED_MODULE_7___default.a,
                  null,
                  rowCount > 0 && this.renderTableRows()
                )
              ),
              expanded && rowCount === 0 && !collapseOnEmpty && this.renderNoContentPanel()
            ),
            isLoading && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_13___default.a, { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(defaultClasses.loadingDiv, classes.loadingDiv) })
          )
        )
      );
    }
  }, {
    key: 'visibleColumns',
    get: function get() {
      var _props2 = this.props,
          columns = _props2.columns,
          columnVisibility = _props2.columnVisibility;
      // If we don't have the column visibility enabled or if we didn't specify any
      // columns, then return all the columns.

      if (!columnVisibility.enabled || this.state.hiddenColumnIds.length === 0) return columns;

      var hiddenColumnIds = this.state.hiddenColumnIds;

      return columns.filter(function (c) {
        return !hiddenColumnIds.includes(c.id);
      });
    }
  }, {
    key: 'visibleDataColumns',
    get: function get() {
      var filteredColumns = this.visibleColumns;
      if (!this.props.columnVisibility.enabled) return filteredColumns;

      var last = filteredColumns[filteredColumns.length - 1];
      var lastCellProps = last.cellProps || {};
      return filteredColumns.slice(0, -1).concat(_extends({}, last, {
        cellProps: _extends({}, lastCellProps, {
          colSpan: (lastCellProps.colSpan || 1) + 1
        })
      }));
    }
  }, {
    key: 'visibleColumnHeaders',
    get: function get() {
      var visibleColumns = this.visibleColumns;

      if (!this.props.columnVisibility.enabled) return visibleColumns;

      var isNotLast = function isNotLast(i) {
        return i < visibleColumns.length - 1;
      };
      var isLastAndNotEmpty = function isLastAndNotEmpty(c, i) {
        return i === visibleColumns.length - 1 && visibleColumns[i].label !== '';
      };
      return visibleColumns.filter(function (c, i) {
        return isNotLast(i) || isLastAndNotEmpty(c, i);
      });
    }
  }]);

  return DataTable;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

DataTable.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /**
   * title is the text displayed in titlebar above the table,
   * if not title or toolbar specified, titlebar will be hidden
   */
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Typography variant to be used by title */
  titleVariant: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'body2', 'body1', 'caption', 'button']),
  /** className will be append to root element of datatable */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** a MUI like api to allow customize style on each part of the table */
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** columns */
  columns: _propTypes__WEBPACK_IMPORTED_MODULE_18__["columnsPropType"], // eslint-disable-line react/require-default-props
  /** hide the table header */
  hideColumnHeads: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** items is an array of rows, each row is a js object */
  items: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)),
  /** toolbar allows expand and collapse */
  expandable: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * display expand icon on left or right
   */
  expandIconPosition: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['left', 'right']),
  /** display the table as expanded */
  expanded: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** listen to expanded changed event (incase expanded is passed as prop, this should be provided as well) */
  onExpandedChanged: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** toolbar is a optional component to allow display actions in the titlebar floating right */
  toolbar: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** isLoading is the flag to decide if display a progress */
  isLoading: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * fixedHaeader is the flag to decide if need to display header
   * as a separate table with table-layout:fixed.
   * this is ususally used with className which specify a table body height
   */
  fixedHeader: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * noContentText is the text to be displayed when it is not loading
   * but items is falsy or empty, it has a default value
   */
  noContentText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /**
   * addNewText is the text to be displayed when it is not loading but items is falsy
   * or emptyand onAddNewClick is specified, it has a default value
   */
  addNewText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /**
   * onAddNewClick is the callback function to handle add new link click,
   * if speified and no table data, a "add new" link will be displayed
   */
  onAddNewClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * onSelectRow is the callback function to handle click on a table row
   */
  onSelectRow: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * disableOnSelectRowForExpandableRows is the flag to decide if the onSelectRow callback function should be triggered
   * when an expandable row is clicked.
   */
  disableOnSelectRowForExpandableRows: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * onSelectSubrow is the callback function to handle click on a table subrow
   */
  onSelectSubrow: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * Flag to show the row in a selected state
   */
  showSelected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * Flag to hide no content message when list is empty
   */
  collapseOnEmpty: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * Custom component for rendering custom rows, see dataTableRow for what properties will be passed in
   */
  RowComponent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  RowActionsComponent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * Extra properties to be passed to RowComponent
   */
  rowProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /**
   * Allow check row if true
   */
  enableCheck: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * By default a clear icon is shown above the check column
   * if any row is checked. This prop can be used to prevent the
   * display of the clear icon.
   */
  preventClearChecks: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * CHecked row ids for current table
   */
  checkedIDs: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string),
  /**
   * Handler to handle checkbox value change
   * e.g. function(item, checked)
   */
  onCheckRow: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * Handler on click clear icon for selections
   */
  onClearChecks: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * Allow rows to be expanded. When true,
   * all rows with subrows defined are expandable,
   * (even if subrows.length === 0).
   */
  expandableRows: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /*
   * Exanded rows (ids)
   */
  expandedRowIds: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string),
  /* Handler to handle a row being expanded (or retracted)
   * e.g. function(item, expanded)
   */
  onExpandToggled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * Content to be set to cell if cell text is empty or undefined
   */
  emptyCellContent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /**
   * Allow text in data table cells to wrap. When
   * off in single line mode the text is truncated and
   * an ellipsis (...) is shown.
   */
  multiline: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * Sort information:
   * {
   *   [column.id]: 'asc' || 'desc'
   * }
   */
  sort: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.objectOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['asc', 'desc'])),
  /**
   * Callback when sortable header clicked
   * column instance will be passed to callback
   */
  onSortChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** table-layout CSS value, fixed or auto. Default is fixed. */
  layout: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['fixed', 'auto']),
  /** If set to false, table will ignore row clicking event */
  allowSelection: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (optional) selecting a row will not clear previous selections */
  allowMultipleSelection: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** If set to false, subrows will ignore subrow clicking event */
  allowSubrowSelection: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (optional) force the selection of row(s) by id */
  selectedIds: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string),

  /** (optional) column visibility properties */
  columnVisibility: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    /** (optional) Whether we should show the option to toggle columns. Default is false */
    enabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

    /** (optional) The ids of all the columns that should be hidden. Defaults to all columns */
    hidden: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string),

    /**
     * (optional) The ids of all the columns that cannot have their visibility toggled.
     * Default is all columns that don't have a label
     */
    untoggleableIds: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string),

    /** (optional) Callback func to call when the column visibilties have changed. */
    onVisibilityChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
  }),

  // config table row hover state
  hover: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (optional) adds icons to the table row */
  rowItemActions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
    label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
  })),
  /** (optional) reduces cell padding */
  dense: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (optional) function to get a row identifier */
  getRowId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  'data-cy': prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** property in items which holds information about the checkbox being disabled in the row */
  checkBoxDisabledProp: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

DataTable.defaultProps = {
  id: 'dataTable',
  title: undefined,
  titleVariant: 'h6',
  className: undefined,
  classes: {},
  toolbar: undefined,
  hideColumnHeads: false,
  expandable: false,
  expanded: true,
  expandIconPosition: 'right',
  onExpandedChanged: undefined,
  items: undefined,
  isLoading: false,
  fixedHeader: false,
  noContentText: 'No content found',
  addNewText: 'Create One Here',
  onAddNewClick: undefined,
  onSelectRow: undefined,
  disableOnSelectRowForExpandableRows: false,
  onSelectSubrow: undefined,
  showSelected: false,
  collapseOnEmpty: false,
  RowComponent: _dataTableRow__WEBPACK_IMPORTED_MODULE_19__["default"],
  RowActionsComponent: undefined,
  rowProps: undefined,
  enableCheck: false,
  preventClearChecks: false,
  checkedIDs: [],
  onCheckRow: undefined,
  onClearChecks: undefined,
  expandableRows: false,
  expandedRowIds: [],
  onExpandToggled: undefined,
  emptyCellContent: '',
  multiline: false,
  sort: undefined,
  onSortChange: undefined,
  layout: 'fixed',
  allowSelection: true,
  allowMultipleSelection: false,
  allowSubrowSelection: true,
  selectedIds: undefined,
  columnVisibility: {
    enabled: false,
    hidden: undefined,
    toggleableIds: undefined,
    onVisibilityChange: undefined
  },
  hover: true,
  dense: false,
  rowItemActions: undefined,
  getRowId: function getRowId(row) {
    return row.id;
  },
  'data-cy': undefined,
  checkBoxDisabledProp: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (DataTable);

/***/ }),

/***/ "./src/DataTable/dataTable.scss":
/*!**************************************!*\
  !*** ./src/DataTable/dataTable.scss ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./dataTable.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DataTable/dataTable.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/DataTable/dataTableRow.jsx":
/*!****************************************!*\
  !*** ./src/DataTable/dataTableRow.jsx ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/TableRow */ "@material-ui/core/TableRow");
/* harmony import */ var _material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/TableCell */ "@material-ui/core/TableCell");
/* harmony import */ var _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/icons/KeyboardArrowDown */ "@material-ui/icons/KeyboardArrowDown");
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Icon */ "./src/Icon/index.js");
/* harmony import */ var _propTypes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./propTypes */ "./src/DataTable/propTypes.js");
/* harmony import */ var _dataTable_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./dataTable.scss */ "./src/DataTable/dataTable.scss");
/* harmony import */ var _dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_dataTable_scss__WEBPACK_IMPORTED_MODULE_10__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var DataTableRow = function DataTableRow(_ref) {
  var row = _ref.row,
      columns = _ref.columns,
      onSelect = _ref.onSelect,
      onSelectSubrow = _ref.onSelectSubrow,
      disableOnSelectRowForExpandableRows = _ref.disableOnSelectRowForExpandableRows,
      _selected = _ref.selected,
      enableCheck = _ref.enableCheck,
      onCheck = _ref.onCheck,
      checked = _ref.checked,
      expandable = _ref.expandable,
      onExpandToggled = _ref.onExpandToggled,
      expanded = _ref.expanded,
      classes = _ref.classes,
      className = _ref.className,
      emptyCellContent = _ref.emptyCellContent,
      multiline = _ref.multiline,
      disabled = _ref.disabled,
      hover = _ref.hover,
      getRowId = _ref.getRowId,
      subrowProps = _ref.subrowProps,
      RowActionsComponent = _ref.RowActionsComponent,
      checkBoxDisabled = _ref.checkBoxDisabled;

  var isDisabled = disabled ? disabled(row) : false;
  var isSelected = _selected && _selected(row) || checked;

  var expandRows = function expandRows(e) {
    e.stopPropagation();
    if (onExpandToggled) {
      onExpandToggled(row, !expanded);
    }
    if (onSelect && !disableOnSelectRowForExpandableRows) {
      onSelect(e);
    }
  };

  var renderRowActionsComponent = function renderRowActionsComponent(row) {
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { className: _dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.tableCellActions },
      RowActionsComponent(row)
    );
  };

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment,
    null,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_4___default.a,
      {
        hover: hover,
        onClick: expandable && !!row.subrows ? expandRows : onSelect,
        selected: isSelected,
        classes: classes,
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, { 'parent-row': !!row.subrows })
      },
      enableCheck && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_5___default.a,
        {
          className: _dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.checkboxCell,
          onClick: function onClick(e) {
            // FMP
            // this is to ignore row click
            e.stopPropagation();
            if (onCheck && !checkBoxDisabled) {
              onCheck(row, !checked);
            }
          },
          key: 'checkbox',
          padding: 'none'
        },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_7__["Checkbox"], { compact: true, value: checked, disabled: checkBoxDisabled })
      ),
      expandable && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_5___default.a,
        {
          className: _dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.checkboxCell,
          key: 'expand',
          padding: 'none'
        },
        !!row.subrows && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _Icon__WEBPACK_IMPORTED_MODULE_8__["default"],
          { className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.chevron, _defineProperty({}, _dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.expandedChevron, expanded)) },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_6___default.a, null)
        )
      ),
      columns.map(function (column, index) {
        var _classNames2;

        var value = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(row, column.id, '');
        var cellContent = column.render ? column.render(value, row, index) : value;
        var cellClassName = column.cellProps ? column.cellProps.className : null;
        if (!cellContent) {
          cellContent = emptyCellContent;
        }
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_TableCell__WEBPACK_IMPORTED_MODULE_5___default.a,
          _extends({
            key: column.id + getRowId(row),
            align: column.align
          }, column.cellProps, {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.tableCell, cellClassName, (_classNames2 = {}, _defineProperty(_classNames2, _dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.multiline, !!multiline), _defineProperty(_classNames2, _dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.singleline, !multiline), _defineProperty(_classNames2, _dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.cellDisabled, isDisabled), _classNames2))
          }),
          cellContent,
          columns.length - 1 == index && hover && RowActionsComponent && renderRowActionsComponent(row)
        );
      })
    ),
    !!row.subrows && expanded && row.subrows.map(function (sr) {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(DataTableRow, _extends({
        key: getRowId(row) + '-' + sr.id,
        row: sr,
        selected: function selected() {
          return _selected(row, sr);
        },
        onSelect: function onSelect(e) {
          onSelectSubrow(e, sr);
        },
        className: _dataTable_scss__WEBPACK_IMPORTED_MODULE_10___default.a.expandedRow,
        columns: enableCheck ? [{ id: '' }].concat(_toConsumableArray(columns)) : columns
      }, _extends({
        expandable: expandable,
        emptyCellContent: emptyCellContent,
        multiline: multiline
      }, subrowProps)));
    })
  );
};

DataTableRow.propTypes = {
  row: _propTypes__WEBPACK_IMPORTED_MODULE_9__["rowPropType"].isRequired,
  columns: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(Object).isRequired,
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  disableOnSelectRowForExpandableRows: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  onSelectSubrow: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onCheck: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onExpandToggled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  enableCheck: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  expandable: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  checked: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  selected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  expanded: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * Content to be set to cell if cell text is empty or undefined
   */
  emptyCellContent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  multiline: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /**
   * A function that can be used to query the row to
   * tell if the row is disabled or not. If disabled,
   * then the row will be rendered with disabled styling.
   */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  // config table row hover state
  hover: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (optional) function to get a row identifier */
  getRowId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * Extra properties to be passed to subrows
   */
  subrowProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  RowActionsComponent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  checkBoxDisabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};

DataTableRow.defaultProps = {
  onSelect: undefined,
  disableOnSelectRowForExpandableRows: false,
  onSelectSubrow: undefined,
  onCheck: undefined,
  onExpandToggled: undefined,
  enableCheck: undefined,
  expandable: undefined,
  expanded: false,
  selected: undefined,
  checked: false,
  emptyCellContent: '',
  multiline: false,
  disabled: undefined,
  classes: undefined,
  className: '',
  hover: true,
  getRowId: function getRowId(row) {
    return row.id;
  },
  subrowProps: undefined,
  RowActionsComponent: undefined,
  checkBoxDisabled: false
};

/* harmony default export */ __webpack_exports__["default"] = (DataTableRow);

/***/ }),

/***/ "./src/DataTable/index.js":
/*!********************************!*\
  !*** ./src/DataTable/index.js ***!
  \********************************/
/*! exports provided: default, idsFor, TickCell, renderTick, DataTableRow */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _dataTable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dataTable */ "./src/DataTable/dataTable.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _dataTable__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "idsFor", function() { return _dataTable__WEBPACK_IMPORTED_MODULE_0__["idsFor"]; });

/* harmony import */ var _tick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./tick */ "./src/DataTable/tick.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TickCell", function() { return _tick__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderTick", function() { return _tick__WEBPACK_IMPORTED_MODULE_1__["renderTick"]; });

/* harmony import */ var _dataTableRow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./dataTableRow */ "./src/DataTable/dataTableRow.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataTableRow", function() { return _dataTableRow__WEBPACK_IMPORTED_MODULE_2__["default"]; });






/***/ }),

/***/ "./src/DataTable/propTypes.js":
/*!************************************!*\
  !*** ./src/DataTable/propTypes.js ***!
  \************************************/
/*! exports provided: columnPropType, columnsPropType, rowPropType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columnPropType", function() { return columnPropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columnsPropType", function() { return columnsPropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rowPropType", function() { return rowPropType; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);


/**
 * mandatory fields:
 * - 'id' is the path to resolve the column data in each row (e.g. display_name or address.suburb)
 * - 'label' display header for the column
 * optional fields:
 * - 'align' is alignment of column contents.
 * - 'disablePadding' avoid render padding, e.g. for a 'checkbox' column or 'delete' column
 * - 'render' a custom function to render the row entry, e.g can be used to render icons instead of plain text
 */
var columnPropType = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  label: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node.isRequired,
  align: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  disablePadding: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
  render: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  /**
     * The properties to be passed into all cells of the column (including header)
     */
  cellProps: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(Object),
  /**
   * Tell if the column is sortable.
   * If set to true
   *  - column header will be clickable
   *  - click on the header cell will trigger DataTable.onSortChange callback.
   */
  sortable: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool
});

/**
   * columns is an array of column definition.
   */
var columnsPropType = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.arrayOf(columnPropType).isRequired;

/**
 * row is an object to be rendered as a DataTableRow
 */
var rowPropType = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({
  subrows: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(Array)
});

/***/ }),

/***/ "./src/DataTable/tick.jsx":
/*!********************************!*\
  !*** ./src/DataTable/tick.jsx ***!
  \********************************/
/*! exports provided: renderTick, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderTick", function() { return renderTick; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_icons_Done__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/icons/Done */ "@material-ui/icons/Done");
/* harmony import */ var _material_ui_icons_Done__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Done__WEBPACK_IMPORTED_MODULE_2__);





var Tick = function Tick(_ref) {
  var value = _ref.value;
  return value && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Done__WEBPACK_IMPORTED_MODULE_2___default.a, { className: 'tick icon-tick' });
};
Tick.propTypes = {
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};
Tick.defaultProps = {
  value: undefined
};

var renderTick = function renderTick(value) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Tick, { value: value });
};
/* harmony default export */ __webpack_exports__["default"] = (Tick);

/***/ }),

/***/ "./src/DatePicker/component.jsx":
/*!**************************************!*\
  !*** ./src/DatePicker/component.jsx ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-moment-proptypes */ "react-moment-proptypes");
/* harmony import */ var react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_calendar_dist_entry_nostyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react-calendar/dist/entry.nostyle */ "react-calendar/dist/entry.nostyle");
/* harmony import */ var react_calendar_dist_entry_nostyle__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_calendar_dist_entry_nostyle__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/ */ "@material-ui/core/");
/* harmony import */ var _material_ui_core___WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core___WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/icons/ArrowDropDown */ "@material-ui/icons/ArrowDropDown");
/* harmony import */ var _material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_icons_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @material-ui/icons/KeyboardArrowLeft */ "@material-ui/icons/KeyboardArrowLeft");
/* harmony import */ var _material_ui_icons_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _material_ui_icons_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @material-ui/icons/KeyboardArrowRight */ "@material-ui/icons/KeyboardArrowRight");
/* harmony import */ var _material_ui_icons_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! moment */ "moment");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./styles.scss */ "./src/DatePicker/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Input_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../Input/utils */ "./src/Input/utils.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
/* harmony import */ var _helpers_date__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../helpers/date */ "./helpers/date.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var inputMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

var parseDate = function parseDate(value, format) {
  if (!value) return [null, ''];

  var momentValue = moment__WEBPACK_IMPORTED_MODULE_11___default()(value, [_helpers_date__WEBPACK_IMPORTED_MODULE_16__["ISO_DATE_FORMAT"], format], true);
  if (momentValue.isValid()) return [momentValue, momentValue.format(format)];

  return [null, value];
};

var generateYears = function generateYears(minYear, maxYear) {
  var arr = [];
  for (var i = minYear; i <= maxYear; i += 1) {
    arr.push({ name: i.toString(), value: i.toString() });
  }
  return arr;
};

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _initialiseProps.call(_this);

    var _parseDate = parseDate(props.value, props.format),
        _parseDate2 = _slicedToArray(_parseDate, 2),
        selectedDate = _parseDate2[0],
        textValue = _parseDate2[1];

    var startingDate = selectedDate || moment__WEBPACK_IMPORTED_MODULE_11___default()();

    _this.state = {
      activeStartDate: startingDate.clone().startOf('month'),
      currentMonth: startingDate.month(),
      currentYear: startingDate.year(),
      textValue: textValue,
      popoverOpen: false,
      anchor: null
    };

    _this.receivingAutoFocus = !!props.autoFocus;
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var properties = ['value', 'disabled', 'helperText', 'error', 'warning'];
      return !Object(lodash__WEBPACK_IMPORTED_MODULE_10__["isEqual"])(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["pick"])(nextProps, properties), Object(lodash__WEBPACK_IMPORTED_MODULE_10__["pick"])(this.props, properties)) || !Object(lodash__WEBPACK_IMPORTED_MODULE_10__["isEqual"])(nextState, this.state);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          maxDate = _props.maxDate,
          minDate = _props.minDate,
          value = _props.value,
          native = _props.native,
          disabled = _props.disabled,
          format = _props.format,
          endAdornment = _props.endAdornment,
          dayClassCallback = _props.dayClassCallback,
          rest = _objectWithoutProperties(_props, ['id', 'maxDate', 'minDate', 'value', 'native', 'disabled', 'format', 'endAdornment', 'dayClassCallback']);

      var _state = this.state,
          textValue = _state.textValue,
          popoverOpen = _state.popoverOpen,
          currentMonth = _state.currentMonth,
          currentYear = _state.currentYear,
          activeStartDate = _state.activeStartDate,
          anchor = _state.anchor;


      var wrapperId = id;
      var inputId = id ? id + '-input' : null;

      if (native || Object(_utils__WEBPACK_IMPORTED_MODULE_15__["isMobile"])()) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          _extends({
            id: wrapperId,
            className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_13___default.a.root, _styles_scss__WEBPACK_IMPORTED_MODULE_13___default.a.reset)
          }, this.getTestAttributes()),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_12__["Input"], _extends({}, rest, {
            'data-cy': 'Input',
            id: inputId,
            name: wrapperId,
            type: 'date',
            value: textValue ? moment__WEBPACK_IMPORTED_MODULE_11___default()(textValue, [_helpers_date__WEBPACK_IMPORTED_MODULE_16__["ISO_DATE_FORMAT"], _helpers_date__WEBPACK_IMPORTED_MODULE_16__["PLAIN_DATE_FORMAT"]], true).format(_helpers_date__WEBPACK_IMPORTED_MODULE_16__["ISO_DATE_FORMAT"]) : null,
            onChange: this.handleNativeInputChange,
            inputProps: _extends({
              min: this.minDate.format(_helpers_date__WEBPACK_IMPORTED_MODULE_16__["ISO_DATE_FORMAT"]),
              max: this.maxDate.format(_helpers_date__WEBPACK_IMPORTED_MODULE_16__["ISO_DATE_FORMAT"])
            }, rest.inputProps),
            disabled: disabled
          }))
        );
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        _extends({
          id: wrapperId,
          className: _styles_scss__WEBPACK_IMPORTED_MODULE_13___default.a.root,
          ref: this.handleAnchorRef
        }, this.getTestAttributes()),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_12__["Input"], _extends({}, rest, {
          'data-cy': 'Input',
          id: inputId,
          name: wrapperId,
          value: textValue,
          onChange: this.handleTextChange,
          onFocus: this.handleFocus,
          onClick: this.handleFocus,
          onBlur: this.handleBlur,
          onKeyDown: this.handleKeyDown
          // Use the underlying div wrapping label and input as the target DOM element rather than the whole Input
          // component, because Input component may have FormHelperText component which pushes the popper down.
          , inputRef: this.handleInputRef,
          placeholder: this.props.format,
          autoComplete: 'off',
          className: _styles_scss__WEBPACK_IMPORTED_MODULE_13___default.a.input,
          disabled: disabled,
          mask: inputMask,
          endAdornment: !disabled && this.endAdornment
        })),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ___WEBPACK_IMPORTED_MODULE_12__["Popover"],
          {
            open: popoverOpen,
            onClose: this.closePopup,
            anchorEl: anchor,
            anchorBottomEl: (this.inputRef || {}).inputElement,
            classes: { paper: _styles_scss__WEBPACK_IMPORTED_MODULE_13___default.a.paper },
            disableRestoreFocus: true,
            disableEnforceFocus: true,
            disableAutoFocus: true,
            'data-cy': 'DatePicker-Popover'
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            null,
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              'div',
              { className: _styles_scss__WEBPACK_IMPORTED_MODULE_13___default.a.header },
              react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                ___WEBPACK_IMPORTED_MODULE_12__["IconButton"],
                {
                  onClick: this.prevMonth,
                  disabled: this.disablePrev(),
                  tabIndex: -1
                },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_8___default.a, null)
              ),
              popoverOpen && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_12__["Select"], {
                value: currentMonth.toString(),
                data: _helpers_date__WEBPACK_IMPORTED_MODULE_16__["MONTHS"],
                onChange: this.handleMonthChange,
                tabIndex: -1,
                label: '',
                hideEmpty: true,
                notInForm: true
              }),
              '\xA0',
              popoverOpen && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_12__["Select"], {
                value: currentYear.toString(),
                data: generateYears(this.minDate.year(), this.maxDate.year()),
                onChange: this.handleYearChange,
                tabIndex: -1,
                label: '',
                hideEmpty: true,
                notInForm: true
              }),
              react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                ___WEBPACK_IMPORTED_MODULE_12__["IconButton"],
                {
                  onClick: this.nextMonth,
                  disabled: this.disableNext(),
                  tabIndex: -1
                },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_9___default.a, null)
              )
            ),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_calendar_dist_entry_nostyle__WEBPACK_IMPORTED_MODULE_5__["MonthView"], {
              className: _styles_scss__WEBPACK_IMPORTED_MODULE_13___default.a.monthView,
              activeStartDate: Object(_utils__WEBPACK_IMPORTED_MODULE_15__["convertMomentToDate"])(activeStartDate),
              calendarType: 'ISO 8601',
              onClick: this.handleChange,
              tileClassName: this.generateTitleClassName,
              minDate: Object(_utils__WEBPACK_IMPORTED_MODULE_15__["convertMomentToDate"])(this.minDate),
              maxDate: Object(_utils__WEBPACK_IMPORTED_MODULE_15__["convertMomentToDate"])(this.maxDate)
            })
          )
        )
      );
    }
  }, {
    key: 'endAdornment',
    get: function get() {
      var downArrow = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core___WEBPACK_IMPORTED_MODULE_6__["InputAdornment"],
        { position: 'end', key: 'arrow' },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_7___default.a, { className: _styles_scss__WEBPACK_IMPORTED_MODULE_13___default.a.arrow })
      );
      if (!this.props.endAdornment) {
        return downArrow;
      }

      return this.props.endAdornment;
    }
  }, {
    key: 'minDate',
    get: function get() {
      var minDate = this.props.minDate;

      var minDateMoment = typeof minDate === 'string' ? moment__WEBPACK_IMPORTED_MODULE_11___default()(minDate, 'YYYY-MM-DD') : minDate;
      return minDateMoment;
    }
  }, {
    key: 'maxDate',
    get: function get() {
      var maxDate = this.props.maxDate;

      var maxDateMoment = typeof maxDate === 'string' ? moment__WEBPACK_IMPORTED_MODULE_11___default()(maxDate, 'YYYY-MM-DD') : maxDate;
      return maxDateMoment;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      var _parseDate3 = parseDate(props.value, props.format),
          _parseDate4 = _slicedToArray(_parseDate3, 2),
          selectedDate = _parseDate4[0],
          textValue = _parseDate4[1];

      var startingDate = selectedDate || moment__WEBPACK_IMPORTED_MODULE_11___default()();

      if (textValue !== state.textValue) {
        return {
          activeStartDate: startingDate.clone().startOf('month'),
          currentMonth: startingDate.month(),
          currentYear: startingDate.year(),
          textValue: textValue
        };
      }
      return null;
    }
  }]);

  return DatePicker;
}(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

/* eslint-disable react/forbid-prop-types */


var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getTestAttributes = function () {
    var defaultDataCy = typeof _this2.props.label === 'string' ? _this2.props.label : undefined;
    return {
      'data-cy': _this2.props['data-cy'] || defaultDataCy,
      'data-component': 'DatePicker'
    };
  };

  this.handleChange = function (value) {
    var valueMoment = Object(_utils__WEBPACK_IMPORTED_MODULE_15__["convertDateToMoment"])(value); // value is a date object
    var name = _this2.props.name;

    _this2.setState({
      textValue: valueMoment.format(_this2.props.format),
      popoverOpen: false
    }, function () {
      // react-calendar returns the value, so we need to create an event
      var event = {
        target: {
          value: valueMoment.format(_helpers_date__WEBPACK_IMPORTED_MODULE_16__["ISO_DATE_FORMAT"]),
          name: name,
          type: 'date'
        }
      };

      if (_this2.props.onChange) _this2.props.onChange(event);
    });
  };

  this.handleTextChange = function (event) {
    var name = _this2.props.name;

    var dateValue = moment__WEBPACK_IMPORTED_MODULE_11___default()(event.target.value, _this2.props.format, true);
    var dateOutput = dateValue.isValid() ? dateValue.format(_helpers_date__WEBPACK_IMPORTED_MODULE_16__["ISO_DATE_FORMAT"]) : event.target.value;

    var isoEvent = {
      target: {
        value: dateOutput,
        name: name,
        type: 'date'
      }
    };
    if (_this2.props.onChange) _this2.props.onChange(isoEvent);
    var textValue = event.target.value;
    _this2.setState({
      textValue: textValue
    });
  };

  this.handleFocus = function () {
    if (_this2.props.disabled || _this2.props.readOnly) return;
    if (_this2.receivingAutoFocus) {
      _this2.receivingAutoFocus = false;
      return;
    }
    _this2.setState({
      popoverOpen: true,
      anchor: Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["findDOMNode"])(_this2.anchorRef) // eslint-disable-line react/no-find-dom-node
    });
  };

  this.handleBlur = function (event) {
    if (_this2.props.onBlur) _this2.props.onBlur(event);
  };

  this.closePopup = function () {
    if (_this2.state.popoverOpen) {
      _this2.setState({
        popoverOpen: false
      });
    }
  };

  this.handleKeyDown = function (event) {
    switch (event.keyCode) {
      case _Input_utils__WEBPACK_IMPORTED_MODULE_14__["asciiCodes"].ENTER:
      case _Input_utils__WEBPACK_IMPORTED_MODULE_14__["asciiCodes"].ESC:
      case _Input_utils__WEBPACK_IMPORTED_MODULE_14__["asciiCodes"].TAB:
        _this2.closePopup();
        break;
      default:
    }
  };

  this.selectMonth = function (val, cb) {
    _this2.setState({
      currentMonth: val,
      activeStartDate: _this2.state.activeStartDate.clone().month(val)
    }, cb);
  };

  this.selectYear = function (val, cb) {
    _this2.setState({
      currentYear: val,
      activeStartDate: _this2.state.activeStartDate.clone().year(val)
    }, cb);
  };

  this.prevMonth = function () {
    var m = _this2.state.currentMonth - 1;
    if (m < 0) {
      _this2.selectYear(_this2.state.currentYear - 1, function () {
        _this2.selectMonth(11);
      });
      return;
    }
    _this2.selectMonth(m);
  };

  this.nextMonth = function () {
    var m = _this2.state.currentMonth + 1;
    if (m > 11) {
      _this2.selectYear(_this2.state.currentYear + 1, function () {
        _this2.selectMonth(0);
      });
      return;
    }
    _this2.selectMonth(m);
  };

  this.disablePrev = function () {
    return _this2.state.currentYear === _this2.minDate.year() && _this2.state.currentMonth === _this2.minDate.month();
  };

  this.disableNext = function () {
    return _this2.state.currentYear === _this2.maxDate.year() && _this2.state.currentMonth === _this2.maxDate.month();
  };

  this.handleMonthChange = function (e) {
    _this2.selectMonth(Number(e.target.value));
  };

  this.handleYearChange = function (e) {
    _this2.selectYear(Number(e.target.value));
  };

  this.handleNativeInputChange = function (e) {
    // The value is a 'YYYY-MM-DD' string
    // https://www.w3.org/TR/2011/WD-html-markup-20110405/input.date.html#input.date.attrs.value
    var value = e.target.value;

    var dateValue = Object(_utils__WEBPACK_IMPORTED_MODULE_15__["convertMomentToDate"])(moment__WEBPACK_IMPORTED_MODULE_11___default()(value, 'YYYY-MM-DD'));
    _this2.handleChange(dateValue);
  };

  this.handleAnchorRef = function (node) {
    _this2.anchorRef = node;
  };

  this.handleInputRef = function (node) {
    _this2.inputRef = node;
  };

  this.generateTitleClassName = function (_ref) {
    var date = _ref.date;
    var format = _this2.props.format;
    var textValue = _this2.state.textValue;

    var dateMoment = Object(_utils__WEBPACK_IMPORTED_MODULE_15__["convertDateToMoment"])(date);

    var sameDay = textValue && moment__WEBPACK_IMPORTED_MODULE_11___default()(textValue, format).isSame(dateMoment, 'day');
    var classes = [];

    if (_this2.props.dayClassCallback) {
      classes.push(_this2.props.dayClassCallback({ dateMoment: dateMoment }));
    }
    if (sameDay) {
      classes.push(_styles_scss__WEBPACK_IMPORTED_MODULE_13___default.a.selectedDate);
      classes.push('react-calendar__tile--active');
    }
    return classes.join(' ');
  };
};

DatePicker.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  /** Called when the user selects a date, or types in the input. */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
  /** Called when the input loses focus */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
  /** The date furthest in the future that can be selected as a {moment} object or 'YYYY-MM-DD' string. */
  maxDate: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string, react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__["momentObj"]]),
  /** The date furthest in the past that can be selected as a {moment} object or 'YYYY-MM-DD' string. */
  minDate: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string, react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__["momentObj"]]),
  /** The name of the date picker field, will be used in change event */
  name: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  /** The currently selected date as a {moment} object. */
  value: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.any,
  /** Render a native HTML5 datepicker instead */
  native: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  /** adornments placed at the end of the input (e.g. Age in DateOfBirth) */
  endAdornment: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,
  /** remove margins applied to the select */
  noMargin: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  error: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  warning: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  /** Autofocus on the input on first render? (note: this will not open the popup) */
  autoFocus: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  readOnly: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  format: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  /** a callback function fn({dateMoment:momentObj}) to return extra class name string for each day cell in month view */
  dayClassCallback: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
  label: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,
  'data-cy': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};
/* eslint-enable react/forbid-prop-types */

DatePicker.defaultProps = {
  id: undefined,
  onChange: undefined,
  onBlur: undefined,
  maxDate: moment__WEBPACK_IMPORTED_MODULE_11___default()().add(5, 'years').endOf('year').format(_helpers_date__WEBPACK_IMPORTED_MODULE_16__["ISO_DATE_FORMAT"]),
  minDate: moment__WEBPACK_IMPORTED_MODULE_11___default()().subtract(5, 'years').startOf('year').format(_helpers_date__WEBPACK_IMPORTED_MODULE_16__["ISO_DATE_FORMAT"]),
  name: undefined,
  value: '',
  native: false,
  endAdornment: undefined,
  noMargin: false,
  disabled: false,
  helperText: '',
  error: false,
  warning: false,
  autoFocus: false,
  readOnly: false,
  format: _helpers_date__WEBPACK_IMPORTED_MODULE_16__["PLAIN_DATE_FORMAT"],
  dayClassCallback: undefined,
  label: undefined,
  'data-cy': undefined
};

/* harmony default export */ __webpack_exports__["default"] = (DatePicker);

/***/ }),

/***/ "./src/DatePicker/index.js":
/*!*********************************!*\
  !*** ./src/DatePicker/index.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/DatePicker/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/DatePicker/spec-helper.js":
/*!***************************************!*\
  !*** ./src/DatePicker/spec-helper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatePicker = function () {
  function DatePicker(wrapper, id) {
    _classCallCheck(this, DatePicker);

    this.wrapper = wrapper;
    this.id = id;
    this.type = 'DatePicker';
  }

  _createClass(DatePicker, [{
    key: 'value',
    value: function value() {
      return this.input.props().value;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      var event = { target: { value: value.toString() } };
      this.input.props().onChange(event);
      this.input.simulate('blur');
    }
  }, {
    key: 'openMenu',
    value: function openMenu() {
      this.input.simulate('focus');
    }
  }, {
    key: 'selectDay',
    value: function selectDay(number) {
      this.modal.find('Day').at(number - 1).simulate('click');
    }
  }, {
    key: 'el',
    get: function get() {
      return this.wrapper.find(this.id);
    }
  }, {
    key: 'input',
    get: function get() {
      return this.el.find('Input').first();
    }
  }, {
    key: 'modal',
    get: function get() {
      return this.wrapper.find('Popover');
    }
  }]);

  return DatePicker;
}();

/* harmony default export */ __webpack_exports__["default"] = (DatePicker);

/***/ }),

/***/ "./src/DatePicker/styles.scss":
/*!************************************!*\
  !*** ./src/DatePicker/styles.scss ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DatePicker/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/DateRangePicker/component.jsx":
/*!*******************************************!*\
  !*** ./src/DateRangePicker/component.jsx ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "moment");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/Menu */ "@material-ui/core/Menu");
/* harmony import */ var _material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/MenuItem */ "@material-ui/core/MenuItem");
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/core/FormHelperText */ "@material-ui/core/FormHelperText");
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @material-ui/icons/Clear */ "@material-ui/icons/Clear");
/* harmony import */ var _material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _material_ui_icons_MoreVert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @material-ui/icons/MoreVert */ "@material-ui/icons/MoreVert");
/* harmony import */ var _material_ui_icons_MoreVert__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_MoreVert__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _options__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./options */ "./src/DateRangePicker/options.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./styles.scss */ "./src/DateRangePicker/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../Tooltip */ "./src/Tooltip/index.js");
/* harmony import */ var _DatePicker__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../DatePicker */ "./src/DatePicker/index.js");
/* harmony import */ var _helpers_date__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../helpers/date */ "./helpers/date.js");
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../IconButton */ "./src/IconButton/index.jsx");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var getOption = function getOption(key) {
  return _options__WEBPACK_IMPORTED_MODULE_10__["default"].find(function (option) {
    return option.key === key;
  });
};

var labelFromValues = function labelFromValues(value) {
  var option = _options__WEBPACK_IMPORTED_MODULE_10__["default"].find(function (opt) {
    return opt.from === value.from && opt.to === value.to;
  });
  if (option) return option.label;
  return '';
};

var DateRangePicker = function (_React$Component) {
  _inherits(DateRangePicker, _React$Component);

  function DateRangePicker(props) {
    _classCallCheck(this, DateRangePicker);

    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));

    _this.setValue = function (value) {
      _this.setState({ value: value });
      if (_this.props.onChange) _this.props.onChange(value);
    };

    _this.clearValues = function () {
      _this.setValue({ from: undefined, to: undefined });
    };

    _this.handleChange = function (type) {
      return function (e) {
        var autoFillRangeOnSelect = _this.props.autoFillRangeOnSelect;
        var value = e.target.value;

        var newValue = moment__WEBPACK_IMPORTED_MODULE_3___default()(value, _helpers_date__WEBPACK_IMPORTED_MODULE_15__["ISO_DATE_FORMAT"], true);
        var otherType = type === 'from' ? 'to' : 'from';
        var newRange = _extends({}, _this.state.value, _defineProperty({}, type, value));

        if (autoFillRangeOnSelect && newValue.isValid()) {
          // keep the other value up to date
          if (_this.hasMissingValue()) {
            newRange[otherType] = value;
            _this[otherType + 'Input'].handleFocus();
            _this[type + 'Input'].closePopup();
          }
          // if new value isn't valid, reset to be in line with other value
          var otherValue = _this.getValue(otherType);
          if (otherValue && otherValue.isValid() && (type === 'to' && newValue.isBefore(otherValue) || type === 'from' && newValue.isAfter(otherValue))) {
            newRange[type] = _this.state.value[otherType];
          }
        }

        _this.setValue(newRange);
      };
    };

    _this.handleRangesClick = function (event) {
      return _this.setState({ anchorEl: event.currentTarget });
    };

    _this.isBetweenRange = function (_ref) {
      var dateMoment = _ref.dateMoment;
      var _this$state$value = _this.state.value,
          from = _this$state$value.from,
          to = _this$state$value.to;

      if (from && to && dateMoment.isBetween(from, to, null, '[]')) {
        return 'react-calendar__tile--active';
      }
      return '';
    };

    _this.handleClose = function () {
      _this.setState({ anchorEl: undefined });
    };

    _this.handleClear = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.clearValues();
    };

    _this.handleSetFromInputRef = function (node) {
      _this.fromInput = node;
    };

    _this.handleSetToInputRef = function (node) {
      _this.toInput = node;
    };

    var defaultValueFromPreset = props.value;
    if (props.defaultValueFromPreset) {
      var _getOption = getOption(props.defaultValueFromPreset),
          from = _getOption.from,
          to = _getOption.to;

      defaultValueFromPreset = { from: from, to: to };
    }

    _this.state = {
      value: defaultValueFromPreset || {
        to: undefined,
        from: undefined
      }
    };
    return _this;
  }

  _createClass(DateRangePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onChange = _props.onChange,
          defaultValueFromPreset = _props.defaultValueFromPreset;

      if (defaultValueFromPreset && onChange) {
        var _getOption2 = getOption(defaultValueFromPreset),
            from = _getOption2.from,
            to = _getOption2.to;

        onChange({ from: from, to: to });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var properties = ['value', 'helperText', 'error', 'warning'];
      return !Object(lodash__WEBPACK_IMPORTED_MODULE_4__["isEqual"])(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["pick"])(nextProps, properties), Object(lodash__WEBPACK_IMPORTED_MODULE_4__["pick"])(this.props, properties)) || !Object(lodash__WEBPACK_IMPORTED_MODULE_4__["isEqual"])(nextState, this.state);
    }
  }, {
    key: 'getValue',
    value: function getValue(type) {
      if (!this.state.value[type]) {
        return undefined;
      }
      return moment__WEBPACK_IMPORTED_MODULE_3___default()(this.state.value[type], _helpers_date__WEBPACK_IMPORTED_MODULE_15__["ISO_DATE_FORMAT"], true);
    }
  }, {
    key: 'hasMissingValue',
    value: function hasMissingValue() {
      return Object.values(this.state.value).indexOf(undefined) >= 0;
    }
  }, {
    key: 'renderAdornment',
    value: function renderAdornment() {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Tooltip__WEBPACK_IMPORTED_MODULE_13__["default"],
        { title: 'Clear' },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _IconButton__WEBPACK_IMPORTED_MODULE_16__["default"],
          {
            id: 'datepicker-clear',
            inputAdornment: true,
            onClick: this.handleClear
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Clear__WEBPACK_IMPORTED_MODULE_8___default.a, null)
        )
      );
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this2 = this;

      var anchorEl = this.state.anchorEl;

      var open = Boolean(anchorEl);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_5___default.a,
        {
          anchorEl: anchorEl,
          open: open,
          onClose: this.handleClose
        },
        _options__WEBPACK_IMPORTED_MODULE_10__["default"].map(function (option) {
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6___default.a,
            {
              key: option.label,
              onClick: function onClick() {
                _this2.setValue({
                  from: option.from,
                  to: option.to
                }, option.label);
                _this2.handleClose();
              }
            },
            option.label
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state$value = this.state.value,
          from = _state$value.from,
          to = _state$value.to;
      var _props2 = this.props,
          fromLabel = _props2.fromLabel,
          toLabel = _props2.toLabel,
          error = _props2.error,
          warning = _props2.warning,
          showPresets = _props2.showPresets,
          onBlur = _props2.onBlur,
          fromDatePickerProps = _props2.fromDatePickerProps,
          toDatePickerProps = _props2.toDatePickerProps;


      var helperText = this.props.helperText || labelFromValues(this.state.value);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.root },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: _layout_scss__WEBPACK_IMPORTED_MODULE_12___default.a.flex },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_12___default.a.flexGrow, 'datepicker-from') },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_DatePicker__WEBPACK_IMPORTED_MODULE_14__["default"], _extends({
              label: fromLabel,
              onChange: this.handleChange('from'),
              value: from,
              maxDate: this.fromMaxDate,
              dayClassCallback: this.isBetweenRange,
              ref: this.handleSetFromInputRef,
              endAdornment: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('span', null) /* prevent rendering downarrow */
              , error: error,
              onBlur: onBlur,
              warning: warning
            }, fromDatePickerProps))
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_12___default.a.flexGrow, 'datepicker-to') },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_DatePicker__WEBPACK_IMPORTED_MODULE_14__["default"], _extends({
              label: toLabel,
              onChange: this.handleChange('to'),
              value: to,
              minDate: this.toMinDate,
              onBlur: onBlur,
              dayClassCallback: this.isBetweenRange,
              ref: this.handleSetToInputRef,
              endAdornment: this.renderAdornment(),
              error: error
            }, toDatePickerProps))
          ),
          showPresets && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment,
            null,
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              _IconButton__WEBPACK_IMPORTED_MODULE_16__["default"],
              {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('datepicker-preset-btn', _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.presetsBtn),
                onClick: this.handleRangesClick
              },
              react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_MoreVert__WEBPACK_IMPORTED_MODULE_9___default.a, null)
            ),
            this.renderMenu()
          )
        ),
        helperText && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_7___default.a,
          { error: error, classes: { root: _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.helperText } },
          helperText
        )
      );
    }
  }, {
    key: 'fromMaxDate',
    get: function get() {
      var to = this.state.value.to;
      var defaultFromMaxDate = this.props.defaultFromMaxDate;

      if (!defaultFromMaxDate) {
        return to;
      }
      if (!to) {
        return defaultFromMaxDate;
      }
      var toMoment = moment__WEBPACK_IMPORTED_MODULE_3___default()(to, _helpers_date__WEBPACK_IMPORTED_MODULE_15__["ISO_DATE_FORMAT"], true);
      var defaultFromMaxDateMoment = moment__WEBPACK_IMPORTED_MODULE_3___default()(defaultFromMaxDate, _helpers_date__WEBPACK_IMPORTED_MODULE_15__["ISO_DATE_FORMAT"], true);
      return toMoment.isBefore(defaultFromMaxDateMoment) ? to : defaultFromMaxDate;
    }
  }, {
    key: 'toMinDate',
    get: function get() {
      var from = this.state.value.from;
      var defaultToMinDate = this.props.defaultToMinDate;

      if (!defaultToMinDate) {
        return from;
      }
      if (!from) {
        return defaultToMinDate;
      }
      var fromMoment = moment__WEBPACK_IMPORTED_MODULE_3___default()(from, _helpers_date__WEBPACK_IMPORTED_MODULE_15__["ISO_DATE_FORMAT"], true);
      var defaultToMinDateMoment = moment__WEBPACK_IMPORTED_MODULE_3___default()(defaultToMinDate, _helpers_date__WEBPACK_IMPORTED_MODULE_15__["ISO_DATE_FORMAT"], true);
      return fromMoment.isAfter(defaultToMinDateMoment) ? from : defaultToMinDate;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.value && !Object(lodash__WEBPACK_IMPORTED_MODULE_4__["isEqual"])(props.value, state.value)) {
        return {
          helperText: labelFromValues(props.value),
          value: props.value
        };
      }
      return null;
    }
  }]);

  return DateRangePicker;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

DateRangePicker.propTypes = {
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    from: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    to: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
  }),
  fromLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  toLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  defaultValueFromPreset: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['today', 'yesterday', 'this_week', 'last_week', 'this_month', 'last_month', 'this_quarter', 'last_quarter', 'this_financial_year', 'last_financial_year']),
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  warning: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  showPresets: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  autoFillRangeOnSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  defaultFromMaxDate: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  defaultToMinDate: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  fromDatePickerProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  toDatePickerProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)
};

DateRangePicker.defaultProps = {
  value: undefined,
  fromLabel: 'From',
  toLabel: 'To',
  onChange: undefined,
  onBlur: undefined,
  defaultValueFromPreset: undefined,
  helperText: undefined,
  error: undefined,
  warning: undefined,
  showPresets: true,
  autoFillRangeOnSelect: true,
  defaultFromMaxDate: '',
  defaultToMinDate: '',
  fromDatePickerProps: undefined,
  toDatePickerProps: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (DateRangePicker);

/***/ }),

/***/ "./src/DateRangePicker/index.js":
/*!**************************************!*\
  !*** ./src/DateRangePicker/index.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/DateRangePicker/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/DateRangePicker/options.js":
/*!****************************************!*\
  !*** ./src/DateRangePicker/options.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! moment */ "moment");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helpers/date */ "./helpers/date.js");



var format = function format(date) {
  return date.format(_helpers_date__WEBPACK_IMPORTED_MODULE_1__["ISO_DATE_FORMAT"]);
};

var options = [{
  label: 'Today',
  key: 'today',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()()),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()())
}, {
  label: 'Yesterday',
  key: 'yesterday',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(1, 'day').startOf('day')),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(1, 'day').startOf('day'))
}, {
  label: 'This Week',
  key: 'this_week',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().startOf('week')),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().endOf('week'))
}, {
  label: 'Last Week',
  key: 'last_week',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(1, 'week').startOf('week')),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(1, 'week').endOf('week'))
}, {
  label: 'This Month',
  key: 'this_month',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().startOf('month')),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().endOf('month'))
}, {
  label: 'Last Month',
  key: 'last_month',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(1, 'month').startOf('month')),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(1, 'month').endOf('month'))
}, {
  label: 'This Quarter',
  key: 'this_quarter',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().startOf('quarter')),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().endOf('quarter'))
}, {
  label: 'Last Quarter',
  key: 'last_quarter',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(3, 'months').startOf('quarter')),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(3, 'months').endOf('quarter'))
}, {
  label: 'Past 12 Months',
  key: 'past_12_months',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(12, 'months')),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()())
}, {
  label: 'Past 24 Months',
  key: 'past_24_months',
  from: format(moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(24, 'months')),
  to: format(moment__WEBPACK_IMPORTED_MODULE_0___default()())
}, {
  label: 'This Financial Year',
  key: 'this_financial_year',
  from: format(function () {
    var july = moment__WEBPACK_IMPORTED_MODULE_0___default()().month(6).date(1).hour(0).second(0);
    if (july > moment__WEBPACK_IMPORTED_MODULE_0___default()()) july.subtract(1, 'year');
    return july;
  }()),
  to: format(function () {
    var june = moment__WEBPACK_IMPORTED_MODULE_0___default()().month(5).date(30).hour(0).minute(0).second(0);
    if (june < moment__WEBPACK_IMPORTED_MODULE_0___default()()) june.add(1, 'year');
    return june;
  }())
}, {
  label: 'Last Financial Year',
  key: 'last_financial_year',
  from: format(function () {
    var july = moment__WEBPACK_IMPORTED_MODULE_0___default()().month(6).date(1).hour(0).second(0);
    if (july > moment__WEBPACK_IMPORTED_MODULE_0___default()()) {
      july.subtract(2, 'years');
    } else {
      july.subtract(1, 'year');
    }
    return july;
  }()),
  to: format(function () {
    var june = moment__WEBPACK_IMPORTED_MODULE_0___default()().month(5).date(30).hour(0).minute(0).second(0);
    if (june > moment__WEBPACK_IMPORTED_MODULE_0___default()()) june.subtract(1, 'year');
    return june;
  }())
}];

/* harmony default export */ __webpack_exports__["default"] = (options);

/***/ }),

/***/ "./src/DateRangePicker/styles.scss":
/*!*****************************************!*\
  !*** ./src/DateRangePicker/styles.scss ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DateRangePicker/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Dialog/component.jsx":
/*!**********************************!*\
  !*** ./src/Dialog/component.jsx ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Dialog */ "@material-ui/core/Dialog");
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/icons/Close */ "@material-ui/icons/Close");
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../IconButton */ "./src/IconButton/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./styles.scss */ "./src/Dialog/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_6__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










var Dialog = function Dialog(_ref) {
  var fullScreen = _ref.fullScreen,
      locked = _ref.locked,
      hideClose = _ref.hideClose,
      children = _ref.children,
      onClose = _ref.onClose,
      className = _ref.className,
      classes = _ref.classes,
      other = _objectWithoutProperties(_ref, ['fullScreen', 'locked', 'hideClose', 'children', 'onClose', 'className', 'classes']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3___default.a,
    _extends({
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_6___default.a.container, className),
      classes: _extends({ paperWidthSm: fullScreen ? '' : _styles_scss__WEBPACK_IMPORTED_MODULE_6___default.a.content }, classes),
      disableBackdropClick: locked,
      disableEscapeKeyDown: locked,
      onClose: onClose,
      fullScreen: fullScreen,
      id: 'modal_root'
    }, other),
    !hideClose && onClose && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _IconButton__WEBPACK_IMPORTED_MODULE_5__["default"],
      {
        disabled: locked,
        className: _styles_scss__WEBPACK_IMPORTED_MODULE_6___default.a.closeBtn,
        onClick: onClose
      },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4___default.a, null)
    ),
    children
  );
};

Dialog.propTypes = {
  /** Content of the modal */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,
  /** Hide the close button on the modal (Note: button is also hidden if onClose is not provided) */
  hideClose: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  fullScreen: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Disables the close button, the escape to close and the backdrop click to close functionality */
  locked: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Callback for close button */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.objectOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string)
};

Dialog.defaultProps = {
  hideClose: false,
  fullScreen: false,
  locked: false,
  onClose: undefined,
  className: '',
  classes: {}
};

/* harmony default export */ __webpack_exports__["default"] = (Dialog);

/***/ }),

/***/ "./src/Dialog/index.js":
/*!*****************************!*\
  !*** ./src/Dialog/index.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Dialog/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Dialog/styles.scss":
/*!********************************!*\
  !*** ./src/Dialog/styles.scss ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Dialog/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/DialogActions/index.js":
/*!************************************!*\
  !*** ./src/DialogActions/index.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material-ui/core/DialogActions */ "@material-ui/core/DialogActions");
/* harmony import */ var _material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__);



var styles = function styles(theme) {
  return {
    root: {
      margin: theme.spacing.unit + 'px ' + theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 2 + 'px ' + theme.spacing.unit * 3 + 'px'
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__["withStyles"])(styles)(_material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_0___default.a));

/***/ }),

/***/ "./src/DialogContentOverflowHidden/component.jsx":
/*!*******************************************************!*\
  !*** ./src/DialogContentOverflowHidden/component.jsx ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/DialogContent */ "@material-ui/core/DialogContent");
/* harmony import */ var _material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.scss */ "./src/DialogContentOverflowHidden/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var DialogContentOverflowHidden = function DialogContentOverflowHidden(_ref) {
  var children = _ref.children,
      needsBottomPadding = _ref.needsBottomPadding,
      other = _objectWithoutProperties(_ref, ['children', 'needsBottomPadding']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_3___default.a,
    _extends({
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, needsBottomPadding ? _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.dialogContentWithBottomPad : _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.dialogContent)
    }, other),
    children
  );
};

DialogContentOverflowHidden.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,
  // Bottom padding will be increased if true
  needsBottomPadding: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};

DialogContentOverflowHidden.defaultProps = {
  needsBottomPadding: false
};

/* harmony default export */ __webpack_exports__["default"] = (DialogContentOverflowHidden);

/***/ }),

/***/ "./src/DialogContentOverflowHidden/index.js":
/*!**************************************************!*\
  !*** ./src/DialogContentOverflowHidden/index.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/DialogContentOverflowHidden/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/DialogContentOverflowHidden/styles.scss":
/*!*****************************************************!*\
  !*** ./src/DialogContentOverflowHidden/styles.scss ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DialogContentOverflowHidden/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/DialogTitle/component.jsx":
/*!***************************************!*\
  !*** ./src/DialogTitle/component.jsx ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.scss */ "./src/DialogTitle/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







function renderPrimaryTitle(title, children, disableTypography) {
  var primaryTitle = title || children;
  if (disableTypography) {
    return primaryTitle;
  }
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _Typography__WEBPACK_IMPORTED_MODULE_3__["default"],
    { variant: 'h6' },
    primaryTitle
  );
}

/**
* DialogTitle is a reimplementation of the Material UI component, but ours has
* custom padding and supports title and subtitle attributes.
*/
var DialogTitle = function DialogTitle(_ref) {
  var className = _ref.className,
      children = _ref.children,
      classes = _ref.classes,
      title = _ref.title,
      subtitle = _ref.subtitle,
      disableTypography = _ref.disableTypography,
      other = _objectWithoutProperties(_ref, ['className', 'children', 'classes', 'title', 'subtitle', 'disableTypography']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    _extends({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, classes.root, className) }, other),
    renderPrimaryTitle(title, children, disableTypography),
    subtitle && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Typography__WEBPACK_IMPORTED_MODULE_3__["default"],
      { variant: 'body1', color: 'secondary' },
      subtitle
    )
  );
};

DialogTitle.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  subtitle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  disableTypography: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};

DialogTitle.defaultProps = {
  children: null,
  classes: {},
  className: undefined,
  title: undefined,
  subtitle: undefined,
  disableTypography: false
};

/* harmony default export */ __webpack_exports__["default"] = (DialogTitle);

/***/ }),

/***/ "./src/DialogTitle/index.js":
/*!**********************************!*\
  !*** ./src/DialogTitle/index.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/DialogTitle/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/DialogTitle/styles.scss":
/*!*************************************!*\
  !*** ./src/DialogTitle/styles.scss ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/DialogTitle/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Drawer/component.jsx":
/*!**********************************!*\
  !*** ./src/Drawer/component.jsx ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/Paper */ "@material-ui/core/Paper");
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Typography */ "@material-ui/core/Typography");
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/Drawer */ "@material-ui/core/Drawer");
/* harmony import */ var _material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/icons/Close */ "@material-ui/icons/Close");
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../IconButton */ "./src/IconButton/index.jsx");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./style.scss */ "./src/Drawer/style.scss");
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_style_scss__WEBPACK_IMPORTED_MODULE_9__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var ids = {
  root: 'drawer',
  closeButton: 'drawer_close_button'
};

var Drawer = function (_Component) {
  _inherits(Drawer, _Component);

  function Drawer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Drawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.renderTitle = function () {
      if (typeof _this.props.title === 'string') {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3___default.a,
          { className: _style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.title, variant: 'h6' },
          _this.props.title
        );
      }

      return _this.props.title;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Drawer, [{
    key: 'render',
    value: function render() {
      var _classNames2,
          _this2 = this;

      var _props = this.props,
          id = _props.id,
          classes = _props.classes,
          title = _props.title,
          footer = _props.footer,
          open = _props.open,
          onClose = _props.onClose,
          children = _props.children,
          disableBodyGutter = _props.disableBodyGutter,
          modalVersion = _props.modalVersion,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['id', 'classes', 'title', 'footer', 'open', 'onClose', 'children', 'disableBodyGutter', 'modalVersion', 'className']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_4___default.a
        /*
         * MUI drawer has a bug that when resize window to narrower,
         * the position of right anchored drawer content is not positioned properly.
         * See storybook Drawer for demo of the bug.
         * Therefore set the drawer to invisible when not open, this will lose the animation on close
         */
        ,
        _extends({}, rest, {
          className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(className, ___WEBPACK_IMPORTED_MODULE_8__["layout"].container, _style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.muiDrawerBugFix, _defineProperty({}, _style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.open, open)),
          open: open,
          anchor: 'right',
          variant: modalVersion ? 'temporary' : 'persistent',
          onClose: onClose
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_2___default.a,
          {
            id: id,
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.root, classes.root, (_classNames2 = {}, _defineProperty(_classNames2, _style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.mobile, this.context.layout && this.context.layout.isMobile), _defineProperty(_classNames2, _style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.modalVersion, modalVersion), _classNames2))
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.content, classes.content), style: this.customStyle, ref: function ref(el) {
                _this2.contentRef = el;
              } },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              'div',
              { className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.header, classes.header) },
              this.renderTitle(),
              onClose && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                _IconButton__WEBPACK_IMPORTED_MODULE_7__["default"],
                { id: ids.closeButton, className: _style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.closeBtn, onClick: onClose },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_6___default.a, null)
              )
            ),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              'div',
              { className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.body, classes.body, _defineProperty({}, _style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.disableBodyGutter, disableBodyGutter)) },
              react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                react__WEBPACK_IMPORTED_MODULE_0__["Fragment"],
                null,
                children,
                modalVersion && footer
              )
            ),
            !modalVersion && footer && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              'div',
              { className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_style_scss__WEBPACK_IMPORTED_MODULE_9___default.a.stickyFooter, classes.footer) },
              footer
            )
          )
        )
      );
    }
  }]);

  return Drawer;
}(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Drawer);


Drawer.propTypes = {
  /** Open/close the drawer */
  open: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Custom classes */
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    root: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    content: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    header: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
  }),
  /** Node representing the title. String or any other renderable component/s */
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** Node representing the footer String or any other renderable component/s */
  footer: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** Body of the drawer. String or any other renderable component/s */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** Event handler for the modal is attempted to be closed */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** if true, disable the left and right padding on body */
  disableBodyGutter: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  modalVersion: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

Drawer.defaultProps = {
  open: false,
  classes: { root: '' },
  title: null,
  footer: null,
  children: null,
  onClose: undefined,
  disableBodyGutter: false,
  id: ids.root,
  modalVersion: false,
  className: undefined
};

Drawer.contextTypes = {
  layout: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    main: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
      addEventListener: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
      removeEventListener: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
    }),
    isMobile: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
  })
};

/***/ }),

/***/ "./src/Drawer/index.jsx":
/*!******************************!*\
  !*** ./src/Drawer/index.jsx ***!
  \******************************/
/*! exports provided: Drawer, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Drawer/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Drawer", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });





/***/ }),

/***/ "./src/Drawer/style.scss":
/*!*******************************!*\
  !*** ./src/Drawer/style.scss ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./style.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Drawer/style.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/EmptyState/EmptyStateIcon.jsx":
/*!*******************************************!*\
  !*** ./src/EmptyState/EmptyStateIcon.jsx ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);


// eslint-disable-next-line max-len
var EmptyStateIcon = function EmptyStateIcon() {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    "svg",
    { width: "121", height: "81", xmlns: "http://www.w3.org/2000/svg" },
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", { d: "M18.527 80.653c2.78 0 25.802-.978 69.067-2.934 3.152.187 5.124-.85 5.917-3.11.793-2.261 5.242-15.924 13.347-40.989.618-2.667-.283-4-2.702-4H30.621c-2.633-.45-4.273.472-4.918 2.763-.645 2.292-4.195 17.404-10.65 45.336-.463 1.956.695 2.934 3.474 2.934z", fill: "#D2ECF0", opacity: ".8" }),
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", { d: "M97.733 21.785V11.55c-.352-2.174-1.646-3.261-3.882-3.261H44.263c-1.941 0-3.393-.365-4.355-1.093-.963-.729-2.822-2.42-5.577-5.073-.586-.705-1.42-1.057-2.502-1.057H4.806C2.269.642 1 2.263 1 5.928s4.083 27.318 12.25 70.96c1.13 1.72 2.21 2.58 3.237 2.58", stroke: "#7CC9D3", strokeWidth: "2" }),
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", { d: "M26.14 29.922l2.71-6.601 57.757-2.255c-.302-1.86-1.41-2.791-3.323-2.791H40.83c-1.662 0-2.905-.312-3.73-.936-.823-.624-2.415-2.071-4.774-4.343-.502-.603-1.216-.905-2.142-.905H7.05c-2.172-.363-3.258 1.025-3.258 4.163 0 3.137 3.496 23.388 10.487 60.75.85 2.051 1.716 3.076 2.595 3.076", fill: "#D2ECF0", opacity: ".8" }),
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", { d: "M19.042 79.653c3.154 0 29.526-1.12 78.96-3.356l.105.001c3.195.19 5.022-.77 5.766-2.89.903-2.574 5.995-18.213 15.237-46.782.569-2.458-.034-3.35-2.117-3.35H32.876l-.168-.015c-2.53-.43-3.903.34-4.496 2.447-.73 2.597-4.797 19.907-12.172 51.818-.354 1.498.39 2.127 3.002 2.127z", stroke: "#7CC9D3", strokeWidth: "2" })
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (EmptyStateIcon);

/***/ }),

/***/ "./src/EmptyState/index.jsx":
/*!**********************************!*\
  !*** ./src/EmptyState/index.jsx ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _EmptyStateIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./EmptyStateIcon */ "./src/EmptyState/EmptyStateIcon.jsx");
/* harmony import */ var _FormGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../FormGrid */ "./src/FormGrid/index.js");
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_5__);







var EmptyState = function EmptyState(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      actions = _ref.actions,
      className = _ref.className;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _FormGrid__WEBPACK_IMPORTED_MODULE_3__["default"],
    {
      container: true,
      className: className,
      direction: 'column',
      justify: 'center',
      alignItems: 'center'
    },
    icon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _FormGrid__WEBPACK_IMPORTED_MODULE_3__["default"],
      { item: true },
      icon
    ),
    title && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _FormGrid__WEBPACK_IMPORTED_MODULE_3__["default"],
      { item: true },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Typography__WEBPACK_IMPORTED_MODULE_4__["default"],
        null,
        title
      )
    ),
    actions && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _FormGrid__WEBPACK_IMPORTED_MODULE_3__["default"],
      { item: true },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: _layout_scss__WEBPACK_IMPORTED_MODULE_5___default.a.paddingTopSmall },
        actions
      )
    )
  );
};
EmptyState.propTypes = {
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  actions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
EmptyState.defaultProps = {
  icon: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_EmptyStateIcon__WEBPACK_IMPORTED_MODULE_2__["default"], null),
  actions: undefined,
  title: undefined,
  className: _layout_scss__WEBPACK_IMPORTED_MODULE_5___default.a.fullHeight
};

/* harmony default export */ __webpack_exports__["default"] = (EmptyState);

/***/ }),

/***/ "./src/FormControlLabel/index.jsx":
/*!****************************************!*\
  !*** ./src/FormControlLabel/index.jsx ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! recompose */ "recompose");
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(recompose__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/FormControlLabel */ "@material-ui/core/FormControlLabel");
/* harmony import */ var _material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./styles.scss */ "./src/FormControlLabel/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_5__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









// Allow pass in component as children so that it can be tested by shallow()
var FormControlLabel = function FormControlLabel(_ref) {
  var children = _ref.children,
      control = _ref.control,
      noHorizontalMargin = _ref.noHorizontalMargin,
      noVerticalMargin = _ref.noVerticalMargin,
      classes = _ref.classes,
      props = _objectWithoutProperties(_ref, ['children', 'control', 'noHorizontalMargin', 'noVerticalMargin', 'classes']);

  var _ref2 = classes || {},
      root = _ref2.root,
      otherClasses = _objectWithoutProperties(_ref2, ['root']);

  var defaultDataCy = typeof props.label === 'string' ? props.label : undefined;
  var defaultComponentName = Object(recompose__WEBPACK_IMPORTED_MODULE_2__["getDisplayName"])((children || control || {}).type);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_3___default.a, _extends({
    'data-cy': defaultDataCy,
    'data-component': defaultComponentName
  }, props, {
    control: children || control,
    classes: _extends({
      root: classnames__WEBPACK_IMPORTED_MODULE_1___default()(root, _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.root, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.noHorizontalMargin, noHorizontalMargin), _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.noVerticalMargin, noVerticalMargin))
    }, otherClasses)
  }));
};

FormControlLabel.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,
  control: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,
  noHorizontalMargin: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  noVerticalMargin: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.instanceOf(Object),
  // label will be passed to the MUI FormControlLabel component
  label: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node
};
FormControlLabel.defaultProps = {
  children: undefined,
  control: undefined,
  noHorizontalMargin: false,
  noVerticalMargin: false,
  classes: undefined,
  label: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (FormControlLabel);

/***/ }),

/***/ "./src/FormControlLabel/styles.scss":
/*!******************************************!*\
  !*** ./src/FormControlLabel/styles.scss ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/FormControlLabel/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/FormGrid/component.jsx":
/*!************************************!*\
  !*** ./src/FormGrid/component.jsx ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/Grid */ "@material-ui/core/Grid");
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var GUTTERS = [0, 8, 16, 24, 32, 40];

var generateGutter = function generateGutter(theme, breakpoint) {
  var styles = {};

  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles['spacing-h-' + breakpoint + '-' + spacing] = {
      marginLeft: -spacing / 2,
      marginRight: -spacing / 2,
      width: 'calc(100% + ' + spacing + 'px)',
      '& > $item': {
        paddingLeft: spacing / 2,
        paddingRight: spacing / 2
      }
    };
    styles['spacing-v-' + breakpoint + '-' + spacing] = {
      marginTop: -spacing / 2,
      marginBottom: -spacing / 2,
      '& > $item': {
        paddingTop: spacing / 2,
        paddingBottom: spacing / 2
      }
    };
  });

  return styles;
};

var styles = function styles(theme) {
  return _extends({
    item: {}
  }, generateGutter(theme, 'xs'));
};

var FormGrid = function FormGrid(_ref) {
  var _classNames;

  var spacingV = _ref.spacingV,
      spacingH = _ref.spacingH,
      classes = _ref.classes,
      container = _ref.container,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['spacingV', 'spacingH', 'classes', 'container', 'className']);

  var combinedClassName = classnames__WEBPACK_IMPORTED_MODULE_4___default()((_classNames = {}, _defineProperty(_classNames, classes['spacing-v-xs-' + String(spacingV)], container && spacingV !== 0), _defineProperty(_classNames, classes['spacing-h-xs-' + String(spacingH)], container && spacingH !== 0), _classNames), className);

  // remove 'spacing-v' and 'spacing-h' classes before passing it to MuiGrid
  var muiClasses = Object.entries(classes).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        key = _ref3[0];

    return !key.match(/spacing-[vh]/);
  }).reduce(function (acc, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        val = _ref5[1];

    acc[key] = val;
    return acc;
  }, {});

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_2___default.a, _extends({}, rest, { container: container, classes: muiClasses, className: combinedClassName }));
};

FormGrid.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  spacingV: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(GUTTERS),
  spacingH: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(GUTTERS),
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  container: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  item: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};

FormGrid.defaultProps = {
  className: undefined,
  spacingH: 24,
  spacingV: 16,
  classes: undefined,
  container: false,
  item: false
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__["withStyles"])(styles)(FormGrid));

/***/ }),

/***/ "./src/FormGrid/index.js":
/*!*******************************!*\
  !*** ./src/FormGrid/index.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/FormGrid/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/FormHelperText/index.jsx":
/*!**************************************!*\
  !*** ./src/FormHelperText/index.jsx ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/FormHelperText */ "@material-ui/core/FormHelperText");
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/icons/Error */ "@material-ui/icons/Error");
/* harmony import */ var _material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_Info__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/icons/Info */ "@material-ui/icons/Info");
/* harmony import */ var _material_ui_icons_Info__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Info__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_icons_Warning__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/icons/Warning */ "@material-ui/icons/Warning");
/* harmony import */ var _material_ui_icons_Warning__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Warning__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Icon */ "./src/Icon/index.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./styles.scss */ "./src/FormHelperText/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_8__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var getIcon = function getIcon(type) {
  switch (type) {
    case 'error':
      return _material_ui_icons_Warning__WEBPACK_IMPORTED_MODULE_6___default.a;
    case 'info':
      return _material_ui_icons_Info__WEBPACK_IMPORTED_MODULE_5___default.a;
    case 'warning':
      return _material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_4___default.a;
    default:
      return undefined;
  }
};

var FormHelperText = function FormHelperText(_ref) {
  var children = _ref.children,
      className = _ref.className,
      type = _ref.type,
      alignRight = _ref.alignRight,
      showIcon = _ref.showIcon,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'type', 'alignRight', 'showIcon']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_2___default.a,
    _extends({}, props, {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a.root, _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a.helperText, _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a[type], _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a.alignRight, alignRight)),
      error: type === 'error'
    }),
    showIcon ? [react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_7__["default"], { size: 'small', key: 'icon', component: getIcon(type) }), children] : children
  );
};

FormHelperText.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  alignRight: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  showIcon: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  type: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOf(['error', 'warning', 'info'])
};
FormHelperText.defaultProps = {
  children: undefined,
  className: undefined,
  type: 'error',
  alignRight: false,
  showIcon: false
};

/* harmony default export */ __webpack_exports__["default"] = (FormHelperText);

/***/ }),

/***/ "./src/FormHelperText/styles.scss":
/*!****************************************!*\
  !*** ./src/FormHelperText/styles.scss ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/FormHelperText/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Hyperlink/component.jsx":
/*!*************************************!*\
  !*** ./src/Hyperlink/component.jsx ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Colored__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Colored */ "./src/Colored/index.jsx");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var styles = function styles(theme) {
  return {
    root: _extends({}, theme.typography.body1, {
      fontWeight: 300,
      textDecoration: 'underline',
      '&:link, &:visited': {
        color: theme.palette.primary[500]
      },
      '&:hover, &:active': {
        color: theme.palette.primary[700]
      }
    }),
    noUnderline: {
      '&:link': {
        textDecoration: 'none'
      },
      '&:hover, &:active': {
        textDecoration: 'underline'
      }
    },
    mediumWeight: {
      fontWeight: theme.typography.body2.fontWeight
    },
    disabled: {
      pointerEvents: 'none',
      '&:link, &:visited': {
        color: theme.palette.text.disabled
      }
    }
  };
};

var stopPropagation = function stopPropagation(e) {
  return e.stopPropagation();
};

var Hyperlink = function Hyperlink(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      classes = _ref.classes,
      noUnderline = _ref.noUnderline,
      weight = _ref.weight,
      disabled = _ref.disabled,
      color = _ref.color,
      other = _objectWithoutProperties(_ref, ['children', 'className', 'classes', 'noUnderline', 'weight', 'disabled', 'color']);

  var linkNode =
  // We're stopping propagation, to prevent the clicking of the link from triggering one of the link's parent's onClick handlers.
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
  react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'a',
    _extends({
      onClick: stopPropagation,
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, classes.root, (_classNames = {}, _defineProperty(_classNames, classes.noUnderline, noUnderline), _defineProperty(_classNames, classes.mediumWeight, weight === 'medium'), _defineProperty(_classNames, classes.disabled, disabled), _classNames))
    }, other),
    children
  );

  if (color) return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _Colored__WEBPACK_IMPORTED_MODULE_4__["default"],
    { color: color },
    linkNode
  );

  return linkNode;
};

Hyperlink.propTypes = {
  /** The text/node content of the link */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** (optional) classname added to <a> */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Classes from withStyles HOC */
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** Removes the default underline */
  noUnderline: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Font weight, regular or medium, defaults to regular */
  weight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['regular', 'medium']),
  /** Disables the link, defaults to false */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (optional) Wraps the hyperlink content in a Colored */
  color: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(_Colored__WEBPACK_IMPORTED_MODULE_4__["colors"])
};

Hyperlink.defaultProps = {
  children: undefined,
  className: undefined,
  classes: undefined,
  noUnderline: false,
  weight: 'regular',
  disabled: false,
  color: null
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__["withStyles"])(styles)(Hyperlink));

/***/ }),

/***/ "./src/Hyperlink/index.js":
/*!********************************!*\
  !*** ./src/Hyperlink/index.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Hyperlink/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Icon/component.jsx":
/*!********************************!*\
  !*** ./src/Icon/component.jsx ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./styles.scss */ "./src/Icon/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var Icon = function Icon(_ref) {
  var tag = _ref.tag,
      color = _ref.color,
      className = _ref.className,
      children = _ref.children,
      viewBox = _ref.viewBox,
      size = _ref.size,
      titleAccess = _ref.titleAccess,
      RenderComponent = _ref.component,
      other = _objectWithoutProperties(_ref, ['tag', 'color', 'className', 'children', 'viewBox', 'size', 'titleAccess', 'component']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    RenderComponent,
    _extends({
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, _styles_scss__WEBPACK_IMPORTED_MODULE_3___default.a.root, _styles_scss__WEBPACK_IMPORTED_MODULE_3___default.a['size-' + size], color && _styles_scss__WEBPACK_IMPORTED_MODULE_3___default.a[color]),
      focusable: 'false',
      width: 24,
      height: 24,
      viewBox: viewBox,
      'aria-hidden': titleAccess ? 'false' : 'true'
    }, other),
    titleAccess ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'title',
      null,
      titleAccess
    ) : null,
    children
  );
};

Icon.propTypes = {
  /** component allows pass MUI icons and appl */
  component: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]),
  color: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf([undefined, 'error', 'success', 'warning', 'brandGreen', 'grey']),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['small', 'regular', 'large']),
  tag: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  viewBox: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  titleAccess: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

Icon.defaultProps = {
  component: 'svg',
  color: undefined,
  size: 'regular',
  tag: '',
  className: '',
  viewBox: '0 0 24 24',
  children: null,
  titleAccess: null
};

/* harmony default export */ __webpack_exports__["default"] = (Icon);

/***/ }),

/***/ "./src/Icon/index.js":
/*!***************************!*\
  !*** ./src/Icon/index.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Icon/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Icon/internal/CheckBox.jsx":
/*!****************************************!*\
  !*** ./src/Icon/internal/CheckBox.jsx ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var recompose_pure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! recompose/pure */ "recompose/pure");
/* harmony import */ var recompose_pure__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(recompose_pure__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/SvgIcon */ "@material-ui/core/SvgIcon");
/* harmony import */ var _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2__);





/**
 * This is copied from MaterialUI internal component to allow customization
 */
var CheckBoxIcon = function CheckBoxIcon(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2___default.a,
    props,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
  );
};
var CheckBox = recompose_pure__WEBPACK_IMPORTED_MODULE_1___default()(CheckBoxIcon);
CheckBox.muiName = 'SvgIcon';

/* harmony default export */ __webpack_exports__["default"] = (CheckBox);

/***/ }),

/***/ "./src/Icon/internal/CheckBoxOutlineBlank.jsx":
/*!****************************************************!*\
  !*** ./src/Icon/internal/CheckBoxOutlineBlank.jsx ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var recompose_pure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! recompose/pure */ "recompose/pure");
/* harmony import */ var recompose_pure__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(recompose_pure__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/SvgIcon */ "@material-ui/core/SvgIcon");
/* harmony import */ var _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2__);





/**
 * This is copied from MaterialUI internal component to allow customization
 */
var CheckBoxOutlineBlankIcon = function CheckBoxOutlineBlankIcon(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2___default.a,
    props,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
  );
};
var CheckBoxOutlineBlank = recompose_pure__WEBPACK_IMPORTED_MODULE_1___default()(CheckBoxOutlineBlankIcon);
CheckBoxOutlineBlank.muiName = 'SvgIcon';

/* harmony default export */ __webpack_exports__["default"] = (CheckBoxOutlineBlank);

/***/ }),

/***/ "./src/Icon/internal/IndeterminateCheckBox.jsx":
/*!*****************************************************!*\
  !*** ./src/Icon/internal/IndeterminateCheckBox.jsx ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var recompose_pure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! recompose/pure */ "recompose/pure");
/* harmony import */ var recompose_pure__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(recompose_pure__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/SvgIcon */ "@material-ui/core/SvgIcon");
/* harmony import */ var _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2__);





/**
 * This is copied from MaterialUI internal component to allow customization
 */
var IndeterminateCheckBoxIcon = function IndeterminateCheckBoxIcon(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_2___default.a,
    props,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' })
  );
};
var IndeterminateCheckBox = recompose_pure__WEBPACK_IMPORTED_MODULE_1___default()(IndeterminateCheckBoxIcon);
IndeterminateCheckBox.muiName = 'SvgIcon';

/* harmony default export */ __webpack_exports__["default"] = (IndeterminateCheckBox);

/***/ }),

/***/ "./src/Icon/styles.scss":
/*!******************************!*\
  !*** ./src/Icon/styles.scss ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Icon/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/IconButton/index.jsx":
/*!**********************************!*\
  !*** ./src/IconButton/index.jsx ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/IconButton */ "@material-ui/core/IconButton");
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./style.scss */ "./src/IconButton/style.scss");
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Colored_index_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Colored/index.scss */ "./src/Colored/index.scss");
/* harmony import */ var _Colored_index_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Colored_index_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Colored_colors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Colored/colors */ "./src/Colored/colors.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







 // TODO remove this once inputAdornment is removed



var jssStyles = function jssStyles(theme) {
  return {
    root: {
      color: theme.palette.text.secondary,
      width: theme.spacing.unit * 5,
      height: theme.spacing.unit * 5,
      '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light
      }
    }
  };
};

var GentuIconButton = function (_React$PureComponent) {
  _inherits(GentuIconButton, _React$PureComponent);

  function GentuIconButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GentuIconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GentuIconButton.__proto__ || Object.getPrototypeOf(GentuIconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      active: _this.props.active || false
    }, _this.handleClick = function (e) {
      e.persist();
      var _this$props = _this.props,
          toggle = _this$props.toggle,
          onClick = _this$props.onClick,
          onChange = _this$props.onChange;
      var active = _this.state.active;

      if (toggle && _this.props.active === undefined) {
        _this.setState({ active: !active }, function () {
          if (onChange) onChange(_this.state.active);
        });
      }
      if (onClick) onClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GentuIconButton, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          inputAdornment = _props.inputAdornment,
          children = _props.children,
          toggle = _props.toggle,
          active = _props.active,
          activeColor = _props.activeColor,
          onClick = _props.onClick,
          activeIcon = _props.activeIcon,
          other = _objectWithoutProperties(_props, ['className', 'inputAdornment', 'children', 'toggle', 'active', 'activeColor', 'onClick', 'activeIcon']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3___default.a,
        _extends({
          'data-cy': 'icon_button',
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_Colored_index_scss__WEBPACK_IMPORTED_MODULE_6___default.a.root, className, _style_scss__WEBPACK_IMPORTED_MODULE_5___default.a.root, (_classnames = {}, _defineProperty(_classnames, _style_scss__WEBPACK_IMPORTED_MODULE_5___default.a.inputAdornment, inputAdornment), _defineProperty(_classnames, _Colored_index_scss__WEBPACK_IMPORTED_MODULE_6___default.a[activeColor || 'brandPink'], this.state.active), _classnames))
        }, other, {
          onClick: this.handleClick
        }),
        toggle && this.state.active && activeIcon ? activeIcon : children
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props) {
      var active = props.active;

      if (active !== undefined) {
        return { active: active };
      }
      return null;
    }
  }]);

  return GentuIconButton;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

GentuIconButton.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  inputAdornment: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  toggle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  active: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  activeColor: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(_Colored_colors__WEBPACK_IMPORTED_MODULE_7__["default"]),
  activeIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.element
};

GentuIconButton.defaultProps = {
  className: undefined,
  inputAdornment: false,
  children: null,
  toggle: false,
  active: undefined,
  onChange: undefined,
  onClick: undefined,
  activeColor: undefined,
  activeIcon: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__["withStyles"])(jssStyles)(GentuIconButton));

/***/ }),

/***/ "./src/IconButton/style.scss":
/*!***********************************!*\
  !*** ./src/IconButton/style.scss ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./style.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/IconButton/style.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/InfoBox/component.jsx":
/*!***********************************!*\
  !*** ./src/InfoBox/component.jsx ***!
  \***********************************/
/*! exports provided: infoBoxPropTypes, infoBoxDefaultProps, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "infoBoxPropTypes", function() { return infoBoxPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "infoBoxDefaultProps", function() { return infoBoxDefaultProps; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/icons/Close */ "@material-ui/icons/Close");
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _Popover__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Popover */ "./src/Popover/index.js");
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../IconButton */ "./src/IconButton/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./styles.scss */ "./src/InfoBox/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_7__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var InfoBox = function (_React$PureComponent) {
  _inherits(InfoBox, _React$PureComponent);

  function InfoBox() {
    _classCallCheck(this, InfoBox);

    return _possibleConstructorReturn(this, (InfoBox.__proto__ || Object.getPrototypeOf(InfoBox)).apply(this, arguments));
  }

  _createClass(InfoBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          children = _props.children,
          PaperProps = _props.PaperProps,
          rest = _objectWithoutProperties(_props, ['title', 'children', 'PaperProps']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Popover__WEBPACK_IMPORTED_MODULE_5__["default"],
        _extends({}, rest, {
          className: _styles_scss__WEBPACK_IMPORTED_MODULE_7___default.a.root,
          elevation: 4,
          PaperProps: _extends({}, PaperProps, { classes: { root: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_defineProperty({}, PaperProps.className, !!PaperProps.className), _styles_scss__WEBPACK_IMPORTED_MODULE_7___default.a.paper) } }),
          horizontalAlign: 'center',
          limitWidth: true
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          react__WEBPACK_IMPORTED_MODULE_0__["Fragment"],
          null,
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _IconButton__WEBPACK_IMPORTED_MODULE_6__["default"],
            {
              className: _styles_scss__WEBPACK_IMPORTED_MODULE_7___default.a.closeBtn,
              onClick: this.props.onClose
            },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_2___default.a, null)
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _Typography__WEBPACK_IMPORTED_MODULE_4__["default"],
            { variant: 'subtitle1', className: _styles_scss__WEBPACK_IMPORTED_MODULE_7___default.a.title },
            title,
            '\xA0'
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _Typography__WEBPACK_IMPORTED_MODULE_4__["default"],
            { component: 'div', variant: 'body1', className: _styles_scss__WEBPACK_IMPORTED_MODULE_7___default.a.content },
            children
          )
        )
      );
    }
  }]);

  return InfoBox;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

var limitWidthPropTypeFromPopover = _Popover__WEBPACK_IMPORTED_MODULE_5__["popOverPropTypes"].limitWidth,
    horizontalAlignPropTypeFromPopover = _Popover__WEBPACK_IMPORTED_MODULE_5__["popOverPropTypes"].horizontalAlign,
    infoBoxPropTypesFromPopover = _objectWithoutProperties(_Popover__WEBPACK_IMPORTED_MODULE_5__["popOverPropTypes"], ['limitWidth', 'horizontalAlign']);

var infoBoxPropTypes = _extends({}, infoBoxPropTypesFromPopover, {
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
});

InfoBox.propTypes = infoBoxPropTypes;

var limitWidthDefaultPropFromPopover = _Popover__WEBPACK_IMPORTED_MODULE_5__["popOverDefaultProps"].limitWidth,
    infoBoxDefaultPropsFromPopover = _objectWithoutProperties(_Popover__WEBPACK_IMPORTED_MODULE_5__["popOverDefaultProps"], ['limitWidth']);

var infoBoxDefaultProps = _extends({}, infoBoxDefaultPropsFromPopover, {
  title: '',
  PaperProps: {
    style: {
      maxWidth: 250
    }
  }
});

InfoBox.defaultProps = infoBoxDefaultProps;

/* harmony default export */ __webpack_exports__["default"] = (InfoBox);

/***/ }),

/***/ "./src/InfoBox/index.js":
/*!******************************!*\
  !*** ./src/InfoBox/index.js ***!
  \******************************/
/*! exports provided: default, infoBoxPropTypes, infoBoxDefaultProps */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/InfoBox/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "infoBoxPropTypes", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["infoBoxPropTypes"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "infoBoxDefaultProps", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["infoBoxDefaultProps"]; });





/***/ }),

/***/ "./src/InfoBox/styles.scss":
/*!*********************************!*\
  !*** ./src/InfoBox/styles.scss ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/InfoBox/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Input/TextareaAutoHeight/component.jsx":
/*!****************************************************!*\
  !*** ./src/Input/TextareaAutoHeight/component.jsx ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../input */ "./src/Input/input.jsx");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils */ "./src/Input/TextareaAutoHeight/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TextareaAutoHeight = function (_React$Component) {
  _inherits(TextareaAutoHeight, _React$Component);

  function TextareaAutoHeight(props) {
    _classCallCheck(this, TextareaAutoHeight);

    var _this = _possibleConstructorReturn(this, (TextareaAutoHeight.__proto__ || Object.getPrototypeOf(TextareaAutoHeight)).call(this, props));

    _this.setInputRef = function (input) {
      var inputRef = _this.props.inputRef;


      _this.input = input;
      if (inputRef) inputRef(input);

      _this.forceVisibleRows();
    };

    _this.beginListeningForMouseUp = function () {
      // bind to document rather than input, as the mouseup event could be outside of the input
      document.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      document.removeEventListener('mouseup', _this.handleMouseUp);
      _this.calculateVisibleRows(true);
    };

    _this.forceVisibleRows = function () {
      var _this$props = _this.props,
          minRows = _this$props.minRows,
          initialRows = _this$props.initialRows;

      if (_this.input) {
        // we want to calculate the height when the input has no scrollbars
        var initialOverflowStyle = _this.input.style.overflow;
        _this.input.style.overflow = 'hidden';

        var _getVisibleRows = Object(_utils__WEBPACK_IMPORTED_MODULE_4__["getVisibleRows"])(_this.input, minRows),
            requiredToSeeAllRows = _getVisibleRows.requiredToSeeAllRows;

        _this.input.style.overflow = initialOverflowStyle; // restore original overflow style
        _this.input.rows = Math.max(requiredToSeeAllRows, initialRows);

        _this.visibleInputRows = requiredToSeeAllRows;
      }
    };

    _this.calculateVisibleRows = function () {
      var shouldSync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var minRows = _this.props.minRows;

      if (_this.input) {
        var _getVisibleRows2 = Object(_utils__WEBPACK_IMPORTED_MODULE_4__["getVisibleRows"])(_this.input, minRows),
            visibleRows = _getVisibleRows2.visibleRows;

        // only fire the callback if the value has changed and we want to sync the change


        if (visibleRows !== _this.visibleInputRows) {

          _this.visibleInputRows = visibleRows;

          if (shouldSync) {
            _this.triggerOnResize();
          }
        }
      }
    };

    _this.triggerOnResize = function () {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          onResize = _this$props2.onResize;

      onResize(name, _this.visibleInputRows);
    };

    _this.input = null;
    _this.visibleInputRows = null;
    return _this;
  }

  _createClass(TextareaAutoHeight, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          minRows = _props.minRows,
          initialRows = _props.initialRows,
          onResize = _props.onResize,
          rest = _objectWithoutProperties(_props, ['minRows', 'initialRows', 'onResize']);

      var rows = minRows;

      return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_input__WEBPACK_IMPORTED_MODULE_3__["default"], _extends({
        rows: rows,
        multiline: true,
        canResize: true
      }, rest, {
        onMouseDown: this.beginListeningForMouseUp,
        inputRef: this.setInputRef
      }));
    }
  }]);

  return TextareaAutoHeight;
}(react__WEBPACK_IMPORTED_MODULE_1___default.a.Component);

TextareaAutoHeight.propTypes = {
  minRows: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  initialRows: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  name: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string.isRequired,
  value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string.isRequired,
  onResize: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired,
  inputRef: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func
};

TextareaAutoHeight.defaultProps = {
  initialRows: 0,
  minRows: 4,
  inputRef: lodash__WEBPACK_IMPORTED_MODULE_0__["noop"]
};

/* harmony default export */ __webpack_exports__["default"] = (TextareaAutoHeight);

/***/ }),

/***/ "./src/Input/TextareaAutoHeight/index.js":
/*!***********************************************!*\
  !*** ./src/Input/TextareaAutoHeight/index.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Input/TextareaAutoHeight/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Input/TextareaAutoHeight/utils.js":
/*!***********************************************!*\
  !*** ./src/Input/TextareaAutoHeight/utils.js ***!
  \***********************************************/
/*! exports provided: sanitizeNumber, getVisibleRows */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sanitizeNumber", function() { return sanitizeNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVisibleRows", function() { return getVisibleRows; });
var sanitizeNumber = function sanitizeNumber(value, fallback) {
  var returnValue = Math.floor(parseFloat(value));

  // just in case we end up having tried to parse a silly number
  if (Number.isNaN(returnValue)) return fallback;
  return returnValue;
};

var getVisibleRows = function getVisibleRows(input, minRows) {
  var defaultLineHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

  // inputs use content-box for box-sizing, so we need to ignore padding
  // values should come back as strings with "px" appended to the number we want
  var _getComputedStyle = getComputedStyle(input),
      paddingTop = _getComputedStyle.paddingTop,
      paddingBottom = _getComputedStyle.paddingBottom,
      lineHeight = _getComputedStyle.lineHeight;

  var verticalPaddingTotal = sanitizeNumber(paddingTop, 0) + sanitizeNumber(paddingBottom, 0);

  var contentBoxHeight = input.clientHeight - verticalPaddingTotal;
  var scrollBoxHeight = input.scrollHeight - verticalPaddingTotal;
  var sensibleLineHeight = Math.max(sanitizeNumber(lineHeight, defaultLineHeight), defaultLineHeight); // prevent line height 0 explosions

  // use Math.ceil as we want to include lines that could be half visible
  var visibleRows = Math.max(Math.ceil(contentBoxHeight / sensibleLineHeight), minRows);
  return {
    visibleRows: visibleRows,
    requiredToSeeAllRows: Math.max(Math.ceil(scrollBoxHeight / sensibleLineHeight), visibleRows, minRows)
  };
};

/***/ }),

/***/ "./src/Input/VisiblePasswordInput/component.jsx":
/*!******************************************************!*\
  !*** ./src/Input/VisiblePasswordInput/component.jsx ***!
  \******************************************************/
/*! exports provided: VisiblePasswordInputRaw, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VisiblePasswordInputRaw", function() { return VisiblePasswordInputRaw; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! recompose */ "recompose");
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(recompose__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_icons_Visibility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/icons/Visibility */ "@material-ui/icons/Visibility");
/* harmony import */ var _material_ui_icons_Visibility__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Visibility__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_VisibilityOff__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/icons/VisibilityOff */ "@material-ui/icons/VisibilityOff");
/* harmony import */ var _material_ui_icons_VisibilityOff__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_VisibilityOff__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../input */ "./src/Input/input.jsx");
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Icon */ "./src/Icon/index.js");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Tooltip */ "./src/Tooltip/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }












var VisiblePasswordInput = function VisiblePasswordInput(_ref) {
  var passwordVisible = _ref.passwordVisible,
      setPasswordVisible = _ref.setPasswordVisible,
      props = _objectWithoutProperties(_ref, ['passwordVisible', 'setPasswordVisible']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_input__WEBPACK_IMPORTED_MODULE_5__["default"], _extends({
    type: passwordVisible ? 'text' : 'password',
    endAdornment: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Tooltip__WEBPACK_IMPORTED_MODULE_8__["default"],
      {
        key: 'tooltip-' + passwordVisible,
        title: passwordVisible ? "Hide password" : "Show password"
      },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_6__["default"], {
        component: passwordVisible ? _material_ui_icons_Visibility__WEBPACK_IMPORTED_MODULE_3___default.a : _material_ui_icons_VisibilityOff__WEBPACK_IMPORTED_MODULE_4___default.a,
        color: 'grey',
        className: _layout_scss__WEBPACK_IMPORTED_MODULE_7___default.a.clickable,
        onClick: function onClick() {
          return setPasswordVisible(!passwordVisible);
        }
      })
    )
  }, props));
};
VisiblePasswordInput.propTypes = {
  passwordVisible: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool.isRequired,
  setPasswordVisible: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired
};
var VisiblePasswordInputRaw = VisiblePasswordInput;
/* harmony default export */ __webpack_exports__["default"] = (Object(recompose__WEBPACK_IMPORTED_MODULE_2__["withState"])('passwordVisible', 'setPasswordVisible', false)(VisiblePasswordInput));

/***/ }),

/***/ "./src/Input/VisiblePasswordInput/index.js":
/*!*************************************************!*\
  !*** ./src/Input/VisiblePasswordInput/index.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Input/VisiblePasswordInput/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Input/adornmentHOCs/styles.scss":
/*!*********************************************!*\
  !*** ./src/Input/adornmentHOCs/styles.scss ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../node_modules/css-loader??ref--5-1!../../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Input/adornmentHOCs/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Input/adornmentHOCs/withDurationAdornment.jsx":
/*!***********************************************************!*\
  !*** ./src/Input/adornmentHOCs/withDurationAdornment.jsx ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/InputAdornment */ "@material-ui/core/InputAdornment");
/* harmony import */ var _material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.scss */ "./src/Input/adornmentHOCs/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var withDurationAdornment = function withDurationAdornment(C) {
  return function (_React$PureComponent) {
    _inherits(DurationAdornmentWrapper, _React$PureComponent);

    function DurationAdornmentWrapper() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, DurationAdornmentWrapper);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DurationAdornmentWrapper.__proto__ || Object.getPrototypeOf(DurationAdornmentWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.getDurationDescription = function () {
        var duration = _this.props.value;


        if (!duration) return null;

        var asNumber = Number(duration);
        if (Number.isNaN(duration)) return null;

        var hours = Math.floor(asNumber / 60);
        var minutes = Math.floor(asNumber % 60);

        return [hours ? hours + 'h' : '', minutes ? minutes + 'm' : ''].filter(function (part) {
          return !!part;
        }).join(', ');
      }, _this.getDurationEndAdornment = function () {
        var value = _this.getDurationDescription();
        if (!value) return null;

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_2___default.a,
          { position: 'end', className: _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.adornment },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _Typography__WEBPACK_IMPORTED_MODULE_3__["default"],
            { variant: 'body1', color: 'secondary' },
            value
          )
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DurationAdornmentWrapper, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            value = _props.value,
            other = _objectWithoutProperties(_props, ['value']);

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(C, _extends({}, other, {
          value: value,
          endAdornment: this.getDurationEndAdornment()
        }));
      }
    }], [{
      key: 'propTypes',
      get: function get() {
        return {
          value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number])
        };
      }
    }, {
      key: 'defaultProps',
      get: function get() {
        return {
          value: null
        };
      }
    }]);

    return DurationAdornmentWrapper;
  }(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);
};

/* harmony default export */ __webpack_exports__["default"] = (withDurationAdornment);

/***/ }),

/***/ "./src/Input/checkbox.jsx":
/*!********************************!*\
  !*** ./src/Input/checkbox.jsx ***!
  \********************************/
/*! exports provided: Checkbox, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return Checkbox; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Checkbox */ "@material-ui/core/Checkbox");
/* harmony import */ var _material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _withCheckedAsValue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./withCheckedAsValue */ "./src/Input/withCheckedAsValue.jsx");
/* harmony import */ var _Icon_internal_CheckBox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Icon/internal/CheckBox */ "./src/Icon/internal/CheckBox.jsx");
/* harmony import */ var _Icon_internal_CheckBoxOutlineBlank__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Icon/internal/CheckBoxOutlineBlank */ "./src/Icon/internal/CheckBoxOutlineBlank.jsx");
/* harmony import */ var _Icon_internal_IndeterminateCheckBox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Icon/internal/IndeterminateCheckBox */ "./src/Icon/internal/IndeterminateCheckBox.jsx");
/* harmony import */ var _checkbox_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./checkbox.scss */ "./src/Input/checkbox.scss");
/* harmony import */ var _checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_checkbox_scss__WEBPACK_IMPORTED_MODULE_8__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// eslint-disable-next-line react/prefer-stateless-function
var Checkbox = function (_React$PureComponent) {
  _inherits(Checkbox, _React$PureComponent);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          compact = _props.compact,
          mini = _props.mini,
          className = _props.className,
          dataCy = _props.dataCy,
          disabled = _props.disabled,
          color = _props.color,
          other = _objectWithoutProperties(_props, ['compact', 'mini', 'className', 'dataCy', 'disabled', 'color']);

      var classNameProp = classnames__WEBPACK_IMPORTED_MODULE_2___default()(_checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default.a.root, _checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default.a.item, className, (_classnames = {}, _defineProperty(_classnames, _checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default.a.compact, compact), _defineProperty(_classnames, _checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default.a.mini, mini), _classnames));

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_1___default.a, _extends({
        color: color,
        icon: mini ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon_internal_CheckBoxOutlineBlank__WEBPACK_IMPORTED_MODULE_6__["default"], { className: _checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default.a.mini }) : undefined,
        checkedIcon: mini ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon_internal_CheckBox__WEBPACK_IMPORTED_MODULE_5__["default"], { className: _checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default.a.mini }) : undefined,
        indeterminateIcon: mini ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon_internal_IndeterminateCheckBox__WEBPACK_IMPORTED_MODULE_7__["default"], { className: _checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default.a.mini }) : undefined,
        className: classNameProp,
        'data-cy': dataCy,
        disabled: disabled
      }, other));
    }
  }]);

  return Checkbox;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

Checkbox.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  compact: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  mini: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  dataCy: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  color: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};

Checkbox.defaultProps = {
  className: undefined,
  compact: false,
  mini: false,
  dataCy: 'checkbox',
  disabled: false,
  color: 'primary'
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_withCheckedAsValue__WEBPACK_IMPORTED_MODULE_4__["default"])(Checkbox));

/***/ }),

/***/ "./src/Input/checkbox.scss":
/*!*********************************!*\
  !*** ./src/Input/checkbox.scss ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./checkbox.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Input/checkbox.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Input/checkbox.spec-helper.js":
/*!*******************************************!*\
  !*** ./src/Input/checkbox.spec-helper.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Checkbox = function () {
  function Checkbox(wrapper, id) {
    var _this = this;

    _classCallCheck(this, Checkbox);

    this.checkOn = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var event;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event = { target: { checked: true } };
              _context.next = 3;
              return _this.input.simulate('change', event);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    this.checkOff = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var event;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event = { target: { checked: false } };
              _context2.next = 3;
              return _this.input.simulate('change', event);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    this.wrapper = wrapper;
    this.id = id;
    this.type = 'Checkbox';
  }

  _createClass(Checkbox, [{
    key: 'disabled',
    value: function disabled() {
      return this.input.props().disabled;
    }
  }, {
    key: 'checked',
    value: function checked() {
      return this.input.props().checked;
    }
  }, {
    key: 'visible',
    value: function visible() {
      return this.input.length > 0;
    }
  }, {
    key: 'el',
    get: function get() {
      return this.wrapper.find(this.id);
    }
  }, {
    key: 'input',
    get: function get() {
      return this.el.find('input[type="checkbox"]');
    }
  }]);

  return Checkbox;
}();

/* harmony default export */ __webpack_exports__["default"] = (Checkbox);

/***/ }),

/***/ "./src/Input/currencyInput.jsx":
/*!*************************************!*\
  !*** ./src/Input/currencyInput.jsx ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/InputAdornment */ "@material-ui/core/InputAdornment");
/* harmony import */ var _material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../theme_export.scss */ "./src/theme_export.scss");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_theme_export_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./helpers */ "./src/Input/helpers.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var adornmentStyles = {
  root: {
    marginTop: _theme_export_scss__WEBPACK_IMPORTED_MODULE_6__["spacingUnit"] * 0.5 + 'px',
    marginRight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_6__["spacingUnit"] * 0.5 + 'px'
  }
};
var StyledInputAdornment = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__["withStyles"])(adornmentStyles)(_material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_4___default.a);

// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var CurrencyInput = function (_React$PureComponent) {
  _inherits(CurrencyInput, _React$PureComponent);

  function CurrencyInput(props) {
    _classCallCheck(this, CurrencyInput);

    var _this = _possibleConstructorReturn(this, (CurrencyInput.__proto__ || Object.getPrototypeOf(CurrencyInput)).call(this, props));

    _this.handleChange = function (event) {
      _this.setState({
        value: event.target.value
      });

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleBlur = function (event) {
      var newEvent = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["tap"])(event, function (e) {
        e.target.value = Object(_helpers__WEBPACK_IMPORTED_MODULE_8__["default"])(e.target.value || '0');
      });

      _this.setState({ hasFocus: false });
      _this.handleChange(newEvent);
      if (_this.props.onBlur) {
        _this.props.onBlur(newEvent);
      }
    };

    _this.handleFocus = function () {
      _this.setState({
        hasFocus: true
      });
    };

    _this.state = { value: _this.initialValue() };
    return _this;
  }

  _createClass(CurrencyInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = this.state.hasFocus ? nextProps.value : Object(_helpers__WEBPACK_IMPORTED_MODULE_8__["default"])(nextProps.value);
      this.setState({ value: value });
    }
  }, {
    key: 'initialValue',
    value: function initialValue() {
      return this.props.value ? Object(_helpers__WEBPACK_IMPORTED_MODULE_8__["default"])(this.props.value.toString()) : '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          value = _props.value,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          alignRight = _props.alignRight,
          _props$classes = _props.classes,
          classes = _props$classes === undefined ? {} : _props$classes,
          other = _objectWithoutProperties(_props, ['value', 'onBlur', 'onChange', 'alignRight', 'classes']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_7__["Input"], _extends({
        startAdornment: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          StyledInputAdornment,
          { position: 'start' },
          '$'
        ),
        value: this.state.value,
        placeholder: this.props.placeholder,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        classes: _extends({}, classes, {
          input: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_classNames = {}, _defineProperty(_classNames, classes.input, !!classes.input), _defineProperty(_classNames, ___WEBPACK_IMPORTED_MODULE_7__["layout"].alignRight, alignRight), _classNames))
        })
      }, other));
    }
  }]);

  return CurrencyInput;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

CurrencyInput.propTypes = {
  placeholder: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  alignRight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number]),
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.objectOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string)
};

CurrencyInput.defaultProps = {
  placeholder: '0.00',
  value: '',
  alignRight: false,
  onChange: undefined,
  onBlur: undefined,
  classes: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (CurrencyInput);

/***/ }),

/***/ "./src/Input/div.spec-helper.js":
/*!**************************************!*\
  !*** ./src/Input/div.spec-helper.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Div = function () {
  function Div(wrapper, id) {
    _classCallCheck(this, Div);

    this.wrapper = wrapper;
    this.id = id;
    this.el = this.wrapper.find(id);
    this.type = 'Input';
  }

  _createClass(Div, [{
    key: 'content',
    value: function content() {
      return this.el.text();
    }
  }, {
    key: 'visible',
    value: function visible() {
      return this.el.length > 0;
    }
  }]);

  return Div;
}();

/* harmony default export */ __webpack_exports__["default"] = (Div);

/***/ }),

/***/ "./src/Input/durationInput.js":
/*!************************************!*\
  !*** ./src/Input/durationInput.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _input__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./input */ "./src/Input/input.jsx");
/* harmony import */ var _adornmentHOCs_withDurationAdornment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./adornmentHOCs/withDurationAdornment */ "./src/Input/adornmentHOCs/withDurationAdornment.jsx");



/* harmony default export */ __webpack_exports__["default"] = (Object(_adornmentHOCs_withDurationAdornment__WEBPACK_IMPORTED_MODULE_1__["default"])(_input__WEBPACK_IMPORTED_MODULE_0__["default"]));

/***/ }),

/***/ "./src/Input/fieldLabel.jsx":
/*!**********************************!*\
  !*** ./src/Input/fieldLabel.jsx ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./styles.scss */ "./src/Input/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_5__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var alignLeft = _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.alignLeft,
    alignRight = _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.alignRight,
    alignCenter = _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.alignCenter;

var classLookup = {
  left: alignLeft,
  right: alignRight,
  center: alignCenter
};

var FieldLabel = function FieldLabel(_ref) {
  var label = _ref.label,
      labelAlign = _ref.labelAlign,
      labelProps = _ref.labelProps;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _Typography__WEBPACK_IMPORTED_MODULE_3__["default"],
    _extends({
      variant: 'caption',
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([classLookup[labelAlign], _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.fieldLabel])
    }, labelProps),
    label
  );
};

FieldLabel.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
  labelAlign: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['left', 'right', 'center']),
  labelProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)
};

FieldLabel.defaultProps = {
  labelAlign: 'right',
  labelProps: {}
};

/* harmony default export */ __webpack_exports__["default"] = (FieldLabel);

/***/ }),

/***/ "./src/Input/helpers.js":
/*!******************************!*\
  !*** ./src/Input/helpers.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// formatValue prepares value for display
var formatValue = function formatValue(value) {
  if (value === undefined || value === '') {
    return value;
  }
  var val = value;

  if (Number.isNaN(parseFloat(value))) {
    val = '0.00';
  }

  return parseFloat(val).toFixed(2).toString();
};

/* harmony default export */ __webpack_exports__["default"] = (formatValue);

/***/ }),

/***/ "./src/Input/index.js":
/*!****************************!*\
  !*** ./src/Input/index.js ***!
  \****************************/
/*! exports provided: CurrencyInput, Select, Input, TextareaAutoHeight, DurationInput, Checkbox, LabelCheckbox, formatValue, RadioButtons, Radio, withDurationAdornment, VisiblePasswordInput, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _currencyInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./currencyInput */ "./src/Input/currencyInput.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CurrencyInput", function() { return _currencyInput__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _select__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./select */ "./src/Input/select.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return _select__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./input */ "./src/Input/input.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return _input__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _TextareaAutoHeight__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TextareaAutoHeight */ "./src/Input/TextareaAutoHeight/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextareaAutoHeight", function() { return _TextareaAutoHeight__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _durationInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./durationInput */ "./src/Input/durationInput.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationInput", function() { return _durationInput__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./checkbox */ "./src/Input/checkbox.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _checkbox__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _labelCheckbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./labelCheckbox */ "./src/Input/labelCheckbox.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LabelCheckbox", function() { return _labelCheckbox__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./helpers */ "./src/Input/helpers.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "formatValue", function() { return _helpers__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _radioButtons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./radioButtons */ "./src/Input/radioButtons.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioButtons", function() { return _radioButtons__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _radio__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./radio */ "./src/Input/radio.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return _radio__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _adornmentHOCs_withDurationAdornment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./adornmentHOCs/withDurationAdornment */ "./src/Input/adornmentHOCs/withDurationAdornment.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withDurationAdornment", function() { return _adornmentHOCs_withDurationAdornment__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _VisiblePasswordInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./VisiblePasswordInput */ "./src/Input/VisiblePasswordInput/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VisiblePasswordInput", function() { return _VisiblePasswordInput__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _input__WEBPACK_IMPORTED_MODULE_2__["default"]; });
















/***/ }),

/***/ "./src/Input/input.jsx":
/*!*****************************!*\
  !*** ./src/Input/input.jsx ***!
  \*****************************/
/*! exports provided: inputPropTypes, inputDefaultProps, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inputPropTypes", function() { return inputPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inputDefaultProps", function() { return inputDefaultProps; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Input */ "@material-ui/core/Input");
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react-text-mask */ "react-text-mask");
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_text_mask__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lodash/omit */ "lodash/omit");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/core/FormControl */ "@material-ui/core/FormControl");
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @material-ui/core/InputLabel */ "@material-ui/core/InputLabel");
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _FormHelperText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../FormHelperText */ "./src/FormHelperText/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./styles.scss */ "./src/Input/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils */ "./src/Input/utils.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
















var randomElementId = function randomElementId() {
  return Object(_utils__WEBPACK_IMPORTED_MODULE_12__["randomString"])(8);
};

// Material UI Input component allows you to specify the `inputRef` and
// `inputProps` ... but it will always pass the `inputRef` prop, which
// MaskedInput does not know about. It will actually pass any extra props
// directly to the native input component which does not support `inputRef`
// and therefore prints an error in the console. This little hack puts `ref`
// in its place.
var MaskedInputWithoutInputRef = function MaskedInputWithoutInputRef(_ref) {
  var inputRef = _ref.inputRef,
      other = _objectWithoutProperties(_ref, ['inputRef']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_text_mask__WEBPACK_IMPORTED_MODULE_5___default.a, _extends({ ref: function ref(el) {
      return el && inputRef(el.inputElement);
    } }, other));
};

MaskedInputWithoutInputRef.propTypes = {
  inputRef: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};
MaskedInputWithoutInputRef.defaultProps = {
  inputRef: undefined
};

// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var Input = function (_React$PureComponent) {
  _inherits(Input, _React$PureComponent);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.getTestAttributes = function () {
      return {
        'data-cy': _this.props['data-cy'] || _this.props.label,
        'data-component': 'Input'
      };
    };

    _this.handleLabelClick = function (e) {
      if (_this.inputRef) {
        _this.inputRef.focus();
        var _this$props$mask = _this.props.mask,
            mask = _this$props$mask === undefined ? [] : _this$props$mask;

        Object(_utils__WEBPACK_IMPORTED_MODULE_11__["adjustCursorPosition"])(_this.inputRef, mask, mask.length);
      }
      e.preventDefault();
      e.stopPropagation();
    };

    _this.handleSelect = function (event) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          mask = _this$props.mask;

      Object(_utils__WEBPACK_IMPORTED_MODULE_11__["adjustCursorPosition"])(_this.inputRef, mask);
      if (onSelect) {
        onSelect(event);
      }
    };

    _this.handleChange = function (event) {
      var inputValue = event.target.value;

      if (_this.props.allowedChars) {
        inputValue = Object(_utils__WEBPACK_IMPORTED_MODULE_11__["applyCharWhitelist"])(inputValue, _this.props.allowedChars);
      }

      inputValue = _this.getValueText(inputValue);

      if (_this.props.onChange) {
        _this.props.onChange(_extends({}, event, { target: _extends({}, event.target, { value: inputValue }) }));
      }
    };

    _this.handleFocus = function (event) {
      _this.setState({ shouldCapitalize: event.target.value === '' && _this.props.autoCapitalize });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      var inputValue = event.target.value;

      if (_this.state.shouldCapitalize && inputValue) {
        inputValue = Object(_utils__WEBPACK_IMPORTED_MODULE_12__["capitalize"])(inputValue);

        if (_this.props.onChange) {
          _this.props.onChange(_extends({}, event, { target: _extends({}, event.target, { value: inputValue }) }));
        }
      }

      if (_this.props.onBlur) {
        inputValue = _this.getValueText(inputValue);
        _this.props.onBlur(_extends({}, event, { target: _extends({}, event.target, { value: inputValue }) }));
      }
    };

    _this.focus = function () {
      if (_this.inputRef) {
        _this.inputRef.focus();
      }
    };

    _this.handleInputRef = function (el) {
      var inputRef = _this.props.inputRef;

      // eslint-disable-next-line react/no-find-dom-node

      _this.inputRef = Object(react_dom__WEBPACK_IMPORTED_MODULE_4__["findDOMNode"])(el);
      if (inputRef) inputRef(el);
    };

    _this.state = {
      uniqueCode: !props.enableAutoComplete ? randomElementId() : null,
      shouldCapitalize: false
    };
    return _this;
  }

  _createClass(Input, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoFocus) {
        setTimeout(function () {
          if (!_this2.inputRef) return;
          _this2.inputRef.select();
        }, 100);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.id && nextProps.id !== this.props.id) {
        this.setState({ uniqueCode: !nextProps.enableAutoComplete ? randomElementId() : null });
      }
    }
  }, {
    key: 'getValueText',
    value: function getValueText(inputValue) {
      if (!this.props.mask) return inputValue;

      if (this.props.discardMask) {
        var inputChars = [];
        this.props.mask.forEach(function (mask, index) {
          if (mask instanceof RegExp && mask.test(inputValue[index])) {
            inputChars.push(inputValue[index]);
          }
        });
        return inputChars.join('');
      }
      // handle empty input
      var defaultPlaceHolder = '_';
      var isEmpty = this.props.mask.every(function (mask, index) {
        return typeof mask === 'string' || inputValue[index] === defaultPlaceHolder;
      });
      if (isEmpty) {
        return null;
      }
      return inputValue;
    }
  }, {
    key: 'getLabel',
    value: function getLabel() {
      if (this.props.required) {
        return this.props.label + '*';
      }
      return this.props.label;
    }
  }, {
    key: 'inputComponent',
    value: function inputComponent() {
      if (this.props.mask) {
        return MaskedInputWithoutInputRef;
      }
      if (this.props.inputComponent) {
        return this.props.inputComponent;
      }
      return undefined;
    }
  }, {
    key: 'inputProps',
    value: function inputProps() {
      var maskProps = {
        mask: this.props.mask,
        'data-name': this.props.id
      };
      if (this.props.mask && !this.props.placeholder) {
        maskProps.showMask = true;
      }
      if (this.props.enablePasswordManagers === false) {
        // ignore lastpass
        maskProps['data-lpignore'] = 'true';
      }
      if (this.props.enableAutoComplete === false) {
        // this currently seems to work for all inputs except `type="password"` which we do not have a fix for yet.
        if (!this.props.autoComplete) maskProps.autoComplete = 'new-password';

        // helps prevent browser from providing autocomplete results for this field
        maskProps.id = this.id;
      }
      if (this.props.multiline) {
        maskProps.classes = {
          root: _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.multilineRoot,
          shadow: _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.multilineShadow
        };
      }
      return Object.assign(maskProps, this.props.inputProps);
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          notInForm = _props.notInForm,
          hideHelperText = _props.hideHelperText,
          helperText = _props.helperText,
          mask = _props.mask,
          error = _props.error,
          id = _props.id,
          required = _props.required,
          label = _props.label,
          inputComponent = _props.inputComponent,
          inputProps = _props.inputProps,
          value = _props.value,
          onChange = _props.onChange,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          discardMask = _props.discardMask,
          enablePasswordManagers = _props.enablePasswordManagers,
          enableAutoComplete = _props.enableAutoComplete,
          warning = _props.warning,
          allowedChars = _props.allowedChars,
          noMargin = _props.noMargin,
          inputRef = _props.inputRef,
          onSelect = _props.onSelect,
          rootClassName = _props.rootClassName,
          helperTextAlignRight = _props.helperTextAlignRight,
          items = _props.items,
          secondaryHelperText = _props.secondaryHelperText,
          secondaryHelperTextProps = _props.secondaryHelperTextProps,
          canResize = _props.canResize,
          autoCapitalize = _props.autoCapitalize,
          displayWarningIcon = _props.displayWarningIcon,
          compact = _props.compact,
          dynamicLabel = _props.dynamicLabel,
          classes = _props.classes,
          showHelperTextIcon = _props.showHelperTextIcon,
          other = _objectWithoutProperties(_props, ['className', 'notInForm', 'hideHelperText', 'helperText', 'mask', 'error', 'id', 'required', 'label', 'inputComponent', 'inputProps', 'value', 'onChange', 'onFocus', 'onBlur', 'discardMask', 'enablePasswordManagers', 'enableAutoComplete', 'warning', 'allowedChars', 'noMargin', 'inputRef', 'onSelect', 'rootClassName', 'helperTextAlignRight', 'items', 'secondaryHelperText', 'secondaryHelperTextProps', 'canResize', 'autoCapitalize', 'displayWarningIcon', 'compact', 'dynamicLabel', 'classes', 'showHelperTextIcon']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3___default.a, _extends({
        fullWidth: true,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.input, (_classnames = {}, _defineProperty(_classnames, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.multilineNoLabel, this.props.multiline && (!label || notInForm)), _defineProperty(_classnames, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.multiline, this.props.multiline), _defineProperty(_classnames, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.canResize, this.props.canResize), _defineProperty(_classnames, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.compact, compact), _classnames)),
        error: error,
        margin: 'none',
        inputComponent: this.inputComponent(),
        disableUnderline: this.props.multiline,
        id: this.id,
        inputRef: this.handleInputRef,
        inputProps: this.inputProps(),
        value: value === null ? '' : value,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onSelect: this.handleSelect,
        classes: lodash_omit__WEBPACK_IMPORTED_MODULE_6___default()(classes, ['inputRoot', 'label', 'labelShrink'])
      }, other, {
        'data-cy': undefined // test attributes already applied to root element
      }));
    }
  }, {
    key: 'renderHelperText',
    value: function renderHelperText() {
      var _props2 = this.props,
          error = _props2.error,
          warning = _props2.warning,
          helperText = _props2.helperText,
          hideHelperText = _props2.hideHelperText,
          helperTextAlignRight = _props2.helperTextAlignRight,
          displayWarningIcon = _props2.displayWarningIcon,
          showHelperTextIcon = _props2.showHelperTextIcon;


      if (hideHelperText || Object(_utils__WEBPACK_IMPORTED_MODULE_11__["isEmptyNode"])(helperText)) {
        return null;
      }

      var type = void 0;
      if (error) {
        type = 'error';
      } else if (warning) {
        type = 'warning';
      } else {
        type = 'info';
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _FormHelperText__WEBPACK_IMPORTED_MODULE_9__["default"],
        {
          showIcon: showHelperTextIcon || type === 'warning' && displayWarningIcon,
          type: type,
          className: 'error-message' // error-message class is used in cucumber tests only
          , alignRight: helperTextAlignRight
        },
        helperText
      );
    }
  }, {
    key: 'renderSecondaryHelperText',
    value: function renderSecondaryHelperText() {
      var _props3 = this.props,
          secondaryHelperText = _props3.secondaryHelperText,
          secondaryHelperTextProps = _props3.secondaryHelperTextProps;

      if (Object(_utils__WEBPACK_IMPORTED_MODULE_11__["isEmptyNode"])(secondaryHelperText)) {
        return undefined;
      }
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _FormHelperText__WEBPACK_IMPORTED_MODULE_9__["default"],
        _extends({
          type: 'info'
        }, secondaryHelperTextProps),
        secondaryHelperText
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          notInForm = _props4.notInForm,
          error = _props4.error,
          id = _props4.id,
          noMargin = _props4.noMargin,
          rootClassName = _props4.rootClassName,
          compact = _props4.compact,
          dynamicLabel = _props4.dynamicLabel,
          classes = _props4.classes;

      if (notInForm) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          _extends({
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.reset, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.noMargin, noMargin), rootClassName, classes.root)
          }, this.getTestAttributes()),
          this.renderInput()
        );
      }

      var wrapperId = id ? id + '-wrapper' : null;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7___default.a,
        _extends({
          fullWidth: true,
          margin: 'none',
          id: wrapperId,
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.reset, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.container, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.compact, compact), _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.noMargin, noMargin), rootClassName, classes.root)
        }, this.getTestAttributes()),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8___default.a,
          {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.label, classes.label, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.allowShrink, !!dynamicLabel)),
            classes: { shrink: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.shrink, classes.labelShrink) },
            onClick: this.handleLabelClick,
            error: error,
            htmlFor: this.id,
            shrink: dynamicLabel ? undefined : true
          },
          this.getLabel()
        ),
        this.renderInput(),
        this.renderHelperText(),
        this.renderSecondaryHelperText()
      );
    }
  }, {
    key: 'id',
    get: function get() {
      var _props5 = this.props,
          id = _props5.id,
          enableAutoComplete = _props5.enableAutoComplete;

      if (enableAutoComplete) return id || null;
      var uniqueCode = this.state.uniqueCode;

      return this.props.id ? id + '-' + uniqueCode : 'random-' + uniqueCode;
    }
  }]);

  return Input;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

var inputPropTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** autoFocus on the input */
  autoFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** className will be applied to MuiInput */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** rootClassName will be applied to the root component */
  rootClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  inputComponent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number]),
  /** Apply a mask to the input */
  // eslint-disable-next-line react/forbid-prop-types
  mask: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array,
  required: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  warning: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  displayWarningIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  showHelperTextIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** If true, a textarea is rendered, instead of an input[type="text"] */
  multiline: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (for multiline only) Can the textarea be resized vertically? */
  canResize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  inputProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** Ref for the internal MUIInput element */
  inputRef: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Set this to true only when use input outside of form to save some vertical space */
  hideHelperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Set notInForm to true if not using the input in form, label and error will not be displayed */
  notInForm: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Discard mask chars before raising onChange event */
  discardMask: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  placeholder: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Add some measures to prevent password managers from managing this field */
  enablePasswordManagers: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Add some measures to prevent browsers from supplying autocomplete results for this field */
  enableAutoComplete: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Autocapitalize this each word of this field on blur, and make all other letters lowercase, if the field was empty at the time it was focused on. */
  autoCapitalize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Restrict input to these chars */
  allowedChars: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** No margins to input container */
  noMargin: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** event handler for select event */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Align helper text to the right of the input */
  helperTextAlignRight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * sometimes we want to display extra helper text for complex use cases, e.g. addressee in letter form
   * in this case, secondaryHelperText can be provided to display an additional helper text,
   * it is default to info type instead of 'error'
   */
  secondaryHelperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /**
   * This is to allow customize props for secondaryHelperText
   */
  secondaryHelperTextProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  autoComplete: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /**
   * give input equal 4px padding, removes margin top
   */
  compact: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Dynamic labels act as placeholders, then shrink on focus */
  dynamicLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    // motif custom classes, all other classes will be passed to Material UI input
    inputRoot: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    labelShrink: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
  }),
  'data-cy': prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  items: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Array)
};
Input.propTypes = inputPropTypes;

var inputDefaultProps = {
  id: undefined,
  autoFocus: false,
  className: undefined,
  rootClassName: undefined,
  helperText: '',
  secondaryHelperText: '',
  secondaryHelperTextProps: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  inputComponent: undefined,
  inputRef: undefined,
  required: false,
  value: undefined,
  mask: undefined,
  label: undefined,
  error: false,
  warning: false,
  displayWarningIcon: true,
  showHelperTextIcon: false,
  hideHelperText: false,
  notInForm: false,
  inputProps: undefined,
  multiline: false,
  canResize: false,
  discardMask: false,
  placeholder: undefined,
  enablePasswordManagers: false,
  enableAutoComplete: true,
  autoCapitalize: false,
  allowedChars: undefined,
  noMargin: false,
  onSelect: undefined,
  helperTextAlignRight: false,
  autoComplete: undefined,
  compact: false,
  dynamicLabel: false,
  classes: {},
  'data-cy': undefined,
  items: undefined
};
Input.defaultProps = inputDefaultProps;

/* harmony default export */ __webpack_exports__["default"] = (Input);

/***/ }),

/***/ "./src/Input/input.spec-helper.js":
/*!****************************************!*\
  !*** ./src/Input/input.spec-helper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Input = function () {
  function Input(wrapper, id) {
    _classCallCheck(this, Input);

    this.wrapper = wrapper;
    this.id = id;
    this.el = this.wrapper.find(id);
    this.type = 'Input';
  }

  _createClass(Input, [{
    key: 'getInput',
    value: function getInput() {
      var findInput = this.el.find('input');
      return findInput.length > 0 ? findInput : this.el.find('textarea');
    }
  }, {
    key: 'value',
    value: function value() {
      return this.getInput().props().value;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      var event = { target: { value: value.toString() } };
      this.getInput().simulate('change', event);
      this.getInput().simulate('blur');
    }
  }, {
    key: 'displayText',
    value: function displayText() {
      return this.getInput().text();
    }
  }, {
    key: 'label',
    value: function label() {
      return this.el.find('label').text();
    }
  }, {
    key: 'disabled',
    value: function disabled() {
      return this.getInput().props().disabled;
    }
  }, {
    key: 'placeholder',
    value: function placeholder() {
      return this.getInput().props().placeholder;
    }
  }, {
    key: 'visible',
    value: function visible() {
      return this.el.length > 0;
    }
  }, {
    key: 'helperText',
    value: function helperText() {
      var wrapper = this.el.find('FormHelperText').at(0);
      return wrapper.exists() ? wrapper.text() : null;
    }
  }]);

  return Input;
}();

/* harmony default export */ __webpack_exports__["default"] = (Input);

/***/ }),

/***/ "./src/Input/labelCheckbox.jsx":
/*!*************************************!*\
  !*** ./src/Input/labelCheckbox.jsx ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/FormHelperText */ "@material-ui/core/FormHelperText");
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _FormControlLabel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../FormControlLabel */ "./src/FormControlLabel/index.jsx");
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Input */ "./src/Input/index.js");
/* harmony import */ var _checkbox_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./checkbox.scss */ "./src/Input/checkbox.scss");
/* harmony import */ var _checkbox_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_checkbox_scss__WEBPACK_IMPORTED_MODULE_6__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// eslint-disable-next-line react/prefer-stateless-function

var LabelCheckbox = function (_React$PureComponent) {
  _inherits(LabelCheckbox, _React$PureComponent);

  function LabelCheckbox() {
    _classCallCheck(this, LabelCheckbox);

    return _possibleConstructorReturn(this, (LabelCheckbox.__proto__ || Object.getPrototypeOf(LabelCheckbox)).apply(this, arguments));
  }

  _createClass(LabelCheckbox, [{
    key: 'render',
    value: function render() {
      var _classnames2;

      var _props = this.props,
          label = _props.label,
          noVerticalMargin = _props.noVerticalMargin,
          noHorizontalMargin = _props.noHorizontalMargin,
          mini = _props.mini,
          helperText = _props.helperText,
          error = _props.error,
          other = _objectWithoutProperties(_props, ['label', 'noVerticalMargin', 'noHorizontalMargin', 'mini', 'helperText', 'error']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment,
        null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_FormControlLabel__WEBPACK_IMPORTED_MODULE_4__["default"], {
          control: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment,
            null,
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Input__WEBPACK_IMPORTED_MODULE_5__["Checkbox"], _extends({ mini: mini }, other)),
            error && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_3___default.a,
              { error: true, className: _checkbox_scss__WEBPACK_IMPORTED_MODULE_6___default.a.errorLabel },
              helperText
            )
          ),
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_checkbox_scss__WEBPACK_IMPORTED_MODULE_6___default.a.label, _defineProperty({}, _checkbox_scss__WEBPACK_IMPORTED_MODULE_6___default.a.noVerticalMargin, noVerticalMargin)),
          classes: {
            label: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_classnames2 = {}, _defineProperty(_classnames2, _checkbox_scss__WEBPACK_IMPORTED_MODULE_6___default.a.disabled, other.disabled), _defineProperty(_classnames2, _checkbox_scss__WEBPACK_IMPORTED_MODULE_6___default.a.mini, mini), _classnames2))
          },
          label: label,
          noVerticalMargin: noVerticalMargin,
          noHorizontalMargin: noHorizontalMargin
        })
      );
    }
  }]);

  return LabelCheckbox;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

LabelCheckbox.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  noVerticalMargin: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  noHorizontalMargin: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  mini: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

LabelCheckbox.defaultProps = {
  label: '',
  noVerticalMargin: false,
  noHorizontalMargin: false,
  error: false,
  helperText: '',
  mini: false
};

/* harmony default export */ __webpack_exports__["default"] = (LabelCheckbox);

/***/ }),

/***/ "./src/Input/newid.js":
/*!****************************!*\
  !*** ./src/Input/newid.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var lastId = 0;

/* harmony default export */ __webpack_exports__["default"] = (function () {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';

  lastId += 1;
  return '' + prefix + lastId;
});

/***/ }),

/***/ "./src/Input/radio.jsx":
/*!*****************************!*\
  !*** ./src/Input/radio.jsx ***!
  \*****************************/
/*! exports provided: default, RadioWrapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadioWrapper", function() { return Radio; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Radio__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Radio */ "@material-ui/core/Radio");
/* harmony import */ var _material_ui_core_Radio__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Radio__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/**
 * Override the default margin right to remove the gap
 */
var styles = {
  root: {
    marginRight: '-10px'
  },
  /**
  * when passed override class name to radio component,
  * it will complain the class to override isn't implemented unless it is defined here.
  */
  checked: ''
};

/**
 * Wrapper for MUI's Radio component so we can override the default color to use primary
 * @param {object} props -  component's props
 * @returns {Node} A Radio component
 * @constructor
 */
var Radio = function Radio(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_Radio__WEBPACK_IMPORTED_MODULE_1___default.a, _extends({ color: 'primary' }, props));
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__["withStyles"])(styles)(Radio));
// For test


/***/ }),

/***/ "./src/Input/radio.spec-helper.js":
/*!****************************************!*\
  !*** ./src/Input/radio.spec-helper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RadioButtons = function () {
  function RadioButtons(wrapper, id) {
    _classCallCheck(this, RadioButtons);

    this.wrapper = wrapper;
    this.id = id;
    this.el = this.wrapper.find(id);
    this.type = 'RadioButtons';
  }

  _createClass(RadioButtons, [{
    key: 'select',
    value: function select(index) {
      var input = this.el.find('div[role="radiogroup"] label').at(index).find('input');
      var val = this.el.find('div[role="radiogroup"] label').at(index).find('input').props().value;
      var event = { target: { checked: true, value: val } };

      input.simulate('change', event);
    }
  }, {
    key: 'value',
    value: function value() {
      var result = void 0;
      this.el.find('div[role="radiogroup"] label').forEach(function (element) {
        var input = element.find('input');
        if (input.props().checked) {
          result = input.props().value;
        }
      });

      return result || '';
    }
  }, {
    key: 'labels',
    value: function labels() {
      return this.el.find('div[role="radiogroup"] label').map(function (element) {
        return element.text();
      });
    }
  }, {
    key: 'visible',
    value: function visible() {
      return this.el.length > 0;
    }
  }]);

  return RadioButtons;
}();

/* harmony default export */ __webpack_exports__["default"] = (RadioButtons);

/***/ }),

/***/ "./src/Input/radioButtons.jsx":
/*!************************************!*\
  !*** ./src/Input/radioButtons.jsx ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_RadioGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/RadioGroup */ "@material-ui/core/RadioGroup");
/* harmony import */ var _material_ui_core_RadioGroup__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_RadioGroup__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/FormControl */ "@material-ui/core/FormControl");
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/InputLabel */ "@material-ui/core/InputLabel");
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/FormHelperText */ "@material-ui/core/FormHelperText");
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _radio__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./radio */ "./src/Input/radio.jsx");
/* harmony import */ var _FormControlLabel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../FormControlLabel */ "./src/FormControlLabel/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./styles.scss */ "./src/Input/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _newid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./newid */ "./src/Input/newid.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var FormControl = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__["withStyles"])({ root: { marginTop: 4 } })(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3___default.a);

// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var RadioButtons = function (_React$PureComponent) {
  _inherits(RadioButtons, _React$PureComponent);

  function RadioButtons(props) {
    _classCallCheck(this, RadioButtons);

    var _this = _possibleConstructorReturn(this, (RadioButtons.__proto__ || Object.getPrototypeOf(RadioButtons)).call(this, props));

    _this.getTestAttributes = function () {
      return {
        'data-cy': _this.props['data-cy'] || _this.props.label,
        'data-component': 'RadioButtons'
      };
    };

    _this.handleChange = function (e, value) {
      _this.setState({ value: value });

      if (_this.props.onChange) _this.props.onChange(e);
    };

    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(RadioButtons, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value || nextProps.value === '') {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: 'getLabel',
    value: function getLabel() {
      if (this.props.required) {
        return this.props.label + '*';
      }
      return this.props.label;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props = this.props,
          error = _props.error,
          id = _props.id,
          hideHelperText = _props.hideHelperText,
          helperText = _props.helperText,
          horizontal = _props.horizontal,
          multiLineLabel = _props.multiLineLabel,
          ariaLabel = _props.ariaLabel,
          groupName = _props.groupName,
          fullWidth = _props.fullWidth,
          className = _props.className,
          disableLabelTop = _props.disableLabelTop,
          noMargin = _props.noMargin;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        FormControl,
        _extends({
          id: id,
          fullWidth: fullWidth,
          value: this.state.value,
          margin: 'none',
          className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.radioControl, className, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.noMargin, noMargin))
        }, this.getTestAttributes()),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_4___default.a,
          { error: error, htmlFor: id, shrink: true },
          this.getLabel()
        ),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_RadioGroup__WEBPACK_IMPORTED_MODULE_2___default.a,
          {
            'aria-label': ariaLabel,
            name: groupName,
            value: this.state.value,
            onChange: this.handleChange,
            className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.group, (_classNames2 = {}, _defineProperty(_classNames2, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.disableLabelTop, disableLabelTop), _defineProperty(_classNames2, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.horizontal, horizontal), _defineProperty(_classNames2, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.multiLineLabel, multiLineLabel), _classNames2))
          },
          this.content
        ),
        !hideHelperText && helperText && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_5___default.a,
          { error: error, classes: { root: _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.helperText } },
          helperText
        )
      );
    }
  }, {
    key: 'content',
    get: function get() {
      var _props2 = this.props,
          data = _props2.data,
          disabled = _props2.disabled,
          children = _props2.children;

      if (data) {
        return data.map(function (row) {
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_FormControlLabel__WEBPACK_IMPORTED_MODULE_9__["default"], {
            className: 'radio-option' // allow tests to select labels
            , value: row.value,
            control: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_radio__WEBPACK_IMPORTED_MODULE_8__["default"], null),
            label: row.label,
            disabled: disabled || row.disabled,
            key: row.value
          });
        });
      }
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.map(children, function (child) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.cloneElement(child, {
          key: child.props.value,
          disabled: disabled || child.props.disabled
        });
      });
    }
  }]);

  return RadioButtons;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

RadioButtons.propTypes = {
  /** Currently selected value */
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** (optional) Array of data items each item must have `label` and `value`,
     optionally include `disabled` */
  data: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
    value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
  })),
  /** (optional) child elements, e.g.
     <FormControlLabel value="male" control={<Radio />} label="Male" /> */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** Horizontal layout mode toggle */
  horizontal: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Allow label text to wrap into multiple lines */
  multiLineLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Unique string added to each radio input */
  // eslint-disable-next-line react/no-typos
  groupName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
  /** Describe the group, used for screen readers */
  ariaLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Called when the value is changed */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Disable all radio buttons (overrides individual settings) */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Adds * to form label */
  required: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Unique ID (optional) */
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Is the component in an error state */
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Helper text below the input */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Hide the helperText / error text */
  hideHelperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Form label to show above Radio buttons */
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Class applied to the root element */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Decide whether or not to use full container width */
  fullWidth: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** if set to true, top set to label > span will be reset to unset,
   * this is to allow customize gap above for non-form usage */
  disableLabelTop: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** No margins to input container */
  noMargin: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  'data-cy': prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

RadioButtons.defaultProps = {
  className: undefined,
  value: undefined,
  data: undefined,
  children: null,
  horizontal: true, // most of our radio buttons are horizontal, default to true
  multiLineLabel: false,
  ariaLabel: undefined,
  onChange: undefined,
  disabled: false,
  required: false,
  id: Object(_newid__WEBPACK_IMPORTED_MODULE_11__["default"])(),
  error: false,
  helperText: '',
  hideHelperText: false,
  label: undefined,
  fullWidth: true,
  disableLabelTop: false,
  noMargin: false,
  'data-cy': undefined
};

/* harmony default export */ __webpack_exports__["default"] = (RadioButtons);

/***/ }),

/***/ "./src/Input/select.jsx":
/*!******************************!*\
  !*** ./src/Input/select.jsx ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var memoize_one__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! memoize-one */ "memoize-one");
/* harmony import */ var memoize_one__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(memoize_one__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/Input */ "@material-ui/core/Input");
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/InputLabel */ "@material-ui/core/InputLabel");
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_Select__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/Select */ "@material-ui/core/Select");
/* harmony import */ var _material_ui_core_Select__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Select__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/core/MenuItem */ "@material-ui/core/MenuItem");
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @material-ui/core/FormControl */ "@material-ui/core/FormControl");
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @material-ui/core/FormHelperText */ "@material-ui/core/FormHelperText");
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./styles.scss */ "./src/Input/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _newid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./newid */ "./src/Input/newid.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var MENU_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'left'
};
var KEYBOARD_INPUT_TIMEOUT = 800;

// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var Select = function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.getTestAttributes = function () {
      return {
        'data-cy': _this.props['data-cy'] || _this.props.label,
        'data-component': 'Select'
      };
    };

    _this.isValueDisabled = memoize_one__WEBPACK_IMPORTED_MODULE_3___default()(function (data, value) {
      return !!data.find(function (i) {
        return i.value === value && i.disabled;
      });
    });

    _this.handleBlur = function (event) {
      event.persist();
      // the event target in this instance is incorrect, so we need to set the value
      // so objects further up the chain can read the value correctly.
      // eslint-disable-next-line no-param-reassign
      event.target.value = _this.state.value;
      setTimeout(function () {
        if (_this.props.onBlur) {
          _this.props.onBlur(event);
        }
      }, 1);
    };

    _this.handleChange = function (name) {
      return function (event) {
        _this.setState(_defineProperty({}, name, event.target.value));
        if (_this.props.onChange) {
          _this.props.onChange(event);
        }
      };
    };

    _this.handleKeyPress = function (event) {
      // We have to use keyPress here, because the SelectInput uses keyDown with a preventDefault
      // keyPress returns ASCII codes, so find the key that was pressed
      var keyChar = String.fromCharCode(event.which); // e.g. "a"
      if (!keyChar) return; // non-typeable character e.g. Enter
      var newKeyboardInput = _this.state.keyboardInput + keyChar.toLowerCase();

      var bestMatch = _this.props.data.find(function (item) {
        return item.name.toLowerCase().startsWith(newKeyboardInput);
      });

      if (bestMatch) {
        _this.setState({
          keyboardInput: newKeyboardInput,
          value: bestMatch.value
        });

        if (_this.props.onChange) {
          _this.props.onChange({ target: { value: bestMatch.value } });
        }
      }
      // NB: if they overtype, don't reset the input (e.g. "Male" matches, "Maleee" shouldn't clear the selected value)
      // this mirrors native implementations

      if (_this.keyboardTimeout) clearTimeout(_this.keyboardTimeout);
      _this.keyboardTimeout = setTimeout(_this.clearKeyboardInput, KEYBOARD_INPUT_TIMEOUT);
    };

    _this.clearKeyboardInput = function () {
      _this.setState({ keyboardInput: '' });
    };

    _this.renderOptionsFooter = function () {
      var OptionsFooter = _this.props.OptionsFooter;

      return OptionsFooter ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        null,
        OptionsFooter
      ) : null;
    };

    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.state = {
      value: _this.initialValue(),
      keyboardInput: ''
    };
    _this.keyboardTimeout = null;
    return _this;
  }

  _createClass(Select, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ value: nextProps.value });
    }
  }, {
    key: 'getLabel',


    /** Generates the label */
    value: function getLabel() {
      if (this.props.required) {
        return this.props.label + '*';
      }
      return this.props.label;
    }
  }, {
    key: 'initialValue',
    value: function initialValue() {
      if (this.props.value) {
        return this.props.value;
      }
      if (this.props.hideEmpty && this.props.required && this.props.data.length === 1) {
        if (this.props.onChange) {
          this.props.onChange({ target: { value: this.props.data[0].value, isInitialValue: true } });
        }
        return this.props.data[0].value;
      }
      return '';
    }

    /**
     * Detect keyPresses on the input and try to select a value based on the typedString
     */

  }, {
    key: 'itemWalker',


    /**
    * Offers up callbacks at the group and item level.
    * @param {function} groupCallback called for each group
    * @param {function} itemCallback called for each item
    */
    value: function itemWalker(groupCallback, itemCallback) {
      var _props = this.props,
          data = _props.data,
          groups = _props.groups;


      if (groups.length) {
        groups.forEach(function (group) {
          groupCallback(group);
          return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["filter"])(data, {
            group: group.id
          }).forEach(function (el) {
            return itemCallback(el);
          });
        });
        return;
      }
      data.forEach(function (item) {
        return itemCallback(item);
      });
    }

    /**
    * Returns the elements to display in the dropdown menu
    * @param {array} props.data Dropdown choices
    * @param {boolean} props.native Implement native dropdown
    * @returns {array} Menu Items
    */

  }, {
    key: 'renderListMenuItems',
    value: function renderListMenuItems() {
      var _this2 = this;

      var _props2 = this.props,
          native = _props2.native,
          includesDeleted = _props2.includesDeleted;

      var items = [];
      if (native) {
        this.itemWalker(function (group) {
          return items.push(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'option',
            { disabled: true, key: group.id },
            group.label
          ));
        }, function (item) {
          if (includesDeleted && item.deleted && item.value !== _this2.state.value) return;
          return items.push(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'option',
            {
              disabled: item.disabled || includesDeleted && item.deleted,
              key: item.value,
              value: item.value
            },
            item.name
          ));
        });
      } else {
        this.itemWalker(function (group) {
          return items.push(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7___default.a,
            { disabled: true, key: group.id },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              'i',
              null,
              group.label
            )
          ));
        }, function (item) {
          if (includesDeleted && item.deleted && item.value !== _this2.state.value) return;
          return items.push(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7___default.a,
            {
              disabled: item.disabled || includesDeleted && item.deleted,
              key: item.value,
              value: item.value
            },
            item.name
          ));
        });
      }
      return items;
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props3 = this.props,
          native = _props3.native,
          required = _props3.required,
          hideEmpty = _props3.hideEmpty,
          id = _props3.id,
          error = _props3.error,
          name = _props3.name,
          disableUnderline = _props3.disableUnderline,
          data = _props3.data,
          className = _props3.className,
          classes = _props3.classes;
      var value = this.state.value;


      var valueIsDisabled = this.isValueDisabled(data, value);
      var selectedValue = this.props.value || value;
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Select__WEBPACK_IMPORTED_MODULE_6___default.a,
        {
          MenuProps: {
            'data-cy': 'Select-Menu',
            'data-component': 'Menu',
            anchorOrigin: MENU_ORIGIN,
            getContentAnchorEl: undefined,
            classes: {
              paper: _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.selectPaper
            }
          },
          value: selectedValue || '',
          onChange: this.handleChange('value'),
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.input, classes.selectRoot, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.valueIsDisabled, valueIsDisabled), className),
          name: name,
          input: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_4___default.a, {
            id: id,
            onChange: this.handleChange('value'),
            margin: 'none',
            value: selectedValue || '',
            required: required,
            error: error,
            onBlur: this.handleBlur,
            disableUnderline: disableUnderline,
            onKeyPress: this.handleKeyPress,
            'data-cy': 'Input'
          }),
          autoWidth: true,
          native: native,
          classes: { select: _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.select, root: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.selectRoot, classes.inputRoot) }
        },
        !native && !hideEmpty && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7___default.a,
          { value: '' },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'em',
            null,
            'None'
          )
        ),
        native && !hideEmpty && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('option', { value: '' }),
        this.renderListMenuItems(),
        this.renderOptionsFooter()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames2;

      var _props4 = this.props,
          disabled = _props4.disabled,
          error = _props4.error,
          id = _props4.id,
          notInForm = _props4.notInForm,
          helperText = _props4.helperText,
          noMargin = _props4.noMargin,
          classes = _props4.classes,
          dynamicLabel = _props4.dynamicLabel,
          formControlProps = _props4.formControlProps;


      var allFormControlProps = _extends({
        margin: 'none',
        fullWidth: true,
        disabled: disabled,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.reset, classes.root, (_classnames2 = {}, _defineProperty(_classnames2, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.noMargin, noMargin), _defineProperty(_classnames2, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.container, !notInForm), _classnames2))
      }, this.getTestAttributes(), formControlProps || {});

      if (notInForm) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_8___default.a,
          allFormControlProps,
          this.renderInput()
        );
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { id: id + '-container', autoComplete: 'off', className: _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.selectContainer },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_8___default.a,
          allFormControlProps,
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_5___default.a,
            {
              error: error,
              shrink: dynamicLabel ? undefined : true,
              htmlFor: id,
              className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.label, classes.label, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.allowShrink, !!dynamicLabel)),
              classes: { shrink: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.shrink, classes.labelShrink) }
            },
            this.getLabel()
          ),
          this.renderInput(),
          helperText && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_9___default.a,
            { error: !!error, classes: { root: _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.helperText } },
            helperText
          )
        )
      );
    }
  }]);

  return Select;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

Select.propTypes = {
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  error: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
  /** Data to generate dropdown options from */
  data: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.shape({
    /** Display name */
    name: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.node]).isRequired,

    /** Value saved */
    value: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.number]).isRequired
  })).isRequired,
  /** Use the native select */
  native: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  // eslint-disable-next-line react/no-typos
  label: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string.isRequired,
  id: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.func,
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.func,
  includesDeleted: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  /** do not display an empty state for the select */
  hideEmpty: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  value: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
  required: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  groups: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.shape({
    id: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.number]).isRequired,
    label: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string.isRequired
  })),
  /** Set notInForm to true if not using the input in form, label and error will not be displayed */
  notInForm: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  name: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
  disableUnderline: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  /** No margin applied to the component */
  noMargin: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  /**
   * Optional footer to be appended to the list of options
  */
  OptionsFooter: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.shape({
    // motif custom classes
    root: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string, // root level FormControl
    inputRoot: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string, // clases.root on MuiSelect
    selectRoot: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string, // className on MuiSelect
    label: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string, // className on InputLabel
    labelShrink: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string // classes.shrink on InputLabel
  }),
  /** Dynamic labels act as placeholders, then shrink on focus */
  dynamicLabel: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
  'data-cy': prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
  formControlProps: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.shape({})
};

Select.defaultProps = {
  disabled: false,
  error: false,
  helperText: undefined,
  value: '',
  includesDeleted: false,
  required: false,
  native: false,
  hideEmpty: false,
  onChange: undefined,
  onBlur: undefined,
  id: Object(_newid__WEBPACK_IMPORTED_MODULE_12__["default"])(),
  groups: [],
  notInForm: false,
  name: '',
  disableUnderline: false,
  noMargin: false,
  OptionsFooter: undefined,
  className: '',
  classes: {},
  dynamicLabel: false,
  'data-cy': undefined,
  formControlProps: {}
};

/* harmony default export */ __webpack_exports__["default"] = (Select);

/***/ }),

/***/ "./src/Input/select.spec-helper.js":
/*!*****************************************!*\
  !*** ./src/Input/select.spec-helper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_event__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../helpers/event */ "./helpers/event.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils */ "./src/Input/utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Select = function () {
  function Select(wrapper, id) {
    _classCallCheck(this, Select);

    this.wrapper = wrapper;
    this.id = id;
    this.el = this.wrapper.find(id);
    this.type = 'Select';
  }

  _createClass(Select, [{
    key: 'value',
    value: function value() {
      return this.el.find('input[type="hidden"]').props().value;
    }
  }, {
    key: 'displayText',
    value: function displayText() {
      return this.el.find('div[role="button"]').text();
    }
  }, {
    key: 'visible',
    value: function visible() {
      return this.el.length > 0;
    }
  }, {
    key: 'disabled',
    value: function disabled() {
      return this.el.find('SelectInput').prop('disabled');
    }
  }, {
    key: 'openMenu',
    value: function openMenu() {
      this.el.find('div[role="button"]').simulate('click');
    }
  }, {
    key: 'options',
    value: function options() {
      this.openMenu();
      var els = this.wrapper.find(this.id).find('[className*="MuiMenu-"] ul li');
      var result = els.map(function (el) {
        return el.text();
      });
      this.closeMenu();
      return result;
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu() {
      // eslint-disable-line class-methods-use-this
      var el = document.querySelectorAll('[class*="MuiMenu-"]')[0];
      if (el) {
        el.parentNode.removeChild(el);
      }
    }
  }, {
    key: 'select',
    value: function select(index) {
      this.openMenu();
      this.wrapper.update();
      var menuItems = document.querySelectorAll('[class*="MuiMenu-"] ul li');
      Object(_helpers_event__WEBPACK_IMPORTED_MODULE_0__["triggerClick"])(menuItems[index]);
      this.wrapper.update();
    }
  }, {
    key: 'typeChar',
    value: function typeChar(char) {
      this.el.find('div[className*="MuiInput-root-"]').simulate('keyPress', { which: _utils__WEBPACK_IMPORTED_MODULE_1__["asciiCodes"][char] });
      this.wrapper.update();
    }
  }]);

  return Select;
}();

/* harmony default export */ __webpack_exports__["default"] = (Select);

/***/ }),

/***/ "./src/Input/styles.scss":
/*!*******************************!*\
  !*** ./src/Input/styles.scss ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Input/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Input/utils.js":
/*!****************************!*\
  !*** ./src/Input/utils.js ***!
  \****************************/
/*! exports provided: applyCharWhitelist, isEmptyNode, adjustCursorPosition, asciiCodes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyCharWhitelist", function() { return applyCharWhitelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmptyNode", function() { return isEmptyNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adjustCursorPosition", function() { return adjustCursorPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asciiCodes", function() { return asciiCodes; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);


// Strip out any chars which are not in the allowed chars list.
var applyCharWhitelist = function applyCharWhitelist(input, allowedChars) {
  var allowedCharsArray = allowedChars.constructor === String ? allowedChars.split('') : allowedChars;

  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["filter"])(input.split(''), function (item) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["includes"])(allowedCharsArray, item);
  }).join('');
};

var calculateNewCaretPosition = function calculateNewCaretPosition(value, mask) {
  var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (!value || !mask) {
    return pos;
  }
  var newPos = pos;
  for (var i = 0; i < pos; i += 1) {
    var m = mask[i];
    var v = value[i];
    if (m instanceof RegExp && !m.test(v)) {
      newPos = i;
      break;
    }
  }
  return newPos;
};

/** Check if a node instance is empty */
var isEmptyNode = function isEmptyNode(node) {
  return !node || Array.isArray(node) && node.length === 0;
};

/**
 * When user click into an input, we want to automatically set the cursor to the next mask place needs input
 * Unfortunately unlike angular ui-mask, mask-text (the one we use in React) doesn't support auto adjust caret position yet (as in 5.2.0)
 * - if user tab into the input the browser will select all the text, in this case do nothing
 * - if user clicked into place before the next masked place, e.g. user want to correct an error, in this case do nothing
 * - note this feature is not working in all browsers, for detail check https://caniuse.com/#search=selectionStart
 * @param {*} inputElement
 * @param {*} mask
 */
var adjustCursorPosition = function adjustCursorPosition(inputElement, // Expecting an <input> element, or custom object
mask, forcePosition) {
  if (!inputElement) {
    return;
  }
  if (!inputElement.setSelectionRange || inputElement.type === 'number' || inputElement.type === 'email') {
    return;
  } // not supported
  if (!mask) {
    return;
  } // no mask
  var start = forcePosition || inputElement.selectionStart || 0;
  var end = forcePosition || inputElement.selectionEnd || 0;
  if (start !== end) {
    return;
  } // has selection range
  var value = inputElement.value || '';

  var newPos = calculateNewCaretPosition(value, mask, start);
  inputElement.focus();
  inputElement.setSelectionRange(newPos, newPos);
};

// ASCII key codes are different from Unicode
// keyPress events return ASCII codes
// full list available here: https://github.com/edsilv/key-codes/blob/master/src/KeyCodes.ts#L112
var asciiCodes = {
  ENTER: 13,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ESC: 27,
  TAB: 9,
  BACKSPACE: 8,
  DELETE: 46,
  zero: 48,
  one: 49,
  two: 50,
  three: 51,
  four: 52,
  five: 53,
  six: 54,
  seven: 55,
  eight: 56,
  nine: 57,
  a: 97,
  b: 98,
  c: 99,
  d: 100,
  e: 101,
  f: 102,
  g: 103,
  h: 104,
  i: 105,
  j: 106,
  k: 107,
  l: 108,
  m: 109,
  n: 110,
  o: 111,
  p: 112,
  q: 113,
  r: 114,
  s: 115,
  t: 116,
  u: 117,
  v: 118,
  w: 119,
  x: 120,
  y: 121,
  z: 122,
  spacebar: 32
};

/***/ }),

/***/ "./src/Input/withCheckedAsValue.jsx":
/*!******************************************!*\
  !*** ./src/Input/withCheckedAsValue.jsx ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var recompose_getDisplayName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! recompose/getDisplayName */ "recompose/getDisplayName");
/* harmony import */ var recompose_getDisplayName__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(recompose_getDisplayName__WEBPACK_IMPORTED_MODULE_2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var withCheckedAsValue = function withCheckedAsValue(Component) {
  var WithCheckedAsValue = function (_React$PureComponent) {
    _inherits(WithCheckedAsValue, _React$PureComponent);

    function WithCheckedAsValue() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WithCheckedAsValue);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithCheckedAsValue.__proto__ || Object.getPrototypeOf(WithCheckedAsValue)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
        if (_this.props.onChange) {
          _this.props.onChange(_extends({}, e, {
            target: {
              checked: e.target.checked,
              value: e.target.checked
            }
          }));
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WithCheckedAsValue, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            value = _props.value,
            _props$error = _props.error,
            error = _props$error === undefined ? false : _props$error,
            _props$warning = _props.warning,
            warning = _props$warning === undefined ? false : _props$warning,
            helperText = _props.helperText,
            other = _objectWithoutProperties(_props, ['value', 'error', 'warning', 'helperText']);

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({}, other, { error: error.toString(), warning: warning.toString(), onChange: this.handleChange, checked: value }));
      }
    }]);

    return WithCheckedAsValue;
  }(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

  WithCheckedAsValue.propTypes = {
    onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
    value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
    error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, // other components accept this, but not Checkbox and other `checked`-based components. We need to convert to string
    prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
    warning: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, // other components accept this, but not Checkbox and other `checked`-based components. We need to convert to string
    prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
    helperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
  };

  WithCheckedAsValue.defaultProps = {
    onChange: null,
    value: false,
    error: 'false',
    warning: 'false',
    helperText: ''
  };
  WithCheckedAsValue.displayName = recompose_getDisplayName__WEBPACK_IMPORTED_MODULE_2___default()(Component);
  return WithCheckedAsValue;
};

/* harmony default export */ __webpack_exports__["default"] = (withCheckedAsValue);

/***/ }),

/***/ "./src/KeyboardNavigation/component.jsx":
/*!**********************************************!*\
  !*** ./src/KeyboardNavigation/component.jsx ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Input_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Input/utils */ "./src/Input/utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var KeyboardNavigation = function (_React$PureComponent) {
  _inherits(KeyboardNavigation, _React$PureComponent);

  function KeyboardNavigation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, KeyboardNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KeyboardNavigation.__proto__ || Object.getPrototypeOf(KeyboardNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.getCurrentIndex = function () {
      var _this$props = _this.props,
          highlightedIndex = _this$props.highlightedIndex,
          scrollToIndex = _this$props.scrollToIndex;

      if (scrollToIndex < 0) return highlightedIndex;
      return highlightedIndex >= 0 ? highlightedIndex : scrollToIndex;
    }, _this.handleKeyDown = function (event) {
      var _this$props2 = _this.props,
          highlightedIndex = _this$props2.highlightedIndex,
          items = _this$props2.items,
          isItemDisabled = _this$props2.isItemDisabled,
          onHighlight = _this$props2.onHighlight,
          onSelect = _this$props2.onSelect,
          allowSelect = _this$props2.allowSelect,
          onClose = _this$props2.onClose,
          closeWhenTab = _this$props2.closeWhenTab;

      var newIndex = void 0;

      var currentIndex = _this.getCurrentIndex();

      switch (event.keyCode) {
        case _Input_utils__WEBPACK_IMPORTED_MODULE_2__["asciiCodes"].DOWN:
          newIndex = currentIndex + 1 < items.length ? currentIndex + 1 : 0;
          onHighlight(newIndex >= 0 ? items[newIndex] : undefined, newIndex);
          event.preventDefault();
          event.stopPropagation();
          break;
        case _Input_utils__WEBPACK_IMPORTED_MODULE_2__["asciiCodes"].UP:
          newIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : items.length - 1;
          onHighlight(newIndex >= 0 ? items[newIndex] : undefined, newIndex);
          event.preventDefault();
          event.stopPropagation();
          break;
        case _Input_utils__WEBPACK_IMPORTED_MODULE_2__["asciiCodes"].ENTER:
          if (allowSelect) {
            var item = items[highlightedIndex];
            if (item) {
              var disabled = isItemDisabled && isItemDisabled(item, highlightedIndex);
              if (!disabled) onSelect(item, highlightedIndex);
            }
            event.preventDefault();
            event.stopPropagation();
          }
          break;
        case _Input_utils__WEBPACK_IMPORTED_MODULE_2__["asciiCodes"].TAB:
          if (closeWhenTab) onClose();
          break;
        case _Input_utils__WEBPACK_IMPORTED_MODULE_2__["asciiCodes"].ESC:
          onClose();
          break;
        default:
      }
      if (_this.onKeyDown) {
        _this.onKeyDown(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(KeyboardNavigation, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var element = react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.only(children);
      this.onKeyDown = element.props.onKeyDown;
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.cloneElement(element, { onKeyDown: this.handleKeyDown });
    }
  }]);

  return KeyboardNavigation;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

KeyboardNavigation.propTypes = {
  items: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.any).isRequired,
  /** Function that returns true if item is disabled, false otherwise.
    * If undefined, all items are enabled.
    */
  isItemDisabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * Up/down keypress will navigate up/down relative to
   * currently highlighted index
   */
  highlightedIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** Index displayed on render
   * up/down keypress will navigate up/down relative to scrollToIndex
   * if no highlightedIndex.
   */
  scrollToIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  allowSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool.isRequired,
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  onHighlight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,
  closeWhenTab: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};

KeyboardNavigation.defaultProps = {
  isItemDisabled: undefined,
  highlightedIndex: -1,
  scrollToIndex: -1,
  closeWhenTab: false
};

/* harmony default export */ __webpack_exports__["default"] = (KeyboardNavigation);

/***/ }),

/***/ "./src/KeyboardNavigation/index.js":
/*!*****************************************!*\
  !*** ./src/KeyboardNavigation/index.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/KeyboardNavigation/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),

/***/ "./src/ListItem/component.jsx":
/*!************************************!*\
  !*** ./src/ListItem/component.jsx ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material-ui/core/ListItem */ "@material-ui/core/ListItem");
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__);




var styles = function styles(theme) {
  return {
    root: {
      'padding-bottom': theme.spacing.unit * 1.5,
      'padding-left': theme.spacing.unit * 3,
      'padding-right': theme.spacing.unit * 3,
      'padding-top': theme.spacing.unit * 1.5
    },
    button: {
      '&:hover': {
        'background-color': 'rgba(0, 0, 0, 0.14)'
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__["withStyles"])(styles)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_0___default.a));

/***/ }),

/***/ "./src/ListItem/index.js":
/*!*******************************!*\
  !*** ./src/ListItem/index.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/ListItem/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/ListItemPrimaryText/index.jsx":
/*!*******************************************!*\
  !*** ./src/ListItemPrimaryText/index.jsx ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./index.scss */ "./src/ListItemPrimaryText/index.scss");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_3__);





var ListItemPrimaryText = function ListItemPrimaryText(_ref) {
  var title = _ref.title,
      text = _ref.text,
      dataCy = _ref.dataCy;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    { className: _index_scss__WEBPACK_IMPORTED_MODULE_3___default.a.root, 'data-cy': dataCy },
    title && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Typography__WEBPACK_IMPORTED_MODULE_2__["default"],
      { variant: 'subtitle1', className: _index_scss__WEBPACK_IMPORTED_MODULE_3___default.a.title },
      title
    ),
    text && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Typography__WEBPACK_IMPORTED_MODULE_2__["default"],
      { variant: 'body1', className: _index_scss__WEBPACK_IMPORTED_MODULE_3___default.a.text },
      text
    )
  );
};

ListItemPrimaryText.propTypes = {
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  text: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  dataCy: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
ListItemPrimaryText.defaultProps = {
  title: undefined,
  text: undefined,
  dataCy: 'list_item_primary_text'
};
/* harmony default export */ __webpack_exports__["default"] = (ListItemPrimaryText);

/***/ }),

/***/ "./src/ListItemPrimaryText/index.scss":
/*!********************************************!*\
  !*** ./src/ListItemPrimaryText/index.scss ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./index.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ListItemPrimaryText/index.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/ListItemText/index.jsx":
/*!************************************!*\
  !*** ./src/ListItemText/index.jsx ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/ListItemText */ "@material-ui/core/ListItemText");
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./index.scss */ "./src/ListItemText/index.scss");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var ListItemText = function ListItemText(_ref) {
  var className = _ref.className,
      other = _objectWithoutProperties(_ref, ['className']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_1___default.a, _extends({
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_index_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, _index_scss__WEBPACK_IMPORTED_MODULE_4___default.a.text, className)
  }, other));
};
ListItemText.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};
ListItemText.defaultProps = {
  className: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (ListItemText);

/***/ }),

/***/ "./src/ListItemText/index.scss":
/*!*************************************!*\
  !*** ./src/ListItemText/index.scss ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./index.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/ListItemText/index.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/LoadingState/component.jsx":
/*!****************************************!*\
  !*** ./src/LoadingState/component.jsx ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/CircularProgress */ "@material-ui/core/CircularProgress");
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! .. */ "./src/index.js");






var LoadingState = function LoadingState(props) {
  if (props.error) {
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(___WEBPACK_IMPORTED_MODULE_4__["layout"].flexColumnContainer, ___WEBPACK_IMPORTED_MODULE_4__["layout"].flexGrow, ___WEBPACK_IMPORTED_MODULE_4__["layout"].centerContent) },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'p',
        null,
        'Failed to load page :('
      )
    );
  }

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    { className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(___WEBPACK_IMPORTED_MODULE_4__["layout"].flexColumnContainer, ___WEBPACK_IMPORTED_MODULE_4__["layout"].flexGrow, ___WEBPACK_IMPORTED_MODULE_4__["layout"].centerContent) },
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_2___default.a, null)
  );
};

LoadingState.propTypes = {
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Error)])
};

LoadingState.defaultProps = {
  error: null
};

/* harmony default export */ __webpack_exports__["default"] = (LoadingState);

/***/ }),

/***/ "./src/LoadingState/index.js":
/*!***********************************!*\
  !*** ./src/LoadingState/index.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/LoadingState/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/NakedDatePicker/component.jsx":
/*!*******************************************!*\
  !*** ./src/NakedDatePicker/component.jsx ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-moment-proptypes */ "react-moment-proptypes");
/* harmony import */ var react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "moment");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_calendar_dist_entry_nostyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react-calendar/dist/entry.nostyle */ "react-calendar/dist/entry.nostyle");
/* harmony import */ var react_calendar_dist_entry_nostyle__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_calendar_dist_entry_nostyle__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_icons_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/icons/KeyboardArrowLeft */ "@material-ui/icons/KeyboardArrowLeft");
/* harmony import */ var _material_ui_icons_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_icons_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/icons/KeyboardArrowRight */ "@material-ui/icons/KeyboardArrowRight");
/* harmony import */ var _material_ui_icons_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _helpers_date__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../helpers/date */ "./helpers/date.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./styles.scss */ "./src/NakedDatePicker/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_11__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















/**
 * NakedDatePicker is similar to DatePicker, but rendered directly in the page instead of as a field with a popover.
 */

var generateYears = function generateYears(minYear, maxYear) {
  var arr = [];
  for (var i = minYear; i <= maxYear; i += 1) {
    arr.push({ name: i.toString(), value: i.toString() });
  }
  return arr;
};

var getNewState = function getNewState(startingDate) {
  return {
    activeStartDate: startingDate.clone().startOf('month'), // If it errors at this point, check props.startSelectedDate is a moment object.
    currentMonth: startingDate.month(),
    currentYear: startingDate.year()
  };
};

var today = function today() {
  return moment__WEBPACK_IMPORTED_MODULE_3___default()().startOf('day');
};

var NakedDatePicker = function (_React$PureComponent) {
  _inherits(NakedDatePicker, _React$PureComponent);

  function NakedDatePicker(props) {
    _classCallCheck(this, NakedDatePicker);

    var _this = _possibleConstructorReturn(this, (NakedDatePicker.__proto__ || Object.getPrototypeOf(NakedDatePicker)).call(this, props));

    _this.selectMonth = function (newMonth, callback) {
      _this.setState({
        activeStartDate: _this.state.activeStartDate.clone().month(newMonth),
        currentMonth: newMonth,
        activeStartDateChanged: true // eslint-disable-line react/no-unused-state
      }, callback);
    };

    _this.selectYear = function (newYear, callback) {
      _this.setState({
        activeStartDate: _this.state.activeStartDate.clone().year(newYear),
        currentYear: newYear,
        activeStartDateChanged: true // eslint-disable-line react/no-unused-state
      }, callback);
    };

    _this.prevMonth = function () {
      var m = _this.state.currentMonth - 1;
      if (m < 0) {
        _this.selectYear(_this.state.currentYear - 1, function () {
          _this.selectMonth(11);
        });
        return;
      }
      _this.selectMonth(m);
    };

    _this.nextMonth = function () {
      var m = _this.state.currentMonth + 1;
      if (m > 11) {
        _this.selectYear(_this.state.currentYear + 1, function () {
          _this.selectMonth(0);
        });
        return;
      }
      _this.selectMonth(m);
    };

    _this.handleSelectDate = function (date) {
      var dateMoment = Object(_utils__WEBPACK_IMPORTED_MODULE_10__["convertDateToMoment"])(date);
      if (_this.props.disableSelectedDates && _this.isSelectedDay(dateMoment)) return;
      _this.setState({
        activeStartDate: dateMoment.clone().startOf('month'),
        currentMonth: dateMoment.month(),
        currentYear: dateMoment.year()
      });
      if (_this.props.onSelectDateMoment) {
        _this.props.onSelectDateMoment(dateMoment);
      }
    };

    _this.handleSelectYear = function (e) {
      _this.selectYear(Number(e.target.value));
    };

    _this.handleSelectMonth = function (e) {
      _this.selectMonth(Number(e.target.value));
    };

    _this.classesForDate = function (_ref) {
      var _ref2;

      var date = _ref.date;

      var dateMoment = Object(_utils__WEBPACK_IMPORTED_MODULE_10__["convertDateToMoment"])(date);
      var isSelected = _this.isSelectedDay(dateMoment);

      return classnames__WEBPACK_IMPORTED_MODULE_4___default.a.apply(undefined, _toConsumableArray(_this.props.dayClassCallback ? _this.props.dayClassCallback({ date: date }) : {}).concat([_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.date, 'basic-datepicker-date', dateMoment.month() === _this.state.currentMonth ? 'basic-datepicker-currentmonth' : _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.notCurrentMonth, (_ref2 = {}, _defineProperty(_ref2, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.selected, isSelected), _defineProperty(_ref2, 'basic-datepicker-selected', isSelected), _defineProperty(_ref2, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.startSelectedDate, _this.props.startSelectedDate.isSame(dateMoment, 'day')), _defineProperty(_ref2, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.endSelectedDate, _this.props.endSelectedDate.isSame(dateMoment, 'day')), _ref2)]));
    };

    _this.isSelectedDay = function (dateMoment) {
      var _this$props = _this.props,
          startSelectedDate = _this$props.startSelectedDate,
          endSelectedDate = _this$props.endSelectedDate;

      return !!startSelectedDate && !!endSelectedDate && !startSelectedDate.isAfter(dateMoment) && !dateMoment.isAfter(endSelectedDate);
    };

    _this.renderDay = function (todayMoment) {
      return function (_ref3) {
        var date = _ref3.date;

        var dateMoment = Object(_utils__WEBPACK_IMPORTED_MODULE_10__["convertDateToMoment"])(date);
        var unclickable = _this.props.disableSelectedDates && _this.isSelectedDay(dateMoment);

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.dateCell, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.unclickable, unclickable)) },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { className: _this.classesForDate({ date: date }) },
            todayMoment.isSame(dateMoment, 'day') ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              'div',
              { className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.today, 'basic-datepicker-today') },
              date.getDate()
            ) : date.getDate()
          )
        );
      };
    };

    _this.state = getNewState(props.startSelectedDate || today());
    return _this;
  }

  _createClass(NakedDatePicker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          minDate = _props.minDate,
          maxDate = _props.maxDate,
          compact = _props.compact,
          disableUnderline = _props.disableUnderline,
          calendarClassName = _props.className,
          reactCalendarProps = _objectWithoutProperties(_props, ['minDate', 'maxDate', 'compact', 'disableUnderline', 'className']);

      var _state = this.state,
          currentMonth = _state.currentMonth,
          currentYear = _state.currentYear,
          activeStartDate = _state.activeStartDate;

      var numberOfLettersInHeading = compact ? 1 : 3;

      var selectProps = {
        tabIndex: -1,
        label: '',
        hideEmpty: true,
        notInForm: true,
        disableUnderline: true,
        formControlProps: {
          fullWidth: false
        }
      };

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.root, compact ? _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.compactWidth : _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.normalWidth) },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.header, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.compact, compact)) },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            ___WEBPACK_IMPORTED_MODULE_8__["IconButton"],
            {
              onClick: this.prevMonth,
              tabIndex: -1,
              className: _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.leftNavigate
            },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_6___default.a, null)
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["Select"], _extends({
            className: 'basic-datepicker-select-month',
            value: currentMonth.toString(),
            data: _helpers_date__WEBPACK_IMPORTED_MODULE_9__["MONTHS"],
            onChange: this.handleSelectMonth
          }, selectProps)),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["Select"], _extends({
            className: 'basic-datepicker-select-year',
            value: currentYear.toString(),
            data: generateYears(minDate.year(), maxDate.year()),
            onChange: this.handleSelectYear
          }, selectProps)),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            ___WEBPACK_IMPORTED_MODULE_8__["IconButton"],
            {
              onClick: this.nextMonth,
              tabIndex: -1,
              className: _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.rightNavigate
            },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_7___default.a, null)
          )
        ),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_calendar_dist_entry_nostyle__WEBPACK_IMPORTED_MODULE_5__["MonthView"], _extends({
          className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(calendarClassName, _styles_scss__WEBPACK_IMPORTED_MODULE_11___default.a.monthView),
          activeStartDate: Object(_utils__WEBPACK_IMPORTED_MODULE_10__["convertMomentToDate"])(activeStartDate),
          calendarType: 'ISO 8601',
          onClick: this.handleSelectDate,
          tileContent: this.renderDay(today()),
          formatShortWeekday: function formatShortWeekday(date) {
            return _helpers_date__WEBPACK_IMPORTED_MODULE_9__["DAYS"][date.getDay()].slice(0, numberOfLettersInHeading);
          },
          minDate: Object(_utils__WEBPACK_IMPORTED_MODULE_10__["convertMomentToDate"])(minDate),
          maxDate: Object(_utils__WEBPACK_IMPORTED_MODULE_10__["convertMomentToDate"])(maxDate),
          showFixedNumberOfWeeks: true
        }, reactCalendarProps))
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      var startingDate = props.startSelectedDate || today();

      // don't get derived state if displayed date, rather than date prop, changed
      if (state.activeStartDateChanged) return _extends({}, state, { activeStartDateChanged: false });

      // don't get derived state if selected month & year did not change
      if (state.activeStartDate && state.activeStartDate.isSame(startingDate, 'month')) return null;

      return getNewState(startingDate);
    }
  }]);

  return NakedDatePicker;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

NakedDatePicker.propTypes = {
  /* First and last selected date
   * If only one date selected, set start and end to the same date */
  startSelectedDate: react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__["momentObj"],
  endSelectedDate: react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__["momentObj"],

  /* max and min selectable dates */
  minDate: react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__["momentObj"],
  maxDate: react_moment_proptypes__WEBPACK_IMPORTED_MODULE_2__["momentObj"],

  /* Function called when a date is selected (pass moment value) */
  onSelectDateMoment: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,

  /* function used to determine class(es) of a particular cell/day */
  dayClassCallback: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,

  /* Compact display option */
  compact: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /* Disables line under date & month selectors */
  disableUnderline: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /* Determines whether selected dates are clickable.
   * Setting to true will prevent select date handler from executing
   * for currently selected date(s).
   */
  disableSelectedDates: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /* class(es) for MonthView component */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

NakedDatePicker.defaultProps = {
  onSelectDateMoment: undefined,
  startSelectedDate: undefined,
  endSelectedDate: undefined,
  maxDate: moment__WEBPACK_IMPORTED_MODULE_3___default()().add(5, 'years').endOf('year'),
  minDate: moment__WEBPACK_IMPORTED_MODULE_3___default()().subtract(5, 'years').startOf('year'),
  dayClassCallback: undefined,
  compact: false,
  disableUnderline: false,
  disableSelectedDates: false,
  className: ''
};

/* harmony default export */ __webpack_exports__["default"] = (NakedDatePicker);

/***/ }),

/***/ "./src/NakedDatePicker/index.js":
/*!**************************************!*\
  !*** ./src/NakedDatePicker/index.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/NakedDatePicker/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/NakedDatePicker/styles.scss":
/*!*****************************************!*\
  !*** ./src/NakedDatePicker/styles.scss ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/NakedDatePicker/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Notice/component.jsx":
/*!**********************************!*\
  !*** ./src/Notice/component.jsx ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.scss */ "./src/Notice/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_4__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Notice = function Notice(_ref) {
  var _classnames;

  var icon = _ref.icon,
      title = _ref.title,
      type = _ref.type,
      size = _ref.size,
      id = _ref.id,
      className = _ref.className;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    {
      id: id,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(type, className, (_classnames = {}, _defineProperty(_classnames, _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, true), _defineProperty(_classnames, _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.smallFont, size === 'small'), _classnames))
    },
    icon,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Typography__WEBPACK_IMPORTED_MODULE_3__["default"],
      {
        variant: 'subtitle1',
        classes: {
          root: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.heading, type)
        }
      },
      title
    )
  );
};

Notice.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /* Notice type: info, warning, or error */
  type: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['info', 'warning', 'error']),
  /* Size: small, normal */
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['small', 'normal']),
  /* Notice main title */
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /* 24px x 24px Icon Node for display on left */
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

Notice.defaultProps = {
  id: undefined,
  type: 'info',
  size: 'normal',
  title: '',
  icon: null,
  className: ''
};

/* harmony default export */ __webpack_exports__["default"] = (Notice);

/***/ }),

/***/ "./src/Notice/index.js":
/*!*****************************!*\
  !*** ./src/Notice/index.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Notice/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Notice/styles.scss":
/*!********************************!*\
  !*** ./src/Notice/styles.scss ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Notice/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/PDFViewer/ButtonBar.jsx":
/*!*************************************!*\
  !*** ./src/PDFViewer/ButtonBar.jsx ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Grid */ "@material-ui/core/Grid");
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/Paper */ "@material-ui/core/Paper");
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_Add__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/icons/Add */ "@material-ui/icons/Add");
/* harmony import */ var _material_ui_icons_Add__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Add__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_icons_Remove__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/icons/Remove */ "@material-ui/icons/Remove");
/* harmony import */ var _material_ui_icons_Remove__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Remove__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_icons_RotateRight__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/icons/RotateRight */ "@material-ui/icons/RotateRight");
/* harmony import */ var _material_ui_icons_RotateRight__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_RotateRight__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./helpers */ "./src/PDFViewer/helpers.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./styles.scss */ "./src/PDFViewer/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_10__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var renderButton = function renderButton(name, Component, onClick) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
    { item: true },
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      ___WEBPACK_IMPORTED_MODULE_8__["IconButton"],
      { onClick: onClick, id: 'pdf-preview-' + name },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, null)
    )
  );
};

var ButtonBar = function ButtonBar(_ref) {
  var pageCount = _ref.pageCount,
      currentPageNum = _ref.currentPageNum,
      onPageNumChange = _ref.onPageNumChange,
      onPageNumBlur = _ref.onPageNumBlur,
      zoomIndex = _ref.zoomIndex,
      onRotate = _ref.onRotate,
      onZoomIn = _ref.onZoomIn,
      onZoomOut = _ref.onZoomOut,
      onZoomSelect = _ref.onZoomSelect,
      isMobile = _ref.isMobile;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_4___default.a,
    {
      elevation: 4,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.paper, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.buttonBar, ___WEBPACK_IMPORTED_MODULE_8__["layout"].flexNone, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.onMobile, isMobile))
    },
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
      { container: true, justify: 'space-between' },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
        { item: true, container: true, xs: 3, spacing: 8, justify: 'flex-start', alignItems: 'center' },
        pageCount ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          react__WEBPACK_IMPORTED_MODULE_0__["Fragment"],
          null,
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
            { item: true, className: _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.pageNumInput },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["Input"], {
              value: currentPageNum,
              onChange: onPageNumChange,
              onBlur: onPageNumBlur,
              noMargin: true,
              notInForm: true
            })
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
            { item: true },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              ___WEBPACK_IMPORTED_MODULE_8__["Typography"],
              { className: _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.totalPageNum },
              'of ' + pageCount
            )
          )
        ) : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('span', null) // need to render something in Grid as it displays a '0' if it has no content

      ),
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
        { item: true, container: true, xs: 9, spacing: 8, justify: 'flex-end', alignItems: 'center' },
        renderButton('rotate', _material_ui_icons_RotateRight__WEBPACK_IMPORTED_MODULE_7___default.a, onRotate),
        renderButton('zoomin', _material_ui_icons_Add__WEBPACK_IMPORTED_MODULE_5___default.a, onZoomIn),
        renderButton('zoomout', _material_ui_icons_Remove__WEBPACK_IMPORTED_MODULE_6___default.a, onZoomOut),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
          { item: true, className: _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.zoomSelect },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["Select"], {
            label: 'Zoom',
            value: '' + zoomIndex,
            onChange: onZoomSelect,
            data: _helpers__WEBPACK_IMPORTED_MODULE_9__["zoomScale"].map(function (zoom, index) {
              return {
                name: zoom * 100 + '%',
                value: '' + index,
                key: 'zoom-' + index
              };
            }).reverse(),
            hideEmpty: true,
            noMargin: true,
            notInForm: true
          })
        )
      )
    )
  );
};

ButtonBar.propTypes = {
  pageCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  currentPageNum: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  onPageNumChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onPageNumBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  zoomIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  onRotate: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onZoomIn: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onZoomOut: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onZoomSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  isMobile: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};

ButtonBar.defaultProps = {
  pageCount: undefined,
  currentPageNum: undefined,
  onPageNumChange: undefined,
  onPageNumBlur: undefined,
  zoomIndex: _helpers__WEBPACK_IMPORTED_MODULE_9__["defaultZoom"],
  onRotate: undefined,
  onZoomIn: undefined,
  onZoomOut: undefined,
  onZoomSelect: undefined,
  isMobile: false
};

/* harmony default export */ __webpack_exports__["default"] = (ButtonBar);

/***/ }),

/***/ "./src/PDFViewer/PDFDocument.jsx":
/*!***************************************!*\
  !*** ./src/PDFViewer/PDFDocument.jsx ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-pdf */ "react-pdf");
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_pdf__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Paper */ "@material-ui/core/Paper");
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _LoadingState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../LoadingState */ "./src/LoadingState/index.js");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./styles.scss */ "./src/PDFViewer/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_6__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PDFDocument = function (_React$Component) {
  _inherits(PDFDocument, _React$Component);

  function PDFDocument() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PDFDocument);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PDFDocument.__proto__ || Object.getPrototypeOf(PDFDocument)).call.apply(_ref, [this].concat(args))), _this), _this.rotationFor = function (page) {
      return (page.rotation + _this.props.globalRotation) % 360;
    }, _this.handleError = function (errorType) {
      return function () {
        var onError = _this.props.onError;

        if (onError) {
          onError({ type: errorType });
        }
      };
    }, _this.renderPage = function (pageNum) {
      var _this$props = _this.props,
          pages = _this$props.pages,
          scale = _this$props.scale;

      var page = pages[pageNum - 1];

      var id = 'pdfPage-' + pageNum;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        {
          id: id,
          key: id,
          ref: page.ref,
          className: _styles_scss__WEBPACK_IMPORTED_MODULE_6___default.a.pageContainer
        },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_3___default.a,
          { elevation: 4, className: _styles_scss__WEBPACK_IMPORTED_MODULE_6___default.a.paper },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_pdf__WEBPACK_IMPORTED_MODULE_2__["Page"], {
            className: _styles_scss__WEBPACK_IMPORTED_MODULE_6___default.a.page,
            pageNumber: pageNum,
            rotate: _this.rotationFor(page),
            scale: scale,
            onLoadError: _this.handleError('pageLoad'),
            onGetTextError: _this.handleError('pageGetText')
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PDFDocument, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.src !== this.props.src || nextProps.pages.length !== this.props.pages.length || nextProps.globalRotation !== this.props.globalRotation || nextProps.scale !== this.props.scale;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          src = _props.src,
          pages = _props.pages,
          onDocumentLoad = _props.onDocumentLoad;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        react_pdf__WEBPACK_IMPORTED_MODULE_2__["Document"],
        {
          file: src,
          loading: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_LoadingState__WEBPACK_IMPORTED_MODULE_4__["default"], { className: _layout_scss__WEBPACK_IMPORTED_MODULE_5___default.a.centerContent }),
          onLoadSuccess: onDocumentLoad,
          onLoadError: this.handleError('documentLoad'),
          onSourceError: this.handleError('documentSource'),
          onPassword: this.handleError('documentPasswordRequired') // PDFViewer not currently able to handle password protected PDFs
        },
        pages.map(function (_, index) {
          return _this2.renderPage(index + 1);
        })
      );
    }
  }]);

  return PDFDocument;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

PDFDocument.propTypes = {
  src: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
  pages: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(Object).isRequired,
  globalRotation: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.isRequired,
  scale: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.isRequired,
  onDocumentLoad: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  onError: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

PDFDocument.defaultProps = {
  onError: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (PDFDocument);

/***/ }),

/***/ "./src/PDFViewer/component.jsx":
/*!*************************************!*\
  !*** ./src/PDFViewer/component.jsx ***!
  \*************************************/
/*! exports provided: VIEWER_MARGIN, PDFViewerRaw, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIEWER_MARGIN", function() { return VIEWER_MARGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PDFViewerRaw", function() { return PDFViewerRaw; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _ButtonBar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ButtonBar */ "./src/PDFViewer/ButtonBar.jsx");
/* harmony import */ var _withIsMobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../withIsMobile */ "./src/withIsMobile.jsx");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./helpers */ "./src/PDFViewer/helpers.js");
/* harmony import */ var _PDFDocument__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./PDFDocument */ "./src/PDFViewer/PDFDocument.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./styles.scss */ "./src/PDFViewer/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_8__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var VIEWER_MARGIN = 50;

var PDFViewer = function (_React$Component) {
  _inherits(PDFViewer, _React$Component);

  function PDFViewer(props) {
    _classCallCheck(this, PDFViewer);

    var _this = _possibleConstructorReturn(this, (PDFViewer.__proto__ || Object.getPrototypeOf(PDFViewer)).call(this, props));

    _this.getPageEl = function (pageNum) {
      if (!_this.state.pages.length) return undefined;
      return _this.state.pages[pageNum - 1].ref.current;
    };

    _this.observePages = function () {
      return _this.state.pages.forEach(function (page) {
        return _this.currentPageObserver.observe(page.ref.current);
      });
    };

    _this.handleDocumentLoadSuccess = function (doc) {
      return Promise.all(new Array(doc.numPages).fill().map(function (_, index) {
        return doc.getPage(index + 1);
      })) // fetch page attributes
      .then(function (pageObjects) {
        var pages = pageObjects.map(function (page) {
          return { ref: react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef(), rotation: page.rotate };
        });
        _this.setState({ pages: pages }, _this.observePages);
      });
    };

    _this.handleVisibilityChange = function (newVisibilities) {
      _this.setState(function (_ref) {
        var pages = _ref.pages;
        return {
          pages: Object(_helpers__WEBPACK_IMPORTED_MODULE_6__["addNewVisibilities"])(newVisibilities, pages)
        };
      }, function () {
        var newPageNum = Object(_helpers__WEBPACK_IMPORTED_MODULE_6__["findPageNumWithHighestVisibility"])(_this.state.pages);
        if (!newPageNum) return;

        _this.setState({
          currentValidPageNum: newPageNum,
          currentPageNum: newPageNum
        });
      });
    };

    _this.scrollToPage = function (pageNum) {
      _this.scrollingEl.scrollTop = _this.getPageEl(pageNum).offsetTop;
    };

    _this.handleRotate = function () {
      return _this.setState(function (_ref2) {
        var globalRotation = _ref2.globalRotation;
        return { globalRotation: (globalRotation + 90) % 360 };
      }, function () {
        return _this.state.pages.length && _this.scrollToPage(_this.state.currentValidPageNum);
      });
    };

    _this.handleZoomIn = function () {
      return _this.setState(function (_ref3) {
        var zoomIndex = _ref3.zoomIndex;
        return { zoomIndex: Object(_helpers__WEBPACK_IMPORTED_MODULE_6__["isMaxZoom"])(zoomIndex) ? zoomIndex : zoomIndex + 1 };
      });
    };

    _this.handleZoomOut = function () {
      return _this.setState(function (_ref4) {
        var zoomIndex = _ref4.zoomIndex;
        return { zoomIndex: Object(_helpers__WEBPACK_IMPORTED_MODULE_6__["isMinZoom"])(zoomIndex) ? zoomIndex : zoomIndex - 1 };
      });
    };

    _this.handleZoomSelect = function (event) {
      var value = event.target.value;

      _this.setState({ zoomIndex: parseInt(value, 10) });
    };

    _this.handlePageSelect = function (event) {
      var value = event.target.value;
      var pages = _this.state.pages;


      _this.setState({ currentPageNum: value });

      var pageNum = Object(_helpers__WEBPACK_IMPORTED_MODULE_6__["parsePageNum"])(value, pages.length);
      if (pageNum) {
        _this.setState({ currentValidPageNum: pageNum });
        _this.scrollToPage(pageNum);
      }
    };

    _this.handlePageFieldBlur = function () {
      return _this.setState(function (state) {
        return { currentPageNum: state.currentValidPageNum };
      });
    };

    _this.scrollingRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();

    _this.state = {
      pages: [],
      globalRotation: 0,
      zoomIndex: _helpers__WEBPACK_IMPORTED_MODULE_6__["defaultZoom"],
      currentPageNum: 1,
      currentValidPageNum: 1
    };
    return _this;
  }

  _createClass(PDFViewer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // set up observer for determining which page we're currently on
      var observerProps = {
        root: this.scrollingEl,
        threshold: [0, 0.25, 0.5, 0.75, 1] // trigger callback when a page's visibility changes by 25%
      };
      this.currentPageObserver = new IntersectionObserver(this.handleVisibilityChange, observerProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMobile = _props.isMobile,
          src = _props.src,
          onError = _props.onError;
      var _state = this.state,
          pages = _state.pages,
          zoomIndex = _state.zoomIndex,
          currentPageNum = _state.currentPageNum,
          globalRotation = _state.globalRotation;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a.pdfContainer, ___WEBPACK_IMPORTED_MODULE_3__["layout"].flexAuto, ___WEBPACK_IMPORTED_MODULE_3__["layout"].flexColumnContainer) },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ButtonBar__WEBPACK_IMPORTED_MODULE_4__["default"], {
          pageCount: pages.length,
          currentPageNum: currentPageNum,
          zoomIndex: zoomIndex,
          onRotate: this.handleRotate,
          onZoomIn: this.handleZoomIn,
          onZoomOut: this.handleZoomOut,
          onZoomSelect: this.handleZoomSelect,
          onPageNumChange: this.handlePageSelect,
          onPageNumBlur: this.handlePageFieldBlur,
          isMobile: isMobile
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a.pdfScroll, ___WEBPACK_IMPORTED_MODULE_3__["layout"].flexAuto), ref: this.scrollingRef },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_PDFDocument__WEBPACK_IMPORTED_MODULE_7__["default"], {
            src: src,
            pages: pages,
            globalRotation: globalRotation,
            scale: _helpers__WEBPACK_IMPORTED_MODULE_6__["zoomScale"][zoomIndex],
            onDocumentLoad: this.handleDocumentLoadSuccess,
            onError: onError
          })
        )
      );
    }
  }, {
    key: 'scrollingEl',
    get: function get() {
      return this.scrollingRef.current;
    }

    // Adds page refs to the IntersectionObserver which it uses to notify when a page has come into view


    // create array containing a ref and the default rotation for each page (we need to keep track of this, otherwise
    //  setting a rotation will override the default rotation)


    // updates current visibility for relevant pages


    // rotate, then ensure the current page is still visible


    // update the current page num, and (if new value is valid) the current valid page num


    // resets current page num to the last valid page num

  }]);

  return PDFViewer;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

PDFViewer.propTypes = {
  src: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
  isMobile: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  // callback called if there is an error rendering the file
  onError: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

PDFViewer.defaultProps = {
  isMobile: false,
  onError: undefined
};

var PDFViewerRaw = PDFViewer;
/* harmony default export */ __webpack_exports__["default"] = (Object(_withIsMobile__WEBPACK_IMPORTED_MODULE_5__["default"])(PDFViewer));

/***/ }),

/***/ "./src/PDFViewer/helpers.js":
/*!**********************************!*\
  !*** ./src/PDFViewer/helpers.js ***!
  \**********************************/
/*! exports provided: zoomScale, defaultZoom, isMaxZoom, isMinZoom, parsePageNum, addNewVisibilities, findPageNumWithHighestVisibility */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zoomScale", function() { return zoomScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultZoom", function() { return defaultZoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMaxZoom", function() { return isMaxZoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMinZoom", function() { return isMinZoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePageNum", function() { return parsePageNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewVisibilities", function() { return addNewVisibilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findPageNumWithHighestVisibility", function() { return findPageNumWithHighestVisibility; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var zoomScale = [0.1, 0.25, 0.5, 0.75, 1, 1.25, 1.5, 2]; // PDF zoom options (0.25 = 25%)
var defaultZoom = zoomScale.indexOf(1); // defaults to 100%
var isMaxZoom = function isMaxZoom(index) {
  return index === zoomScale.length - 1;
};
var isMinZoom = function isMinZoom(index) {
  return index === 0;
};

// converts string value to an integer. Returns undefined if value cannot be converted to an int,
// or is outside the valid range (between 1 and numPages inclusive).
var parsePageNum = function parsePageNum(value, numPages) {
  var pageNum = parseInt(value, 10);
  var isValid = !!pageNum && pageNum > 0 && pageNum <= numPages;
  return isValid ? pageNum : undefined;
};

// returns new object with new visibilities ('intersection ratios') applied to relevant pages
var addNewVisibilities = function addNewVisibilities(intersectionObserverEntries, pages) {
  var newPages = [].concat(_toConsumableArray(pages));

  intersectionObserverEntries.forEach(function (entry) {
    var targetId = entry.target.id;
    var pageNum = parsePageNum(targetId.split('-')[1], pages.length);
    if (pageNum) {
      newPages[pageNum - 1] = _extends({}, pages[pageNum - 1], {
        ratio: entry.intersectionRatio
      });
    }
  });

  return newPages;
};

// returns the page num of the most visible page (i.e. the one with the highest % of itself visible)
var findPageNumWithHighestVisibility = function findPageNumWithHighestVisibility(pages) {
  var firstPageIndex = 0;

  var mostVisiblePageIndex = pages.reduce(function (currentMostVisiblePage, _, nextPageIndex) {
    var currentMaxRatio = pages[currentMostVisiblePage].ratio;
    var nextPageRatio = pages[nextPageIndex].ratio;
    return nextPageRatio > currentMaxRatio ? nextPageIndex : currentMostVisiblePage;
  }, firstPageIndex);

  return mostVisiblePageIndex + 1;
};

/***/ }),

/***/ "./src/PDFViewer/index.js":
/*!********************************!*\
  !*** ./src/PDFViewer/index.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/PDFViewer/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/PDFViewer/styles.scss":
/*!***********************************!*\
  !*** ./src/PDFViewer/styles.scss ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/PDFViewer/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Panel/component.jsx":
/*!*********************************!*\
  !*** ./src/Panel/component.jsx ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_Card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/Card */ "@material-ui/core/Card");
/* harmony import */ var _material_ui_core_Card__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Card__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_CardActions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/CardActions */ "@material-ui/core/CardActions");
/* harmony import */ var _material_ui_core_CardActions__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_CardActions__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_CardContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/CardContent */ "@material-ui/core/CardContent");
/* harmony import */ var _material_ui_core_CardContent__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_CardContent__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/Hidden */ "@material-ui/core/Hidden");
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_Toolbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/Toolbar */ "@material-ui/core/Toolbar");
/* harmony import */ var _material_ui_core_Toolbar__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Toolbar__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/core/Collapse */ "@material-ui/core/Collapse");
/* harmony import */ var _material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @material-ui/icons/KeyboardArrowDown */ "@material-ui/icons/KeyboardArrowDown");
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../IconButton */ "./src/IconButton/index.jsx");
/* harmony import */ var _ButtonToolbar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../ButtonToolbar */ "./src/ButtonToolbar/index.js");
/* harmony import */ var _Colored__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../Colored */ "./src/Colored/index.jsx");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./styles.scss */ "./src/Panel/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_15__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var Panel = function (_React$PureComponent) {
  _inherits(Panel, _React$PureComponent);

  function Panel(props) {
    _classCallCheck(this, Panel);

    var _this = _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));

    _this.getTestAttributes = function () {
      var defaultDataCy = typeof _this.props.title === 'string' ? _this.props.title : undefined;
      return {
        'data-cy': _this.props['data-cy'] || defaultDataCy,
        'data-component': 'Panel'
      };
    };

    _this.toggleExpanded = function () {
      if (!_this.canToggleExpanded()) {
        return;
      }
      _this.setState({ expanded: !_this.state.expanded });
    };

    _this.titleColor = function () {
      var _this$props = _this.props,
          lockExpandedValue = _this$props.lockExpandedValue,
          lockExpandedTitleColor = _this$props.lockExpandedTitleColor;

      return lockExpandedValue !== undefined ? lockExpandedTitleColor : undefined;
    };

    _this.expanded = function () {
      var expanded = _this.state.expanded;
      var lockExpandedValue = _this.props.lockExpandedValue;

      return lockExpandedValue !== undefined ? lockExpandedValue : expanded;
    };

    _this.renderExpandButton = function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          _this$props2$expandBu = _this$props2.expandButtonProps,
          expandButtonProps = _this$props2$expandBu === undefined ? {} : _this$props2$expandBu,
          expandButtonVisible = _this$props2.expandButtonVisible;

      if (!expandButtonVisible) {
        return null;
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _IconButton__WEBPACK_IMPORTED_MODULE_11__["default"],
        _extends({}, expandButtonProps, {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(classes.expandButton, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.expandButton, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.expanded, _this.expanded() && children), expandButtonProps.className),
          onClick: _this.toggleExpanded,
          component: 'div',
          disabled: !_this.canToggleExpanded()
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_8___default.a, null)
      );
    };

    _this.renderTitle = function () {
      var _this$props3 = _this.props,
          title = _this$props3.title,
          Icon = _this$props3.icon;

      if (typeof title === 'string') {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          react__WEBPACK_IMPORTED_MODULE_0__["Fragment"],
          null,
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_5___default.a,
            { smUp: true },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              _Typography__WEBPACK_IMPORTED_MODULE_10__["default"],
              { variant: 'subtitle2', color: _this.titleColor(), className: _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.title },
              Icon ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Icon, { className: _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.icon }) : null,
              title
            )
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_5___default.a,
            { only: 'xs' },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              _Typography__WEBPACK_IMPORTED_MODULE_10__["default"],
              { variant: 'h6', color: _this.titleColor(), className: _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.title },
              Icon ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Icon, { className: _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.icon }) : null,
              title
            )
          )
        );
      }
      if (Icon) {
        return [react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Icon, { key: 'icon', className: _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.icon }), title];
      }

      return title;
    };

    _this.renderSubtitle = function () {
      if (!_this.props.subtitle) return null;
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Typography__WEBPACK_IMPORTED_MODULE_10__["default"],
        { variant: 'body1' },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _Colored__WEBPACK_IMPORTED_MODULE_13__["default"],
          { color: _this.titleColor() || "secondary" },
          _this.props.subtitle
        )
      );
    };

    _this.renderHeaderActions = function () {
      var actions = _this.props.actions;

      if (!actions) return null;

      if (Array.isArray(actions)) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _ButtonToolbar__WEBPACK_IMPORTED_MODULE_12__["default"],
          { className: _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.headerActions },
          actions.map(function (btn, index) {
            return _this.renderSingleHeaderAction(btn, index === actions.length - 1);
          })
        );
      }

      // if there is only one action, avoid the map, so you don't need a `key` prop
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _ButtonToolbar__WEBPACK_IMPORTED_MODULE_12__["default"],
        { className: _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.headerActions },
        _this.renderSingleHeaderAction(actions)
      );
    };

    _this.renderSingleHeaderAction = function (action) {
      var isLast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!action || !isLast || action.type !== _IconButton__WEBPACK_IMPORTED_MODULE_11__["default"]) return action;
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.cloneElement(action, { className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(action.props.className, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.lastButtonIsIcon) });
    };

    _this.renderHeader = function () {
      var _classNames2;

      var _this$props4 = _this.props,
          expandOnClickTitle = _this$props4.expandOnClickTitle,
          expandButtonOnRight = _this$props4.expandButtonOnRight,
          expandable = _this$props4.expandable,
          _this$props4$headerPr = _this$props4.headerProps,
          headerProps = _this$props4$headerPr === undefined ? {} : _this$props4$headerPr;


      var headerClasses = headerProps.classes || {};

      var classes = _extends({}, headerClasses, {
        root: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.header, (_classNames2 = {}, _defineProperty(_classNames2, headerClasses.root, !!headerClasses.root), _defineProperty(_classNames2, _layout_scss__WEBPACK_IMPORTED_MODULE_14__["clickable"], _this.canToggleExpanded() && expandOnClickTitle), _classNames2))
      });
      var titleClasses = classnames__WEBPACK_IMPORTED_MODULE_9___default()('at-title', _layout_scss__WEBPACK_IMPORTED_MODULE_14__["flexGrow"]);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Toolbar__WEBPACK_IMPORTED_MODULE_6___default.a,
        _extends({
          onClick: expandOnClickTitle ? _this.toggleExpanded : undefined
        }, headerProps, {
          classes: classes
        }),
        expandable && !expandButtonOnRight && _this.renderExpandButton(),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: titleClasses },
          _this.renderTitle(),
          _this.renderSubtitle()
        ),
        _this.renderHeaderActions(),
        expandable && expandButtonOnRight && _this.renderExpandButton()
      );
    };

    _this.renderContent = function () {
      var _classNames3;

      var _this$props5 = _this.props,
          title = _this$props5.title,
          variant = _this$props5.variant,
          type = _this$props5.type,
          children = _this$props5.children,
          fullWidthContent = _this$props5.fullWidthContent,
          expandable = _this$props5.expandable,
          _this$props5$contentP = _this$props5.contentProps,
          contentProps = _this$props5$contentP === undefined ? {} : _this$props5$contentP;


      var contentClasses = contentProps.classes || {};

      var classes = _extends({}, contentClasses, {
        root: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.content, (_classNames3 = {}, _defineProperty(_classNames3, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.bodyWTitle, !!title && variant === 'plain' && type === 'primary' && !expandable), _defineProperty(_classNames3, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.fullWidthContent, fullWidthContent), _defineProperty(_classNames3, contentClasses.root, !!contentClasses.root), _classNames3))
      });

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_CardContent__WEBPACK_IMPORTED_MODULE_4___default.a,
        _extends({}, contentProps, { classes: classes }),
        children
      );
    };

    _this.renderActions = function () {
      var panelActions = _this.props.panelActions;

      if (!panelActions || panelActions.length === 0) return null;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_CardActions__WEBPACK_IMPORTED_MODULE_3___default.a,
        { classes: { root: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.panelActions) } },
        panelActions
      );
    };

    _this.state = { expanded: _this.props.expandDefault };
    return _this;
  }

  _createClass(Panel, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.onExpandToggle && prevState.expanded !== this.state.expanded) {
        this.props.onExpandToggle(this.state.expanded);
      }
    }
  }, {
    key: 'canToggleExpanded',
    value: function canToggleExpanded() {
      var _props = this.props,
          expandable = _props.expandable,
          lockExpandedValue = _props.lockExpandedValue,
          children = _props.children;

      return expandable && lockExpandedValue === undefined && !!children;
    }

    // render a single action (e.g. a button)
    // if the last action is an IconButton, add `lastButtonIsIcon` style

  }, {
    key: 'render',
    value: function render() {
      var _classNames4;

      var _props2 = this.props,
          id = _props2.id,
          fullWidth = _props2.fullWidth,
          fitHeight = _props2.fitHeight,
          _props2$classes = _props2.classes,
          expandButton = _props2$classes.expandButton,
          cardClasses = _objectWithoutProperties(_props2$classes, ['expandButton']),
          expandAnimationTime = _props2.expandAnimationTime,
          type = _props2.type,
          variant = _props2.variant,
          expandable = _props2.expandable,
          footer = _props2.footer,
          noElevation = _props2.noElevation,
          noHeader = _props2.noHeader;

      var collapseProps = {
        'aria-hidden': !this.expanded(),
        in: this.expanded(),
        timeout: expandAnimationTime
      };
      var cardProps = noElevation ? { elevation: 0 } : {};

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Card__WEBPACK_IMPORTED_MODULE_2___default.a,
        _extends({}, this.getTestAttributes(), {
          id: id,
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.root, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a[type], _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a[variant], (_classNames4 = {}, _defineProperty(_classNames4, _layout_scss__WEBPACK_IMPORTED_MODULE_14__["fullWidth"], fullWidth), _defineProperty(_classNames4, _layout_scss__WEBPACK_IMPORTED_MODULE_14__["fitHeight"], fitHeight), _defineProperty(_classNames4, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.expandable, expandable), _classNames4)),
          classes: cardClasses
        }, cardProps),
        !noHeader && this.renderHeader(),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_7___default.a,
          collapseProps,
          this.renderContent(),
          this.renderActions(),
          footer
        )
      );
    }
  }]);

  return Panel;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

Panel.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** The value for the header */
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** (optional) subtitle */
  subtitle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** (optional) icon displayed before the title */
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** The actions to display in the header */
  actions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Any classes to pass through to the card component */
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),

  /** The panel should take up all available room on the page */
  fullWidth: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /** Type controls the size of the panel, padding, etc */
  type: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['primary', 'secondary', 'tertiary']),

  /** Controls the visual style of the panel header */
  variant: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['plain', 'grey', 'lightGrey', 'brandGreen']),

  /** The panel content has no padding to the panel container */
  fullWidthContent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /** Default is to fit ViewPort, fitHeight makes panel adjust to fit content */
  fitHeight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /** Whether this panel can be expanded and collapsed */
  expandable: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /** If set to true or false instead of undefined, expanded state or expandDefault will be ignored */
  lockExpandedValue: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /** color to be used to render title when expanded value is locked */
  lockExpandedTitleColor: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Called when the panel is either expanded or collapsed */
  onExpandToggle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,

  /** The default state if this panel is expanded or not */
  expandDefault: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /** Timeout for the collapse animation. Either 'auto' or a duration in ms. 0 for no animation */
  expandAnimationTime: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number]),

  /** Any actions that can be displayed at the bottom of the panel. Includes standard padding, use this for buttons, etc. */
  panelActions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** The bottom edge of the panel. Includes no padding, use this for AuditBarGroup, etc */
  footer: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** The props will be spread to header node */
  headerProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** The props will be spread to expandButton node */
  expandButtonProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** if set to true, expand button will not be rendered */
  expandButtonVisible: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** if set to true, expand button will be displayed on right */
  expandButtonOnRight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** determine if click on panel title should toggle expand */
  expandOnClickTitle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** The props will be spread to content node */
  contentProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** Whether this panel has a border */
  noElevation: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** if set to true, there is no header for the panel */
  noHeader: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  'data-cy': prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

Panel.defaultProps = {
  id: undefined,
  title: null,
  subtitle: undefined,
  icon: undefined,
  actions: null,
  children: null,
  classes: {},
  fullWidth: false,
  type: 'primary',
  variant: 'plain',
  fullWidthContent: false,
  fitHeight: false,
  lockExpandedValue: undefined,
  lockExpandedTitleColor: 'disabled',
  expandable: false,
  expandDefault: true,
  onExpandToggle: undefined,
  expandAnimationTime: 'auto',
  panelActions: null,
  footer: undefined,
  headerProps: undefined,
  expandButtonProps: undefined,
  expandButtonVisible: true,
  expandOnClickTitle: true,
  expandButtonOnRight: false,
  contentProps: undefined,
  noElevation: false,
  noHeader: false,
  'data-cy': undefined
};

/* harmony default export */ __webpack_exports__["default"] = (Panel);

/***/ }),

/***/ "./src/Panel/index.js":
/*!****************************!*\
  !*** ./src/Panel/index.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Panel/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Panel/styles.scss":
/*!*******************************!*\
  !*** ./src/Panel/styles.scss ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Panel/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Popover/component.jsx":
/*!***********************************!*\
  !*** ./src/Popover/component.jsx ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Popover */ "@material-ui/core/Popover");
/* harmony import */ var _material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _propTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./propTypes */ "./src/Popover/propTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var Popover = function (_React$PureComponent) {
  _inherits(Popover, _React$PureComponent);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.componentWillMount = function () {
      if (_this.props.anchorEl) _this.reposition(_this.props.anchorEl);
    }, _this.componentWillReceiveProps = function (nextProps) {
      if (nextProps.anchorEl) _this.reposition(nextProps.anchorEl);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popover, [{
    key: 'reposition',
    value: function reposition(anchorEl) {
      var iRect = anchorEl.getBoundingClientRect();
      var spaceBelow = window.innerHeight - (iRect.top + iRect.height);
      var spaceAbove = iRect.top + iRect.height;
      this.setState({ shouldFlip: spaceAbove > spaceBelow });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          highlightedIndex = _props.highlightedIndex,
          onOpen = _props.onOpen,
          onSelect = _props.onSelect,
          children = _props.children,
          anchorEl = _props.anchorEl,
          anchorTopEl = _props.anchorTopEl,
          anchorBottomEl = _props.anchorBottomEl,
          horizontalAlign = _props.horizontalAlign,
          limitWidth = _props.limitWidth,
          rest = _objectWithoutProperties(_props, ['id', 'highlightedIndex', 'onOpen', 'onSelect', 'children', 'anchorEl', 'anchorTopEl', 'anchorBottomEl', 'horizontalAlign', 'limitWidth']);

      var shouldFlip = this.state.shouldFlip;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_1___default.a,
        _extends({
          anchorOrigin: {
            vertical: shouldFlip ? 'top' : 'bottom',
            horizontal: horizontalAlign
          },
          transformOrigin: {
            vertical: shouldFlip ? 'bottom' : 'top',
            horizontal: horizontalAlign
          },
          disableAutoFocus: true,
          onBackdropClick: this.props.onClose,
          onFocus: this.props.onFocus,
          anchorEl: this.anchor
        }, rest, {
          id: id,
          keepMounted: true,
          PaperProps: this.paperProps
        }),
        children
      );
    }
  }, {
    key: 'anchor',
    get: function get() {
      var positionalAnchor = this.state.shouldFlip ? this.props.anchorTopEl : this.props.anchorBottomEl;
      return positionalAnchor || this.props.anchorEl;
    }
  }, {
    key: 'paperProps',
    get: function get() {
      if (!this.props.limitWidth || !this.anchor) return this.props.PaperProps;

      var _props$PaperProps$sty = this.props.PaperProps.style;
      _props$PaperProps$sty = _props$PaperProps$sty === undefined ? {} : _props$PaperProps$sty;
      var maxWidthFromPaperProps = _props$PaperProps$sty.maxWidth;


      var maxWidth = maxWidthFromPaperProps || maxWidthFromPaperProps === 0 ? maxWidthFromPaperProps : this.anchor.getBoundingClientRect().width;

      return _extends({}, this.props.PaperProps, {
        style: _extends({}, this.props.PaperProps.style, {
          maxWidth: maxWidth
        })
      });
    }
  }]);

  return Popover;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

Popover.propTypes = _propTypes__WEBPACK_IMPORTED_MODULE_2__["popOverPropTypes"];
Popover.defaultProps = _propTypes__WEBPACK_IMPORTED_MODULE_2__["popOverDefaultProps"];

/* harmony default export */ __webpack_exports__["default"] = (Popover);

/***/ }),

/***/ "./src/Popover/index.js":
/*!******************************!*\
  !*** ./src/Popover/index.js ***!
  \******************************/
/*! exports provided: popOverPropTypes, popOverDefaultProps, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _propTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./propTypes */ "./src/Popover/propTypes.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "popOverPropTypes", function() { return _propTypes__WEBPACK_IMPORTED_MODULE_0__["popOverPropTypes"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "popOverDefaultProps", function() { return _propTypes__WEBPACK_IMPORTED_MODULE_0__["popOverDefaultProps"]; });

/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./component */ "./src/Popover/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_1__["default"]; });





/***/ }),

/***/ "./src/Popover/propTypes.js":
/*!**********************************!*\
  !*** ./src/Popover/propTypes.js ***!
  \**********************************/
/*! exports provided: popOverPropTypes, popOverDefaultProps */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popOverPropTypes", function() { return popOverPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popOverDefaultProps", function() { return popOverDefaultProps; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);


var anchorPropType = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(HTMLInputElement), prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(HTMLDivElement), prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(HTMLButtonElement)]);

var popOverPropTypes = {
  /** contents of the Popover */
  children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node.isRequired,
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  /** Index of the highlighted row */
  highlightedIndex: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  /** Items to display */
  items: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(Array),
  open: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
  /** The element the Popover will position by */
  anchorEl: anchorPropType,
  /** The element the Popover will position by when being positioned at the top (optional) */
  anchorTopEl: anchorPropType,
  /** The element the Popover will position by when being positioned at the bottom (optional) */
  anchorBottomEl: anchorPropType,
  /** Triggered when the modal should open */
  onOpen: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  /** Triggered when the modal should close */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  /** Triggered when popover has received focus */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  /** Triggered when an item from the list has been selected */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  horizontalAlign: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOf(['left', 'center', 'right']),
  /** Limit the width of the popup to the width of the anchorEl */
  limitWidth: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
  /** Props object passed down to Paper node */
  PaperProps: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(Object)
};

var popOverDefaultProps = {
  id: 'popover',
  highlightedIndex: 0,
  items: [],
  open: false,
  anchorEl: undefined,
  anchorTopEl: undefined,
  anchorBottomEl: undefined,
  onSelect: undefined,
  onFocus: undefined,
  onOpen: undefined,
  onClose: undefined,
  onKeyDown: undefined,
  horizontalAlign: 'left',
  limitWidth: false,
  PaperProps: {}
};

/***/ }),

/***/ "./src/Popper/component.jsx":
/*!**********************************!*\
  !*** ./src/Popper/component.jsx ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Popper */ "@material-ui/core/Popper");
/* harmony import */ var _material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/Paper */ "@material-ui/core/Paper");
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _propTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./propTypes */ "./src/Popper/propTypes.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.scss */ "./src/Popper/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/* Material UI Popper uses a third party library popper.js for the positioning of the pop up component.
 * Unfortunatelly popper.js prefers to position the poppup at the top, if nether top nor bottom of the
 * viewport have enough space to fit the pop up. A workaround had been implemented to check if the plipping
 * has occured unnecessarily, and if so the pop up is put back to the bottom.
 */

var Popper = function (_React$PureComponent) {
  _inherits(Popper, _React$PureComponent);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.preflipFn = function (data) {
      // Flipping invokes all preceding modifiers to be executed once again.
      // Make sure this modifier is executed only once.
      if (data.flipped) {
        return data;
      }
      // Preserve the original offsets before flipping
      var offsets = _extends({}, data.offsets, { preflip: _extends({}, data.popper) });
      return _extends({}, data, { offsets: offsets });
    }, _this.postflipFn = function (data, options) {
      var scrollingElement = function (el) {
        return el.scrollingElement || el.documentElement;
      }(data.instance.reference.ownerDocument);
      var documentCapacity = scrollingElement.scrollHeight - options.padding;

      // Do nothing if ...
      if (
      // ... Popper is not flipped
      !data.flipped ||
      // ... Popper is below the top margin of the view port
      data.popper.top >= scrollingElement.scrollTop + options.padding ||
      // ... Popper is below the top margin of the page and if flipped back will be above the bottom margin of the page
      data.popper.top >= options.padding && data.offsets.preflip.bottom >= documentCapacity) {
        return data;
      }

      // Undo flipping
      var popper = _extends({}, data.offsets.preflip);
      return _extends({}, data, {
        flipped: false,
        placement: data.originalPlacement,
        popper: popper,
        offsets: _extends({}, data.offsets, { popper: popper })
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // preflipFn saves the original state of the pop up


  // postflipFn checks if the pop up needs to be flipped back to the state saved on preflipFn


  _createClass(Popper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          children = _props.children,
          anchorEl = _props.anchorEl,
          wrapperRef = _props.wrapperRef,
          rest = _objectWithoutProperties(_props, ['id', 'children', 'anchorEl', 'wrapperRef']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_1___default.a,
        _extends({
          placement: 'bottom-start',
          anchorEl: anchorEl
        }, rest, {
          id: id,
          className: _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.popper,
          modifiers: {
            // Custom modifier to be executed before flip
            preflip: {
              enabled: true,
              order: 590, // just before the built-in flip modifier with order 600
              fn: this.preflipFn
            },
            // Custom modifier to be executed after flip
            postflip: {
              enabled: true,
              order: 610, // just after the built-in flip modifier with order 600
              boundariesElement: 'viewport',
              padding: 5,
              fn: this.postflipFn
            },
            preventOverflow: {
              enabled: false
            }
          }
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { ref: wrapperRef },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_2___default.a,
            null,
            children
          )
        )
      );
    }
  }]);

  return Popper;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

Popper.propTypes = _propTypes__WEBPACK_IMPORTED_MODULE_3__["popperPropTypes"];
Popper.defaultProps = _propTypes__WEBPACK_IMPORTED_MODULE_3__["popperDefaultProps"];

/* harmony default export */ __webpack_exports__["default"] = (Popper);

/***/ }),

/***/ "./src/Popper/index.js":
/*!*****************************!*\
  !*** ./src/Popper/index.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Popper/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Popper/propTypes.js":
/*!*********************************!*\
  !*** ./src/Popper/propTypes.js ***!
  \*********************************/
/*! exports provided: popperPropTypes, popperDefaultProps */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popperPropTypes", function() { return popperPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popperDefaultProps", function() { return popperDefaultProps; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);


var anchorPropType = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(HTMLInputElement), prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(HTMLDivElement), prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(HTMLButtonElement)]);

var popperPropTypes = {
  /** contents of the Popper */
  children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node.isRequired,
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  /** Items to display */
  items: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(Array),
  open: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
  /** The element the Popper will position by */
  anchorEl: anchorPropType,
  /** Triggered when the modal should close */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  /** Triggered when popper has received focus */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  wrapperRef: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({ current: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.instanceOf(Element) })
};

var popperDefaultProps = {
  id: 'popper',
  items: [],
  open: false,
  anchorEl: undefined,
  onFocus: undefined,
  onClose: undefined,
  onKeyDown: undefined,
  wrapperRef: undefined
};

/***/ }),

/***/ "./src/Popper/styles.scss":
/*!********************************!*\
  !*** ./src/Popper/styles.scss ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Popper/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/PreviewList/classes.js":
/*!************************************!*\
  !*** ./src/PreviewList/classes.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./styles.scss */ "./src/PreviewList/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_2__);




/* harmony default export */ __webpack_exports__["default"] = ({
  root: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_2___default.a.root, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.fullWidth),
  smallIcon: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.buttonSizeSmall, _styles_scss__WEBPACK_IMPORTED_MODULE_2___default.a.icon, _styles_scss__WEBPACK_IMPORTED_MODULE_2___default.a.mainIcon),
  previewColumn: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.dividerLeft, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flex),
  previewContainer: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexColumnContainer, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexGrow),
  itemsContainer: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexGrow, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexColumnContainer),
  headerInner: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexRowContainer, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.fullWidth, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.fullHeight, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.spaceContentBetween, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.centerVertically),
  previewBodyWrapper: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexColumnContainer, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexGrow, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.scroll),
  previewBodyInner: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.scroll, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexGrow, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexColumnContainer),
  emptyWrapper: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.centerContent, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexColumnContainer, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexGrow),
  emptyInner: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.fullWidth, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.alignCenter, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.fullHeight, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexGrow, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexColumnContainer, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.centerHorizontally, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.centerVertically),
  paginationRoot: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexBasis0, _styles_scss__WEBPACK_IMPORTED_MODULE_2___default.a.pagedRoot),
  paginationLoading: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexColumnContainer, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexGrow, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.centerContent, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.centerVertically),
  paginationLoadingContainer: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.absolute, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.flexColumnContainer, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.fullWidth, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.fullHeight, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.centerHorizontally, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.centerVertically),
  paginationTable: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_2___default.a.pagination, _layout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.dividerTop)
});

/***/ }),

/***/ "./src/PreviewList/component.jsx":
/*!***************************************!*\
  !*** ./src/PreviewList/component.jsx ***!
  \***************************************/
/*! exports provided: validateListHeading, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateListHeading", function() { return validateListHeading; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_icons_MoreVert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/icons/MoreVert */ "@material-ui/icons/MoreVert");
/* harmony import */ var _material_ui_icons_MoreVert__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_MoreVert__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/icons/ArrowBack */ "@material-ui/icons/ArrowBack");
/* harmony import */ var _material_ui_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/Paper */ "@material-ui/core/Paper");
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/core/Grid */ "@material-ui/core/Grid");
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_ListItemSecondaryAction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/core/ListItemSecondaryAction */ "@material-ui/core/ListItemSecondaryAction");
/* harmony import */ var _material_ui_core_ListItemSecondaryAction__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemSecondaryAction__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _paged__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./paged */ "./src/PreviewList/paged.jsx");
/* harmony import */ var _listItemText__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./listItemText */ "./src/PreviewList/listItemText.jsx");
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./classes */ "./src/PreviewList/classes.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./styles.scss */ "./src/PreviewList/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_12__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var strFromConfig = function strFromConfig(item, listConfiguration, attr) {
  var value = listConfiguration[attr];
  if (!value) return undefined;
  return typeof value === 'string' ? item[value] : value(item);
};

// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var PreviewList = function (_React$PureComponent) {
  _inherits(PreviewList, _React$PureComponent);

  function PreviewList(props) {
    var _this2 = this;

    _classCallCheck(this, PreviewList);

    var _this = _possibleConstructorReturn(this, (PreviewList.__proto__ || Object.getPrototypeOf(PreviewList)).call(this, props));

    _this.handleCancel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var onItemDeselected;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onItemDeselected = _this.props.onItemDeselected;

              if (!onItemDeselected) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return onItemDeselected();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.handleFilterChange = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e, value) {
        var allowToChange, onFilterWillChange, _this$state, page, rowsPerPage;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                allowToChange = true;
                onFilterWillChange = _this.props.onFilterWillChange;

                if (!onFilterWillChange) {
                  _context2.next = 7;
                  break;
                }

                _this$state = _this.state, page = _this$state.page, rowsPerPage = _this$state.rowsPerPage;
                _context2.next = 6;
                return onFilterWillChange({ filter: value, page: page, rowsPerPage: rowsPerPage });

              case 6:
                allowToChange = _context2.sent;

              case 7:

                if (allowToChange) {
                  _this.setState({ selectedFilter: value, page: 0 }, _this.handleFiltersChange);
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleFiltersChange = function () {
      var _this$state2 = _this.state,
          page = _this$state2.page,
          rowsPerPage = _this$state2.rowsPerPage,
          selectedFilter = _this$state2.selectedFilter;

      if (_this.props.onFilterChange) {
        _this.props.onFilterChange({ filter: selectedFilter, page: page, rowsPerPage: rowsPerPage });
      }
    };

    _this.handlePageChange = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e, newPage) {
        var allowToChange, onPageWillChange, _this$state3, rowsPerPage, selectedFilter;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                allowToChange = true;
                onPageWillChange = _this.props.onPageWillChange;

                if (!onPageWillChange) {
                  _context3.next = 7;
                  break;
                }

                _this$state3 = _this.state, rowsPerPage = _this$state3.rowsPerPage, selectedFilter = _this$state3.selectedFilter;
                _context3.next = 6;
                return onPageWillChange({ filter: selectedFilter, page: newPage, rowsPerPage: rowsPerPage });

              case 6:
                allowToChange = _context3.sent;

              case 7:

                if (allowToChange) {
                  _this.setState({ page: newPage }, _this.handleFiltersChange);
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.handleRowsPerPageChange = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
        var allowToChange, onRowsPerPageWillChange, _this$state4, page, selectedFilter;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                allowToChange = true;
                onRowsPerPageWillChange = _this.props.onRowsPerPageWillChange;

                if (!onRowsPerPageWillChange) {
                  _context4.next = 7;
                  break;
                }

                _this$state4 = _this.state, page = _this$state4.page, selectedFilter = _this$state4.selectedFilter;
                _context4.next = 6;
                return onRowsPerPageWillChange({ filter: selectedFilter, page: page, rowsPerPage: e.target.value });

              case 6:
                allowToChange = _context4.sent;

              case 7:

                if (allowToChange) {
                  _this.setState({ rowsPerPage: e.target.value }, _this.handleFiltersChange);
                }

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.renderItemContent = function (item, args) {
      var _this$props = _this.props,
          onItemSelected = _this$props.onItemSelected,
          listConfiguration = _this$props.listConfiguration,
          disableGutters = _this$props.disableGutters,
          dense = _this$props.dense,
          _this$props$listItemC = _this$props.listItemClasses,
          listItemRoot = _this$props$listItemC.root,
          listItemClasses = _objectWithoutProperties(_this$props$listItemC, ['root']);

      var _this$props$listConfi = _this.props.listConfiguration.actions,
          actions = _this$props$listConfi === undefined ? [] : _this$props$listConfi;

      var primaryString = strFromConfig(item, listConfiguration, 'primary');
      var secondaryString = strFromConfig(item, listConfiguration, 'secondary');
      var tertiaryString = strFromConfig(item, listConfiguration, 'tertiary');

      // Customise actions for this particular item
      var customisedActions = actions.filter(function (a) {
        return !a.previewOnly;
      }).map(function (action) {
        return _extends({}, action, {
          onClick: function onClick() {
            var originalHandler = action.onClick;

            return originalHandler(item);
          }
        });
      });

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        ___WEBPACK_IMPORTED_MODULE_8__["ListItem"],
        _extends({
          button: true,
          component: 'div',
          disableGutters: disableGutters,
          dense: dense
        }, args, {
          ContainerComponent: 'div',
          classes: _extends({
            root: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_12___default.a.listItem, listItemRoot)
          }, listItemClasses),
          onClick: _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (!onItemSelected) {
                      _context5.next = 5;
                      break;
                    }

                    _context5.next = 3;
                    return onItemSelected(args.key);

                  case 3:
                    _context5.next = 6;
                    break;

                  case 5:
                    _this.setState({
                      selectedItemId: args.key
                    });

                  case 6:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this2);
          }))
        }),
        listConfiguration && listConfiguration.icon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["Icon"], { size: 'small', className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_12___default.a.icon, ___WEBPACK_IMPORTED_MODULE_8__["layout"].flexShrinkNone), color: 'grey', component: _this.renderIcon(item) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_listItemText__WEBPACK_IMPORTED_MODULE_10__["default"], {
          primary: primaryString,
          secondary: secondaryString,
          tertiary: tertiaryString
        }),
        customisedActions && customisedActions.length > 0 && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_ListItemSecondaryAction__WEBPACK_IMPORTED_MODULE_7___default.a,
          { className: _styles_scss__WEBPACK_IMPORTED_MODULE_12___default.a.secondaryAction },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            ___WEBPACK_IMPORTED_MODULE_8__["ButtonMenu"],
            {
              buttonComponent: ___WEBPACK_IMPORTED_MODULE_8__["IconButton"],
              buttonProps: { className: _styles_scss__WEBPACK_IMPORTED_MODULE_12___default.a.contextButton },
              alignRight: true,
              items: customisedActions
            },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_MoreVert__WEBPACK_IMPORTED_MODULE_3___default.a, null)
          )
        )
      );
    };

    _this.renderPreview = function () {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: _classes__WEBPACK_IMPORTED_MODULE_11__["default"].previewBodyWrapper, 'data-component': 'PreviewList-Preview' },
        _this.item && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: _classes__WEBPACK_IMPORTED_MODULE_11__["default"].previewBodyInner },
          _this.props.preview(_this.item)
        ),
        !_this.item && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: _classes__WEBPACK_IMPORTED_MODULE_11__["default"].emptyWrapper },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { className: _classes__WEBPACK_IMPORTED_MODULE_11__["default"].emptyInner },
            _this.props.isLoading && 'Loading',
            !_this.props.isLoading && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["EmptyState"], { icon: null, title: _this.props.emptyPreviewMessage })
          )
        )
      );
    };

    _this.renderPreviewHeading = function () {
      var _this$props2 = _this.props,
          showTitle = _this$props2.showTitle,
          previewTitle = _this$props2.previewTitle,
          previewTitleRenderer = _this$props2.previewTitleRenderer,
          listConfiguration = _this$props2.listConfiguration,
          isMobile = _this$props2.isMobile;


      if (!showTitle) return null;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_12___default.a.previewHeader, _defineProperty({}, ___WEBPACK_IMPORTED_MODULE_8__["layout"].dividerBottom, showTitle)), 'data-component': 'PreviewList-PreviewHeading' },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: _classes__WEBPACK_IMPORTED_MODULE_11__["default"].headerInner },
          previewTitleRenderer ? previewTitleRenderer(_this.item) : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            react__WEBPACK_IMPORTED_MODULE_0__["Fragment"],
            null,
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              'div',
              { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(___WEBPACK_IMPORTED_MODULE_8__["layout"].flexRowContainer, ___WEBPACK_IMPORTED_MODULE_8__["layout"].marginLeft) },
              isMobile && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_4___default.a, { className: 'previewList-back', onClick: _this.handleCancel }),
              _this.item && listConfiguration.icon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["Icon"], { size: 'small', color: 'grey', component: listConfiguration.icon(_this.item) }),
              _this.item && previewTitle && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                ___WEBPACK_IMPORTED_MODULE_8__["Typography"],
                { component: 'div', variant: 'body1', className: ___WEBPACK_IMPORTED_MODULE_8__["layout"].marginLeft },
                previewTitle(_this.item)
              )
            ),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              ___WEBPACK_IMPORTED_MODULE_8__["ButtonToolbar"],
              { className: ___WEBPACK_IMPORTED_MODULE_8__["layout"].marginRight },
              _this.renderToolbarActions()
            )
          )
        )
      );
    };

    _this.state = {
      selectedItemId: props.selectedItemId,
      rowsPerPage: 10,
      page: 0,
      selectedFilter: props.selectedFilter
    };
    return _this;
  }

  _createClass(PreviewList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.selectedFilter !== this.props.selectedFilter || newProps.selectedItemId !== this.props.selectedItemId || newProps.page !== this.props.page) {
        this.setState({
          selectedFilter: newProps.selectedFilter,
          selectedItemId: newProps.selectedItemId,
          page: newProps.page || this.state.page
        });
      }
    }
  }, {
    key: 'getTestAttributes',
    value: function getTestAttributes() {
      return {
        'data-cy': this.props['data-cy'],
        'data-component': 'PreviewList'
      };
    }

    // handle any change to a filter, including page, per page etc.

  }, {
    key: 'renderIcon',
    value: function renderIcon(item) {
      var icon = this.props.listConfiguration.icon;

      if (!icon) return undefined;
      if (typeof icon === 'function') {
        return icon(item);
      }
      return icon;
    }
  }, {
    key: 'renderFilters',
    value: function renderFilters() {
      return this.props.filters.map(function (filter) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["Tab"], {
          key: filter.value,
          title: filter.title,
          value: filter.value,
          label: filter.title,
          'data-cy': filter.dataCy,
          classes: {
            root: ___WEBPACK_IMPORTED_MODULE_8__["layout"].resetWidth,
            labelContainer: classnames__WEBPACK_IMPORTED_MODULE_2___default()(___WEBPACK_IMPORTED_MODULE_8__["layout"].paddingSmall, _styles_scss__WEBPACK_IMPORTED_MODULE_12___default.a.tabLabel)
          }
        });
      });
    }

    // renders custom heading above PreviewList list if provided, otherwise renders tab filters

  }, {
    key: 'renderListHeading',
    value: function renderListHeading() {
      var _props = this.props,
          customListHeading = _props.customListHeading,
          selectedFilter = _props.selectedFilter;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(___WEBPACK_IMPORTED_MODULE_8__["layout"].dividerBottom, _styles_scss__WEBPACK_IMPORTED_MODULE_12___default.a.listHeader), 'data-component': 'PreviewList-ListHeading' },
        customListHeading ? customListHeading : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ___WEBPACK_IMPORTED_MODULE_8__["Tabs"],
          {
            variant: 'secondary',
            value: selectedFilter,
            onChange: this.handleFilterChange
          },
          this.renderFilters()
        )
      );
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var _props2 = this.props,
          isLoading = _props2.isLoading,
          items = _props2.items,
          grouper = _props2.grouper,
          totalCount = _props2.totalCount,
          isMobile = _props2.isMobile,
          id = _props2.id,
          paginationOptions = _props2.paginationOptions;
      var _state = this.state,
          selectedItemId = _state.selectedItemId,
          rowsPerPage = _state.rowsPerPage,
          page = _state.page;


      var hasGroups = !!grouper;
      var groupConf = grouper ? grouper(items) : undefined;
      if (!groupConf) hasGroups = false;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _paged__WEBPACK_IMPORTED_MODULE_9__["default"],
        _extends({
          isLoading: isLoading,
          count: totalCount,
          rowsPerPage: rowsPerPage,
          onChangePage: this.handlePageChange,
          onChangeRowsPerPage: this.handleRowsPerPageChange,
          page: page
        }, paginationOptions),
        items.length > 0 && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["DataList"], {
          id: id + '_list',
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(___WEBPACK_IMPORTED_MODULE_8__["layout"].flexGrow, ___WEBPACK_IMPORTED_MODULE_8__["layout"].scroll),
          selectedId: selectedItemId,
          list: hasGroups ? undefined : items,
          isMobile: isMobile,
          groups: hasGroups ? groupConf : undefined,
          itemRender: this.renderItemContent,
          dividerProps: { inset: false }
        }),
        items.length === 0 && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: _classes__WEBPACK_IMPORTED_MODULE_11__["default"].emptyWrapper },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { className: _classes__WEBPACK_IMPORTED_MODULE_11__["default"].emptyInner },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_8__["EmptyState"], { title: 'No results to display' })
          )
        )
      );
    }
  }, {
    key: 'renderToolbarActions',
    value: function renderToolbarActions() {
      var _this3 = this;

      var _props$listConfigurat = this.props.listConfiguration.actions,
          actions = _props$listConfigurat === undefined ? [] : _props$listConfigurat;

      return actions.map(function (action) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ___WEBPACK_IMPORTED_MODULE_8__["Tooltip"],
          { title: action.label, key: action.label },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            ___WEBPACK_IMPORTED_MODULE_8__["IconButton"],
            { onClick: function onClick() {
                return action.onClick && action.onClick(_this3.item);
              }, 'aria-label': action.label },
            action.icon
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          id = _props3.id,
          isMobile = _props3.isMobile,
          selectedItemId = _props3.selectedItemId,
          listWidth = _props3.listWidth;


      var listSm = listWidth.sm || PreviewList.defaultProps.listWidth.sm;
      var listMd = listWidth.md || PreviewList.defaultProps.listWidth.md;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_5___default.a,
        _extends({ className: _classes__WEBPACK_IMPORTED_MODULE_11__["default"].root, id: id }, this.getTestAttributes()),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6___default.a,
          { container: true, spacing: 0, className: ___WEBPACK_IMPORTED_MODULE_8__["layout"].fullHeight },
          (!isMobile || !selectedItemId) && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6___default.a,
            {
              className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("previewList-list", _styles_scss__WEBPACK_IMPORTED_MODULE_12___default.a.list, ___WEBPACK_IMPORTED_MODULE_8__["layout"].relative),
              item: true,
              container: true,
              direction: 'column',
              wrap: 'nowrap',
              xs: 12,
              sm: listSm,
              md: listMd
            },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6___default.a,
              { item: true, container: true, className: ___WEBPACK_IMPORTED_MODULE_8__["layout"].flexNone, wrap: 'nowrap', justify: 'center', spacing: 8 },
              react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
                _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6___default.a,
                { item: true, zeroMinWidth: true, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(___WEBPACK_IMPORTED_MODULE_8__["layout"].flexGrow, ___WEBPACK_IMPORTED_MODULE_8__["layout"].flexBasis0) },
                this.renderListHeading()
              )
            ),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6___default.a,
              { item: true, className: _classes__WEBPACK_IMPORTED_MODULE_11__["default"].itemsContainer },
              this.renderItems()
            )
          ),
          (!isMobile || selectedItemId) && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6___default.a,
            {
              item: true,
              xs: 12,
              sm: 12 - listSm,
              md: 12 - listMd,
              className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_classes__WEBPACK_IMPORTED_MODULE_11__["default"].previewColumn, ___WEBPACK_IMPORTED_MODULE_8__["layout"].fullHeight, ___WEBPACK_IMPORTED_MODULE_8__["layout"].fullWidth, 'previewList-preview')
            },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
              'div',
              { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_classes__WEBPACK_IMPORTED_MODULE_11__["default"].previewContainer, ___WEBPACK_IMPORTED_MODULE_8__["layout"].fullWidth) },
              this.renderPreviewHeading(),
              this.renderPreview()
            )
          )
        )
      );
    }
  }, {
    key: 'item',
    get: function get() {
      var _this4 = this;

      return this.props.items.find(function (i) {
        return i.id === _this4.state.selectedItemId;
      });
    }
  }]);

  return PreviewList;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

var validateListHeading = function validateListHeading(props, _, componentName) {
  var filters = props.filters,
      customListHeading = props.customListHeading;

  if (!customListHeading) return;

  if (!!filters.length && !!customListHeading) {
    throw new Error('invalid props for ' + componentName + ' - only one of [filters, listHeading] can be provided, but both are defined');
  } else if (!(typeof customListHeading === 'string' || (typeof customListHeading === 'undefined' ? 'undefined' : _typeof(customListHeading)) === 'object')) {
    throw new Error('invalid props for ' + componentName + ' - listHeading should be a node');
  }
};

PreviewList.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /* Array of items to display */
  items: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)),
  /* Classes to override ListItem styles */
  listItemClasses: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /* Configure the display of the ListItems */
  listConfiguration: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    /* the title text placement */
    primary: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]),
    /* secondary information text placement */
    secondary: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]),
    /* the smallest of the three text placements, generally used for dates */
    tertiary: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]),
    actions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
      icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
      label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
      onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
      previewOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool // if set to true, action only shown in preview component
    })),
    icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)
  }).isRequired,
  /* The contents of the Preview pane */
  preview: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  /* Configuration objects for the Item Filter tabs */
  filters: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
  })),
  /* The Item Filter tab currently selected */
  selectedFilter: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /* optional alternative heading above list (in place of filters) */
  customListHeading: validateListHeading,
  /* The Item currently selected */
  selectedItemId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /**
   * Callback signifying a change to the filters. The item, page, and rowsPerPage
   * changes will all trigger this callback, provided to the function will be an
   * object containing all three values.
   */
  onFilterChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onItemSelected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onItemDeselected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Renders the title section component, has its own content and layout */
  previewTitleRenderer: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Renders the title string, use one of the defined layout in the DS */
  previewTitle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /* Display the Preview header/title pane on the right hand side */
  showTitle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * Function for grouping items. List items provided when called, an array of
   * group definitions must be returned to be consumed by the data list. Format
   * is [{ header: { id: x, primaryText: y }, list: [items] }, ...]
   */
  grouper: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /* Total number of items for pagination */
  totalCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /* Page number for pagination */
  page: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /* loading flag */
  isLoading: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  isMobile: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /* conditional removal of item gutters */
  disableGutters: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  dense: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /* message to display if preview pane is empty */
  emptyPreviewMessage: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  onFilterWillChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onPageWillChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onRowsPerPageWillChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /* Break-point sm and md widths passing in for List Component to render */
  listWidth: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    sm: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
    md: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number
  }),
  'data-cy': prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  paginationOptions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    rowsPerPageOptions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number)
  })
};

PreviewList.defaultProps = {
  id: undefined,
  items: [],
  listItemClasses: {},
  filters: [],
  customListHeading: undefined,
  selectedFilter: undefined,
  selectedItemId: undefined,
  paginationOptions: {
    rowsPerPageOptions: [5, 10, 25]
  },
  previewTitle: undefined,
  previewTitleRenderer: undefined,
  showTitle: true,
  onFilterChange: undefined,
  onItemSelected: undefined,
  onItemDeselected: undefined,
  grouper: undefined,
  totalCount: undefined,
  page: undefined,
  isLoading: false,
  isMobile: false,
  emptyPreviewMessage: 'Nothing to see here',
  onFilterWillChange: undefined,
  onPageWillChange: undefined,
  onRowsPerPageWillChange: undefined,
  disableGutters: false,
  dense: false,
  listWidth: {
    sm: 4,
    md: 3
  },
  'data-cy': undefined
};

/* harmony default export */ __webpack_exports__["default"] = (PreviewList);

/***/ }),

/***/ "./src/PreviewList/index.js":
/*!**********************************!*\
  !*** ./src/PreviewList/index.js ***!
  \**********************************/
/*! exports provided: default, TertiaryDate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/PreviewList/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _tertiaryDate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./tertiaryDate */ "./src/PreviewList/tertiaryDate.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TertiaryDate", function() { return _tertiaryDate__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),

/***/ "./src/PreviewList/listItemText.jsx":
/*!******************************************!*\
  !*** ./src/PreviewList/listItemText.jsx ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/ListItemText */ "@material-ui/core/ListItemText");
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./styles.scss */ "./src/PreviewList/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_5__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var ListItemText = function ListItemText(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      rest = _objectWithoutProperties(_ref, ['primary', 'secondary', 'tertiary']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_2___default.a, _extends({
    classes: { root: _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.listTextPad },
    primary: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Typography__WEBPACK_IMPORTED_MODULE_4__["default"],
      { variant: 'subtitle1' },
      primary
    ),
    secondary: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment,
      null,
      secondary && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'span',
        { className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('secondary', _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.secondaryText) },
        secondary
      ),
      tertiary && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Typography__WEBPACK_IMPORTED_MODULE_4__["default"],
        { variant: 'caption', component: 'span', className: _styles_scss__WEBPACK_IMPORTED_MODULE_5___default.a.statusWrapper },
        tertiary
      )
    ),
    secondaryTypographyProps: { variant: 'body1', component: 'span' }
  }, rest));
};

ListItemText.propTypes = {
  primary: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  secondary: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  tertiary: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};

ListItemText.defaultProps = {
  primary: '',
  secondary: '',
  tertiary: ''
};

/* harmony default export */ __webpack_exports__["default"] = (ListItemText);

/***/ }),

/***/ "./src/PreviewList/paged.jsx":
/*!***********************************!*\
  !*** ./src/PreviewList/paged.jsx ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_Table__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/Table */ "@material-ui/core/Table");
/* harmony import */ var _material_ui_core_Table__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Table__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_TableFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/TableFooter */ "@material-ui/core/TableFooter");
/* harmony import */ var _material_ui_core_TableFooter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TableFooter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/TableRow */ "@material-ui/core/TableRow");
/* harmony import */ var _material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/CircularProgress */ "@material-ui/core/CircularProgress");
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _classes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./classes */ "./src/PreviewList/classes.js");










var Paged = function Paged(_ref) {
  var count = _ref.count,
      hideCount = _ref.hideCount,
      page = _ref.page,
      rowsPerPage = _ref.rowsPerPage,
      onChangePage = _ref.onChangePage,
      onChangeRowsPerPage = _ref.onChangeRowsPerPage,
      children = _ref.children,
      isLoading = _ref.isLoading,
      rowsPerPageOptions = _ref.rowsPerPageOptions;

  var paginationProps = {
    count: count, rowsPerPage: rowsPerPage, page: page, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, hideCount: hideCount, rowsPerPageOptions: rowsPerPageOptions
  };

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    react__WEBPACK_IMPORTED_MODULE_0__["Fragment"],
    null,
    isLoading && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { className: _classes__WEBPACK_IMPORTED_MODULE_7__["default"].paginationLoadingContainer },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: _classes__WEBPACK_IMPORTED_MODULE_7__["default"].paginationLoading },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_5___default.a, null)
      )
    ),
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { style: { visibility: isLoading ? "hidden" : undefined }, className: _classes__WEBPACK_IMPORTED_MODULE_7__["default"].paginationRoot, 'data-component': 'PreviewList-List' },
      children,
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Table__WEBPACK_IMPORTED_MODULE_2___default.a,
        { className: _classes__WEBPACK_IMPORTED_MODULE_7__["default"].paginationTable },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_TableFooter__WEBPACK_IMPORTED_MODULE_3___default.a,
          null,
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_TableRow__WEBPACK_IMPORTED_MODULE_4___default.a,
            null,
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_6__["TablePagination"], paginationProps)
          )
        )
      )
    )
  );
};

Paged.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,
  count: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  page: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  rowsPerPage: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  rowsPerPageOptions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number),
  onChangePage: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  onChangeRowsPerPage: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  hideCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  isLoading: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};

Paged.defaultProps = {
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 25],
  count: 0,
  page: 0,
  hideCount: false,
  isLoading: false
};

/* harmony default export */ __webpack_exports__["default"] = (Paged);

/***/ }),

/***/ "./src/PreviewList/styles.scss":
/*!*************************************!*\
  !*** ./src/PreviewList/styles.scss ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/PreviewList/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/PreviewList/tertiaryDate.jsx":
/*!******************************************!*\
  !*** ./src/PreviewList/tertiaryDate.jsx ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Colored__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Colored */ "./src/Colored/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./styles.scss */ "./src/PreviewList/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);





var TertiaryDate = function TertiaryDate(_ref) {
  var label = _ref.label,
      value = _ref.value,
      statusIcon = _ref.statusIcon;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment,
    null,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Colored__WEBPACK_IMPORTED_MODULE_2__["default"],
      { component: 'span', color: 'lightTextSecondary' },
      label,
      ':'
    ),
    ' ',
    value,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'span',
      { className: _styles_scss__WEBPACK_IMPORTED_MODULE_3___default.a.statusIcon },
      statusIcon
    )
  );
};

TertiaryDate.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  statusIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};

TertiaryDate.defaultProps = {
  label: null,
  value: null,
  statusIcon: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (TertiaryDate);

/***/ }),

/***/ "./src/RichTextEditor/component.jsx":
/*!******************************************!*\
  !*** ./src/RichTextEditor/component.jsx ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var slate_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! slate-react */ "slate-react");
/* harmony import */ var slate_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slate_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_FormatBold__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/icons/FormatBold */ "@material-ui/icons/FormatBold");
/* harmony import */ var _material_ui_icons_FormatBold__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_FormatBold__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_FormatItalic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/icons/FormatItalic */ "@material-ui/icons/FormatItalic");
/* harmony import */ var _material_ui_icons_FormatItalic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_FormatItalic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_icons_FormatUnderlined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/icons/FormatUnderlined */ "@material-ui/icons/FormatUnderlined");
/* harmony import */ var _material_ui_icons_FormatUnderlined__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_FormatUnderlined__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_icons_FormatClear__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @material-ui/icons/FormatClear */ "@material-ui/icons/FormatClear");
/* harmony import */ var _material_ui_icons_FormatClear__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_FormatClear__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_icons_AddPhotoAlternate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @material-ui/icons/AddPhotoAlternate */ "@material-ui/icons/AddPhotoAlternate");
/* harmony import */ var _material_ui_icons_AddPhotoAlternate__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_AddPhotoAlternate__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components */ "./src/RichTextEditor/components/index.js");
/* harmony import */ var _plugins__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./plugins */ "./src/RichTextEditor/plugins/index.js");
/* harmony import */ var _htmlSerializer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./htmlSerializer */ "./src/RichTextEditor/htmlSerializer.jsx");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./helpers */ "./src/RichTextEditor/helpers.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./styles.scss */ "./src/RichTextEditor/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_15__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var RichTextEditor = function (_React$Component) {
  _inherits(RichTextEditor, _React$Component);

  function RichTextEditor(props) {
    _classCallCheck(this, RichTextEditor);

    var _this = _possibleConstructorReturn(this, (RichTextEditor.__proto__ || Object.getPrototypeOf(RichTextEditor)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      value: _htmlSerializer__WEBPACK_IMPORTED_MODULE_13__["default"].deserialize(props.initialValue)
    };

    _this.schema = Object(_helpers__WEBPACK_IMPORTED_MODULE_14__["schema"])(props.readOnly);

    _this.plugins = [Object(_plugins__WEBPACK_IMPORTED_MODULE_12__["insertImagePlugin"])({
      onInsertImage: _this.props.onInsertImage,
      onError: props.onInsertImageError,
      maxImageSize: props.maxImageSize
    }), Object(_plugins__WEBPACK_IMPORTED_MODULE_12__["helperCommandsPlugin"])(), Object(_plugins__WEBPACK_IMPORTED_MODULE_12__["textColorPlugin"])()];
    _this.editorRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();
    return _this;
  }

  _createClass(RichTextEditor, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.updateDisplayBasedOnSelection(prevState.value);

      if (prevProps.readOnly !== this.props.readOnly) {
        this.schema = Object(_helpers__WEBPACK_IMPORTED_MODULE_14__["schema"])(this.props.readOnly);
      }
    }

    // passes the current value to the parent element as HTML


    // a mark is a text format instruction (e.g. 'bold', 'underline')

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var value = this.state.value;
      var _props = this.props,
          readOnly = _props.readOnly,
          customClass = _props.className;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('richTextEditor', _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.editor, customClass, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.readOnly, readOnly)),
            onClick: function onClick() {
              return _this2.editor.focus();
            }
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(slate_react__WEBPACK_IMPORTED_MODULE_1__["Editor"], {
            schema: this.schema,
            plugins: this.plugins,
            value: value,
            onChange: this.onChange,
            renderMark: this.renderMark,
            renderBlock: this.renderBlock,
            renderInline: this.renderInline,
            ref: this.editorRef,
            readOnly: readOnly
          })
        ),
        !readOnly && this.renderToolbar()
      );
    }
  }, {
    key: 'editor',
    get: function get() {
      return this.editorRef.current;
    }
  }]);

  return RichTextEditor;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onChange = function (_ref) {
    var value = _ref.value;
    var onValueChange = _this3.props.onValueChange;


    if (value.document !== _this3.state.value.document) {
      var html = _htmlSerializer__WEBPACK_IMPORTED_MODULE_13__["default"].serialize(value);
      if (onValueChange) onValueChange(html);
    }

    _this3.setState({ value: value });
  };

  this.onClickMark = function (type) {
    _this3.editor.toggleMark(type);
  };

  this.updateDisplayBasedOnSelection = function (oldValue) {
    var value = _this3.state.value;

    if (!value || !oldValue) {
      return;
    }

    var oldSelectedInlinesCount = oldValue.inlines.count();
    var newSelectedInlinesCount = value.inlines.count();

    var _ref2 = oldValue.inlines.first() || {},
        oldSelectionType = _ref2.type;

    var _ref3 = value.inlines.first() || {},
        newSelectionType = _ref3.type;

    if (oldSelectionType === newSelectionType && oldSelectedInlinesCount === newSelectedInlinesCount) {
      return;
    }

    _this3.setState({
      showImageButtons: newSelectionType === 'image' && newSelectedInlinesCount === 1
    });
  };

  this.hasMark = function (type) {
    var value = _this3.state.value;

    return value.marks.some(function (mark) {
      return mark.type === type;
    });
  };

  this.currentColor = function () {
    var color = _this3.state.value.marks.filter(function (mark) {
      return mark.type === 'color';
    }).first();
    return color ? color.data.get('color') : undefined;
  };

  this.currentSize = function () {
    if (!_this3.currentlySelected('inlines')) return undefined;
    return _this3.currentlySelected('inlines').data.get('width');
  };

  this.currentlySelected = function (nodeType) {
    var _ref4 = _this3.state || {},
        value = _ref4.value;

    if (!value) {
      return undefined;
    }
    return value[nodeType].first();
  };

  this.handleImageResize = function (newWidth) {
    var imageNode = _this3.currentlySelected('inlines');
    _this3.editor.updateNodeData(imageNode, { width: newWidth });
  };

  this.renderMark = function (props, _, next) {
    return _htmlSerializer__WEBPACK_IMPORTED_MODULE_13__["convertToHtml"].marks(props.mark, props.children, next);
  };

  this.renderBlock = function (props, _, next) {
    return _htmlSerializer__WEBPACK_IMPORTED_MODULE_13__["convertToHtml"].blocks(props.node, props.children, next);
  };

  this.renderInline = function (props, _, next) {
    var attributes = props.attributes,
        node = props.node,
        isFocused = props.isFocused;


    switch (node.type) {
      case 'image':
        {
          var width = node.data.get('width');
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('img', _extends({
            alt: ''
          }, attributes, {
            src: node.data.get('src'),
            width: width ? width : 'auto',
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(___WEBPACK_IMPORTED_MODULE_9__["layout"].inline, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.image, _defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_15___default.a.focus, isFocused))
          }));
        }
      default:
        return next();
    }
  };

  this.renderMarkButton = function (type, icon) {
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components__WEBPACK_IMPORTED_MODULE_11__["EditorButton"], {
      onClick: function onClick() {
        return _this3.onClickMark(type);
      },
      icon: icon,
      isActive: _this3.hasMark(type),
      tooltip: Object(_utils__WEBPACK_IMPORTED_MODULE_10__["capitalize"])(type)
    });
  };

  this.renderToolbar = function () {
    var showImageButtons = _this3.state.showImageButtons;
    var toolbarFeatures = _this3.props.toolbarFeatures;


    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { className: ___WEBPACK_IMPORTED_MODULE_9__["layout"].paddingTopXS },
      toolbarFeatures.bold && _this3.renderMarkButton('bold', _material_ui_icons_FormatBold__WEBPACK_IMPORTED_MODULE_4___default.a),
      toolbarFeatures.italic && _this3.renderMarkButton('italic', _material_ui_icons_FormatItalic__WEBPACK_IMPORTED_MODULE_5___default.a),
      toolbarFeatures.underline && _this3.renderMarkButton('underline', _material_ui_icons_FormatUnderlined__WEBPACK_IMPORTED_MODULE_6___default.a),
      toolbarFeatures.color && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components__WEBPACK_IMPORTED_MODULE_11__["ChangeColorButton"], {
        currentColor: _this3.currentColor(),
        onColorChange: function onColorChange(hexColor) {
          return _this3.editor.changeColor(hexColor);
        }
      }),
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components__WEBPACK_IMPORTED_MODULE_11__["EditorButton"], {
        onClick: function onClick() {
          return _this3.editor.removeAllMarks();
        },
        icon: _material_ui_icons_FormatClear__WEBPACK_IMPORTED_MODULE_7___default.a,
        tooltip: 'Clear all formatting'
      }),
      toolbarFeatures.image && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment,
        null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components__WEBPACK_IMPORTED_MODULE_11__["EditorButton"], {
          onClick: function onClick() {
            return _this3.editor.insertImage();
          },
          icon: _material_ui_icons_AddPhotoAlternate__WEBPACK_IMPORTED_MODULE_8___default.a,
          tooltip: 'Insert image'
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components__WEBPACK_IMPORTED_MODULE_11__["ResizeImageButtons"], {
          visible: showImageButtons,
          onResize: _this3.handleImageResize,
          currentSize: _this3.currentSize()
        })
      )
    );
  };
};

RichTextEditor.propTypes = {
  initialValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  onValueChange: _helpers__WEBPACK_IMPORTED_MODULE_14__["requiredFunctionUnlessReadOnly"],
  /**
   * optional function to override default behaviour.
   * 'onInsertImage' should accept the image file and a callback as parameters
   * & call 'callback' with the image's 'src' value (e.g. a URL).
   */
  onInsertImage: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  onInsertImageError: _helpers__WEBPACK_IMPORTED_MODULE_14__["requiredFunctionUnlessReadOnly"],
  maxImageSize: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  readOnly: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  toolbarFeatures: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    bold: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
    italic: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
    underline: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
    color: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
    image: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool
  })
};

RichTextEditor.defaultProps = {
  initialValue: '',
  onValueChange: undefined,
  onInsertImage: undefined,
  onInsertImageError: undefined,
  maxImageSize: 2 * 1024 * 1024, // 2 Mb
  readOnly: false,
  className: '',
  toolbarFeatures: {
    bold: true,
    italic: true,
    underline: true,
    color: true,
    image: true
  }
};

/* harmony default export */ __webpack_exports__["default"] = (RichTextEditor);

/***/ }),

/***/ "./src/RichTextEditor/components/ChangeColorButton.jsx":
/*!*************************************************************!*\
  !*** ./src/RichTextEditor/components/ChangeColorButton.jsx ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_icons_ColorLens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/icons/ColorLens */ "@material-ui/icons/ColorLens");
/* harmony import */ var _material_ui_icons_ColorLens__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_ColorLens__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Popover */ "@material-ui/core/Popover");
/* harmony import */ var _material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react-color */ "react-color");
/* harmony import */ var react_color__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_color__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _EditorButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./EditorButton */ "./src/RichTextEditor/components/EditorButton.jsx");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ChangeColorButton = function (_React$Component) {
  _inherits(ChangeColorButton, _React$Component);

  function ChangeColorButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChangeColorButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChangeColorButton.__proto__ || Object.getPrototypeOf(ChangeColorButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = { showColorPicker: false }, _this.onColorChange = function (color) {
      return _this.props.onColorChange(color.hex);
    }, _this.colorBtnRef = function (colorBtn) {
      _this.colorBtn = colorBtn;
    }, _this.toggleColorPicker = function () {
      return _this.setState(function (_ref2) {
        var showColorPicker = _ref2.showColorPicker;
        return { showColorPicker: !showColorPicker };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChangeColorButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var showColorPicker = this.state.showColorPicker;
      var currentColor = this.props.currentColor;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'span',
        { ref: this.colorBtnRef },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_EditorButton__WEBPACK_IMPORTED_MODULE_5__["default"], {
          onClick: this.toggleColorPicker,
          icon: _material_ui_icons_ColorLens__WEBPACK_IMPORTED_MODULE_2___default.a,
          color: currentColor,
          tooltip: 'Text colour'
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_Popover__WEBPACK_IMPORTED_MODULE_3___default.a,
          {
            anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
            open: showColorPicker,
            anchorEl: this.colorBtn,
            onClose: function onClose() {
              return _this2.toggleColorPicker();
            }
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_color__WEBPACK_IMPORTED_MODULE_4__["SketchPicker"], {
            color: currentColor,
            onChangeComplete: this.onColorChange
          })
        )
      );
    }
  }]);

  return ChangeColorButton;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

ChangeColorButton.propTypes = {
  currentColor: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  onColorChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired
};

ChangeColorButton.defaultProps = {
  currentColor: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (ChangeColorButton);

/***/ }),

/***/ "./src/RichTextEditor/components/EditorButton.jsx":
/*!********************************************************!*\
  !*** ./src/RichTextEditor/components/EditorButton.jsx ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../.. */ "./src/index.js");




var EditorButton = function EditorButton(_ref) {
  var onClick = _ref.onClick,
      Icon = _ref.icon,
      isActive = _ref.isActive,
      color = _ref.color,
      tooltip = _ref.tooltip;

  var renderButton = function renderButton() {
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      ___WEBPACK_IMPORTED_MODULE_2__["IconButton"],
      {
        active: isActive,
        onClick: onClick
      },
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Icon, { style: { color: color } })
    );
  };

  if (!tooltip) {
    return renderButton();
  }

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    ___WEBPACK_IMPORTED_MODULE_2__["Tooltip"],
    { title: tooltip, placement: 'bottom-end' },
    renderButton()
  );
};

EditorButton.propTypes = {
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object).isRequired,
  isActive: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  color: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

EditorButton.defaultProps = {
  isActive: false,
  color: undefined,
  tooltip: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (EditorButton);

/***/ }),

/***/ "./src/RichTextEditor/components/EditorPreview.jsx":
/*!*********************************************************!*\
  !*** ./src/RichTextEditor/components/EditorPreview.jsx ***!
  \*********************************************************/
/*! exports provided: EditorPreviewRaw, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EditorPreviewRaw", function() { return EditorPreviewRaw; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! .. */ "./src/RichTextEditor/index.js");
/* harmony import */ var _withKey__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../withKey */ "./src/withKey/index.jsx");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var EditorPreview = function EditorPreview(props) {
  var value = props.value,
      rest = _objectWithoutProperties(props, ['value']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_2__["default"], _extends({
    initialValue: value,
    readOnly: true
  }, rest));
};

EditorPreview.propTypes = {
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

EditorPreview.defaultProps = {
  value: ''
};

var EditorPreviewRaw = EditorPreview;
/* harmony default export */ __webpack_exports__["default"] = (Object(_withKey__WEBPACK_IMPORTED_MODULE_3__["default"])(function (_ref) {
  var value = _ref.value;
  return value;
})(EditorPreview));

/***/ }),

/***/ "./src/RichTextEditor/components/ResizeImageButtons.jsx":
/*!**************************************************************!*\
  !*** ./src/RichTextEditor/components/ResizeImageButtons.jsx ***!
  \**************************************************************/
/*! exports provided: parse, ResizeImageButtonsRaw, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResizeImageButtonsRaw", function() { return ResizeImageButtonsRaw; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_icons_PhotoSizeSelectSmall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/icons/PhotoSizeSelectSmall */ "@material-ui/icons/PhotoSizeSelectSmall");
/* harmony import */ var _material_ui_icons_PhotoSizeSelectSmall__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_PhotoSizeSelectSmall__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_PhotoSizeSelectLarge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/icons/PhotoSizeSelectLarge */ "@material-ui/icons/PhotoSizeSelectLarge");
/* harmony import */ var _material_ui_icons_PhotoSizeSelectLarge__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_PhotoSizeSelectLarge__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_PhotoSizeSelectActual__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/icons/PhotoSizeSelectActual */ "@material-ui/icons/PhotoSizeSelectActual");
/* harmony import */ var _material_ui_icons_PhotoSizeSelectActual__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_PhotoSizeSelectActual__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../.. */ "./src/index.js");
/* harmony import */ var _withKey__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../withKey */ "./src/withKey/index.jsx");
/* harmony import */ var _EditorButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./EditorButton */ "./src/RichTextEditor/components/EditorButton.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../styles.scss */ "./src/RichTextEditor/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_9__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MAX_WIDTH = 10000;
var SMALL_WIDTH = '150px';
var MEDIUM_WIDTH = '250px';

// Strips non-numeric chars and adds 'px'. Returns empty string if invalid.
var parse = function parse(value) {
  if (!value) return '';
  var number = parseInt(value.replace(/\D/g, ''), 10);
  var isValid = !!number && number > 0 && number <= MAX_WIDTH;
  return isValid ? number + 'px' : '';
};

var ResizeImageButtons = function (_React$Component) {
  _inherits(ResizeImageButtons, _React$Component);

  function ResizeImageButtons(props) {
    _classCallCheck(this, ResizeImageButtons);

    var _this = _possibleConstructorReturn(this, (ResizeImageButtons.__proto__ || Object.getPrototypeOf(ResizeImageButtons)).call(this, props));

    _this.onChange = function (_ref) {
      var value = _ref.target.value;

      _this.setState({ currentEnteredSize: value });

      var newSize = parse(value);
      if (newSize) {
        _this.setState({ lastValidSize: newSize });
      }
    };

    _this.onBlur = function () {
      return _this.props.onResize(_this.state.lastValidSize);
    };

    var currentSize = parse(props.currentSize);
    _this.state = {
      lastValidSize: currentSize, // value that will be returned on blur
      currentEnteredSize: currentSize // what's currently typed in the field
    };
    return _this;
  }

  _createClass(ResizeImageButtons, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          visible = _props.visible,
          onResize = _props.onResize,
          currentSize = _props.currentSize;


      if (!visible) return null;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment,
        null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('div', { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(___WEBPACK_IMPORTED_MODULE_6__["layout"].fullHeight, ___WEBPACK_IMPORTED_MODULE_6__["layout"].dividerRight, ___WEBPACK_IMPORTED_MODULE_6__["layout"].inline, ___WEBPACK_IMPORTED_MODULE_6__["layout"].marginSmall) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_EditorButton__WEBPACK_IMPORTED_MODULE_8__["default"], {
          onClick: function onClick() {
            return onResize(SMALL_WIDTH);
          },
          icon: _material_ui_icons_PhotoSizeSelectSmall__WEBPACK_IMPORTED_MODULE_3___default.a,
          isActive: currentSize === SMALL_WIDTH,
          tooltip: 'Resize image to small'
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_EditorButton__WEBPACK_IMPORTED_MODULE_8__["default"], {
          onClick: function onClick() {
            return onResize(MEDIUM_WIDTH);
          },
          icon: _material_ui_icons_PhotoSizeSelectLarge__WEBPACK_IMPORTED_MODULE_4___default.a,
          isActive: currentSize === MEDIUM_WIDTH,
          tooltip: 'Resize image to medium'
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_EditorButton__WEBPACK_IMPORTED_MODULE_8__["default"], {
          onClick: function onClick() {
            return onResize(undefined);
          },
          icon: _material_ui_icons_PhotoSizeSelectActual__WEBPACK_IMPORTED_MODULE_5___default.a,
          isActive: currentSize === undefined,
          tooltip: 'Use image\'s original size'
        }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.imgSizeInput, ___WEBPACK_IMPORTED_MODULE_6__["layout"].inlineBlock, ___WEBPACK_IMPORTED_MODULE_6__["layout"].paddingLeftSmall) },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_6__["Input"], {
            label: 'Custom Size',
            value: this.state.currentEnteredSize,
            onChange: this.onChange,
            onBlur: this.onBlur,
            noMargin: true,
            notInForm: true,
            placeholder: 'Custom'
          })
        )
      );
    }
  }]);

  return ResizeImageButtons;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

ResizeImageButtons.propTypes = {
  visible: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  onResize: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired,
  currentSize: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};

ResizeImageButtons.defaultProps = {
  visible: false,
  currentSize: undefined
};

var ResizeImageButtonsRaw = ResizeImageButtons;
/* harmony default export */ __webpack_exports__["default"] = (Object(_withKey__WEBPACK_IMPORTED_MODULE_7__["default"])(function (_ref2) {
  var currentSize = _ref2.currentSize;
  return currentSize;
})(ResizeImageButtons));

/***/ }),

/***/ "./src/RichTextEditor/components/index.js":
/*!************************************************!*\
  !*** ./src/RichTextEditor/components/index.js ***!
  \************************************************/
/*! exports provided: ChangeColorButton, EditorButton, EditorPreview, ResizeImageButtons */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ChangeColorButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ChangeColorButton */ "./src/RichTextEditor/components/ChangeColorButton.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChangeColorButton", function() { return _ChangeColorButton__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _EditorButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EditorButton */ "./src/RichTextEditor/components/EditorButton.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EditorButton", function() { return _EditorButton__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _EditorPreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./EditorPreview */ "./src/RichTextEditor/components/EditorPreview.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EditorPreview", function() { return _EditorPreview__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _ResizeImageButtons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ResizeImageButtons */ "./src/RichTextEditor/components/ResizeImageButtons.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeImageButtons", function() { return _ResizeImageButtons__WEBPACK_IMPORTED_MODULE_3__["default"]; });






/***/ }),

/***/ "./src/RichTextEditor/helpers.js":
/*!***************************************!*\
  !*** ./src/RichTextEditor/helpers.js ***!
  \***************************************/
/*! exports provided: schema, defaultCss, requiredFunctionUnlessReadOnly */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "schema", function() { return schema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCss", function() { return defaultCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requiredFunctionUnlessReadOnly", function() { return requiredFunctionUnlessReadOnly; });
/* harmony import */ var slate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slate */ "slate");
/* harmony import */ var slate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slate__WEBPACK_IMPORTED_MODULE_0__);

// import { paletteCommonDarkBlack } from '../theme.scss';

/**
 * permitMultipleWrappers allows multiple templates to be combined in the one RichTextEditor for previewing.
 * For now, this should only be used in readOnly mode as multiple divs leads to errors when editing.
 */
var schema = function schema() {
  var permitMultipleWrappers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    document: {
      nodes: [{ match: [{ type: 'wrapper' }], min: 1, max: permitMultipleWrappers ? undefined : 1 }],
      normalize: function normalize(editor, _ref) {
        var code = _ref.code;

        switch (code) {
          // ensure default CSS is applied to text
          case 'child_type_invalid':
            {
              editor.moveToRangeOfDocument();
              editor.wrapBlock('wrapper');
              editor.deselect();
              return;
            }
          default:
            {
              throw new Error('RichTextEditor encountered an unexpected invalid state: ' + code);
            }
        }
      }
    },
    inlines: {
      image: {
        isVoid: true
      },
      paragraph: {}
    },
    blocks: {
      wrapper: {
        nodes: [{ match: [{ type: 'paragraph' }, { type: 'image' }] }],

        // make sure we always have a paragraph at the end.
        // This prevents bugs like not being able to put the
        // cursor after an image, or having zero paragraph elements
        // in the editor
        last: { type: 'paragraph' },
        normalize: function normalize(editor, _ref2) {
          var code = _ref2.code,
              node = _ref2.node;

          switch (code) {
            case 'last_child_type_invalid':
              {
                var paragraph = slate__WEBPACK_IMPORTED_MODULE_0__["Block"].create('paragraph');
                editor.insertNodeByKey(node.key, node.nodes.size, paragraph);
                return;
              }
            case 'child_required':
              {
                var _paragraph = slate__WEBPACK_IMPORTED_MODULE_0__["Block"].create('paragraph');
                editor.insertNodeByKey(node.key, 0, _paragraph);
                return;
              }
            default:
              {
                throw new Error('RichTextEditor encountered an unexpected invalid state: ' + code);
              }
          }
        }
      }
    }
  };
};

var defaultCss = {
  // fontFamily: 'sans-serif',
  // fontFeatureSettings: '"kern", "liga", "pnum"',
  // fontSize: '16px',
  // fontWeight: '400',
  // lineHeight: '20.8px',
  // color: paletteCommonDarkBlack,
};

// Prop types validation
var requiredFunctionUnlessReadOnly = function requiredFunctionUnlessReadOnly(props, propName, component) {
  var prop = props[propName];
  var readOnly = props.readOnly;


  if (readOnly) return;
  if (!prop) throw new Error('prop ' + propName + ' is required for ' + component + '.');
  if (typeof prop !== 'function') throw new Error(component + ' prop ' + propName + ' must be a function.');
};

/***/ }),

/***/ "./src/RichTextEditor/htmlSerializer.jsx":
/*!***********************************************!*\
  !*** ./src/RichTextEditor/htmlSerializer.jsx ***!
  \***********************************************/
/*! exports provided: convertToHtml, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertToHtml", function() { return convertToHtml; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var slate_html_serializer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! slate-html-serializer */ "slate-html-serializer");
/* harmony import */ var slate_html_serializer__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slate_html_serializer__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers */ "./src/RichTextEditor/helpers.js");




var BLOCK_TAGS = {
  p: 'paragraph',
  div: 'wrapper' // wrapper to set default CSS for the text content
};

var MARK_TAGS = {
  em: 'italic',
  strong: 'bold',
  u: 'underline',
  span: 'color'
};

var INLINE_TAGS = {
  img: 'image'

  // assumes only one style, of type 'color', is defined in style attribute
};var colorFromStyle = function colorFromStyle(el) {
  var styles = el.getAttribute('style').split(':');
  if (styles.length === 2 && styles[0] === 'color') {
    return styles[1];
  }
  return undefined;
};

var convertToHtml = {
  marks: function marks(mark, children) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    switch (mark.type) {
      case 'bold':
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'strong',
          null,
          children
        );
      case 'italic':
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'em',
          null,
          children
        );
      case 'underline':
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'u',
          null,
          children
        );
      case 'color':
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'span',
          { style: { color: mark.data.get('color') } },
          children
        );
      default:
        return fallback ? fallback() : null;
    }
  },

  blocks: function blocks(node, children) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    switch (node.type) {
      case 'paragraph':
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'p',
          { className: node.data.get('className') },
          children
        );
      case 'wrapper':
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { style: _helpers__WEBPACK_IMPORTED_MODULE_2__["defaultCss"] },
          children
        );
      default:
        return fallback ? fallback() : null;
    }
  }
};

var rules = [{
  deserialize: function deserialize(el, next) {
    var blockType = BLOCK_TAGS[el.tagName.toLowerCase()];
    var markType = MARK_TAGS[el.tagName.toLowerCase()];
    var inlineType = INLINE_TAGS[el.tagName.toLowerCase()];

    var data = {};

    if (blockType) {
      return {
        object: 'block',
        type: blockType,
        data: data,
        nodes: next(el.childNodes)
      };
    }

    if (markType) {
      if (markType === 'color') {
        data.color = colorFromStyle(el);
      }
      return {
        object: 'mark',
        type: markType,
        data: data,
        nodes: next(el.childNodes)
      };
    }

    if (inlineType) {
      if (inlineType === 'image') {
        data.src = el.getAttribute('src');
        data.width = el.getAttribute('width');
      }
      return {
        object: 'inline',
        type: inlineType,
        data: data,
        nodes: next(el.childNodes)
      };
    }

    return undefined;
  },
  serialize: function serialize(obj, children) {
    if (obj.object === 'block') {
      return convertToHtml.blocks(obj, children);
    }
    if (obj.object === 'inline') {
      switch (obj.type) {
        case 'image':
          {
            var width = obj.data.get('width');
            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('img', { src: obj.data.get('src'), alt: '', width: width ? width : 'auto' });
          }
        default:
          return null;
      }
    }
    if (obj.object === 'mark') {
      return convertToHtml.marks(obj, children);
    }
  }
}];

/* harmony default export */ __webpack_exports__["default"] = (new slate_html_serializer__WEBPACK_IMPORTED_MODULE_1___default.a({ rules: rules }));

/***/ }),

/***/ "./src/RichTextEditor/index.js":
/*!*************************************!*\
  !*** ./src/RichTextEditor/index.js ***!
  \*************************************/
/*! exports provided: default, EditorPreview */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/RichTextEditor/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _components_EditorPreview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/EditorPreview */ "./src/RichTextEditor/components/EditorPreview.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EditorPreview", function() { return _components_EditorPreview__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),

/***/ "./src/RichTextEditor/plugins/helperCommands.js":
/*!******************************************************!*\
  !*** ./src/RichTextEditor/plugins/helperCommands.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var commands = {
  removeAllMarks: function removeAllMarks(editor) {
    editor.value.marks.forEach(function (mark) {
      return editor.removeMark(mark);
    });
  },
  updateNodeData: function updateNodeData(editor, node, newData) {
    editor.setNodeByKey(node.key, {
      data: _extends({}, node.data.toJS(), newData)
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    onConstruct: function onConstruct(editor, next) {
      Object.keys(commands).forEach(function (cmd) {
        return editor.registerCommand(cmd);
      });
      return next();
    },
    commands: commands
  };
});

/***/ }),

/***/ "./src/RichTextEditor/plugins/index.js":
/*!*********************************************!*\
  !*** ./src/RichTextEditor/plugins/index.js ***!
  \*********************************************/
/*! exports provided: helperCommandsPlugin, insertImagePlugin, textColorPlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helperCommands__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helperCommands */ "./src/RichTextEditor/plugins/helperCommands.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "helperCommandsPlugin", function() { return _helperCommands__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _insertImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./insertImage */ "./src/RichTextEditor/plugins/insertImage.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "insertImagePlugin", function() { return _insertImage__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _textColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./textColor */ "./src/RichTextEditor/plugins/textColor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "textColorPlugin", function() { return _textColor__WEBPACK_IMPORTED_MODULE_2__["default"]; });





/***/ }),

/***/ "./src/RichTextEditor/plugins/insertImage.jsx":
/*!****************************************************!*\
  !*** ./src/RichTextEditor/plugins/insertImage.jsx ***!
  \****************************************************/
/*! exports provided: defaultInsertImageHandler, Editor, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultInsertImageHandler", function() { return defaultInsertImageHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Editor", function() { return Editor; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-dropzone */ "react-dropzone");
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_dropzone__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../.. */ "./src/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PERMITTED_MIMES = ['image/png', 'image/jpg', 'image/jpeg', 'image/tiff'];
var DEFAULT_MAX_IMAGE_SIZE = 100000000;

// The default handler sets the image 'src' to a data URI of the image
var defaultInsertImageHandler = function defaultInsertImageHandler(file, callback) {
  var reader = new FileReader();
  reader.onload = function (event) {
    return callback(event.target.result);
  };
  reader.readAsDataURL(file);
};

var Editor = function (_React$Component) {
  _inherits(Editor, _React$Component);

  function Editor() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Editor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Editor.__proto__ || Object.getPrototypeOf(Editor)).call.apply(_ref, [this].concat(args))), _this), _this.insertImageInEditor = function (src) {
      _this.props.editor.insertInline({
        type: 'image',
        data: { src: src }
      });
    }, _this.handleInsertFiles = function (files) {
      files.forEach(function (file) {
        if (!PERMITTED_MIMES.includes(file.type)) return;
        _this.props.onInsertImage(file, _this.insertImageInEditor);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // inserts img element with the requested src into editor text field


  // processes selected files for inserting


  _createClass(Editor, [{
    key: 'render',


    // renders hidden file input alongside Slate editor
    value: function render() {
      var _props2 = this.props,
          next = _props2.next,
          imageInputRef = _props2.imageInputRef,
          maxImageSize = _props2.maxImageSize,
          onError = _props2.onError;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment,
        null,
        next(),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { className: ___WEBPACK_IMPORTED_MODULE_3__["layout"].hidden },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_dropzone__WEBPACK_IMPORTED_MODULE_2___default.a, {
            onDrop: this.handleInsertFiles,
            ref: imageInputRef,
            maxSize: maxImageSize,
            accept: PERMITTED_MIMES.join(','),
            onDropRejected: function onDropRejected() {
              if (onError) {
                onError('File is either over ' + maxImageSize / 1000000 + 'mb, or an invalid type. Valid file types are PNG, JPG or JPEG and TIFF.');
              }
            }
          })
        )
      );
    }
  }]);

  return Editor;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

Editor.propTypes = {
  editor: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object).isRequired,
  next: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  imageInputRef: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object).isRequired,
  maxImageSize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  onInsertImage: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onError: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

Editor.defaultProps = {
  maxImageSize: DEFAULT_MAX_IMAGE_SIZE,
  onInsertImage: defaultInsertImageHandler,
  onError: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (function (props) {
  var imageInputRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();

  return {
    renderEditor: function renderEditor(_props, editor, next) {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Editor, _extends({
        editor: editor,
        next: next,
        imageInputRef: imageInputRef
      }, props));
    },
    commands: {
      insertImage: function insertImage() {
        return imageInputRef.current.open();
      }
    },
    onConstruct: function onConstruct(editor, next) {
      editor.registerCommand('insertImage');
      return next();
    }
  };
});

/***/ }),

/***/ "./src/RichTextEditor/plugins/textColor.js":
/*!*************************************************!*\
  !*** ./src/RichTextEditor/plugins/textColor.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    commands: {
      // sets current selection to specified color (in hex, e.g. '#fff')
      changeColor: function changeColor(editor, color) {
        editor.value.marks.forEach(function (mark) {
          if (mark.type === 'color') {
            editor.removeMark(mark);
          }
        });

        editor.addMark({
          type: 'color',
          data: { color: color }
        });
      }
    },
    onConstruct: function onConstruct(editor, next) {
      editor.registerCommand('changeColor');
      return next();
    }
  };
});

/***/ }),

/***/ "./src/RichTextEditor/styles.scss":
/*!****************************************!*\
  !*** ./src/RichTextEditor/styles.scss ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/RichTextEditor/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/SearchInput/index.js":
/*!**********************************!*\
  !*** ./src/SearchInput/index.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _searchInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./searchInput */ "./src/SearchInput/searchInput.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _searchInput__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),

/***/ "./src/SearchInput/searchInput.jsx":
/*!*****************************************!*\
  !*** ./src/SearchInput/searchInput.jsx ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/CircularProgress */ "@material-ui/core/CircularProgress");
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/Paper */ "@material-ui/core/Paper");
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/ClickAwayListener */ "@material-ui/core/ClickAwayListener");
/* harmony import */ var _material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/icons/Search */ "@material-ui/icons/Search");
/* harmony import */ var _material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Input_input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Input/input */ "./src/Input/input.jsx");
/* harmony import */ var _searchInput_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./searchInput.scss */ "./src/SearchInput/searchInput.scss");
/* harmony import */ var _searchInput_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_searchInput_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Input_styles_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Input/styles.scss */ "./src/Input/styles.scss");
/* harmony import */ var _Input_styles_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Input_styles_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Input_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Input/utils */ "./src/Input/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














function shouldSearch(text, minLetters) {
  if (text.trim().length < minLetters) return false;
  return true;
}

// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var SearchInput = function (_React$PureComponent) {
  _inherits(SearchInput, _React$PureComponent);

  function SearchInput(props) {
    _classCallCheck(this, SearchInput);

    var _this = _possibleConstructorReturn(this, (SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).call(this, props));

    _this.onClickAway = function () {
      if (_this.state.open) {
        _this.forceClose();
        _this.fakeBlur();
      }
    };

    _this.fakeBlur = function () {
      if (_this.props.onBlur) {
        _this.props.onBlur({
          target: {
            value: _this.state.searchText
          }
        });
      }
    };

    _this.handleKeyDown = function (event) {
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }

      if (event.keyCode === _Input_utils__WEBPACK_IMPORTED_MODULE_10__["asciiCodes"].TAB) {
        _this.forceClose();
        _this.fakeBlur();
      }
    };

    _this.handleFocus = function (event) {
      _this.setState({
        open: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.forceClose = function () {
      _this.setState({ open: false });
    };

    _this.handleChange = function (event) {
      var self = _this;
      var searchText = event.target.value;
      var _this$state = _this.state,
          lastSearchText = _this$state.searchText,
          searchCancelled = _this$state.searchCancelled;
      var _this$props = _this.props,
          isSearching = _this$props.isSearching,
          minLetters = _this$props.minLetters,
          onCancelSearch = _this$props.onCancelSearch,
          deferMillis = _this$props.deferMillis,
          onSearch = _this$props.onSearch;

      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }
      _this.setState({ searchText: searchText });
      if (isSearching && !searchCancelled && onCancelSearch && shouldSearch(searchText, minLetters)) {
        onCancelSearch(lastSearchText);
        _this.setState({ searchCancelled: true });
      }
      if (shouldSearch(searchText, minLetters)) {
        _this.timeout = setTimeout(function () {
          onSearch(searchText);
          self.setState({ searchCancelled: false });
        }, deferMillis);
      }
      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.renderAdornment = function () {
      var isSearching = _this.props.isSearching;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'span',
        { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_searchInput_scss__WEBPACK_IMPORTED_MODULE_8___default.a.icon) },
        !isSearching && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_6___default.a, null),
        isSearching && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_3___default.a, { size: 20, thickness: 3 })
      );
    };

    _this.state = {
      searchText: props.value,
      searchCancelled: false,
      open: false
    };
    return _this;
  }

  _createClass(SearchInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({ searchText: nextProps.value });
      }
    }

    // NOTE: The way that this component has been used, this method is called
    // from outside this class to force the results to close.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isSearching = _props.isSearching,
          onSearch = _props.onSearch,
          minLetters = _props.minLetters,
          deferMillis = _props.deferMillis,
          onCancelSearch = _props.onCancelSearch,
          className = _props.className,
          iconPosition = _props.iconPosition,
          inputClassName = _props.inputClassName,
          onBlur = _props.onBlur,
          other = _objectWithoutProperties(_props, ['children', 'isSearching', 'onSearch', 'minLetters', 'deferMillis', 'onCancelSearch', 'className', 'iconPosition', 'inputClassName', 'onBlur']);

      var open = this.state.open;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_5___default.a,
        { onClickAway: this.onClickAway },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_searchInput_scss__WEBPACK_IMPORTED_MODULE_8___default.a.root, className),
            role: 'presentation'
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { className: _searchInput_scss__WEBPACK_IMPORTED_MODULE_8___default.a.inputContainer },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Input_input__WEBPACK_IMPORTED_MODULE_7__["default"], _extends({}, other, {
              className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_searchInput_scss__WEBPACK_IMPORTED_MODULE_8___default.a.input, inputClassName, _Input_styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.reset, iconPosition !== 'none' ? _searchInput_scss__WEBPACK_IMPORTED_MODULE_8___default.a.icon : ''),
              value: this.state.searchText,
              onFocus: this.handleFocus,
              margin: 'none',
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              startAdornment: iconPosition === 'left' ? this.renderAdornment() : other.startAdornment,
              endAdornment: iconPosition === 'right' ? this.renderAdornment() : other.endAdornment,
              autoComplete: 'search-input-text'
            }))
          ),
          !!children && open && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_4___default.a,
            { className: _searchInput_scss__WEBPACK_IMPORTED_MODULE_8___default.a.searchResult },
            children
          )
        )
      );
    }
  }]);

  return SearchInput;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

SearchInput.propTypes = _extends({}, _Input_input__WEBPACK_IMPORTED_MODULE_7__["inputPropTypes"], {
  /** onSearch is a callback will be triggered when a new search is required  */
  // eslint-disable-next-line react/no-typos
  onSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  /** minLetters specify minimum letters required to allow a search to trigger */
  minLetters: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** deferMillis specify the delay for triggering a search */
  deferMillis: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** isSearching is the flag to tell the search input if to render progress */
  isSearching: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * children is the search result content,
   * if provide it will be rendered in a popup paper under search input
   * NOTE: This prop is deprecated. Instead, use SearchSelectInput or render the dropdown search result as a sibling to this component
   */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /**
   * onCancelSearch is the callback will be triggered when currently inSearching
   * but search is not required anymore or searchText changed
   */
  onCancelSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * className will be applied to the root div
   */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** className will be applied to the Input  */
  inputClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Will pass through to Input */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Will pass through to Input */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** When the input has lost focus. You probably expect this to be the native
   * even from the input field, but that causes a race condition where clicking
   * a result results in the onBlur triggering before the onClick, which means
   * item in the dropdown are not selected. So this is a synthetic event which
   * happens when you expect, but might have some edge cases.
   */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Will pass through to Input */
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** iconPosition is the position to display search icon, either left or right, default to right */
  iconPosition: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['left', 'right', 'none']),
  /** initial value (e.g. when used in a form ) */
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
});

SearchInput.defaultProps = _extends({}, _Input_input__WEBPACK_IMPORTED_MODULE_7__["inputDefaultProps"], {
  minLetters: undefined,
  isSearching: false,
  deferMillis: 300,
  children: undefined,
  onCancelSearch: undefined,
  className: undefined,
  inputClassName: undefined,
  iconPosition: 'left',
  value: ''
});

/* harmony default export */ __webpack_exports__["default"] = (SearchInput);

/***/ }),

/***/ "./src/SearchInput/searchInput.scss":
/*!******************************************!*\
  !*** ./src/SearchInput/searchInput.scss ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./searchInput.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/SearchInput/searchInput.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/SearchSelectInput/component.jsx":
/*!*********************************************!*\
  !*** ./src/SearchSelectInput/component.jsx ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/ListItemText */ "@material-ui/core/ListItemText");
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/FormHelperText */ "@material-ui/core/FormHelperText");
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lodash/isEqual */ "lodash/isEqual");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _KeyboardNavigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../KeyboardNavigation */ "./src/KeyboardNavigation/index.js");
/* harmony import */ var _input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./input */ "./src/SearchSelectInput/input.jsx");
/* harmony import */ var _resultsList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./resultsList */ "./src/SearchSelectInput/resultsList.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./styles.scss */ "./src/SearchSelectInput/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_10__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var SearchSelectInput = function (_React$PureComponent) {
  _inherits(SearchSelectInput, _React$PureComponent);

  function SearchSelectInput(props) {
    _classCallCheck(this, SearchSelectInput);

    var _this = _possibleConstructorReturn(this, (SearchSelectInput.__proto__ || Object.getPrototypeOf(SearchSelectInput)).call(this, props));

    _this.handleSearch = function (searchText) {
      if (!_this.props.performRequest) return undefined;
      _this.setState({ isSearching: true });
      return _this.props.performRequest(searchText).then(function (result) {
        if (!_this.state.isSearching) return;
        if (searchText !== _this.state.value) {
          // search results are stale
          return;
        }

        if (!result) {
          _this.setState({
            open: true,
            items: _this.props.items,
            isSearching: false,
            highlightedIndex: -1
          });
          return;
        }

        _this.handleHighlight(result.data[0], _this.props.highlightedIndex);
        _this.setState({
          isSearching: false,
          items: result.data.slice(0, _this.props.maxItems),
          listWrapperOptions: result.resultListWrapperOptions,
          open: !result.forceClose,
          valueForItems: searchText
        });
      }).catch(function (error) {
        if (error.__CANCEL__) {
          return;
        }
        _this.setState({
          isSearching: false
        });
        throw error;
      });
    };

    _this.handleCancelSearch = function () {
      _this.setState({ isSearching: false });
      var onCancelSearch = _this.props.onCancelSearch;

      if (onCancelSearch) {
        onCancelSearch();
      }
    };

    _this.handleKeyDown = function (event) {
      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
    };

    _this.handleBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      var value = event.target.value;

      if (_this.props.onLeave && !_this.selectedItem) {
        _this.props.onLeave({ target: { value: value } });
      }

      if (_this.props.clearOnBlur) {
        _this.clearInput();
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      // if focusing on an clickable item, don't open the popover (important for ChipInput close button)
      if (event.target.onclick) return;
      var newState = { isSearching: false };

      if (_this.suggestedItems.length > 0) {
        newState.items = _this.suggestedItems;
        newState.highlightedIndex = _this.props.highlightedIndex;
        newState.open = true;
      }

      _this.setState(newState);
    };

    _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
      if (_this.suggestedItems.length > 0) {
        _this.setState({
          items: _this.suggestedItems,
          highlightedIndex: _this.props.highlightedIndex,
          open: true
        });
      }
    };

    _this.handleChange = function (event) {
      var value = event.target.value;
      var onChange = _this.props.onChange;

      _this.setState({ value: value });
      if (onChange) onChange(event);
      if (value === '') {
        if (_this.props.suggestedItems.length > 0) {
          _this.setState({
            items: _this.suggestedItems,
            highlightedIndex: _this.props.highlightedIndex,
            open: true
          });
        } else {
          _this.handleClose();
        }
      }
    };

    _this.clearInput = function () {
      if (_this.props.onClearInput) {
        _this.props.onClearInput();
      }
      _this.selectedItem = false;
      _this.setState({
        value: '',
        isSearching: false,
        highlightedIndex: undefined
      });
    };

    _this.handleHighlight = function (item, index) {
      if (!item) return;

      _this.setState({
        open: true,
        highlightedIndex: index
      });

      if (_this.props.onHighlight) _this.props.onHighlight(item, index);
    };

    _this.handleSelect = function (item) {
      if (_this.props.onSelect) _this.props.onSelect(item);
      _this.selectedItem = true;
      if (!_this.props.preserveTextOnSelect) {
        _this.clearInput();
      }
      _this.handleClose();
    };

    _this.handleClose = function () {
      _this.setState({ open: false, items: [], highlightedIndex: undefined });
    };

    _this.handleSearchInputRef = function (input) {
      _this.searchInput = input;
    };

    _this.renderValue = function (value) {
      if (typeof value === 'string') return value;
      if (_this.props.renderValue) {
        return _this.props.renderValue(value) || '';
      }

      return value || '';
    };

    _this.renderItem = function (item, index) {
      var label = item.label;

      if (_this.props.renderItem) {
        return _this.props.renderItem(item, index, index === _this.state.highlightedIndex, _this.state.valueForItems);
      }
      if (!label) {
        console.warn(_this.constructor.name + ': item.label or props.renderItem should be present'); // eslint-disable-line no-console
      }
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_3___default.a, { primary: label });
    };

    _this.state = {
      items: _this.suggestedItems,
      isSearching: false,
      open: false,
      value: _this.renderValue(props.value),
      valueForItems: '',
      highlightedIndex: props.highlightedIndex,
      listWrapperOptions: undefined
    };
    return _this;
  }

  _createClass(SearchSelectInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-find-dom-node
      this.anchorEl = Object(react_dom__WEBPACK_IMPORTED_MODULE_5__["findDOMNode"])(this.searchInput);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.highlightedIndex) {
        this.setState({
          highlightedIndex: nextProps.highlightedIndex
        });
      }
      if (nextProps.value !== this.props.value) {
        this.setState({ value: this.renderValue(nextProps.value) });
      }

      if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default()(nextProps.items, this.props.items) && this.state.value !== '' && nextProps.items.length > 0) {
        this.setState(function (state) {
          if (state.value === '') return {};
          return {
            isSearching: false,
            items: nextProps.items,
            open: true,
            valueForItems: _this2.state.value,
            highlightedIndex: nextProps.highlightedIndex
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          searchInputProps = _props.searchInputProps,
          noResultText = _props.noResultText,
          resultsListProps = _props.resultsListProps,
          isItemDisabled = _props.isItemDisabled,
          helperText = _props.helperText,
          error = _props.error;


      var dataCyProps = {};
      if (this.props['data-cy']) {
        dataCyProps['data-cy'] = this.props['data-cy'];
      }

      var _state = this.state,
          open = _state.open,
          value = _state.value,
          highlightedIndex = _state.highlightedIndex,
          items = _state.items,
          listWrapperOptions = _state.listWrapperOptions;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        _extends({ id: id, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.container) }, dataCyProps),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _KeyboardNavigation__WEBPACK_IMPORTED_MODULE_7__["default"],
          {
            items: items,
            isItemDisabled: isItemDisabled,
            onClose: this.handleClose,
            onHighlight: this.handleHighlight,
            highlightedIndex: highlightedIndex,
            onSelect: this.handleSelect,
            allowSelect: open,
            closeWhenTab: true,
            onKeyDown: this.handleKeyDown
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_input__WEBPACK_IMPORTED_MODULE_8__["default"]
          // default props
          , _extends({ id: id ? id + '_input' : undefined,
            minLetters: 2
            // custom props
          }, searchInputProps, {
            // enforced props
            value: value,
            isSearching: this.state.isSearching,
            onKeyDown: this.handleKeyDown,
            onSearch: this.handleSearch,
            onCancelSearch: this.handleCancelSearch,
            onChange: this.handleChange,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onClick: this.handleClick,
            ref: this.handleSearchInputRef,
            onClearInput: this.clearInput,
            'data-cy': 'search_input'
          }))
        ),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_resultsList__WEBPACK_IMPORTED_MODULE_9__["default"], _extends({
          id: id ? id + '_popover' : undefined,
          open: open,
          anchorEl: this.anchorEl,
          onOpen: this.handleOpen,
          items: items,
          onClose: this.handleClose,
          onHighlight: this.handleHighlight,
          itemRenderer: this.renderItem,
          isItemDisabled: isItemDisabled,
          highlightedIndex: highlightedIndex,
          onSelect: this.handleSelect,
          searchTerm: this.state.valueForItems,
          noResultText: noResultText,
          listWrapperProps: {
            options: listWrapperOptions
          }
        }, resultsListProps)),
        helperText && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_4___default.a,
          { error: !!error, classes: { root: _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.helperText } },
          helperText
        )
      );
    }
  }, {
    key: 'suggestedItems',
    get: function get() {
      var _props2 = this.props,
          suggestedItemsFilter = _props2.suggestedItemsFilter,
          suggestedItems = _props2.suggestedItems;

      if (suggestedItemsFilter) {
        return suggestedItemsFilter(suggestedItems);
      }

      return suggestedItems;
    }
  }]);

  return SearchSelectInput;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

SearchSelectInput.propTypes = {
  /** ID applied to root div */
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Class applied to root div */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Fires when the search text is changed. Returns the search text  */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Fires when an item is highlighted via mouse/keyboard input */
  onHighlight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Fires when the user moves away from the search box without selecting any item. Returns the search text  */
  onLeave: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Fires when an item is selected */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** When the search request is cancelled this function is called. */
  onCancelSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onClearInput: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * Search function to perform request. Will be called with the search term
   * This is not named onSearch since it is considered more than a event handler,
   * implementation needs to return promise of the search result
   */
  performRequest: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Custom function to render the individual dropdown item row */
  renderItem: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Function that returns true if item is disabled, false otherwise.
    * If undefined, all items are enabled.
    */
  isItemDisabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** allow externally setting a highlighted index */
  highlightedIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** (optional) Clear search input on blur */
  clearOnBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (optional) initial value of the field (string or object) if object is passed, include a renderValue function */
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)]),
  /** (optional) renderer for the value after it has been selected, use this if value is an object */
  renderValue: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** suggested items will be displayed when there is no search result */
  suggestedItems: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.any),
  /**
   * function to handle filter suggested items, if provided, suggested items will be passed in
   * and returned value will be used as displayed suggest items
   */
  suggestedItemsFilter: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** (optional) you can pass in items directly (e.g. to pull from redux) if doing this, performRequest should return null */
  items: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array, // eslint-disable-line react/forbid-prop-types
  /** Maximum number of items to display in search result */
  maxItems: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /**
   * By default the input text is clear when the user makes a selection. Use
   * this property to prevent the search text being cleared.
   */
  preserveTextOnSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * all values will be forward to underlying SearchInput
   * Note, all event handlers that also handled by SearchSelectInput
   * must be passed in as property to SearchSelectInput
   * e.g. onBlur, onChange etc.
   */
  searchInputProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** pass into SearchResult */
  noResultText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** props to pass to ResultsList component */
  resultsListProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  'data-cy': prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

SearchSelectInput.defaultProps = {
  id: undefined,
  className: undefined,
  onChange: undefined,
  onLeave: undefined,
  onHighlight: undefined,
  onSelect: undefined,
  onKeyDown: undefined,
  onClick: undefined,
  onBlur: undefined,
  onFocus: undefined,
  onClearInput: undefined,
  onCancelSearch: undefined,
  performRequest: undefined,
  renderItem: undefined,
  isItemDisabled: undefined,
  highlightedIndex: -1,
  clearOnBlur: false,
  value: '',
  renderValue: undefined,
  suggestedItems: [],
  suggestedItemsFilter: undefined,
  maxItems: 10,
  error: false,
  helperText: undefined,
  preserveTextOnSelect: false,
  items: [],
  searchInputProps: undefined,
  noResultText: undefined,
  resultsListProps: undefined,
  'data-cy': undefined
};

/* harmony default export */ __webpack_exports__["default"] = (SearchSelectInput);

/***/ }),

/***/ "./src/SearchSelectInput/index.js":
/*!****************************************!*\
  !*** ./src/SearchSelectInput/index.js ***!
  \****************************************/
/*! exports provided: default, dontReturnResults */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dontReturnResults", function() { return dontReturnResults; });
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/SearchSelectInput/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/*
  SearchSelectInput's performRequest prop is a function that accepts a query and returns
  a Promise which resolves with { data : results: [] }.
  SearchSelectInput also accepts search result items directly, (useful with Redux), so use this function if
  you are supplying a performRequest function, but want to pass in the results via props:
  e.g. performRequest={query => searchManifestations(query).then(dontReturnResults)}
 */
var dontReturnResults = function dontReturnResults() {
  return null;
};

/***/ }),

/***/ "./src/SearchSelectInput/input.jsx":
/*!*****************************************!*\
  !*** ./src/SearchSelectInput/input.jsx ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash/debounce */ "lodash/debounce");
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/CircularProgress */ "@material-ui/core/CircularProgress");
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/icons/Close */ "@material-ui/icons/Close");
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @material-ui/icons/Search */ "@material-ui/icons/Search");
/* harmony import */ var _material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./styles.scss */ "./src/SearchSelectInput/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_8__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












function shouldSearch(text, minLetters) {
  if (text.trim().length < minLetters) return false;
  return true;
}

var SearchInput = function (_React$PureComponent) {
  _inherits(SearchInput, _React$PureComponent);

  function SearchInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchCancelled: false
    }, _this.inputRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef(), _this.cancelSearch = function () {
      var searchCancelled = _this.state.searchCancelled;
      var _this$props = _this.props,
          lastSearchText = _this$props.value,
          isSearching = _this$props.isSearching,
          onCancelSearch = _this$props.onCancelSearch;

      if (isSearching && !searchCancelled && onCancelSearch) {
        onCancelSearch(lastSearchText);
        _this.setState({ searchCancelled: true });
      }
    }, _this.handleFocus = function (event) {
      var value = event.target.value;
      var minLetters = _this.props.minLetters;


      if (minLetters === 0) _this.performSearch(value);
    }, _this.handleChange = function (event) {
      var value = event.target.value;
      var minLetters = _this.props.minLetters;

      _this.cancelSearch();
      if (shouldSearch(value, minLetters)) {
        _this.performSearch(value);
      } else {
        // cancel the previous scheduled performSearch invocation because the latest user input does not pass search criteria check
        _this.performSearch.cancel();
      }

      if (_this.props.onChange) _this.props.onChange(event);
    }, _this.performSearch = lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(function (text) {
      _this.props.onSearch(text);
      _this.setState({ searchCancelled: false });
    }, _this.props.deferMillis), _this.handleCancelClearClick = function () {
      _this.cancelSearch();
      var onClearInput = _this.props.onClearInput;

      if (onClearInput) {
        onClearInput();
      }
    }, _this.focus = function () {
      _this.inputRef.current.focus();
    }, _this.renderSearchSpinner = function () {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a.loader, key: 'loader' },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_4___default.a, { size: 20, thickness: 3 })
      );
    }, _this.renderStartAdornment = function () {
      var _this$props2 = _this.props,
          startAdornment = _this$props2.startAdornment,
          hideSearchIcon = _this$props2.hideSearchIcon,
          hideSearchSpinnerProp = _this$props2.hideSearchSpinner,
          showSpinnerOnRight = _this$props2.showSpinnerOnRight,
          isSearching = _this$props2.isSearching;

      var hideSearchSpinner = hideSearchSpinnerProp === undefined ? hideSearchIcon : hideSearchSpinnerProp;

      var adornments = startAdornment ? [startAdornment] : [];
      if (!hideSearchIcon && !isSearching) {
        adornments.push(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          { key: 'search', className: _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a.icon },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_6___default.a, null)
        ));
      }
      if (!hideSearchSpinner && isSearching && !showSpinnerOnRight) {
        adornments.push(_this.renderSearchSpinner());
      }
      return adornments.length === 0 ? undefined : adornments;
    }, _this.renderEndAdornment = function () {
      var _this$props3 = _this.props,
          isSearching = _this$props3.isSearching,
          value = _this$props3.value,
          showCancelClearIcon = _this$props3.showCancelClearIcon,
          endAdornment = _this$props3.endAdornment,
          hideSearchSpinnerProp = _this$props3.hideSearchSpinner,
          hideSearchIcon = _this$props3.hideSearchIcon,
          showSpinnerOnRight = _this$props3.showSpinnerOnRight;

      var hideSearchSpinner = hideSearchSpinnerProp === undefined ? hideSearchIcon : hideSearchSpinnerProp;
      var adornments = [];

      if (!hideSearchSpinner && isSearching && showSpinnerOnRight) {
        adornments.push(_this.renderSearchSpinner());
      }

      if (showCancelClearIcon) {
        var hasValue = value && value.length;
        var canCancelOrClear = hasValue || isSearching;
        adornments.push(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ___WEBPACK_IMPORTED_MODULE_7__["IconButton"],
          {
            key: 'cancelOrClear',
            inputAdornment: true,
            disabled: !canCancelOrClear,
            className: ___WEBPACK_IMPORTED_MODULE_7__["layout"].marginTopXS,
            onClick: _this.handleCancelClearClick
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_5___default.a, null)
        ));
      }

      if (endAdornment) {
        adornments.push(endAdornment);
      }
      return adornments.length === 0 ? undefined : adornments;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchInput, [{
    key: 'render',
    value: function render() {
      // When the input has lost focus. You probably expect this to be the native
      // even from the input field, but that causes a race condition where clicking
      // a result results in the onBlur triggering before the onClick, which means
      // item in the dropdown are not selected. So this is a synthetic event which
      // happens when you expect, but might have some edge cases.
      // NOTE: The above mentioned issue is resolved in the SearchSelectPopperInput.
      var _props = this.props,
          hideSearchIcon = _props.hideSearchIcon,
          showCancelClearIcon = _props.showCancelClearIcon,
          inputClassName = _props.inputClassName,
          onClearInput = _props.onClearInput,
          minLetters = _props.minLetters,
          isSearching = _props.isSearching,
          deferMillis = _props.deferMillis,
          onCancelSearch = _props.onCancelSearch,
          onChange = _props.onChange,
          onSearch = _props.onSearch,
          className = _props.className,
          startAdornment = _props.startAdornment,
          endAdornment = _props.endAdornment,
          hideSearchSpinner = _props.hideSearchSpinner,
          showSpinnerOnRight = _props.showSpinnerOnRight,
          other = _objectWithoutProperties(_props, ['hideSearchIcon', 'showCancelClearIcon', 'inputClassName', 'onClearInput', 'minLetters', 'isSearching', 'deferMillis', 'onCancelSearch', 'onChange', 'onSearch', 'className', 'startAdornment', 'endAdornment', 'hideSearchSpinner', 'showSpinnerOnRight']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_7__["Input"], _extends({
        ref: this.inputRef
        // default props
        , label: '',
        margin: 'none',
        autoComplete: 'search-input-text'
        // custom props
      }, other, {
        // enforced props
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(inputClassName, ___WEBPACK_IMPORTED_MODULE_7__["inputStyles"].reset),
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        startAdornment: this.renderStartAdornment(),
        endAdornment: this.renderEndAdornment()
      }));
    }
  }]);

  return SearchInput;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

SearchInput.propTypes = {
  /** onSearch is a callback will be triggered when a new search is required  */
  // eslint-disable-next-line react/no-typos
  onSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  /** minLetters specify minimum letters required to allow a search to trigger, if set to 0 a search will be performed onFocus */
  minLetters: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** deferMillis specify the delay for triggering a search */
  deferMillis: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** isSearching is the flag to tell the search input if to render progress */
  isSearching: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * children is the search result content,
   * if provide it will be rendered in a popup paper under search input
   * NOTE: This prop is deprecated. Instead, use SearchSelectInput or render the dropdown search result as a sibling to this component
   */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /**
   * onCancelSearch is the callback will be triggered when currently inSearching
   * but search is not required anymore or value changed
   */
  onCancelSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * className will be applied to the root div
   */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** className will be applied to the Input  */
  inputClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Will pass through to Input */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Will pass through to Input */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** When the input has lost focus. You probably expect this to be the native
   * even from the input field, but that causes a race condition where clicking
   * a result results in the onBlur triggering before the onClick, which means
   * item in the dropdown are not selected. So this is a synthetic event which
   * happens when you expect, but might have some edge cases.
   * NOTE: The above mentioned issue is resolved in the SearchSelectPopperInput.
   */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number]),
  /** Turns a search icon on or off, will always be rendered to the left. */
  hideSearchIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Turns a search spinner on or off, will default to hideSearchIcon value if not specified */
  hideSearchSpinner: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** If set to true, searching progress will be displayed on right */
  showSpinnerOnRight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Turns a cancel/clear icon on or off, will always be rendered to the right. */
  showCancelClearIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Callback that gets called when user clicks cancel/clear icon */
  onClearInput: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  startAdornment: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  endAdornment: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};

SearchInput.defaultProps = {
  minLetters: undefined,
  isSearching: false,
  deferMillis: 200,
  children: undefined,
  onCancelSearch: undefined,
  className: undefined,
  inputClassName: undefined,
  showCancelClearIcon: false,
  onClearInput: undefined,
  onFocus: undefined,
  onBlur: undefined,
  onKeyDown: undefined,
  onChange: undefined,
  value: '',
  startAdornment: undefined,
  endAdornment: undefined,
  hideSearchIcon: false,
  // keep this to undefined since the default value is the value of hideSearchIcon prop
  hideSearchSpinner: undefined,
  showSpinnerOnRight: false
};

/* harmony default export */ __webpack_exports__["default"] = (SearchInput);

/***/ }),

/***/ "./src/SearchSelectInput/resultsList.jsx":
/*!***********************************************!*\
  !*** ./src/SearchSelectInput/resultsList.jsx ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/List */ "@material-ui/core/List");
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_List__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/ListItem */ "@material-ui/core/ListItem");
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/ListItemText */ "@material-ui/core/ListItemText");
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/ListSubheader */ "@material-ui/core/ListSubheader");
/* harmony import */ var _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./styles.scss */ "./src/SearchSelectInput/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var ResultsList = function (_React$Component) {
  _inherits(ResultsList, _React$Component);

  function ResultsList(props) {
    _classCallCheck(this, ResultsList);

    var _this = _possibleConstructorReturn(this, (ResultsList.__proto__ || Object.getPrototypeOf(ResultsList)).call(this, props));

    _this.state = {};

    _this.scrollToCurrentValue = function () {
      var scrollToIndex = _this.props.scrollToIndex;

      if (scrollToIndex) _this.handleScroll(scrollToIndex);
    };

    _this.handleScroll = function (index) {
      if (!_this.popover || index < 0) return;

      setTimeout(function () {
        var el = _this.popover.children[index];
        if (el && el.scrollIntoView) {
          el.scrollIntoView();
        }
      }, 0);
    };

    _this.handleRefPopoverElem = function (e) {
      // eslint-disable-next-line react/no-find-dom-node
      _this.popover = Object(react_dom__WEBPACK_IMPORTED_MODULE_6__["findDOMNode"])(e);
    };

    _this.handleMouseLeave = function () {
      return _this.setState({ mouseHighlight: undefined });
    };

    _this.handlePopoverAction = function (actions) {
      _this.updatePosition = actions.updatePosition;
    };

    _this.renderSearchResult = function () {
      var _this$props = _this.props,
          items = _this$props.items,
          grouping = _this$props.grouping;

      var groupedItems = grouping ? Object(_utils__WEBPACK_IMPORTED_MODULE_11__["groupBy"])(items, grouping) : { _: items };
      var index = 0;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_List__WEBPACK_IMPORTED_MODULE_2___default.a,
        {
          dense: true,
          className: _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.root,
          ref: _this.handleRefPopoverElem,
          onMouseLeave: _this.handleMouseLeave
        },
        items.length === 0 && _this.renderNoResult(),
        Object.entries(groupedItems).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              group = _ref2[0],
              groupItems = _ref2[1];

          // eslint-disable-next-line no-plusplus
          var renderedItems = groupItems.map(function (item) {
            return _this.renderItem(item, index++);
          });
          return grouping ? [_this.renderSubheader(group)].concat(_toConsumableArray(renderedItems)) : renderedItems;
        })
      );
    };

    _this.renderResultWrapper = function () {
      var _this$props2 = _this.props,
          ListWrapper = _this$props2.ListWrapper,
          searchTerm = _this$props2.searchTerm,
          onClose = _this$props2.onClose,
          items = _this$props2.items,
          listWrapperProps = _this$props2.listWrapperProps;

      if (ListWrapper) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ListWrapper,
          _extends({}, listWrapperProps, {
            numChildren: items.length || 0,
            searchTerm: searchTerm,
            onClose: onClose
          }),
          _this.renderSearchResult()
        );
      }
      return _this.renderSearchResult();
    };

    _this.renderNoResult = function () {
      var noResultText = _this.props.noResultText;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3___default.a,
        { key: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4___default.a, { primary: noResultText })
      );
    };

    _this.renderSubheader = function (text) {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_5___default.a,
        { disableSticky: true, key: text },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _Typography__WEBPACK_IMPORTED_MODULE_9__["default"],
          { color: 'textSecondary', variant: 'caption' },
          text
        )
      );
    };

    _this.renderItem = function (item, index) {
      var _this$props3 = _this.props,
          onSelect = _this$props3.onSelect,
          highlightedIndex = _this$props3.highlightedIndex,
          itemRenderer = _this$props3.itemRenderer,
          isItemDisabled = _this$props3.isItemDisabled;
      var mouseHighlight = _this.state.mouseHighlight;


      var disabled = isItemDisabled && isItemDisabled(item, index);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3___default.a,
        {
          key: item.id || index,
          className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(_defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.selected, index === highlightedIndex || index === mouseHighlight)),
          disabled: disabled,
          onMouseOver: function onMouseOver() {
            _this.setState({ mouseHighlight: index }); // FMP
          },
          onFocus: function onFocus() {
            _this.props.onHighlight(item, index); // FMP
          },
          onClick: disabled ? undefined : function (e) {
            onSelect(item, index); // FMP
            e.stopPropagation();
          },
          value: item.value
        },
        itemRenderer(item, index)
      );
    };

    _this.doScrollToValue = true;
    return _this;
  }

  _createClass(ResultsList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.props.highlightedIndex !== newProps.highlightedIndex) {
        this.handleScroll(newProps.highlightedIndex);
      }
      if (this.props.items.length !== newProps.items.length) {
        this.updatePosition();
      }
      if (this.props.scrollToIndex !== newProps.scrollToIndex) {
        this.doScrollToValue = true;
      }
      this.setState({ mouseHighlight: null });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var willUpdate = nextProps.highlightedIndex !== this.props.highlightedIndex || nextProps.searchTerm !== this.props.searchTerm || nextProps.items.length !== this.props.items.length || nextState.mouseHighlight !== this.state.mouseHighlight || nextProps.open !== this.props.open;
      return willUpdate;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          searchTerm = _props.searchTerm,
          itemRenderer = _props.itemRenderer,
          isItemDisabled = _props.isItemDisabled,
          onHighlight = _props.onHighlight,
          noResultText = _props.noResultText,
          ListWrapper = _props.ListWrapper,
          listWrapperProps = _props.listWrapperProps,
          grouping = _props.grouping,
          scrollToIndex = _props.scrollToIndex,
          rest = _objectWithoutProperties(_props, ['items', 'searchTerm', 'itemRenderer', 'isItemDisabled', 'onHighlight', 'noResultText', 'ListWrapper', 'listWrapperProps', 'grouping', 'scrollToIndex']);

      if (this.doScrollToValue && this.popover) {
        this.scrollToCurrentValue();
        this.doScrollToValue = false;
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        ___WEBPACK_IMPORTED_MODULE_8__["Popover"],
        _extends({
          action: this.handlePopoverAction,
          disableRestoreFocus: true,
          disableEnforceFocus: true
        }, rest),
        this.renderResultWrapper()
      );
    }
  }]);

  return ResultsList;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

ResultsList.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Items to display */
  items: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    name: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
  })),
  /** Index of the highlighted row */
  highlightedIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** Index of the item that must be visible when list is displayed */
  scrollToIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  open: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** The element the Popover will position by */
  anchorEl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(HTMLInputElement), prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(HTMLDivElement)]),
  /** Triggered when the highlightedIndex changes */
  onHighlight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Triggered when the modal should open */
  onOpen: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Triggered when the modal should close */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Triggered when popover has received focus */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Triggered when an item from the list has been selected */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Function that will return the contents of the item */
  itemRenderer: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  /** Function that returns true if item is disabled, false otherwise.
    * If undefined, all items are enabled.
    */
  isItemDisabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** The search text used to get the results */
  searchTerm: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** text to be displayed when there is no search result */
  noResultText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /**
   * Optional wrapper for the list of results. Can be used to
   * render a header or footer around the results list.
   * It needs to take a children and searchTerm.
   */
  ListWrapper: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  grouping: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  listWrapperProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)
};

ResultsList.defaultProps = {
  id: 'popover',
  items: [],
  highlightedIndex: -1,
  scrollToIndex: undefined,
  open: false,
  anchorEl: undefined,
  onHighlight: undefined,
  onSelect: undefined,
  onFocus: undefined,
  onOpen: undefined,
  onClose: undefined,
  onKeyDown: undefined,
  isItemDisabled: undefined,
  searchTerm: undefined,
  noResultText: 'Sorry, no results found',
  ListWrapper: undefined,
  grouping: undefined,
  listWrapperProps: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (ResultsList);

/***/ }),

/***/ "./src/SearchSelectInput/styles.scss":
/*!*******************************************!*\
  !*** ./src/SearchSelectInput/styles.scss ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/SearchSelectInput/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/SearchSelectPopperInput/component.jsx":
/*!***************************************************!*\
  !*** ./src/SearchSelectPopperInput/component.jsx ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_event_listener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react-event-listener */ "react-event-listener");
/* harmony import */ var react_event_listener__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_event_listener__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/ListItemText */ "@material-ui/core/ListItemText");
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lodash/isEqual */ "lodash/isEqual");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _KeyboardNavigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../KeyboardNavigation */ "./src/KeyboardNavigation/index.js");
/* harmony import */ var _SearchSelectInput_input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../SearchSelectInput/input */ "./src/SearchSelectInput/input.jsx");
/* harmony import */ var _resultsListPopper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./resultsListPopper */ "./src/SearchSelectPopperInput/resultsListPopper.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./styles.scss */ "./src/SearchSelectPopperInput/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Input_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Input/utils */ "./src/Input/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var SearchSelectPopperInput = function (_React$PureComponent) {
  _inherits(SearchSelectPopperInput, _React$PureComponent);

  function SearchSelectPopperInput(props) {
    _classCallCheck(this, SearchSelectPopperInput);

    var _this = _possibleConstructorReturn(this, (SearchSelectPopperInput.__proto__ || Object.getPrototypeOf(SearchSelectPopperInput)).call(this, props));

    _this.handleSearch = function (searchText) {
      if (!_this.props.performRequest) return undefined;
      _this.setState({ isSearching: true });
      return _this.props.performRequest(searchText).then(function (result) {
        if (!_this.state.isSearching) return;
        if (searchText !== _this.state.value) {
          // search results are stale
          return;
        }

        if (!result) {
          _this.setState({
            open: true,
            items: _this.props.items,
            isSearching: false,
            highlightedIndex: -1
          });
          return;
        }

        _this.handleHighlight(result.data[0], _this.props.highlightedIndex);
        _this.setState({
          isSearching: false,
          items: result.data.slice(0, _this.props.maxItems),
          listWrapperOptions: result.resultListWrapperOptions,
          open: !result.forceClose,
          valueForItems: searchText
        });
      }).catch(function (error) {
        _this.setState({
          isSearching: false
        });
        throw error;
      });
    };

    _this.handleCancelSearch = function () {
      _this.setState({ isSearching: false });
      var onCancelSearch = _this.props.onCancelSearch;

      if (onCancelSearch) {
        onCancelSearch();
      }
    };

    _this.handleKeyDown = function (event) {
      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
    };

    _this.handleSearchInputKeyDown = function (event) {
      _this.handleKeyDown(event);
      // Since SearchInput is the only focussable component, hitting the TAB key
      // makes the entire component loose focus. We intentionally are not handling
      // onBlur of the SearchInput, as it also fires upon mouse clicking in the
      // ResultsList causing events race condition and a logical mess.
      if (event.keyCode == _Input_utils__WEBPACK_IMPORTED_MODULE_11__["asciiCodes"].TAB) {
        _this.handleBlur(event);
      }
    };

    _this.handleDocumentClick = function (event) {
      // Check if the click was outside of our Input or ResultsList
      if (!_this.anchorEl.contains(event.target) && (!_this.state.open || !_this.popperWrapperRef.current.contains(event.target))) {
        _this.handleBlur(event);
      }
    };

    _this.handleBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      if (_this.props.clearOnBlur) {
        _this.clearInput();
      } else {
        _this.setState({
          isSearching: false,
          items: [],
          highlightedIndex: undefined,
          open: false
        });
      }
    };

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      // if focusing on an clickable item, don't open the popover (important for ChipInput close button)
      if (event.target.onclick) return;
      var newState = { isSearching: false };

      if (_this.suggestedItems.length > 0) {
        newState.items = _this.suggestedItems;
        newState.highlightedIndex = _this.props.highlightedIndex;
        newState.open = true;
      }

      _this.setState(newState);
    };

    _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
      if (_this.suggestedItems.length > 0) {
        _this.setState({
          items: _this.suggestedItems,
          highlightedIndex: _this.props.highlightedIndex,
          open: true
        });
      }
    };

    _this.handleChange = function (event) {
      var value = event.target.value;
      var onChange = _this.props.onChange;

      _this.setState({ value: value });
      if (onChange) onChange(event);
      if (value === '') {
        if (_this.props.suggestedItems.length > 0) {
          _this.setState({
            items: _this.suggestedItems,
            highlightedIndex: _this.props.highlightedIndex,
            open: true
          });
        } else {
          _this.handleClose();
        }
      }
    };

    _this.clearInput = function () {
      if (_this.props.onClearInput) {
        _this.props.onClearInput();
      }
      _this.selectedItem = false;
      _this.setState({
        value: '',
        isSearching: false,
        items: [],
        highlightedIndex: undefined,
        open: false
      });
    };

    _this.handleHighlight = function (item, index) {
      if (!item) return;

      _this.setState({
        open: true,
        highlightedIndex: index
      });

      if (_this.props.onHighlight) _this.props.onHighlight(item, index);
    };

    _this.handleSelect = function (item) {
      if (_this.props.onSelect) _this.props.onSelect(item);
      _this.selectedItem = true;
      if (!_this.props.preserveTextOnSelect) {
        _this.clearInput();
      }
      // Mouse click in ResultsList makes the Input loose it's focus.
      // Should put it back, since selection of an item closes the ResultsList
      // and the user may would like to continue their search.
      _this.searchInput.focus();
    };

    _this.handleClose = function () {
      _this.setState({ open: false, items: [], highlightedIndex: undefined });
    };

    _this.handleSearchInputRef = function (input) {
      _this.searchInput = input;
    };

    _this.renderValue = function (value) {
      if (typeof value === 'string') return value;
      if (_this.props.renderValue) {
        return _this.props.renderValue(value) || '';
      }

      return value || '';
    };

    _this.renderItem = function (item, index) {
      var label = item.label;

      if (_this.props.renderItem) {
        return _this.props.renderItem(item, index, index === _this.state.highlightedIndex, _this.state.valueForItems);
      }
      if (!label) {
        console.warn(_this.constructor.name + ': item.label or props.renderItem should be present'); // eslint-disable-line no-console
      }
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4___default.a, { primary: label });
    };

    _this.state = {
      items: _this.suggestedItems,
      isSearching: false,
      open: false,
      value: _this.renderValue(props.value),
      valueForItems: '',
      highlightedIndex: props.highlightedIndex,
      listWrapperOptions: undefined
    };

    _this.popperWrapperRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();
    return _this;
  }

  _createClass(SearchSelectPopperInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-find-dom-node
      this.anchorEl = Object(react_dom__WEBPACK_IMPORTED_MODULE_5__["findDOMNode"])(this.searchInput);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.highlightedIndex) {
        this.setState({
          highlightedIndex: nextProps.highlightedIndex
        });
      }
      if (nextProps.value !== this.props.value) {
        this.setState({ value: this.renderValue(nextProps.value) });
      }

      if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default()(nextProps.items, this.props.items) && this.state.value !== '' && nextProps.items.length > 0) {
        this.setState(function (state) {
          if (state.value === '') return {};
          return {
            isSearching: false,
            items: nextProps.items,
            open: true,
            valueForItems: _this2.state.value,
            highlightedIndex: nextProps.highlightedIndex
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          searchInputProps = _props.searchInputProps,
          noResultText = _props.noResultText,
          resultsListProps = _props.resultsListProps,
          isItemDisabled = _props.isItemDisabled;


      var disableHighlightOnFocus = resultsListProps ? resultsListProps.disableHighlightOnFocus : false;

      var _state = this.state,
          open = _state.open,
          value = _state.value,
          highlightedIndex = _state.highlightedIndex,
          items = _state.items,
          listWrapperOptions = _state.listWrapperOptions;


      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { id: id, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.container) },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _KeyboardNavigation__WEBPACK_IMPORTED_MODULE_7__["default"],
          {
            items: items,
            isItemDisabled: isItemDisabled,
            onClose: this.handleClose,
            onHighlight: this.handleHighlight,
            highlightedIndex: highlightedIndex,
            onSelect: this.handleSelect,
            allowSelect: open,
            closeWhenTab: true,
            onKeyDown: this.handleKeyDown
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_SearchSelectInput_input__WEBPACK_IMPORTED_MODULE_8__["default"]
          // default props
          , _extends({ id: id ? id + '_input' : undefined,
            minLetters: 2
            // custom props
          }, searchInputProps, {
            // enforced props
            value: value,
            isSearching: this.state.isSearching,
            onKeyDown: this.handleSearchInputKeyDown,
            onSearch: this.handleSearch,
            onCancelSearch: this.handleCancelSearch,
            onChange: this.handleChange,
            onFocus: this.handleFocus,
            onClick: this.handleClick,
            ref: this.handleSearchInputRef,
            onClearInput: this.clearInput
          }))
        ),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_resultsListPopper__WEBPACK_IMPORTED_MODULE_9__["default"], _extends({
          id: id ? id + '_popover' : undefined,
          open: open,
          anchorEl: this.anchorEl,
          onOpen: this.handleOpen,
          items: items,
          onClose: this.handleClose,
          onHighlight: this.handleHighlight,
          itemRenderer: this.renderItem,
          isItemDisabled: isItemDisabled,
          highlightedIndex: highlightedIndex,
          onSelect: this.handleSelect,
          searchTerm: this.state.valueForItems,
          noResultText: noResultText,
          listWrapperProps: {
            options: listWrapperOptions
          },
          popperProps: {
            wrapperRef: this.popperWrapperRef
          },
          disableHighlightOnFocus: disableHighlightOnFocus
        }, resultsListProps)),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_event_listener__WEBPACK_IMPORTED_MODULE_3___default.a, {
          target: 'document',
          onClick: this.handleDocumentClick,
          onTouchEnd: this.handleDocumentClick
        })
      );
    }
  }, {
    key: 'suggestedItems',
    get: function get() {
      var _props2 = this.props,
          suggestedItemsFilter = _props2.suggestedItemsFilter,
          suggestedItems = _props2.suggestedItems;

      if (suggestedItemsFilter) {
        return suggestedItemsFilter(suggestedItems);
      }

      return suggestedItems;
    }
  }]);

  return SearchSelectPopperInput;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

SearchSelectPopperInput.propTypes = {
  /** ID applied to root div */
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Class applied to root div */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Fires when the search text is changed. Returns the search text  */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Fires when an item is highlighted via mouse/keyboard input */
  onHighlight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Fires when an item is selected */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** When the search request is cancelled this function is called. */
  onCancelSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onClearInput: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /**
   * Search function to perform request. Will be called with the search term
   * This is not named onSearch since it is considered more than a event handler,
   * implementation needs to return promise of the search result
   */
  performRequest: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Custom function to render the individual dropdown item row */
  renderItem: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Function that returns true if item is disabled, false otherwise.
    * If undefined, all items are enabled.
    */
  isItemDisabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** allow externally setting a highlighted index */
  highlightedIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** (optional) Clear search input on blur */
  clearOnBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** (optional) initial value of the field (string or object) if object is passed, include a renderValue function */
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)]),
  /** (optional) renderer for the value after it has been selected, use this if value is an object */
  renderValue: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** suggested items will be displayed when there is no search result */
  suggestedItems: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.any),
  /**
   * function to handle filter suggested items, if provided, suggested items will be passed in
   * and returned value will be used as displayed suggest items
   */
  suggestedItemsFilter: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** (optional) you can pass in items directly (e.g. to pull from redux) if doing this, performRequest should return null */
  items: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array, // eslint-disable-line react/forbid-prop-types
  /** Maximum number of items to display in search result */
  maxItems: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /**
   * By default the input text is clear when the user makes a selection. Use
   * this property to prevent the search text being cleared.
   */
  preserveTextOnSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /**
   * all values will be forward to underlying SearchInput
   * Note, all event handlers that also handled by SearchSelectPopperInput
   * must be passed in as property to SearchSelectPopperInput
   * e.g. onBlur, onChange etc.
   */
  searchInputProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** pass into SearchResult */
  noResultText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** props to pass to ResultsListPopper component */
  resultsListProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)
};

SearchSelectPopperInput.defaultProps = {
  id: undefined,
  className: undefined,
  onChange: undefined,
  onHighlight: undefined,
  onSelect: undefined,
  onKeyDown: undefined,
  onClick: undefined,
  onBlur: undefined,
  onFocus: undefined,
  onClearInput: undefined,
  onCancelSearch: undefined,
  performRequest: undefined,
  renderItem: undefined,
  isItemDisabled: undefined,
  highlightedIndex: -1,
  clearOnBlur: false,
  value: '',
  renderValue: undefined,
  suggestedItems: [],
  suggestedItemsFilter: undefined,
  maxItems: 10,
  error: false,
  helperText: undefined,
  preserveTextOnSelect: false,
  items: [],
  searchInputProps: undefined,
  noResultText: undefined,
  resultsListProps: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (SearchSelectPopperInput);

/***/ }),

/***/ "./src/SearchSelectPopperInput/index.js":
/*!**********************************************!*\
  !*** ./src/SearchSelectPopperInput/index.js ***!
  \**********************************************/
/*! exports provided: default, dontReturnResults */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dontReturnResults", function() { return dontReturnResults; });
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/SearchSelectPopperInput/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/*
  SearchSelectInput's performRequest prop is a function that accepts a query and returns
  a Promise which resolves with { data : results: [] }.
  SearchSelectInput also accepts search result items directly, (useful with Redux), so use this function if
  you are supplying a performRequest function, but want to pass in the results via props:
  e.g. performRequest={query => searchManifestations(query).then(dontReturnResults)}
 */
var dontReturnResults = function dontReturnResults() {
  return null;
};

/***/ }),

/***/ "./src/SearchSelectPopperInput/resultsListPopper.jsx":
/*!***********************************************************!*\
  !*** ./src/SearchSelectPopperInput/resultsListPopper.jsx ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/List */ "@material-ui/core/List");
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_List__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/ListItem */ "@material-ui/core/ListItem");
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/ListItemText */ "@material-ui/core/ListItemText");
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/ListSubheader */ "@material-ui/core/ListSubheader");
/* harmony import */ var _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./styles.scss */ "./src/SearchSelectPopperInput/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../utils */ "./src/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var ResultsListPopper = function (_React$Component) {
  _inherits(ResultsListPopper, _React$Component);

  function ResultsListPopper(props) {
    _classCallCheck(this, ResultsListPopper);

    var _this = _possibleConstructorReturn(this, (ResultsListPopper.__proto__ || Object.getPrototypeOf(ResultsListPopper)).call(this, props));

    _this.state = {};

    _this.scrollToCurrentValue = function () {
      var scrollToIndex = _this.props.scrollToIndex;

      if (scrollToIndex) _this.handleScroll(scrollToIndex);
    };

    _this.handleScroll = function (index) {
      if (!_this.listEl || index < 0) return;

      setTimeout(function () {
        var el = _this.listEl.children[index];
        if (el && el.scrollIntoView) {
          el.scrollIntoView();
        }
      }, 0);
    };

    _this.handleListRef = function (e) {
      // eslint-disable-next-line react/no-find-dom-node
      _this.listEl = Object(react_dom__WEBPACK_IMPORTED_MODULE_6__["findDOMNode"])(e);
    };

    _this.handleMouseLeave = function () {
      return _this.setState({ mouseHighlight: undefined });
    };

    _this.renderSearchResult = function () {
      var _this$props = _this.props,
          items = _this$props.items,
          grouping = _this$props.grouping;

      var groupedItems = grouping ? Object(_utils__WEBPACK_IMPORTED_MODULE_11__["groupBy"])(items, grouping) : { _: items };
      var index = 0;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_List__WEBPACK_IMPORTED_MODULE_2___default.a,
        {
          dense: true,
          className: _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.root,
          ref: _this.handleListRef,
          onMouseLeave: _this.handleMouseLeave
        },
        items.length === 0 && _this.renderNoResult(),
        Object.entries(groupedItems).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              group = _ref2[0],
              groupItems = _ref2[1];

          // eslint-disable-next-line no-plusplus
          var renderedItems = groupItems.map(function (item) {
            return _this.renderItem(item, index++);
          });
          return grouping ? [_this.renderSubheader(group)].concat(_toConsumableArray(renderedItems)) : renderedItems;
        })
      );
    };

    _this.renderResultWrapper = function () {
      var _this$props2 = _this.props,
          ListWrapper = _this$props2.ListWrapper,
          searchTerm = _this$props2.searchTerm,
          onClose = _this$props2.onClose,
          items = _this$props2.items,
          listWrapperProps = _this$props2.listWrapperProps;

      if (ListWrapper) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ListWrapper,
          _extends({}, listWrapperProps, {
            numChildren: items.length || 0,
            searchTerm: searchTerm,
            onClose: onClose
          }),
          _this.renderSearchResult()
        );
      }
      return _this.renderSearchResult();
    };

    _this.renderNoResult = function () {
      var noResultText = _this.props.noResultText;

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3___default.a,
        { key: 'none' },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_4___default.a, { primary: noResultText })
      );
    };

    _this.renderSubheader = function (text) {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_5___default.a,
        { disableSticky: true, key: text },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _Typography__WEBPACK_IMPORTED_MODULE_9__["default"],
          { color: 'textSecondary', variant: 'caption' },
          text
        )
      );
    };

    _this.renderItem = function (item, index) {
      var _this$props3 = _this.props,
          onSelect = _this$props3.onSelect,
          highlightedIndex = _this$props3.highlightedIndex,
          itemRenderer = _this$props3.itemRenderer,
          isItemDisabled = _this$props3.isItemDisabled;
      var mouseHighlight = _this.state.mouseHighlight;


      var disabled = isItemDisabled && isItemDisabled(item, index);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_3___default.a,
        {
          key: item.id || index,
          className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(_defineProperty({}, _styles_scss__WEBPACK_IMPORTED_MODULE_10___default.a.selected, index === highlightedIndex || index === mouseHighlight)),
          disabled: disabled,
          onMouseOver: function onMouseOver() {
            _this.setState({ mouseHighlight: index }); // FMP
          },
          onFocus: function onFocus() {
            if (_this.props.disableHighlightOnFocus) return;
            _this.props.onHighlight(item, index); // FMP
          },
          onClick: disabled ? undefined : function (e) {
            onSelect(item, index); // FMP
            e.stopPropagation();
          },
          value: item.value
        },
        itemRenderer(item, index)
      );
    };

    _this.doScrollToValue = true;
    return _this;
  }

  _createClass(ResultsListPopper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.props.highlightedIndex !== newProps.highlightedIndex) {
        this.handleScroll(newProps.highlightedIndex);
      }
      if (this.props.scrollToIndex !== newProps.scrollToIndex) {
        this.doScrollToValue = true;
      }
      this.setState({ mouseHighlight: null });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var willUpdate = nextProps.highlightedIndex !== this.props.highlightedIndex || nextProps.searchTerm !== this.props.searchTerm || nextProps.items.length !== this.props.items.length || nextState.mouseHighlight !== this.state.mouseHighlight || nextProps.open !== this.props.open;
      return willUpdate;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          searchTerm = _props.searchTerm,
          itemRenderer = _props.itemRenderer,
          isItemDisabled = _props.isItemDisabled,
          onOpen = _props.onOpen,
          onHighlight = _props.onHighlight,
          noResultText = _props.noResultText,
          ListWrapper = _props.ListWrapper,
          listWrapperProps = _props.listWrapperProps,
          grouping = _props.grouping,
          scrollToIndex = _props.scrollToIndex,
          popperProps = _props.popperProps,
          highlightedIndex = _props.highlightedIndex,
          disableHighlightOnFocus = _props.disableHighlightOnFocus,
          rest = _objectWithoutProperties(_props, ['items', 'searchTerm', 'itemRenderer', 'isItemDisabled', 'onOpen', 'onHighlight', 'noResultText', 'ListWrapper', 'listWrapperProps', 'grouping', 'scrollToIndex', 'popperProps', 'highlightedIndex', 'disableHighlightOnFocus']);

      if (this.doScrollToValue && this.listEl) {
        this.scrollToCurrentValue();
        this.doScrollToValue = false;
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        ___WEBPACK_IMPORTED_MODULE_8__["Popper"],
        _extends({}, rest, popperProps),
        this.renderResultWrapper()
      );
    }
  }]);

  return ResultsListPopper;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

ResultsListPopper.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Items to display */
  items: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    name: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
  })),
  /** Index of the highlighted row */
  highlightedIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  /** Index of the item that must be visible when list is displayed */
  scrollToIndex: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  open: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** The element the Popper will position by */
  anchorEl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(HTMLInputElement), prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(HTMLDivElement)]),
  /** Triggered when the highlightedIndex changes */
  onHighlight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Triggered when the modal should open */
  onOpen: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Triggered when the modal should close */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Triggered when popover has received focus */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Triggered when an item from the list has been selected */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** Function that will return the contents of the item */
  itemRenderer: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  /** Function that returns true if item is disabled, false otherwise.
    * If undefined, all items are enabled.
    */
  isItemDisabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** The search text used to get the results */
  searchTerm: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** text to be displayed when there is no search result */
  noResultText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /**
   * Optional wrapper for the list of results. Can be used to
   * render a header or footer around the results list.
   * It needs to take a children and searchTerm.
   */
  ListWrapper: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  grouping: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  listWrapperProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  popperProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  disableHighlightOnFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};

ResultsListPopper.defaultProps = {
  id: 'popover',
  items: [],
  highlightedIndex: -1,
  scrollToIndex: undefined,
  open: false,
  anchorEl: undefined,
  onHighlight: undefined,
  onSelect: undefined,
  onFocus: undefined,
  onOpen: undefined,
  onClose: undefined,
  onKeyDown: undefined,
  isItemDisabled: undefined,
  searchTerm: undefined,
  noResultText: 'Sorry, no results found',
  ListWrapper: undefined,
  grouping: undefined,
  listWrapperProps: undefined,
  popperProps: undefined,
  disableHighlightOnFocus: false
};

/* harmony default export */ __webpack_exports__["default"] = (ResultsListPopper);

/***/ }),

/***/ "./src/SearchSelectPopperInput/styles.scss":
/*!*************************************************!*\
  !*** ./src/SearchSelectPopperInput/styles.scss ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/SearchSelectPopperInput/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/SplitButton/component.jsx":
/*!***************************************!*\
  !*** ./src/SplitButton/component.jsx ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/icons/ArrowDropDown */ "@material-ui/icons/ArrowDropDown");
/* harmony import */ var _material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ButtonSet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../ButtonSet */ "./src/ButtonSet/index.js");
/* harmony import */ var _ButtonMenu__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../ButtonMenu */ "./src/ButtonMenu/index.js");
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Button */ "./src/Button/index.jsx");
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











var SplitButton = function SplitButton(_ref) {
  var label = _ref.label,
      menuIcon = _ref.menuIcon,
      menuItems = _ref.menuItems,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      ButtonComponent = _ref.buttonComponent,
      rest = _objectWithoutProperties(_ref, ['label', 'menuIcon', 'menuItems', 'disabled', 'onClick', 'buttonComponent']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _ButtonSet__WEBPACK_IMPORTED_MODULE_5__["default"],
    rest,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      ButtonComponent,
      { onClick: onClick, disabled: disabled },
      label
    ),
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ButtonMenu__WEBPACK_IMPORTED_MODULE_6__["default"], {
      id: 'more',
      items: menuItems,
      disabled: disabled,
      buttonProps: {
        label: react__WEBPACK_IMPORTED_MODULE_0___default.a.cloneElement(menuIcon, { className: _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.block }),
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.minWidthNone, _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.paddingHorizontalSmall)
      },
      buttonComponent: ButtonComponent,
      alignRight: true
    })
  );
};

SplitButton.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  menuIcon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** Array of menu items. Any extra props are spread to the MenuItem component (e.g. disabled) */
  menuItems: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
    // component key, if not provided, label string will be used as key
    key: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
    label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
    icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
  })),
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  buttonComponent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

SplitButton.defaultProps = {
  label: undefined,
  menuIcon: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_2___default.a, null),
  menuItems: undefined,
  onClick: undefined,
  buttonComponent: _Button__WEBPACK_IMPORTED_MODULE_7__["PrimaryButton"],
  disabled: false
};

/* harmony default export */ __webpack_exports__["default"] = (SplitButton);

/***/ }),

/***/ "./src/SplitButton/index.js":
/*!**********************************!*\
  !*** ./src/SplitButton/index.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/SplitButton/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/StatusBadge/colors.js":
/*!***********************************!*\
  !*** ./src/StatusBadge/colors.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (['red', 'orange', 'yellow', 'blue', 'green', 'grey']);

/***/ }),

/***/ "./src/StatusBadge/component.jsx":
/*!***************************************!*\
  !*** ./src/StatusBadge/component.jsx ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Icon */ "./src/Icon/index.js");
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./styles.scss */ "./src/StatusBadge/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./colors */ "./src/StatusBadge/colors.js");









var StatusBadge = function StatusBadge(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      color = _ref.color;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    'div',
    null,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_6___default.a.root, _layout_scss__WEBPACK_IMPORTED_MODULE_5___default.a.inlineFlex, _layout_scss__WEBPACK_IMPORTED_MODULE_5___default.a.centerVertically, color) },
      icon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_6___default.a.icon, _layout_scss__WEBPACK_IMPORTED_MODULE_5___default.a.inlineFlex, _layout_scss__WEBPACK_IMPORTED_MODULE_5___default.a.centerVertically) },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          _Icon__WEBPACK_IMPORTED_MODULE_3__["default"],
          { size: 'small' },
          icon
        )
      ),
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Typography__WEBPACK_IMPORTED_MODULE_4__["default"],
        { variant: 'caption', className: _styles_scss__WEBPACK_IMPORTED_MODULE_6___default.a.label },
        label
      )
    )
  );
};

StatusBadge.propTypes = {
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
  color: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(_colors__WEBPACK_IMPORTED_MODULE_7__["default"])
};

StatusBadge.defaultProps = {
  icon: null,
  color: 'grey'
};

/* harmony default export */ __webpack_exports__["default"] = (StatusBadge);

/***/ }),

/***/ "./src/StatusBadge/index.js":
/*!**********************************!*\
  !*** ./src/StatusBadge/index.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/StatusBadge/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/StatusBadge/styles.scss":
/*!*************************************!*\
  !*** ./src/StatusBadge/styles.scss ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/StatusBadge/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/TablePagination/component.jsx":
/*!*******************************************!*\
  !*** ./src/TablePagination/component.jsx ***!
  \*******************************************/
/*! exports provided: default, TablePaginationWrapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TablePaginationWrapper", function() { return TablePagination; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_TablePagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/TablePagination */ "@material-ui/core/TablePagination");
/* harmony import */ var _material_ui_core_TablePagination__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_TablePagination__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/Hidden */ "@material-ui/core/Hidden");
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var styles = function styles(theme) {
  var _toolbarResponsive;

  return {
    toolbar: {
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit,
      justifyContent: 'space-between',
      maxWidth: 350,
      marginLeft: 'auto',
      fontSize: '0.75rem',
      color: theme.palette.common.lightBlack
    },
    spacer: {
      flex: 0
    },
    selectRoot: {
      marginRight: theme.spacing.unit
    },
    actions: {
      marginLeft: theme.spacing.unit
    },
    caption: {
      color: theme.palette.common.darkBlack,
      letterSpacing: 'normal',
      flexShrink: 1,
      '&:empty': {
        display: 'none'
      }
    },

    // Custom classes (not for MuiTablePagination)
    // this is only needed in gentu when application.css is loaded : flag-react
    noBorder: {
      '&:disabled': {
        border: '0'
      }
    },
    toolbarResponsive: (_toolbarResponsive = {}, _defineProperty(_toolbarResponsive, theme.breakpoints.down('md'), {
      maxWidth: 270
    }), _defineProperty(_toolbarResponsive, theme.breakpoints.down('sm'), {
      maxWidth: 166
    }), _toolbarResponsive),
    selectRootResponsive: _defineProperty({}, theme.breakpoints.down('sm'), {
      margin: 0
    })
  };
};

// eslint-disable-next-line react/prop-types
var labelDisplayedRows = function labelDisplayedRows(hideCount, shrinkWithPage) {
  return function (_ref) {
    var from = _ref.from,
        to = _ref.to,
        count = _ref.count;

    var labelString = hideCount ? from + '-' + to : from + '-' + to + ' of ' + count;

    if (shrinkWithPage) {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_4___default.a,
        { mdDown: true, implementation: 'css' },
        labelString
      );
    }
    return labelString;
  };
};

var TablePagination = function TablePagination(_ref2) {
  var _ref2$classes = _ref2.classes,
      noBorder = _ref2$classes.noBorder,
      toolbarResponsive = _ref2$classes.toolbarResponsive,
      selectRootResponsive = _ref2$classes.selectRootResponsive,
      otherClasses = _objectWithoutProperties(_ref2$classes, ['noBorder', 'toolbarResponsive', 'selectRootResponsive']),
      hideCount = _ref2.hideCount,
      shrinkWithPage = _ref2.shrinkWithPage,
      rest = _objectWithoutProperties(_ref2, ['classes', 'hideCount', 'shrinkWithPage']);

  var muiClasses = _extends({}, otherClasses, {
    toolbar: classnames__WEBPACK_IMPORTED_MODULE_2___default()(otherClasses.toolbar, _defineProperty({}, toolbarResponsive, !!shrinkWithPage)),
    selectRoot: classnames__WEBPACK_IMPORTED_MODULE_2___default()(otherClasses.selectRoot, _defineProperty({}, selectRootResponsive, !!shrinkWithPage))
  });

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_TablePagination__WEBPACK_IMPORTED_MODULE_3___default.a, _extends({
    nextIconButtonProps: {
      title: 'Next Page',
      className: noBorder
    },
    backIconButtonProps: {
      title: 'Previous Page',
      className: noBorder
    }
  }, rest, {
    labelRowsPerPage: shrinkWithPage ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_4___default.a,
      { smDown: true, implementation: 'css' },
      'Rows per page:'
    ) : 'Rows per page:',
    classes: muiClasses,
    labelDisplayedRows: labelDisplayedRows(hideCount, shrinkWithPage)
  }));
};

TablePagination.propTypes = {
  /** Classes from withStyles */
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object),
  /** (optional) hide the total items count */
  hideCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Hide caption elements as the page gets narrow (default: true), disable if there are no space constraints */
  shrinkWithPage: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Options available in the 'Rows per page' dropdown menu */
  rowsPerPageOptions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number)
};

TablePagination.defaultProps = {
  classes: {},
  hideCount: false,
  shrinkWithPage: true,
  rowsPerPageOptions: [5, 10, 25]
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__["withStyles"])(styles)(TablePagination));
// For test


/***/ }),

/***/ "./src/TablePagination/index.js":
/*!**************************************!*\
  !*** ./src/TablePagination/index.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/TablePagination/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Tabs/Tab.jsx":
/*!**************************!*\
  !*** ./src/Tabs/Tab.jsx ***!
  \**************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Tab */ "@material-ui/core/Tab");
/* harmony import */ var _material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Tab_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Tab.scss */ "./src/Tabs/Tab.scss");
/* harmony import */ var _Tab_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Tab_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var Tab = function Tab(_ref) {
  var className = _ref.className,
      label = _ref.label,
      children = _ref.children,
      selected = _ref.selected,
      constrainWidth = _ref.constrainWidth,
      _ref$classes = _ref.classes,
      labelContainerClass = _ref$classes.labelContainer,
      otherClasses = _objectWithoutProperties(_ref$classes, ['labelContainer']),
      other = _objectWithoutProperties(_ref, ['className', 'label', 'children', 'selected', 'constrainWidth', 'classes']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_1___default.a, _extends({
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, _Tab_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, 'selected-' + selected, 'gtu-tab', { constrainWidth: constrainWidth }),
    classes: _extends({
      labelContainer: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Tab_scss__WEBPACK_IMPORTED_MODULE_4___default.a.labelContainer, labelContainerClass)
    }, otherClasses),
    selected: selected,
    label: label || children
  }, other));
};
Tab.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node, // Allow pass label as children, it's more shallow friendly
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  selected: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  constrainWidth: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({ labelContainer: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string })
};
Tab.defaultProps = {
  label: undefined,
  selected: false,
  children: undefined,
  className: undefined,
  constrainWidth: true,
  classes: {}
};
/* harmony default export */ __webpack_exports__["default"] = (Tab);

/***/ }),

/***/ "./src/Tabs/Tab.scss":
/*!***************************!*\
  !*** ./src/Tabs/Tab.scss ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./Tab.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tabs/Tab.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Tabs/Tabs.jsx":
/*!***************************!*\
  !*** ./src/Tabs/Tabs.jsx ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Tabs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Tabs */ "@material-ui/core/Tabs");
/* harmony import */ var _material_ui_core_Tabs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Tabs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Tabs_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Tabs.scss */ "./src/Tabs/Tabs.scss");
/* harmony import */ var _Tabs_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Tabs_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Tabs = function (_React$PureComponent) {
  _inherits(Tabs, _React$PureComponent);

  function Tabs() {
    _classCallCheck(this, Tabs);

    return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
  }

  _createClass(Tabs, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          withMargin = _props.withMargin,
          variant = _props.variant,
          divider = _props.divider,
          other = _objectWithoutProperties(_props, ['className', 'children', 'withMargin', 'variant', 'divider']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _material_ui_core_Tabs__WEBPACK_IMPORTED_MODULE_1___default.a,
        _extends({
          className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, _Tabs_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, _Tabs_scss__WEBPACK_IMPORTED_MODULE_4___default.a.reset, _Tabs_scss__WEBPACK_IMPORTED_MODULE_4___default.a[variant], 'gtu-tabs', (_classnames = {}, _defineProperty(_classnames, _Tabs_scss__WEBPACK_IMPORTED_MODULE_4___default.a.withMargin, withMargin), _defineProperty(_classnames, _Tabs_scss__WEBPACK_IMPORTED_MODULE_4___default.a.divider, divider), _defineProperty(_classnames, _Tabs_scss__WEBPACK_IMPORTED_MODULE_4___default.a.fullWidth, variant === 'secondary'), _classnames)),
          classes: {
            scrollButtons: _Tabs_scss__WEBPACK_IMPORTED_MODULE_4___default.a.scrollButtons,
            indicator: _Tabs_scss__WEBPACK_IMPORTED_MODULE_4___default.a.indicator
          },
          variant: 'scrollable'
        }, other),
        children
      );
    }
  }]);

  return Tabs;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

Tabs.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  /** this is to match gentu style guide */
  variant: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(['primary', 'secondary']),
  withMargin: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  divider: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool
};
Tabs.defaultProps = {
  children: undefined,
  className: undefined,
  variant: 'primary',
  withMargin: false,
  divider: true
};
/* harmony default export */ __webpack_exports__["default"] = (Tabs);

/***/ }),

/***/ "./src/Tabs/Tabs.scss":
/*!****************************!*\
  !*** ./src/Tabs/Tabs.scss ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./Tabs.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tabs/Tabs.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Tabs/TabsAndButtons.jsx":
/*!*************************************!*\
  !*** ./src/Tabs/TabsAndButtons.jsx ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Grid */ "@material-ui/core/Grid");
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TabsAndButtons_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./TabsAndButtons.scss */ "./src/Tabs/TabsAndButtons.scss");
/* harmony import */ var _TabsAndButtons_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_TabsAndButtons_scss__WEBPACK_IMPORTED_MODULE_5__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var TabsAndButtons = function TabsAndButtons(_ref) {
  var classes = _ref.classes,
      tabs = _ref.tabs,
      buttons = _ref.buttons,
      dense = _ref.dense;
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
    {
      container: true,
      justify: 'flex-end',
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.flex, _TabsAndButtons_scss__WEBPACK_IMPORTED_MODULE_5___default.a.root, _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.flexNoShrink, 'tabs', _defineProperty({}, _TabsAndButtons_scss__WEBPACK_IMPORTED_MODULE_5___default.a.dense, dense)),
      spacing: 0
    },
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
      { item: true, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.flexGrow, _layout_scss__WEBPACK_IMPORTED_MODULE_4___default.a.maxWidth100, _TabsAndButtons_scss__WEBPACK_IMPORTED_MODULE_5___default.a.tabs, classes.tabs) },
      tabs
    ),
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3___default.a,
      { item: true, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_TabsAndButtons_scss__WEBPACK_IMPORTED_MODULE_5___default.a.buttons, classes.buttons) },
      buttons
    )
  );
};

TabsAndButtons.propTypes = {
  tabs: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,
  buttons: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  dense: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.instanceOf(Object)
};

TabsAndButtons.defaultProps = {
  buttons: null,
  dense: false,
  classes: {}
};

/* harmony default export */ __webpack_exports__["default"] = (TabsAndButtons);

/***/ }),

/***/ "./src/Tabs/TabsAndButtons.scss":
/*!**************************************!*\
  !*** ./src/Tabs/TabsAndButtons.scss ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./TabsAndButtons.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tabs/TabsAndButtons.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Tabs/index.js":
/*!***************************!*\
  !*** ./src/Tabs/index.js ***!
  \***************************/
/*! exports provided: Tabs, Tab, TabsAndButtons */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Tabs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Tabs */ "./src/Tabs/Tabs.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return _Tabs__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _Tab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Tab */ "./src/Tabs/Tab.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _Tab__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _TabsAndButtons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TabsAndButtons */ "./src/Tabs/TabsAndButtons.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabsAndButtons", function() { return _TabsAndButtons__WEBPACK_IMPORTED_MODULE_2__["default"]; });





/***/ }),

/***/ "./src/ThemeProvider/component.jsx":
/*!*****************************************!*\
  !*** ./src/ThemeProvider/component.jsx ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../theme */ "./src/theme.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var MotifThemeProvider = function MotifThemeProvider(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__["MuiThemeProvider"], _extends({ theme: _theme__WEBPACK_IMPORTED_MODULE_2__["default"] }, props));
};

/* harmony default export */ __webpack_exports__["default"] = (MotifThemeProvider);

/***/ }),

/***/ "./src/ThemeProvider/index.js":
/*!************************************!*\
  !*** ./src/ThemeProvider/index.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/ThemeProvider/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Tile/component.jsx":
/*!********************************!*\
  !*** ./src/Tile/component.jsx ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Button */ "@material-ui/core/Button");
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Avatar */ "./src/Avatar/index.jsx");
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Icon */ "./src/Icon/index.js");
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Typography */ "./src/Typography/index.jsx");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











var cssTransition = function cssTransition(props) {
  return props.map(function (prop) {
    return prop + ' 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';
  }).join(', ');
};

var styles = function styles(_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      display: 'block',
      width: '100%',
      textAlign: 'initial',
      backgroundColor: palette.common.white,
      color: palette.primary.main,
      textTransform: 'initial',
      borderTop: 'solid 4px ' + palette.grey[300],
      padding: spacing.unit * 2,
      transition: cssTransition(['background-color', 'box-shadow', 'border-color']),

      '&:hover, &$focusVisible': {
        borderTopColor: palette.primary[300],
        backgroundColor: 'rgba(17, 154, 171, 0.1)',
        color: palette.primary.main
      }
    },
    focusVisible: {},
    disabled: {
      backgroundColor: palette.grey[300],
      color: palette.text.disabled
    },
    header: {
      display: 'flex',
      alignItems: 'center'
    },
    avatar: {
      marginRight: spacing.unit * 2,
      color: palette.common.white,
      backgroundColor: palette.primary[300]
    },
    content: {
      marginLeft: spacing.unit * 2 + 40
    }
  };
};

var Tile = function Tile(_ref2) {
  var children = _ref2.children,
      classes = _ref2.classes,
      className = _ref2.className,
      href = _ref2.href,
      icon = _ref2.icon,
      title = _ref2.title,
      other = _objectWithoutProperties(_ref2, ['children', 'classes', 'className', 'href', 'icon', 'title']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3___default.a,
    _extends({
      disableFocusRipple: true,
      href: href,
      className: className,
      classes: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["omit"])(classes, ['header', 'avatar', 'content']),
      variant: 'contained'
    }, other),
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { className: classes.header },
      icon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Avatar__WEBPACK_IMPORTED_MODULE_5__["default"],
        { className: classes.avatar },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_6__["default"], { component: icon })
      ),
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        _Typography__WEBPACK_IMPORTED_MODULE_7__["default"],
        { variant: 'subtitle2' },
        title
      )
    ),
    children && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      'div',
      { className: classes.content },
      children
    )
  );
};

Tile.propTypes = {
  /** The content of the Tile */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  /** Override or extend the styles applied to the component */
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object.isRequired, // eslint-disable-line react/forbid-prop-types
  /** The classname for the root node */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** The URL to link to when the Tile is clicked. If defined, an `a` element will wrap the root node */
  href: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Avatar icon for the Tile */
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  /** The title of the Tile */
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

Tile.defaultProps = {
  children: undefined,
  className: undefined,
  href: undefined,
  icon: undefined,
  title: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__["withStyles"])(styles)(Tile));

/***/ }),

/***/ "./src/Tile/index.js":
/*!***************************!*\
  !*** ./src/Tile/index.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Tile/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/TimePicker/index.js":
/*!*********************************!*\
  !*** ./src/TimePicker/index.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _timePicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./timePicker */ "./src/TimePicker/timePicker.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _timePicker__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/TimePicker/timePicker.jsx":
/*!***************************************!*\
  !*** ./src/TimePicker/timePicker.jsx ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(setImmediate) {/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "moment");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util */ "./src/TimePicker/util.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
  // eslint-disable-next-line no-extend-native
  String.prototype.padStart = function padStart(targetLength, padString) {
    // eslint-disable-next-line no-bitwise, no-param-reassign
    targetLength >>= 0; // floor if number or convert non-number to 0;
    // eslint-disable-next-line no-param-reassign
    padString = String(padString || ' ');
    if (this.length > targetLength) {
      return String(this);
    }

    // eslint-disable-next-line no-param-reassign
    targetLength -= this.length;
    if (targetLength > padString.length) {
      // eslint-disable-next-line no-param-reassign
      padString += padString.repeat(targetLength / padString.length); // append to original to ensure we are longer than needed
    }
    return padString.slice(0, targetLength) + String(this);
  };
}

// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var TimePicker = function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  function TimePicker(props) {
    _classCallCheck(this, TimePicker);

    var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

    _this.handleBlur = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange;

      var formatedValue = Object(_util__WEBPACK_IMPORTED_MODULE_5__["formatTimeString"])(value);
      if (onChange && value !== formatedValue) {
        onChange({ target: { value: formatedValue } });
        // defer onBlur to ensure onChange event been processed
        if (onBlur) {
          if (e.persist) {
            e.persist(); // persist react synthetic event so it can be used in async code
          }
          setImmediate(function () {
            return onBlur(e);
          });
        }
      } else if (onBlur) {
        onBlur(e);
      }
    };

    _this.doGenerate = true;

    _this.currentTime = { hours: moment__WEBPACK_IMPORTED_MODULE_3___default()().hours(), minutes: moment__WEBPACK_IMPORTED_MODULE_3___default()().minutes() };
    return _this;
  }

  _createClass(TimePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.interval !== this.props.interval) {
        this.doGenerate = true;
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var attrs = ['error', 'value', 'interval'];
      return !Object(lodash__WEBPACK_IMPORTED_MODULE_2__["isEqual"])(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["pick"])(nextProps, attrs), Object(lodash__WEBPACK_IMPORTED_MODULE_2__["pick"])(this.props, attrs));
    }
  }, {
    key: 'generateTimes',
    value: function generateTimes() {
      var t = 0; // minutes
      var tString = null;
      var times = [];

      while (t < 60 * 24) {
        tString = Math.floor(t / 60) + ':' + Math.floor(t % 60).toString().padStart(2, '0');
        times.push({ name: tString, value: tString });
        t += this.props.interval;
      }
      this.times = times;
      this.doGenerate = false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.doGenerate) this.generateTimes();

      var _props = this.props,
          interval = _props.interval,
          onBlur = _props.onBlur,
          value = _props.value,
          rest = _objectWithoutProperties(_props, ['interval', 'onBlur', 'value']);

      var currentValue = Object(_util__WEBPACK_IMPORTED_MODULE_5__["parseTimeString"])(value);
      var roundedTime = Object(_util__WEBPACK_IMPORTED_MODULE_5__["getIntervalRoundedTimeString"])(currentValue || this.currentTime, interval);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_4__["TypeableSelect"], _extends({}, rest, {
        onBlur: this.handleBlur,
        hideHelperText: false,
        placeholder: 'HH:MM',
        items: this.times,
        value: value,
        caret: true,
        findHighlightedIndex: _util__WEBPACK_IMPORTED_MODULE_5__["isMatchingTime"],
        scrollToIndex: this.times.findIndex(function (time) {
          return time.value === roundedTime;
        })
      }));
    }
  }]);

  return TimePicker;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

TimePicker.propTypes = {
  /** Time options interval (in minutes) */
  interval: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
};

TimePicker.defaultProps = {
  interval: 15,
  value: '',
  onChange: undefined,
  onBlur: undefined
};

/* harmony default export */ __webpack_exports__["default"] = (TimePicker);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node_modules/timers-browserify/main.js */ "./node_modules/timers-browserify/main.js").setImmediate))

/***/ }),

/***/ "./src/TimePicker/util.js":
/*!********************************!*\
  !*** ./src/TimePicker/util.js ***!
  \********************************/
/*! exports provided: parseTimeString, formatTimeString, isMatchingTime, getIntervalRoundedTimeString */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseTimeString", function() { return parseTimeString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatTimeString", function() { return formatTimeString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMatchingTime", function() { return isMatchingTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntervalRoundedTimeString", function() { return getIntervalRoundedTimeString; });
/**
 * Uses regex to determine hours, minutes & seconds in provided timestring
 * this function is modified base on
 * https://github.com/jonthornton/jquery-timepicker/blob/master/jquery.timepicker.js
 * to ensure we support same input formats as old angular app
 */
var parseTimeString = function parseTimeString(timeStringParam) {
  var timeString = timeStringParam;
  if (!timeString || typeof timeString !== 'string') return null;

  timeString = timeString.toLowerCase().replace(/[\s.]/g, '');

  // if the last character is an "a" or "p", add the "m"
  if (timeString.slice(-1) === 'a' || timeString.slice(-1) === 'p') {
    timeString += 'm';
  }

  // try to parse time input
  var pattern = new RegExp('^(am|pm)?([0-9]?[0-9])\\W?([0-5][0-9])?\\W?([0-5][0-9])?(am|pm)?$');

  var time = timeString.match(pattern);
  if (!time) {
    return null;
  }

  var hour = parseInt(time[2] * 1, 10);
  var ampm = time[1] || time[5];
  var hours = hour;
  var minutes = time[3] * 1 || 0;
  var seconds = time[4] * 1 || 0;

  if (hour <= 12 && ampm) {
    var isPm = ampm === 'pm';

    if (hour === 12) {
      hours = isPm ? 12 : 0;
    } else {
      hours = hour + (isPm ? 12 : 0);
    }
  }

  return { hours: hours, minutes: minutes, seconds: seconds };
};

// Returns timestring in 24 hour HH:MM format (or H:MM format if withLeadingZero = false)
var formatTimeString = function formatTimeString(timeString) {
  var withLeadingZero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!timeString || typeof timeString !== 'string') {
    return '';
  }
  var time = parseTimeString(timeString);
  if (!time) return timeString; // invalid time string
  var hoursString = withLeadingZero ? ('' + time.hours).padStart(2, '0') : '' + time.hours;
  var minutesString = ('' + time.minutes).padStart(2, '0');
  return hoursString + ':' + minutesString;
};

/**
 * Accepts a string time value and returns a function for comparing it with
 * TimePicker list items.
 */
var isMatchingTime = function isMatchingTime(stringValueToCompare) {
  var formattedValueToCompare = formatTimeString(stringValueToCompare, false);
  return function (timeItem) {
    return timeItem.value === formattedValueToCompare;
  };
};

/**
 * Converts {hour, minutes} to H:MM format and rounds it down to the nearest provided interval.
 * e.g. 10:07 with 5 minute interval is rounded to to 10:05.
 * timeInterval is in minutes.
 */
var getIntervalRoundedTimeString = function getIntervalRoundedTimeString(_ref, timeInterval) {
  var hours = _ref.hours,
      minutes = _ref.minutes;

  var roundedMinutes = Math.floor(parseInt(minutes, 10) / timeInterval) * timeInterval;
  return hours + ':' + ('' + roundedMinutes).padStart(2, '0');
};

/***/ }),

/***/ "./src/Tooltip/component.jsx":
/*!***********************************!*\
  !*** ./src/Tooltip/component.jsx ***!
  \***********************************/
/*! exports provided: isPlainTextAndLessThan500Chars, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlainTextAndLessThan500Chars", function() { return isPlainTextAndLessThan500Chars; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/Tooltip */ "@material-ui/core/Tooltip");
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./styles.scss */ "./src/Tooltip/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/**
 * Check the arg to make sure
 * 1) if it is plan text
 * 2) if the plain text is less than 500 chars
 * @param {*} content - the content to be compared
 * @returns {boolean} true if content's is plain text and is less than 500 chars, false otherwise
 * @private
 */
var isPlainTextAndLessThan500Chars = function isPlainTextAndLessThan500Chars(content) {
  return typeof content === 'string' && content.length < 500;
};

/**
 * A wrapper of MUI's Tooltip component
 * We added CSS triangles as per the DS
 * We applied a default 500ms delay on show/hide
 * We added a default 600px max-width to the tooltip container (300px if small prop is true or content plain text and less than 500 chars)
 */
var Tooltip = function Tooltip(_ref) {
  var _classnames;

  var className = _ref.className,
      title = _ref.title,
      children = _ref.children,
      small = _ref.small,
      maxLines = _ref.maxLines,
      rest = _objectWithoutProperties(_ref, ['className', 'title', 'children', 'small', 'maxLines']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_3___default.a,
    _extends({
      enterDelay: 500,
      leaveDelay: 500,
      classes: {
        popper: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.root, (_classnames = {}, _defineProperty(_classnames, _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.small, small || isPlainTextAndLessThan500Chars(title)), _defineProperty(_classnames, _styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a['maxLines' + maxLines], !!maxLines), _classnames)),
        tooltip: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_4___default.a.tooltip, _defineProperty({}, className, !!className))
      },
      title: title
    }, rest),
    children
  );
};

Tooltip.propTypes = {
  /** className will be applied to MuiTooltip */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  /** Override the width of the toolTip, if 'true', a 300px max-width is applied to the tooltip container,
   * otherwise, it will try to detect:
   * 1) if the tooltip content is plain text (for a html based content, we let the html decide the line break)
   * 2) if the plain text is less than 500 chars
   * then apply the smaller width if both above conditions match
   * If non of above matches, a 600px max-width is applied as default so text can wrap accordingly
   */
  small: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  /** Maximum number of lines displayed in the tooltip */
  maxLines: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf([undefined, 5, 10]),
  /** Tooltip content. It could be a string or React node */
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,
  /** Tooltip reference element. */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired
};

Tooltip.defaultProps = {
  className: undefined,
  maxLines: undefined,
  small: false
};

/* harmony default export */ __webpack_exports__["default"] = (Tooltip);

/***/ }),

/***/ "./src/Tooltip/index.js":
/*!******************************!*\
  !*** ./src/Tooltip/index.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/Tooltip/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/Tooltip/styles.scss":
/*!*********************************!*\
  !*** ./src/Tooltip/styles.scss ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Tooltip/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/TypeableSelect/component.jsx":
/*!******************************************!*\
  !*** ./src/TypeableSelect/component.jsx ***!
  \******************************************/
/*! exports provided: Raw, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Raw", function() { return Raw; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/ListItemText */ "@material-ui/core/ListItemText");
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @material-ui/core/InputAdornment */ "@material-ui/core/InputAdornment");
/* harmony import */ var _material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @material-ui/icons/ArrowDropDown */ "@material-ui/icons/ArrowDropDown");
/* harmony import */ var _material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _withIsMobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../withIsMobile */ "./src/withIsMobile.jsx");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./styles.scss */ "./src/TypeableSelect/styles.scss");
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_9__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var partialStartsWithItemName = function partialStartsWithItemName(query) {
  return function (item) {
    return query && item.name.toLowerCase().startsWith(query.toLowerCase());
  };
}; // function won't match anything if query is null
var partialMatchItemName = function partialMatchItemName(query) {
  return function (item) {
    return item.name.toLowerCase().includes(query.toLowerCase());
  };
};
var defaultEndAdornment = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
  _material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_4___default.a,
  { position: 'end' },
  react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_5___default.a, { className: _styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.arrow })
);

/**
 * A textfield you can type into, with a list of options below.
 * Used for:
 * - Type or select from list - e.g. Timepicker
 * - Type to filter a local list - e.g. Select a specialty
 */
// TODO: refactor code to avoid unsafe life-cycle methods
// eslint-disable-next-line react/no-unsafe

var TypeableSelect = function (_React$PureComponent) {
  _inherits(TypeableSelect, _React$PureComponent);

  function TypeableSelect(props) {
    _classCallCheck(this, TypeableSelect);

    var _this = _possibleConstructorReturn(this, (TypeableSelect.__proto__ || Object.getPrototypeOf(TypeableSelect)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      items: props.items,
      displayValue: _this.getDisplayValue(props.value),
      selected: null,
      open: false
    };
    return _this;
  }

  _createClass(TypeableSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.findHighlight(this.props);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-find-dom-node
      this.anchorEl = Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["findDOMNode"])(this.searchInput);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.items.length !== nextProps.items.length) {
        // No use cases here for a deep compare so far. Keeping it efficient
        this.setState({ items: nextProps.items, selected: null }, function () {
          return _this2.findHighlight(nextProps);
        });
      }

      if (nextProps.value !== this.state.displayValue) {
        this.setState({
          highlightedIndex: nextProps.items.findIndex(this.highlightedIndexCalculator(nextProps.value)),
          displayValue: this.getDisplayValue(nextProps.value),
          selected: null
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var open = this.state.open;

      var _props = this.props,
          filterItems = _props.filterItems,
          className = _props.className,
          inputClassName = _props.inputClassName,
          displayNotFoundItem = _props.displayNotFoundItem,
          caret = _props.caret,
          autoHighlight = _props.autoHighlight,
          onSelect = _props.onSelect,
          hideHelperText = _props.hideHelperText,
          openOnClick = _props.openOnClick,
          mobileNative = _props.mobileNative,
          isMobile = _props.isMobile,
          onChange = _props.onChange,
          noMargin = _props.noMargin,
          scrollToIndex = _props.scrollToIndex,
          findHighlightedIndex = _props.findHighlightedIndex,
          rest = _objectWithoutProperties(_props, ['filterItems', 'className', 'inputClassName', 'displayNotFoundItem', 'caret', 'autoHighlight', 'onSelect', 'hideHelperText', 'openOnClick', 'mobileNative', 'isMobile', 'onChange', 'noMargin', 'scrollToIndex', 'findHighlightedIndex']);

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'div',
        { className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.root, className) },
        mobileNative && isMobile ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_7__["Select"], _extends({}, rest, {
          native: true,
          data: this.state.items,
          onChange: onChange,
          noMargin: noMargin
        })) : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          ___WEBPACK_IMPORTED_MODULE_7__["KeyboardNavigation"],
          {
            items: this.state.items,
            onClose: this.handleClose,
            onHighlight: this.handleHighlight,
            highlightedIndex: this.state.highlightedIndex,
            scrollToIndex: scrollToIndex,
            onSelect: this.selectListItem,
            allowSelect: open,
            closeWhenTab: true
          },
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_7__["Input"], _extends({}, rest, {
            onChange: this.handleChange,
            onBlur: this.handleBlur,
            onClick: this.handleClick,
            value: this.state.displayValue,
            className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_9___default.a.input, inputClassName),
            autoComplete: 'off',
            ref: this.handleSearchInputRef,
            hideHelperText: hideHelperText,
            endAdornment: this.endAdornment,
            noMargin: noMargin
          }))
        ),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(___WEBPACK_IMPORTED_MODULE_7__["ResultsList"], {
          open: open,
          anchorEl: this.anchorEl,
          onOpen: this.handleOpen,
          items: this.state.items,
          onClose: this.handleClose,
          onHighlight: this.handleHighlight,
          itemRenderer: this.renderItem,
          highlightedIndex: this.state.highlightedIndex,
          onSelect: this.selectListItem,
          scrollToIndex: scrollToIndex
        })
      );
    }
  }, {
    key: 'endAdornment',
    get: function get() {
      if (this.props.endAdornment) return this.props.endAdornment; // have provided endAdornment
      if (!this.props.caret || this.props.disabled) return undefined;

      return defaultEndAdornment;
    }
  }, {
    key: 'highlightedIndexCalculator',
    get: function get() {
      return this.props.findHighlightedIndex || partialStartsWithItemName;
    }

    /**
     * If the value matches a value in the items from props, e.g. "au",
     * return the item name, e.g. "Australia". Otherwise, return the param again.
     * @param  {string} value the value of the input field
     * @return {string} Either the display name that corresponds to the value, or the value itself.
     */


    /**
     * Select a list item, save it to state, fire onChange and if necessary, close the menu.
     * @param  {object}  item         Item to save
     */

  }]);

  return TypeableSelect;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getDisplayValue = function (value) {
    var foundValue = _this3.props.items.find(function (item) {
      return item.value === value;
    });
    return foundValue ? foundValue.name : value;
  };

  this.getValue = function (displayValue) {
    var foundValue = _this3.props.items.find(function (item) {
      return item.name === displayValue;
    });
    return foundValue ? foundValue.value : displayValue;
  };

  this.getSelectedItem = function (displayValue) {
    return _this3.props.items.find(function (item) {
      return item.name === displayValue;
    });
  };

  this.findHighlight = function (props) {
    if (!props.value || !props.autoHighlight) return;

    var itemIndex = props.items.findIndex(function (_item) {
      return _item.value === props.value;
    });
    var item = props.items[itemIndex];

    if (itemIndex < 0) {
      itemIndex = props.items.findIndex(partialMatchItemName(props.value));
    }

    _this3.setState({
      displayValue: item ? item.name : props.value,
      highlightedIndex: itemIndex
    });
  };

  this.handleClick = function () {
    if (_this3.props.disabled || !_this3.props.openOnClick) return;
    _this3.setState({ open: true });
  };

  this.handleBlur = function (e) {
    if (_this3.props.onBlur) {
      _this3.props.onBlur(e);
    }
  };

  this.handleHighlight = function (item, index) {
    if (!item) return;
    _this3.selectedItem = true;

    _this3.setState({
      highlightedIndex: index,
      open: true
    });
  };

  this.selectListItem = function (item) {
    _this3.setState({
      displayValue: item.name,
      selected: item,
      open: false
    });

    var event = { target: { value: item.value, selectedItem: item } };
    if (_this3.props.onChange) _this3.props.onChange(event);
    if (_this3.props.onSelect) _this3.props.onSelect(event);
  };

  this.handleClose = function () {
    _this3.setState({ open: false });
  };

  this.handleOpen = function () {
    _this3.setState({ open: true });
  };

  this.handleChange = function (event) {
    var newState = {
      items: _this3.props.items,
      displayValue: event.target.value,
      open: _this3.state.open || true
    };

    if (_this3.props.onChange) {
      var fakeEvent = {
        target: {
          value: _this3.getValue(event.target.value),
          selectedItem: _this3.state.selected
        }
      };
      _this3.props.onChange(fakeEvent);
    }

    if (_this3.props.filterItems) {
      newState = _extends({}, newState, {
        items: _this3.props.items.filter(partialMatchItemName(event.target.value)),
        highlightedIndex: _this3.props.autoHighlight ? 0 : -1
      });
    } else {
      var highlightedIndex = _this3.props.autoHighlight ? _this3.props.items.findIndex(_this3.highlightedIndexCalculator(event.target.value)) : -1;
      newState = _extends({}, newState, {
        highlightedIndex: highlightedIndex
      });
    }

    // if you type in a valid name, highlight that item
    if (_this3.props.autoHighlight) {
      newState.items.forEach(function (item, index) {
        if (item.name.toLowerCase() === event.target.value.toLowerCase()) {
          newState.highlightedIndex = index;
        }
      });
    }

    _this3.setState(newState);
  };

  this.handleSearchInputRef = function (el) {
    if (el && el.inputRef) {
      _this3.searchInput = el.inputRef;
    } else {
      // eslint-disable-next-line react/no-find-dom-node
      _this3.searchInput = Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["findDOMNode"])(el);
    }
  };

  this.renderItem = function (item) {
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_3___default.a, { primary: item.name });
  };
};

TypeableSelect.propTypes = {
  /** className applied to root div */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  inputClassName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  /** Items to show in the dropdown. Names will be displayed,
      values will be returned in onChange. */
  items: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    name: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
    value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
  })),
  /** The currently selected value. If this exists in the items list,
      that item will be highlighted */
  value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  /** Called when typing or selecting */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  /** Called when selecting */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  /** Called when a focus event is triggered */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  /** Called when a blur event is triggered */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  /** Filter the dropdown as you type? */
  filterItems: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** show the caret (aka dropdown arrow) */
  caret: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** show disabled state of component */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** open on click */
  openOnClick: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** Automatically highlight the first item or partial matches */
  autoHighlight: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** Display the 'Not Found' message if no item found */
  displayNotFoundItem: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** Hide helper text */
  hideHelperText: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** endAdorment for the input */
  endAdornment: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  /** Use the native select component if rendered on a mobile device */
  mobileNative: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  /** Index that should be displayed on ResultsList render */
  scrollToIndex: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  /** Optional function used when value is being typed to determine which item should be highlighted.
   * If none provided, default function will match items with the current value as its prefix.
   * Expected format: findHighlightedIndex = currentValue => itemToCompare => true if 'equal', false otherwise
   */
  findHighlightedIndex: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  /** Is the view rendered on a mobile device. Provided by withIsMobile */
  isMobile: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  noMargin: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool
};

TypeableSelect.defaultProps = {
  className: undefined,
  inputClassName: undefined,
  items: [],
  value: '',
  onChange: undefined,
  onSelect: undefined,
  onFocus: undefined,
  onBlur: undefined,
  filterItems: false,
  caret: true,
  disabled: false,
  openOnClick: true,
  displayNotFoundItem: true,
  autoHighlight: true,
  hideHelperText: true,
  endAdornment: undefined,
  mobileNative: false,
  scrollToIndex: undefined,
  findHighlightedIndex: undefined,
  isMobile: false,
  noMargin: false
};

var Raw = TypeableSelect;
/* harmony default export */ __webpack_exports__["default"] = (Object(_withIsMobile__WEBPACK_IMPORTED_MODULE_8__["default"])(TypeableSelect));

/***/ }),

/***/ "./src/TypeableSelect/index.js":
/*!*************************************!*\
  !*** ./src/TypeableSelect/index.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/TypeableSelect/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),

/***/ "./src/TypeableSelect/spec-helper.js":
/*!*******************************************!*\
  !*** ./src/TypeableSelect/spec-helper.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material-ui/core/ListItem */ "@material-ui/core/ListItem");
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./src/index.js");
/* harmony import */ var _helpers_nextTick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helpers/nextTick */ "./helpers/nextTick.js");
/* harmony import */ var _Input_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Input/utils */ "./src/Input/utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var TypeableSelect = function () {
  function TypeableSelect(wrapper, id) {
    _classCallCheck(this, TypeableSelect);

    this.wrapper = wrapper;
    this.id = id;
    this.type = 'TypeableSelect';
  }

  _createClass(TypeableSelect, [{
    key: 'setValue',


    /*
     * Sets a value into the input. Will trigger the opening of the menu.
     * Async function, (i.e  ``` await select.setValue('test') ```)
     */
    value: function setValue(value) {
      this.input.simulate('focus');
      var event = { target: { value: value.toString() } };
      this.input.simulate('change', event);
    }
  }, {
    key: 'simulateEnter',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.input.simulate('keydown', { keyCode: _Input_utils__WEBPACK_IMPORTED_MODULE_3__["asciiCodes"].ENTER });

                _context.next = 3;
                return Object(_helpers_nextTick__WEBPACK_IMPORTED_MODULE_2__["default"])();

              case 3:
                this.wrapper.update();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function simulateEnter() {
        return _ref.apply(this, arguments);
      }

      return simulateEnter;
    }()
  }, {
    key: 'simulateBlur',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.input.simulate('blur');

                _context2.next = 3;
                return Object(_helpers_nextTick__WEBPACK_IMPORTED_MODULE_2__["default"])();

              case 3:
                this.wrapper.update();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function simulateBlur() {
        return _ref2.apply(this, arguments);
      }

      return simulateBlur;
    }()

    /*
     * Select an option by index. Should be called after setValue to ensure the
     * menu is open.
     */

  }, {
    key: 'select',
    value: function select(index) {
      this.menuElements.at(index).simulate('click');
    }
  }, {
    key: 'isMenuOpen',
    value: function isMenuOpen() {
      return this.el.find(___WEBPACK_IMPORTED_MODULE_1__["Popover"]).prop('open');
    }
  }, {
    key: 'el',
    get: function get() {
      return this.wrapper.find(this.id);
    }
  }, {
    key: 'displayText',
    get: function get() {
      return this.input.props().value;
    }
  }, {
    key: 'underlyingValue',
    get: function get() {
      return this.el.props().value;
    }
  }, {
    key: 'input',
    get: function get() {
      return this.el.find('input[type="text"]');
    }
  }, {
    key: 'menuOptions',
    get: function get() {
      return this.menuElements.map(function (li) {
        return li.find('span').text();
      });
    }
  }, {
    key: 'menuElements',
    get: function get() {
      var dialog = this.el.find('Portal');
      return dialog.find(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_0___default.a);
    }
  }, {
    key: 'visible',
    get: function get() {
      return this.el.length > 0;
    }
  }]);

  return TypeableSelect;
}();

/* harmony default export */ __webpack_exports__["default"] = (TypeableSelect);

/***/ }),

/***/ "./src/TypeableSelect/styles.scss":
/*!****************************************!*\
  !*** ./src/TypeableSelect/styles.scss ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./styles.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/TypeableSelect/styles.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/Typography/index.jsx":
/*!**********************************!*\
  !*** ./src/Typography/index.jsx ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Typography */ "@material-ui/core/Typography");
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Colored__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Colored */ "./src/Colored/index.jsx");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./index.scss */ "./src/Typography/index.scss");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_5__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var customVariants = ['subtitle2', 'underlined-h6'];

var Typography = function Typography(_ref) {
  var _classnames;

  var variant = _ref.variant,
      className = _ref.className,
      maxLines = _ref.maxLines,
      color = _ref.color,
      inheritColor = _ref.inheritColor,
      children = _ref.children,
      textOverflow = _ref.textOverflow,
      classes = _ref.classes,
      other = _objectWithoutProperties(_ref, ['variant', 'className', 'maxLines', 'color', 'inheritColor', 'children', 'textOverflow', 'classes']);

  var content = children;
  if (color && !inheritColor) {
    content = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
      _Colored__WEBPACK_IMPORTED_MODULE_4__["default"],
      { color: color },
      children
    );
  }

  var nextClasses = classes;
  if (textOverflow) {
    nextClasses = Object.assign({}, nextClasses, {
      noWrap: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_index_scss__WEBPACK_IMPORTED_MODULE_5___default.a[textOverflow], classes && classes.noWrap)
    });
  }

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_1___default.a,
    _extends({
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, _index_scss__WEBPACK_IMPORTED_MODULE_5___default.a.root, _index_scss__WEBPACK_IMPORTED_MODULE_5___default.a[variant], (_classnames = {}, _defineProperty(_classnames, _index_scss__WEBPACK_IMPORTED_MODULE_5___default.a['maxLines' + maxLines], !!maxLines), _defineProperty(_classnames, _index_scss__WEBPACK_IMPORTED_MODULE_5___default.a.inheritColor, inheritColor), _classnames)),
      classes: nextClasses,
      variant: customVariants.includes(variant) ? undefined : variant
    }, other),
    content
  );
};
Typography.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  variant: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  /** note the maxLines1 is the same to prop noWrap */
  maxLines: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf([undefined, 1, 2, 3]),
  color: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(_Colored__WEBPACK_IMPORTED_MODULE_4__["colors"]),
  /**
   * if inheritColor is true, color prop and default color of typography will be ignored
   * to allow inherit parent node color.
   */
  inheritColor: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  textOverflow: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf([undefined, 'ellipsis', 'clip']),
  classes: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.instanceOf(Object)
};
Typography.defaultProps = {
  className: undefined,
  maxLines: undefined,
  variant: 'body1',
  color: null,
  inheritColor: false,
  children: null,
  textOverflow: undefined,
  classes: undefined
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);

/***/ }),

/***/ "./src/Typography/index.scss":
/*!***********************************!*\
  !*** ./src/Typography/index.scss ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../node_modules/css-loader??ref--5-1!../../node_modules/sass-loader/lib/loader.js!./index.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/Typography/index.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/YesNoSwitch/component.jsx":
/*!***************************************!*\
  !*** ./src/YesNoSwitch/component.jsx ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_core_Switch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material-ui/core/Switch */ "@material-ui/core/Switch");
/* harmony import */ var _material_ui_core_Switch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Switch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/styles/colorManipulator */ "@material-ui/core/styles/colorManipulator");
/* harmony import */ var _material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_3__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var height = 36;

var styles = function styles(theme) {
  return {
    root: _defineProperty({
      '--width': '112px'
    }, theme.breakpoints.down('xs'), {
      '--width': '100%',
      width: '100%'
    }),
    bar: {
      top: 0,
      left: 0,
      marginLeft: 0,
      marginTop: 0,
      backgroundColor: 'transparent',
      border: '1px solid ' + theme.palette.grey[300],
      borderRadius: 2,
      overflow: 'hidden',
      width: 'var(--width)',
      height: height
    },
    icon: _defineProperty({
      borderTopLeftRadius: 2,
      borderBottomLeftRadius: 2,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      border: '1px solid ' + theme.palette.grey[300],
      width: 'calc(var(--width) / 2)',
      height: height,
      boxShadow: 'none',
      backgroundColor: Object(_material_ui_core_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_3__["fade"])(theme.palette.primary.main, 0.1),
      transform: 'translateX(calc(var(--width) / 2))',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    }, theme.breakpoints.down('xs'), {
      transform: 'translateX(calc(var(--width)))'
    }),
    iconChecked: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: 2,
      borderBottomRightRadius: 2,
      transform: 'none'
    },
    checked: {
      transform: 'none' // prevent the transform on switchBase, we will transform the icon instead
    },
    switchBase: {
      width: 'var(--width)',
      height: height + 2,
      justifyContent: 'flex-start',
      '&::before, &::after': {
        position: 'absolute',
        top: (height - theme.typography.fontSize) / 2 - 1,
        width: '50%',
        textAlign: 'center',
        fontFamily: theme.typography.fontFamily,
        pointerEvents: 'none',
        fontSize: theme.typography.fontSize,
        lineHeight: theme.typography.body1.lineHeight
      },
      '&::before': {
        content: '"YES"',
        color: theme.palette.text.secondary
      },
      '&::after': {
        content: '"NO"',
        right: 0,
        color: theme.palette.primary.main
      },
      '&$checked': {
        '&::before': {
          color: theme.palette.primary.main
        },
        '&::after': {
          color: theme.palette.text.secondary
        }
      }
    },
    colorSecondary: {
      '&$checked': {
        '& + $bar': {
          backgroundColor: 'transparent'
        }
      }
    }
  };
};

var YesNoSwitch = function YesNoSwitch(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_material_ui_core_Switch__WEBPACK_IMPORTED_MODULE_1___default.a, _extends({ disableRipple: true }, props));
};

/* harmony default export */ __webpack_exports__["default"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__["withStyles"])(styles)(YesNoSwitch));

/***/ }),

/***/ "./src/YesNoSwitch/index.js":
/*!**********************************!*\
  !*** ./src/YesNoSwitch/index.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./src/YesNoSwitch/component.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _component__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),

/***/ "./src/helpers.js":
/*!************************!*\
  !*** ./src/helpers.js ***!
  \************************/
/*! exports provided: InputHelper, SelectHelper, CheckboxHelper, DivHelper, RadioHelper, ChipInputHelper, TypeableSelectHelper, DatePickerHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Input_input_spec_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Input/input.spec-helper */ "./src/Input/input.spec-helper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputHelper", function() { return _Input_input_spec_helper__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _Input_select_spec_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Input/select.spec-helper */ "./src/Input/select.spec-helper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SelectHelper", function() { return _Input_select_spec_helper__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _Input_checkbox_spec_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Input/checkbox.spec-helper */ "./src/Input/checkbox.spec-helper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckboxHelper", function() { return _Input_checkbox_spec_helper__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _Input_div_spec_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Input/div.spec-helper */ "./src/Input/div.spec-helper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DivHelper", function() { return _Input_div_spec_helper__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _Input_radio_spec_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Input/radio.spec-helper */ "./src/Input/radio.spec-helper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioHelper", function() { return _Input_radio_spec_helper__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _ChipInput_spec_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ChipInput/spec-helper */ "./src/ChipInput/spec-helper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipInputHelper", function() { return _ChipInput_spec_helper__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _TypeableSelect_spec_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./TypeableSelect/spec-helper */ "./src/TypeableSelect/spec-helper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TypeableSelectHelper", function() { return _TypeableSelect_spec_helper__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _DatePicker_spec_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./DatePicker/spec-helper */ "./src/DatePicker/spec-helper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePickerHelper", function() { return _DatePicker_spec_helper__WEBPACK_IMPORTED_MODULE_7__["default"]; });










/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: Hyperlink, AuditBar, AuditBarGroup, Avatar, Badge, Drawer, InlineBadge, Breadcrumb, Button, PrimaryButton, SecondaryButton, TertiaryButton, ButtonGroup, SlideActionButton, buttonStates, ButtonToolbar, Callout, StyledCheckButton, StyledCloseButton, Chip, CollapsiblePanel, Colored, IconButton, Popover, Popper, InfoBox, Typography, Panel, FormControlLabel, FormHelperText, FormGrid, Icon, ListItemText, ListItemPrimaryText, ButtonMenu, ButtonList, KeyboardNavigation, Tabs, Tab, TabsAndButtons, Tile, Tooltip, EmptyState, DataList, DataListItem, ContextMenu, ListItem, PreviewList, TertiaryDate, TablePagination, DataTable, idsFor, TickCell, renderTick, DataTableRow, Notice, YesNoSwitch, LoadingState, PDFViewer, Dialog, DialogTitle, DialogContentOverflowHidden, DialogActions, Input, CurrencyInput, DurationInput, TextareaAutoHeight, Select, Checkbox, CheckboxGroup, LabelCheckbox, FieldLabel, formatValue, inputStyles, SearchInput, RadioButtons, Radio, VisiblePasswordInput, ChipInput, dontReturnResults, SearchSelectInput, SearchSelectPopperInput, ResultsList, TypeableSelect, TimePicker, NakedDatePicker, DatePicker, DateRangePicker, StatusBadge, RichTextEditor, EditorPreview, MotifThemeProvider, withIsMobile, layout, capitalize, convertDateToMoment, convertMomentToDate, preventDefault, styled, withKey, AppBar, Card, CardContent, CardHeader, CardActions, CircularProgress, Divider, DialogContent, FormControl, FormGroup, Hidden, InputAdornment, InputLabel, Grid, LinearProgress, ListItemIcon, ListSubheader, List, Menu, MenuItem, Paper, Portal, Switch, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Toolbar, ClickAwayListener, ThemeProvider, InputHelper, SelectHelper, CheckboxHelper, DivHelper, RadioHelper, ChipInputHelper, TypeableSelectHelper, DatePickerHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Hyperlink__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Hyperlink */ "./src/Hyperlink/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hyperlink", function() { return _Hyperlink__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _AuditBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AuditBar */ "./src/AuditBar/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AuditBar", function() { return _AuditBar__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _AuditBarGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AuditBarGroup */ "./src/AuditBarGroup/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AuditBarGroup", function() { return _AuditBarGroup__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _Avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Avatar */ "./src/Avatar/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Avatar", function() { return _Avatar__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Badge */ "./src/Badge/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return _Badge__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _Drawer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Drawer */ "./src/Drawer/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Drawer", function() { return _Drawer__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _Badge_InlineBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Badge/InlineBadge */ "./src/Badge/InlineBadge.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InlineBadge", function() { return _Badge_InlineBadge__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _Breadcrumb__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Breadcrumb */ "./src/Breadcrumb/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return _Breadcrumb__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Button */ "./src/Button/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _Button__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _Button_primary__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Button/primary */ "./src/Button/primary.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PrimaryButton", function() { return _Button_primary__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _Button_secondary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Button/secondary */ "./src/Button/secondary.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SecondaryButton", function() { return _Button_secondary__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _Button_tertiary__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Button/tertiary */ "./src/Button/tertiary.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TertiaryButton", function() { return _Button_tertiary__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _ButtonGroup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./ButtonGroup */ "./src/ButtonGroup/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _ButtonGroup__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _Button_slideAction__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Button/slideAction */ "./src/Button/slideAction.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SlideActionButton", function() { return _Button_slideAction__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _Button_baseButton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Button/baseButton */ "./src/Button/baseButton.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "buttonStates", function() { return _Button_baseButton__WEBPACK_IMPORTED_MODULE_14__["buttonStates"]; });

/* harmony import */ var _ButtonToolbar__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./ButtonToolbar */ "./src/ButtonToolbar/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return _ButtonToolbar__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _Callout__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Callout */ "./src/Callout/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Callout", function() { return _Callout__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _Callout_Buttons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Callout/Buttons */ "./src/Callout/Buttons/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StyledCheckButton", function() { return _Callout_Buttons__WEBPACK_IMPORTED_MODULE_17__["StyledCheckButton"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StyledCloseButton", function() { return _Callout_Buttons__WEBPACK_IMPORTED_MODULE_17__["StyledCloseButton"]; });

/* harmony import */ var _Chip__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Chip */ "./src/Chip/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Chip", function() { return _Chip__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _CollapsiblePanel__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./CollapsiblePanel */ "./src/CollapsiblePanel/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollapsiblePanel", function() { return _CollapsiblePanel__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _Colored__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./Colored */ "./src/Colored/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Colored", function() { return _Colored__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./IconButton */ "./src/IconButton/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IconButton", function() { return _IconButton__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _Popover__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./Popover */ "./src/Popover/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return _Popover__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _Popper__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Popper */ "./src/Popper/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return _Popper__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _InfoBox__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./InfoBox */ "./src/InfoBox/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InfoBox", function() { return _InfoBox__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./Typography */ "./src/Typography/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Typography", function() { return _Typography__WEBPACK_IMPORTED_MODULE_25__["default"]; });

/* harmony import */ var _Panel__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./Panel */ "./src/Panel/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _Panel__WEBPACK_IMPORTED_MODULE_26__["default"]; });

/* harmony import */ var _FormControlLabel__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./FormControlLabel */ "./src/FormControlLabel/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormControlLabel", function() { return _FormControlLabel__WEBPACK_IMPORTED_MODULE_27__["default"]; });

/* harmony import */ var _FormHelperText__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./FormHelperText */ "./src/FormHelperText/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormHelperText", function() { return _FormHelperText__WEBPACK_IMPORTED_MODULE_28__["default"]; });

/* harmony import */ var _FormGrid__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./FormGrid */ "./src/FormGrid/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormGrid", function() { return _FormGrid__WEBPACK_IMPORTED_MODULE_29__["default"]; });

/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./Icon */ "./src/Icon/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return _Icon__WEBPACK_IMPORTED_MODULE_30__["default"]; });

/* harmony import */ var _ListItemText__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./ListItemText */ "./src/ListItemText/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListItemText", function() { return _ListItemText__WEBPACK_IMPORTED_MODULE_31__["default"]; });

/* harmony import */ var _ListItemPrimaryText__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./ListItemPrimaryText */ "./src/ListItemPrimaryText/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListItemPrimaryText", function() { return _ListItemPrimaryText__WEBPACK_IMPORTED_MODULE_32__["default"]; });

/* harmony import */ var _ButtonMenu__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./ButtonMenu */ "./src/ButtonMenu/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonMenu", function() { return _ButtonMenu__WEBPACK_IMPORTED_MODULE_33__["default"]; });

/* harmony import */ var _ButtonList__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./ButtonList */ "./src/ButtonList/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonList", function() { return _ButtonList__WEBPACK_IMPORTED_MODULE_34__["default"]; });

/* harmony import */ var _KeyboardNavigation__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./KeyboardNavigation */ "./src/KeyboardNavigation/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KeyboardNavigation", function() { return _KeyboardNavigation__WEBPACK_IMPORTED_MODULE_35__["default"]; });

/* harmony import */ var _Tabs__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./Tabs */ "./src/Tabs/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return _Tabs__WEBPACK_IMPORTED_MODULE_36__["Tabs"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _Tabs__WEBPACK_IMPORTED_MODULE_36__["Tab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabsAndButtons", function() { return _Tabs__WEBPACK_IMPORTED_MODULE_36__["TabsAndButtons"]; });

/* harmony import */ var _Tile__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./Tile */ "./src/Tile/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tile", function() { return _Tile__WEBPACK_IMPORTED_MODULE_37__["default"]; });

/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./Tooltip */ "./src/Tooltip/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _Tooltip__WEBPACK_IMPORTED_MODULE_38__["default"]; });

/* harmony import */ var _EmptyState__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./EmptyState */ "./src/EmptyState/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EmptyState", function() { return _EmptyState__WEBPACK_IMPORTED_MODULE_39__["default"]; });

/* harmony import */ var _DataList__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./DataList */ "./src/DataList/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataList", function() { return _DataList__WEBPACK_IMPORTED_MODULE_40__["default"]; });

/* harmony import */ var _DataList_dataListItem__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./DataList/dataListItem */ "./src/DataList/dataListItem.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataListItem", function() { return _DataList_dataListItem__WEBPACK_IMPORTED_MODULE_41__["default"]; });

/* harmony import */ var _ContextMenu__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./ContextMenu */ "./src/ContextMenu/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenu", function() { return _ContextMenu__WEBPACK_IMPORTED_MODULE_42__["default"]; });

/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./ListItem */ "./src/ListItem/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListItem", function() { return _ListItem__WEBPACK_IMPORTED_MODULE_43__["default"]; });

/* harmony import */ var _PreviewList__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./PreviewList */ "./src/PreviewList/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PreviewList", function() { return _PreviewList__WEBPACK_IMPORTED_MODULE_44__["default"]; });

/* harmony import */ var _PreviewList_tertiaryDate__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./PreviewList/tertiaryDate */ "./src/PreviewList/tertiaryDate.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TertiaryDate", function() { return _PreviewList_tertiaryDate__WEBPACK_IMPORTED_MODULE_45__["default"]; });

/* harmony import */ var _TablePagination__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./TablePagination */ "./src/TablePagination/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TablePagination", function() { return _TablePagination__WEBPACK_IMPORTED_MODULE_46__["default"]; });

/* harmony import */ var _DataTable__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./DataTable */ "./src/DataTable/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataTable", function() { return _DataTable__WEBPACK_IMPORTED_MODULE_47__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "idsFor", function() { return _DataTable__WEBPACK_IMPORTED_MODULE_47__["idsFor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TickCell", function() { return _DataTable__WEBPACK_IMPORTED_MODULE_47__["TickCell"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "renderTick", function() { return _DataTable__WEBPACK_IMPORTED_MODULE_47__["renderTick"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataTableRow", function() { return _DataTable__WEBPACK_IMPORTED_MODULE_47__["DataTableRow"]; });

/* harmony import */ var _Notice__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./Notice */ "./src/Notice/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Notice", function() { return _Notice__WEBPACK_IMPORTED_MODULE_48__["default"]; });

/* harmony import */ var _YesNoSwitch__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./YesNoSwitch */ "./src/YesNoSwitch/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "YesNoSwitch", function() { return _YesNoSwitch__WEBPACK_IMPORTED_MODULE_49__["default"]; });

/* harmony import */ var _LoadingState__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./LoadingState */ "./src/LoadingState/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoadingState", function() { return _LoadingState__WEBPACK_IMPORTED_MODULE_50__["default"]; });

/* harmony import */ var _PDFViewer__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./PDFViewer */ "./src/PDFViewer/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PDFViewer", function() { return _PDFViewer__WEBPACK_IMPORTED_MODULE_51__["default"]; });

/* harmony import */ var _Dialog__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./Dialog */ "./src/Dialog/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Dialog", function() { return _Dialog__WEBPACK_IMPORTED_MODULE_52__["default"]; });

/* harmony import */ var _DialogTitle__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./DialogTitle */ "./src/DialogTitle/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DialogTitle", function() { return _DialogTitle__WEBPACK_IMPORTED_MODULE_53__["default"]; });

/* harmony import */ var _DialogContentOverflowHidden__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./DialogContentOverflowHidden */ "./src/DialogContentOverflowHidden/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DialogContentOverflowHidden", function() { return _DialogContentOverflowHidden__WEBPACK_IMPORTED_MODULE_54__["default"]; });

/* harmony import */ var _DialogActions__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./DialogActions */ "./src/DialogActions/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DialogActions", function() { return _DialogActions__WEBPACK_IMPORTED_MODULE_55__["default"]; });

/* harmony import */ var _Input_input__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./Input/input */ "./src/Input/input.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return _Input_input__WEBPACK_IMPORTED_MODULE_56__["default"]; });

/* harmony import */ var _Input_currencyInput__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./Input/currencyInput */ "./src/Input/currencyInput.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CurrencyInput", function() { return _Input_currencyInput__WEBPACK_IMPORTED_MODULE_57__["default"]; });

/* harmony import */ var _Input_durationInput__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./Input/durationInput */ "./src/Input/durationInput.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationInput", function() { return _Input_durationInput__WEBPACK_IMPORTED_MODULE_58__["default"]; });

/* harmony import */ var _Input_TextareaAutoHeight__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./Input/TextareaAutoHeight */ "./src/Input/TextareaAutoHeight/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextareaAutoHeight", function() { return _Input_TextareaAutoHeight__WEBPACK_IMPORTED_MODULE_59__["default"]; });

/* harmony import */ var _Input_select__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./Input/select */ "./src/Input/select.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return _Input_select__WEBPACK_IMPORTED_MODULE_60__["default"]; });

/* harmony import */ var _Input_checkbox__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./Input/checkbox */ "./src/Input/checkbox.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _Input_checkbox__WEBPACK_IMPORTED_MODULE_61__["default"]; });

/* harmony import */ var _CheckboxGroup__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./CheckboxGroup */ "./src/CheckboxGroup/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckboxGroup", function() { return _CheckboxGroup__WEBPACK_IMPORTED_MODULE_62__["default"]; });

/* harmony import */ var _Input_labelCheckbox__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./Input/labelCheckbox */ "./src/Input/labelCheckbox.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LabelCheckbox", function() { return _Input_labelCheckbox__WEBPACK_IMPORTED_MODULE_63__["default"]; });

/* harmony import */ var _Input_fieldLabel__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./Input/fieldLabel */ "./src/Input/fieldLabel.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FieldLabel", function() { return _Input_fieldLabel__WEBPACK_IMPORTED_MODULE_64__["default"]; });

/* harmony import */ var _Input_helpers__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./Input/helpers */ "./src/Input/helpers.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "formatValue", function() { return _Input_helpers__WEBPACK_IMPORTED_MODULE_65__["default"]; });

/* harmony import */ var _Input_styles_scss__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./Input/styles.scss */ "./src/Input/styles.scss");
/* harmony import */ var _Input_styles_scss__WEBPACK_IMPORTED_MODULE_66___default = /*#__PURE__*/__webpack_require__.n(_Input_styles_scss__WEBPACK_IMPORTED_MODULE_66__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "inputStyles", function() { return _Input_styles_scss__WEBPACK_IMPORTED_MODULE_66___default.a; });
/* harmony import */ var _SearchInput__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ./SearchInput */ "./src/SearchInput/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SearchInput", function() { return _SearchInput__WEBPACK_IMPORTED_MODULE_67__["default"]; });

/* harmony import */ var _Input_radioButtons__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ./Input/radioButtons */ "./src/Input/radioButtons.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioButtons", function() { return _Input_radioButtons__WEBPACK_IMPORTED_MODULE_68__["default"]; });

/* harmony import */ var _Input_radio__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ./Input/radio */ "./src/Input/radio.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return _Input_radio__WEBPACK_IMPORTED_MODULE_69__["default"]; });

/* harmony import */ var _Input_VisiblePasswordInput__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ./Input/VisiblePasswordInput */ "./src/Input/VisiblePasswordInput/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VisiblePasswordInput", function() { return _Input_VisiblePasswordInput__WEBPACK_IMPORTED_MODULE_70__["default"]; });

/* harmony import */ var _ChipInput__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ./ChipInput */ "./src/ChipInput/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipInput", function() { return _ChipInput__WEBPACK_IMPORTED_MODULE_71__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dontReturnResults", function() { return _ChipInput__WEBPACK_IMPORTED_MODULE_71__["dontReturnResults"]; });

/* harmony import */ var _SearchSelectInput__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ./SearchSelectInput */ "./src/SearchSelectInput/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SearchSelectInput", function() { return _SearchSelectInput__WEBPACK_IMPORTED_MODULE_72__["default"]; });

/* harmony import */ var _SearchSelectPopperInput__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ./SearchSelectPopperInput */ "./src/SearchSelectPopperInput/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SearchSelectPopperInput", function() { return _SearchSelectPopperInput__WEBPACK_IMPORTED_MODULE_73__["default"]; });

/* harmony import */ var _SearchSelectInput_resultsList__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ./SearchSelectInput/resultsList */ "./src/SearchSelectInput/resultsList.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResultsList", function() { return _SearchSelectInput_resultsList__WEBPACK_IMPORTED_MODULE_74__["default"]; });

/* harmony import */ var _TypeableSelect__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ./TypeableSelect */ "./src/TypeableSelect/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TypeableSelect", function() { return _TypeableSelect__WEBPACK_IMPORTED_MODULE_75__["default"]; });

/* harmony import */ var _TimePicker__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ./TimePicker */ "./src/TimePicker/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimePicker", function() { return _TimePicker__WEBPACK_IMPORTED_MODULE_76__["default"]; });

/* harmony import */ var _NakedDatePicker__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ./NakedDatePicker */ "./src/NakedDatePicker/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NakedDatePicker", function() { return _NakedDatePicker__WEBPACK_IMPORTED_MODULE_77__["default"]; });

/* harmony import */ var _DatePicker__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ./DatePicker */ "./src/DatePicker/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return _DatePicker__WEBPACK_IMPORTED_MODULE_78__["default"]; });

/* harmony import */ var _DateRangePicker__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ./DateRangePicker */ "./src/DateRangePicker/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateRangePicker", function() { return _DateRangePicker__WEBPACK_IMPORTED_MODULE_79__["default"]; });

/* harmony import */ var _StatusBadge__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ./StatusBadge */ "./src/StatusBadge/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StatusBadge", function() { return _StatusBadge__WEBPACK_IMPORTED_MODULE_80__["default"]; });

/* harmony import */ var _RichTextEditor__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ./RichTextEditor */ "./src/RichTextEditor/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RichTextEditor", function() { return _RichTextEditor__WEBPACK_IMPORTED_MODULE_81__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EditorPreview", function() { return _RichTextEditor__WEBPACK_IMPORTED_MODULE_81__["EditorPreview"]; });

/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ./ThemeProvider */ "./src/ThemeProvider/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MotifThemeProvider", function() { return _ThemeProvider__WEBPACK_IMPORTED_MODULE_82__["default"]; });

/* harmony import */ var _withIsMobile__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ./withIsMobile */ "./src/withIsMobile.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withIsMobile", function() { return _withIsMobile__WEBPACK_IMPORTED_MODULE_83__["default"]; });

/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ./layout.scss */ "./src/layout.scss");
/* harmony import */ var _layout_scss__WEBPACK_IMPORTED_MODULE_84___default = /*#__PURE__*/__webpack_require__.n(_layout_scss__WEBPACK_IMPORTED_MODULE_84__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "layout", function() { return _layout_scss__WEBPACK_IMPORTED_MODULE_84___default.a; });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ./utils */ "./src/utils.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return _utils__WEBPACK_IMPORTED_MODULE_85__["capitalize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "convertDateToMoment", function() { return _utils__WEBPACK_IMPORTED_MODULE_85__["convertDateToMoment"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "convertMomentToDate", function() { return _utils__WEBPACK_IMPORTED_MODULE_85__["convertMomentToDate"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "preventDefault", function() { return _utils__WEBPACK_IMPORTED_MODULE_85__["preventDefault"]; });

/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ./styled */ "./src/styled.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "styled", function() { return _styled__WEBPACK_IMPORTED_MODULE_86__["default"]; });

/* harmony import */ var _withKey__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ./withKey */ "./src/withKey/index.jsx");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withKey", function() { return _withKey__WEBPACK_IMPORTED_MODULE_87__["default"]; });

/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ./helpers */ "./src/helpers.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputHelper", function() { return _helpers__WEBPACK_IMPORTED_MODULE_88__["InputHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SelectHelper", function() { return _helpers__WEBPACK_IMPORTED_MODULE_88__["SelectHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckboxHelper", function() { return _helpers__WEBPACK_IMPORTED_MODULE_88__["CheckboxHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DivHelper", function() { return _helpers__WEBPACK_IMPORTED_MODULE_88__["DivHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioHelper", function() { return _helpers__WEBPACK_IMPORTED_MODULE_88__["RadioHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipInputHelper", function() { return _helpers__WEBPACK_IMPORTED_MODULE_88__["ChipInputHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TypeableSelectHelper", function() { return _helpers__WEBPACK_IMPORTED_MODULE_88__["TypeableSelectHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePickerHelper", function() { return _helpers__WEBPACK_IMPORTED_MODULE_88__["DatePickerHelper"]; });

/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! @material-ui/core */ "@material-ui/core");
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_89___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core__WEBPACK_IMPORTED_MODULE_89__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AppBar", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["AppBar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Card"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardContent", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["CardContent"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["CardHeader"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardActions", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["CardActions"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CircularProgress", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["CircularProgress"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Divider"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DialogContent", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["DialogContent"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["FormControl"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["FormGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hidden", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Hidden"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputAdornment", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["InputAdornment"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputLabel", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["InputLabel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Grid"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LinearProgress", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["LinearProgress"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListItemIcon", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["ListItemIcon"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListSubheader", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["ListSubheader"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["List"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Menu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["MenuItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Paper", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Paper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Portal"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Switch"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Table"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableBody", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["TableBody"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableCell", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["TableCell"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableFooter", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["TableFooter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableHead", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["TableHead"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableRow", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["TableRow"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["Toolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickAwayListener", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["ClickAwayListener"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return _material_ui_core__WEBPACK_IMPORTED_MODULE_89__["MuiThemeProvider"]; });






















































// Dialog






// Form/Input






















 // DatePicker component rendered in page
 // DatePicker field with popover




// Misc









// Direct exports of MUI components.


/***/ }),

/***/ "./src/layout.scss":
/*!*************************!*\
  !*** ./src/layout.scss ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../node_modules/css-loader??ref--5-1!../node_modules/sass-loader/lib/loader.js!./layout.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/layout.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/styled.jsx":
/*!************************!*\
  !*** ./src/styled.jsx ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! classnames */ "classnames");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







function mapClassesToClassName(Component) {
  function WrapperComponent(_ref) {
    var classes = _ref.classes,
        props = _objectWithoutProperties(_ref, ['classes']);

    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({}, props, {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, classes.root)
    }));
  }

  WrapperComponent.propTypes = {
    classes: Object(prop_types__WEBPACK_IMPORTED_MODULE_2__["instanceOf"])(Object),
    className: prop_types__WEBPACK_IMPORTED_MODULE_2__["string"]
  };

  WrapperComponent.defaultProps = {
    classes: {},
    className: null
  };

  return WrapperComponent;
}

function styled(Component) {
  return function styleFn(styleBuilder) {
    return function WrapperComponent(props) {
      var propsWithDefaultValues = Object(lodash__WEBPACK_IMPORTED_MODULE_4__["defaults"])({}, props, Component.defaultProps);
      var StyledComponent = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__["withStyles"])(function (theme) {
        return {
          // wrapper styles returned by styleBuilder function into an object with root as the key
          root: styleBuilder(Object.assign({}, { theme: theme }, propsWithDefaultValues))
        };
      })(mapClassesToClassName(Component));
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StyledComponent, props);
    };
  };
}
/* harmony default export */ __webpack_exports__["default"] = (styled);

/***/ }),

/***/ "./src/theme.js":
/*!**********************!*\
  !*** ./src/theme.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material-ui/core/styles */ "@material-ui/core/styles");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./theme_export.scss */ "./src/theme_export.scss");
/* harmony import */ var _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_theme_export_scss__WEBPACK_IMPORTED_MODULE_1__);



/**
 * This is the main theme for Gentu.
 * It just maps the values exported from theme.scss into the JSS
 * that Material UI themes expect.
 * If you need to modify the theme, do that in theme.scss.
 *
 * Usage:
 * import theme from './components/lib/theme';
 * ...
 * <MuiThemeProvider theme={theme}>
 */
var theme = function theme() {
  return Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_0__["createMuiTheme"])({
    direction: 'ltr',
    palette: {
      color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimaryMain,
      common: {
        black: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonBlack,
        white: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonWhite,
        transparent: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonTransparent,
        fullBlack: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonFullBlack,
        darkBlack: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonDarkBlack,
        lightBlack: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonLightBlack,
        minBlack: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonMinBlack,
        faintBlack: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonFaintBlack,
        fullWhite: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonFullWhite,
        darkWhite: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonDarkWhite,
        lightWhite: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteCommonLightWhite
      },
      type: 'light',
      primary: {
        50: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimary50,
        100: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimary100,
        200: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimary200,
        300: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimary300,
        400: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimary400,
        500: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimaryMain,
        600: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimary600,
        700: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimary700,
        800: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimary800,
        900: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimary900,
        A100: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimaryA100,
        A200: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimaryA200,
        A400: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimaryA400,
        A700: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimaryA700,
        contrastDefaultColor: 'light',
        light: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimaryLight,
        main: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimaryMain,
        dark: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.palettePrimaryDark
      },
      secondary: {
        50: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary50,
        100: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary100,
        200: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary200,
        300: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary300,
        400: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary400,
        500: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary500,
        600: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary600,
        700: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary700,
        800: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary800,
        900: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondary900,
        A100: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondaryA100,
        A200: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondaryA200,
        A400: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondaryA400,
        A700: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondaryA700,
        A800: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondaryA800,
        contrastDefaultColor: 'light',
        light: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondaryLight,
        main: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondaryMain,
        dark: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteSecondaryDark
      },
      error: {
        50: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError50,
        100: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError100,
        200: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError200,
        300: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError300,
        400: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError400,
        500: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError500,
        600: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError600,
        700: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError700,
        800: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError800,
        900: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteError900,
        A100: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteErrorA100,
        A200: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteErrorA200,
        A400: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteErrorA400,
        A700: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteErrorA700,
        contrastDefaultColor: 'light',
        light: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteErrorLight,
        main: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteErrorMain,
        dark: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteErrorDark
      },
      grey: {
        50: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey50,
        100: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey100,
        200: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey200,
        300: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey300,
        400: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey400,
        500: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey500,
        600: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey600,
        700: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey700,
        800: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey800,
        900: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGrey900,
        A100: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGreyA100,
        A200: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGreyA200,
        A400: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGreyA400,
        A700: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteGreyA700,
        contrastDefaultColor: 'dark'
      },
      shades: {
        dark: {
          text: {
            primary: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkTextPrimary,
            secondary: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkTextSecondary,
            disabled: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkTextDisabled,
            hint: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkTextHint,
            icon: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkTextIcon,
            divider: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkTextDivider,
            lightDivider: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkTextLightDivider
          },
          input: {
            bottomLine: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkInputBottomLine,
            helperText: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkInputHelperText,
            labelText: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkInputLabelText,
            inputText: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkInputInputText,
            disabled: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkInputDisabled
          },
          action: {
            active: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkActionActive,
            disabled: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkActionDisabled
          },
          background: {
            default: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkBackgroundDefault,
            paper: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkBackgroundPaper,
            appBar: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkBackgroundAppBar,
            contentFrame: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesDarkBackgroundContentFrame
          }
        },
        light: {
          text: {
            primary: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightTextPrimary,
            secondary: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightTextSecondary,
            disabled: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightTextDisabled,
            hint: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightTextHint,
            icon: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightTextIcon,
            divider: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightTextDivider,
            lightDivider: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightTextLightDivider
          },
          input: {
            bottomLine: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightInputBottomLine,
            helperText: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightInputHelperText,
            labelText: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightInputLabelText,
            inputText: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightInputInputText,
            disabled: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightInputDisabled
          },
          action: {
            active: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightActionActive,
            disabled: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightActionDisabled
          },
          background: {
            default: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightBackgroundDefault,
            paper: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightBackgroundPaper,
            appBar: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightBackgroundAppBar,
            contentFrame: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteShadesLightBackgroundContentFrame
          }
        }
      },
      text: {
        primary: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteTextPrimary,
        secondary: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteTextSecondary,
        disabled: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteTextDisabled,
        hint: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteTextHint,
        icon: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteTextIcon,
        divider: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteTextDivider,
        lightDivider: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteTextLightDivider
      },
      input: {
        bottomLine: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteInputBottomLine,
        helperText: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteInputHelperText,
        labelText: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteInputLabelText,
        inputText: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteInputInputText,
        disabled: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteInputDisabled
      },
      action: {
        active: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteActionActive,
        disabled: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteActionDisabled
      },
      background: {
        default: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteBackgroundDefault,
        paper: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteBackgroundPaper,
        appBar: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteBackgroundAppBar,
        contentFrame: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.paletteBackgroundContentFrame
      }
    },
    typography: {
      fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyFontFamily,
      fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyFontSize * 1,
      fontWeightLight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyFontWeightLight,
      fontWeightRegular: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyFontWeightRegular,
      fontWeightMedium: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyFontWeightMedium,

      useNextVariants: true,

      // Deprecated typography variant names
      display4: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay4FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay4FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay4FontFamily,
        letterSpacing: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay4LetterSpacing,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay4LineHeight,
        marginLeft: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay4MarginLeft,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay4Color
      },
      display3: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay3FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay3FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay3FontFamily,
        letterSpacing: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay3LetterSpacing,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay3LineHeight,
        marginLeft: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay3MarginLeft,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay3Color
      },
      display2: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay2FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay2FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay2FontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay2LineHeight,
        marginLeft: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay2MarginLeft,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay2Color
      },
      display1: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay1FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay1FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay1FontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay1LineHeight,
        marginLeft: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay1MarginLeft,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyDisplay1Color
      },
      headline: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyHeadlineFontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyHeadlineFontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyHeadlineFontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyHeadlineLineHeight,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyHeadlineColor
      },
      title: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyTitleFontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyTitleFontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyTitleFontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyTitleLineHeight,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyTitleColor
      },
      subheading: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubheadingFontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubheadingFontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubheadingFontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubheadingLineHeight,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubheadingColor
      },

      // Current typography variant names (as of Material-UI v3.8)
      h1: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH1FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH1FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH1FontFamily,
        letterSpacing: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH1LetterSpacing,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH1LineHeight,
        marginLeft: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH1MarginLeft,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH1Color
      },
      h2: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH2FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH2FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH2FontFamily,
        letterSpacing: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH2LetterSpacing,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH2LineHeight,
        marginLeft: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH2MarginLeft,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH2Color
      },
      h3: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH3FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH3FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH3FontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH3LineHeight,
        marginLeft: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH3MarginLeft,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH3Color
      },
      h4: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH4FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH4FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH4FontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH4LineHeight,
        marginLeft: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH4MarginLeft,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH4Color
      },
      h5: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH5FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH5FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH5FontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH5LineHeight,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH5Color
      },
      h6: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH6FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH6FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH6FontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH6LineHeight,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyH6Color
      },
      subtitle1: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubtitle1FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubtitle1FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubtitle1FontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubtitle1LineHeight,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographySubtitle1Color
      },

      body2: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody2FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody2FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody2FontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody2LineHeight,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody2Color
      },
      body1: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody1FontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody1FontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody1FontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody1LineHeight,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyBody1Color
      },
      caption: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyCaptionFontSize,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyCaptionFontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyCaptionFontFamily,
        lineHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyCaptionLineHeight,
        color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyCaptionColor
      },
      button: {
        fontSize: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyButtonFontSize * 1,
        textTransform: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyButtonTextTransform,
        fontWeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyButtonFontWeight,
        fontFamily: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.typographyButtonFontFamily
      }
    },
    mixins: {
      toolbar: {
        minHeight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.mixinsToolbarMinHeight * 1
      }
    },
    breakpoints: {
      values: {
        xs: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.breakpointsValuesXS * 1,
        sm: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.breakpointsValuesSM * 1,
        md: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.breakpointsValuesMD * 1,
        lg: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.breakpointsValuesLG * 1,
        xl: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.breakpointsValuesXL * 1
      }
    },
    shadows: [_theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows0, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows1, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows2, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows3, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows4, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows5, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows6, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows7, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows8, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows9, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows10, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows11, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows12, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows13, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows14, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows15, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows16, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows17, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows18, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows19, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows20, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows21, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows22, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows23, _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shadows24],
    transitions: {
      easing: {
        easeInOut: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsEasingEaseInOut,
        easeOut: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsEasingEaseOut,
        easeIn: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsEasingEaseIn,
        sharp: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsEasingSharp
      },
      duration: {
        shortest: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsDurationShortest * 1,
        shorter: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsDurationShorter * 1,
        short: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsDurationShort * 1,
        standard: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsDurationStandard * 1,
        complex: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsDurationComplex * 1,
        enteringScreen: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsDurationEnteringScreen * 1,
        leavingScreen: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.transitionsDurationLeavingScreen * 1
      }
    },
    spacing: {
      unitClose: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.spacingUnitClose * 1,
      unit: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.spacingUnit * 1
    },
    zIndex: {
      mobileStepper: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexMobileStepper,
      menu: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexMenu,
      appBar: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexAppBar,
      drawerOverlay: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexDrawerOverlay,
      navDrawer: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexNavDrawer,
      dialogOverlay: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexDialogOverlay,
      dialog: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexDialog,
      modal: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexDialog,
      layer: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexLayer,
      popover: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexPopover,
      snackbar: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexSnackbar,
      tooltip: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.zIndexTooltip
    },
    shape: {
      borderRadius: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.shapeBorderRadius * 1
    },
    secondaryBaseColor: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.secondaryBaseColor,
    brandPink: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.brandPink,
    brandRed: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.brandRed,
    brandGreen: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.brandGreen,
    informationalBlue: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.informationalBlue,
    success: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.success,
    warning: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.warning,
    overrides: {
      MuiInput: {
        underline: {
          '&:hover:not($disabled):not($focused):not($error):before': { // underline color when hovered
            borderBottom: '2px solid ' + _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.primaryBaseColor
          },
          '&:after': { // underline color when focused
            borderBottom: '2px solid ' + _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.primaryBaseColor
          }
        }
      },
      MuiFormLabel: {
        root: {
          '&$focused': { // label color when focused
            color: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.primaryBaseColor
          }
        }
      },
      // Override default. Eventually when we export our own version, we can bake this into the component
      MuiListItemIcon: {
        root: {
          marginRight: _theme_export_scss__WEBPACK_IMPORTED_MODULE_1___default.a.spacingUnit * 1
        }
      }
    }
  });
};

/* harmony default export */ __webpack_exports__["default"] = (theme);

/***/ }),

/***/ "./src/theme_export.scss":
/*!*******************************!*\
  !*** ./src/theme_export.scss ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../node_modules/css-loader??ref--5-1!../node_modules/sass-loader/lib/loader.js!./theme_export.scss */ "./node_modules/css-loader/index.js??ref--5-1!./node_modules/sass-loader/lib/loader.js!./src/theme_export.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/utils.js":
/*!**********************!*\
  !*** ./src/utils.js ***!
  \**********************/
/*! exports provided: MOBILE_MEDIA_QUERY, TABLET_MEDIA_QUERY, LARGE_SCREEN_MEDIA_QUERY, isMobile, randomString, capitalizeFirstChar, capitalize, makeLasagna, removeProps, groupBy, preventDefault, convertMomentToDate, convertDateToMoment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOBILE_MEDIA_QUERY", function() { return MOBILE_MEDIA_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLET_MEDIA_QUERY", function() { return TABLET_MEDIA_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LARGE_SCREEN_MEDIA_QUERY", function() { return LARGE_SCREEN_MEDIA_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobile", function() { return isMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "randomString", function() { return randomString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalizeFirstChar", function() { return capitalizeFirstChar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeLasagna", function() { return makeLasagna; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeProps", function() { return removeProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return groupBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preventDefault", function() { return preventDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertMomentToDate", function() { return convertMomentToDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertDateToMoment", function() { return convertDateToMoment; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! moment */ "moment");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);


var MOBILE_MEDIA_QUERY = '(max-width: 600px)';
var TABLET_MEDIA_QUERY = '(max-width: 800px)';
var LARGE_SCREEN_MEDIA_QUERY = '(min-width: 1281px)';

var isMobile = function isMobile() {
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
};

var randomString = function randomString(len) {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  var i = void 0;
  for (i = 0; i < len; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

var capitalizeFirstChar = function capitalizeFirstChar(s) {
  return '' + s.slice(0, 1).toUpperCase() + s.slice(1);
};

var capitalize = function capitalize(s) {
  if (!s) return '';
  return s.split(' ').map(function (word) {
    return capitalizeFirstChar(word);
  }).join(' ');
};

/**
 * Put mince between each layer of pasta.
 * @example
 * makeLasagna('_', ['x', 'x', 'x']);
 * // ['x', '_', 'x', '_', 'x']
 */
var makeLasagna = function makeLasagna(minceMaker, pastaLayers) {
  return pastaLayers.reduce(function (lasagna, pastaLayer, i) {
    lasagna.push(pastaLayer);
    if (i < pastaLayers.length - 1) {
      lasagna.push(minceMaker());
    }
    return lasagna;
  }, []);
};

/**
 * Remove a clone of object and remove specified fields
 * @param {*} obj
 * @param {*} fields
 */
var removeProps = function removeProps(obj, fields) {
  if (!obj) return undefined;
  if (!fields) return obj;
  var result = Object.assign({}, obj);
  fields.forEach(function (field) {
    delete result[field];
  });
  return result;
};

/* Groups the elements of an array based on the given function.
 * @param {*} arr
 * @param {*} fn
 * @example
 * groupBy([6.1, 4.2, 6.3], Math.floor); // {4: [4.2], 6: [6.1, 6.3]}
 * groupBy(['one', 'two', 'three'], 'length'); // {3: ['one', 'two'], 5: ['three']}
 */
var groupBy = function groupBy(arr, fn) {
  return arr.map(typeof fn === 'function' ? fn : function (val) {
    return val[fn];
  }).reduce(function (acc, val, i) {
    acc[val] = (acc[val] || []).concat(arr[i]);
    return acc;
  }, {});
};

var preventDefault = function preventDefault(f) {
  return function (e) {
    if (e && e.preventDefault) {
      e.preventDefault(); // Protected in if statement to support test events
    }
    f(e);
  };
};

/* Convert moment object with Server timezone e.g. Australia/Brisbane
 * to local browser Date object with timezone e.g. America/NewYork
 */
var convertMomentToDate = function convertMomentToDate(m) {
  // WHAT THE HELL IS THIS DOING I hear you ask????
  // For the cases where we are only interested in a Date (no time) then moment and Javascript
  // Date make it very hard as the browsers timezone gets in the way.
  // e.g.
  // moment timezone is Brisbane
  // Browsers timezone is Chicago
  // You parse the date '2012-02-02' in moment and then convert it to a Date object.
  // The Date object is now '2012-02-01' which is not what you want.
  // This method will change the date object to force it into the correct day
  // e.g.
  // moment('2012-02-02').toDate() = Wed Feb 01 2012 08:00:00 GMT-0600 (CST)
  // To get it back to Brisbane date add minutes
  // m.toDate().getTimezoneOffset() = 360 - This method returns the minutes to get nack to UTC
  // m.utcOffset() = 600 - This method returns minutes from UTC
  // so moment('2012-02-02').add(360 + 600, 'minutes').toDate() = Thu Feb 02 2012 00:00:00 GMT-0600 (CST)
  // which is back on the correct day
  if (!m) return m;
  return m.clone().add(m.toDate().getTimezoneOffset() + m.utcOffset(), 'minutes').toDate();
};

/* Convert local browser Date object with timezone e.g. America/NewYork
 * to moment object with Server timezone e.g. Australia/Brisbane
 */
var convertDateToMoment = function convertDateToMoment(d) {
  if (!d) return d;
  // This is the reverse of the above
  // Take a date and return a moment adjusted for the browser/moment timezone difference
  var m = moment__WEBPACK_IMPORTED_MODULE_0___default()(d); // eslint-disable-line gentu-custom-rules/moment-with-correct-param-number
  return m.add(-m.utcOffset() + -d.getTimezoneOffset(), 'minutes');
};

/***/ }),

/***/ "./src/withIsMobile.jsx":
/*!******************************!*\
  !*** ./src/withIsMobile.jsx ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_media__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-media */ "react-media");
/* harmony import */ var react_media__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_media__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils */ "./src/utils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Renders wrapped component with additional `isMobile` parameter, which will be
// true if browser width is smaller than mobile breakpoint.
/* harmony default export */ __webpack_exports__["default"] = (function (WrappedComponent) {
  return (
    // eslint-disable-next-line react/prefer-stateless-function
    function (_React$PureComponent) {
      _inherits(MobileCheckWrapper, _React$PureComponent);

      function MobileCheckWrapper() {
        _classCallCheck(this, MobileCheckWrapper);

        return _possibleConstructorReturn(this, (MobileCheckWrapper.__proto__ || Object.getPrototypeOf(MobileCheckWrapper)).apply(this, arguments));
      }

      _createClass(MobileCheckWrapper, [{
        key: 'render',
        value: function render() {
          var _this2 = this;

          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            react_media__WEBPACK_IMPORTED_MODULE_1___default.a,
            { query: _utils__WEBPACK_IMPORTED_MODULE_2__["MOBILE_MEDIA_QUERY"] },
            function (matchesMediaQuery) {
              return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(WrappedComponent, _extends({}, _this2.props, {
                isMobile: matchesMediaQuery
              }));
            }
          );
        }
      }]);

      return MobileCheckWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent)
  );
});

/***/ }),

/***/ "./src/withKey/index.jsx":
/*!*******************************!*\
  !*** ./src/withKey/index.jsx ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

/**
 * withKey HOC forces a component to be recreated when one or more of its props change.
 * This removes the need to update the component's internal state when those props change.
 * e.g. when previewing a record, setting the key to the record's ID ensures the component completely rerenders when a new record is selected/previewed.
 */
var withKey = function withKey(keyProvider) {
  return function (Component) {
    var ComponentWithKey = function ComponentWithKey(props) {
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({ key: keyProvider(props) }, props));
    };
    ComponentWithKey.displayName = 'withKey(' + getDisplayName(Component) + ')';
    return ComponentWithKey;
  };
};

/* harmony default export */ __webpack_exports__["default"] = (withKey);

/***/ }),

/***/ "@material-ui/core":
/*!************************************!*\
  !*** external "@material-ui/core" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core");

/***/ }),

/***/ "@material-ui/core/":
/*!*************************************!*\
  !*** external "@material-ui/core/" ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/");

/***/ }),

/***/ "@material-ui/core/Avatar":
/*!*******************************************!*\
  !*** external "@material-ui/core/Avatar" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Avatar");

/***/ }),

/***/ "@material-ui/core/Badge":
/*!******************************************!*\
  !*** external "@material-ui/core/Badge" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Badge");

/***/ }),

/***/ "@material-ui/core/Button":
/*!*******************************************!*\
  !*** external "@material-ui/core/Button" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Button");

/***/ }),

/***/ "@material-ui/core/Button/Button":
/*!**************************************************!*\
  !*** external "@material-ui/core/Button/Button" ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Button/Button");

/***/ }),

/***/ "@material-ui/core/Card":
/*!*****************************************!*\
  !*** external "@material-ui/core/Card" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Card");

/***/ }),

/***/ "@material-ui/core/CardActions":
/*!************************************************!*\
  !*** external "@material-ui/core/CardActions" ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/CardActions");

/***/ }),

/***/ "@material-ui/core/CardContent":
/*!************************************************!*\
  !*** external "@material-ui/core/CardContent" ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/CardContent");

/***/ }),

/***/ "@material-ui/core/Checkbox":
/*!*********************************************!*\
  !*** external "@material-ui/core/Checkbox" ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Checkbox");

/***/ }),

/***/ "@material-ui/core/Chip":
/*!*****************************************!*\
  !*** external "@material-ui/core/Chip" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Chip");

/***/ }),

/***/ "@material-ui/core/CircularProgress":
/*!*****************************************************!*\
  !*** external "@material-ui/core/CircularProgress" ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/CircularProgress");

/***/ }),

/***/ "@material-ui/core/ClickAwayListener":
/*!******************************************************!*\
  !*** external "@material-ui/core/ClickAwayListener" ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ClickAwayListener");

/***/ }),

/***/ "@material-ui/core/Collapse":
/*!*********************************************!*\
  !*** external "@material-ui/core/Collapse" ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Collapse");

/***/ }),

/***/ "@material-ui/core/Dialog":
/*!*******************************************!*\
  !*** external "@material-ui/core/Dialog" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Dialog");

/***/ }),

/***/ "@material-ui/core/DialogActions":
/*!**************************************************!*\
  !*** external "@material-ui/core/DialogActions" ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/DialogActions");

/***/ }),

/***/ "@material-ui/core/DialogContent":
/*!**************************************************!*\
  !*** external "@material-ui/core/DialogContent" ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/DialogContent");

/***/ }),

/***/ "@material-ui/core/Divider":
/*!********************************************!*\
  !*** external "@material-ui/core/Divider" ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Divider");

/***/ }),

/***/ "@material-ui/core/Drawer":
/*!*******************************************!*\
  !*** external "@material-ui/core/Drawer" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Drawer");

/***/ }),

/***/ "@material-ui/core/ExpansionPanel":
/*!***************************************************!*\
  !*** external "@material-ui/core/ExpansionPanel" ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ExpansionPanel");

/***/ }),

/***/ "@material-ui/core/ExpansionPanelActions":
/*!**********************************************************!*\
  !*** external "@material-ui/core/ExpansionPanelActions" ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ExpansionPanelActions");

/***/ }),

/***/ "@material-ui/core/ExpansionPanelDetails":
/*!**********************************************************!*\
  !*** external "@material-ui/core/ExpansionPanelDetails" ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ExpansionPanelDetails");

/***/ }),

/***/ "@material-ui/core/ExpansionPanelSummary":
/*!**********************************************************!*\
  !*** external "@material-ui/core/ExpansionPanelSummary" ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ExpansionPanelSummary");

/***/ }),

/***/ "@material-ui/core/FormControl":
/*!************************************************!*\
  !*** external "@material-ui/core/FormControl" ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/FormControl");

/***/ }),

/***/ "@material-ui/core/FormControlLabel":
/*!*****************************************************!*\
  !*** external "@material-ui/core/FormControlLabel" ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/FormControlLabel");

/***/ }),

/***/ "@material-ui/core/FormGroup":
/*!**********************************************!*\
  !*** external "@material-ui/core/FormGroup" ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/FormGroup");

/***/ }),

/***/ "@material-ui/core/FormHelperText":
/*!***************************************************!*\
  !*** external "@material-ui/core/FormHelperText" ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/FormHelperText");

/***/ }),

/***/ "@material-ui/core/Grid":
/*!*****************************************!*\
  !*** external "@material-ui/core/Grid" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Grid");

/***/ }),

/***/ "@material-ui/core/Hidden":
/*!*******************************************!*\
  !*** external "@material-ui/core/Hidden" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Hidden");

/***/ }),

/***/ "@material-ui/core/IconButton":
/*!***********************************************!*\
  !*** external "@material-ui/core/IconButton" ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/IconButton");

/***/ }),

/***/ "@material-ui/core/Input":
/*!******************************************!*\
  !*** external "@material-ui/core/Input" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Input");

/***/ }),

/***/ "@material-ui/core/InputAdornment":
/*!***************************************************!*\
  !*** external "@material-ui/core/InputAdornment" ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/InputAdornment");

/***/ }),

/***/ "@material-ui/core/InputLabel":
/*!***********************************************!*\
  !*** external "@material-ui/core/InputLabel" ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/InputLabel");

/***/ }),

/***/ "@material-ui/core/LinearProgress":
/*!***************************************************!*\
  !*** external "@material-ui/core/LinearProgress" ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/LinearProgress");

/***/ }),

/***/ "@material-ui/core/List":
/*!*****************************************!*\
  !*** external "@material-ui/core/List" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/List");

/***/ }),

/***/ "@material-ui/core/ListItem":
/*!*********************************************!*\
  !*** external "@material-ui/core/ListItem" ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ListItem");

/***/ }),

/***/ "@material-ui/core/ListItemIcon":
/*!*************************************************!*\
  !*** external "@material-ui/core/ListItemIcon" ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ListItemIcon");

/***/ }),

/***/ "@material-ui/core/ListItemSecondaryAction":
/*!************************************************************!*\
  !*** external "@material-ui/core/ListItemSecondaryAction" ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ListItemSecondaryAction");

/***/ }),

/***/ "@material-ui/core/ListItemText":
/*!*************************************************!*\
  !*** external "@material-ui/core/ListItemText" ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ListItemText");

/***/ }),

/***/ "@material-ui/core/ListSubheader":
/*!**************************************************!*\
  !*** external "@material-ui/core/ListSubheader" ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/ListSubheader");

/***/ }),

/***/ "@material-ui/core/Menu":
/*!*****************************************!*\
  !*** external "@material-ui/core/Menu" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Menu");

/***/ }),

/***/ "@material-ui/core/MenuItem":
/*!*********************************************!*\
  !*** external "@material-ui/core/MenuItem" ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/MenuItem");

/***/ }),

/***/ "@material-ui/core/MenuList":
/*!*********************************************!*\
  !*** external "@material-ui/core/MenuList" ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/MenuList");

/***/ }),

/***/ "@material-ui/core/Paper":
/*!******************************************!*\
  !*** external "@material-ui/core/Paper" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Paper");

/***/ }),

/***/ "@material-ui/core/Popover":
/*!********************************************!*\
  !*** external "@material-ui/core/Popover" ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Popover");

/***/ }),

/***/ "@material-ui/core/Popper":
/*!*******************************************!*\
  !*** external "@material-ui/core/Popper" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Popper");

/***/ }),

/***/ "@material-ui/core/Radio":
/*!******************************************!*\
  !*** external "@material-ui/core/Radio" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Radio");

/***/ }),

/***/ "@material-ui/core/RadioGroup":
/*!***********************************************!*\
  !*** external "@material-ui/core/RadioGroup" ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/RadioGroup");

/***/ }),

/***/ "@material-ui/core/Select":
/*!*******************************************!*\
  !*** external "@material-ui/core/Select" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Select");

/***/ }),

/***/ "@material-ui/core/SvgIcon":
/*!********************************************!*\
  !*** external "@material-ui/core/SvgIcon" ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/SvgIcon");

/***/ }),

/***/ "@material-ui/core/Switch":
/*!*******************************************!*\
  !*** external "@material-ui/core/Switch" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Switch");

/***/ }),

/***/ "@material-ui/core/Tab":
/*!****************************************!*\
  !*** external "@material-ui/core/Tab" ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Tab");

/***/ }),

/***/ "@material-ui/core/Table":
/*!******************************************!*\
  !*** external "@material-ui/core/Table" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Table");

/***/ }),

/***/ "@material-ui/core/TableBody":
/*!**********************************************!*\
  !*** external "@material-ui/core/TableBody" ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/TableBody");

/***/ }),

/***/ "@material-ui/core/TableCell":
/*!**********************************************!*\
  !*** external "@material-ui/core/TableCell" ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/TableCell");

/***/ }),

/***/ "@material-ui/core/TableFooter":
/*!************************************************!*\
  !*** external "@material-ui/core/TableFooter" ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/TableFooter");

/***/ }),

/***/ "@material-ui/core/TableHead":
/*!**********************************************!*\
  !*** external "@material-ui/core/TableHead" ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/TableHead");

/***/ }),

/***/ "@material-ui/core/TablePagination":
/*!****************************************************!*\
  !*** external "@material-ui/core/TablePagination" ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/TablePagination");

/***/ }),

/***/ "@material-ui/core/TableRow":
/*!*********************************************!*\
  !*** external "@material-ui/core/TableRow" ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/TableRow");

/***/ }),

/***/ "@material-ui/core/TableSortLabel":
/*!***************************************************!*\
  !*** external "@material-ui/core/TableSortLabel" ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/TableSortLabel");

/***/ }),

/***/ "@material-ui/core/Tabs":
/*!*****************************************!*\
  !*** external "@material-ui/core/Tabs" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Tabs");

/***/ }),

/***/ "@material-ui/core/Toolbar":
/*!********************************************!*\
  !*** external "@material-ui/core/Toolbar" ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Toolbar");

/***/ }),

/***/ "@material-ui/core/Tooltip":
/*!********************************************!*\
  !*** external "@material-ui/core/Tooltip" ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Tooltip");

/***/ }),

/***/ "@material-ui/core/Typography":
/*!***********************************************!*\
  !*** external "@material-ui/core/Typography" ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Typography");

/***/ }),

/***/ "@material-ui/core/styles":
/*!*******************************************!*\
  !*** external "@material-ui/core/styles" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ "@material-ui/core/styles/colorManipulator":
/*!************************************************************!*\
  !*** external "@material-ui/core/styles/colorManipulator" ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles/colorManipulator");

/***/ }),

/***/ "@material-ui/icons/Add":
/*!*****************************************!*\
  !*** external "@material-ui/icons/Add" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Add");

/***/ }),

/***/ "@material-ui/icons/AddPhotoAlternate":
/*!*******************************************************!*\
  !*** external "@material-ui/icons/AddPhotoAlternate" ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/AddPhotoAlternate");

/***/ }),

/***/ "@material-ui/icons/ArrowBack":
/*!***********************************************!*\
  !*** external "@material-ui/icons/ArrowBack" ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/ArrowBack");

/***/ }),

/***/ "@material-ui/icons/ArrowDropDown":
/*!***************************************************!*\
  !*** external "@material-ui/icons/ArrowDropDown" ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/ArrowDropDown");

/***/ }),

/***/ "@material-ui/icons/Check":
/*!*******************************************!*\
  !*** external "@material-ui/icons/Check" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Check");

/***/ }),

/***/ "@material-ui/icons/Clear":
/*!*******************************************!*\
  !*** external "@material-ui/icons/Clear" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Clear");

/***/ }),

/***/ "@material-ui/icons/Close":
/*!*******************************************!*\
  !*** external "@material-ui/icons/Close" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Close");

/***/ }),

/***/ "@material-ui/icons/ColorLens":
/*!***********************************************!*\
  !*** external "@material-ui/icons/ColorLens" ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/ColorLens");

/***/ }),

/***/ "@material-ui/icons/Delete":
/*!********************************************!*\
  !*** external "@material-ui/icons/Delete" ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Delete");

/***/ }),

/***/ "@material-ui/icons/Done":
/*!******************************************!*\
  !*** external "@material-ui/icons/Done" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Done");

/***/ }),

/***/ "@material-ui/icons/Error":
/*!*******************************************!*\
  !*** external "@material-ui/icons/Error" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Error");

/***/ }),

/***/ "@material-ui/icons/ExpandMore":
/*!************************************************!*\
  !*** external "@material-ui/icons/ExpandMore" ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/ExpandMore");

/***/ }),

/***/ "@material-ui/icons/FormatBold":
/*!************************************************!*\
  !*** external "@material-ui/icons/FormatBold" ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/FormatBold");

/***/ }),

/***/ "@material-ui/icons/FormatClear":
/*!*************************************************!*\
  !*** external "@material-ui/icons/FormatClear" ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/FormatClear");

/***/ }),

/***/ "@material-ui/icons/FormatItalic":
/*!**************************************************!*\
  !*** external "@material-ui/icons/FormatItalic" ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/FormatItalic");

/***/ }),

/***/ "@material-ui/icons/FormatUnderlined":
/*!******************************************************!*\
  !*** external "@material-ui/icons/FormatUnderlined" ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/FormatUnderlined");

/***/ }),

/***/ "@material-ui/icons/Info":
/*!******************************************!*\
  !*** external "@material-ui/icons/Info" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Info");

/***/ }),

/***/ "@material-ui/icons/KeyboardArrowDown":
/*!*******************************************************!*\
  !*** external "@material-ui/icons/KeyboardArrowDown" ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/KeyboardArrowDown");

/***/ }),

/***/ "@material-ui/icons/KeyboardArrowLeft":
/*!*******************************************************!*\
  !*** external "@material-ui/icons/KeyboardArrowLeft" ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/KeyboardArrowLeft");

/***/ }),

/***/ "@material-ui/icons/KeyboardArrowRight":
/*!********************************************************!*\
  !*** external "@material-ui/icons/KeyboardArrowRight" ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/KeyboardArrowRight");

/***/ }),

/***/ "@material-ui/icons/KeyboardArrowUp":
/*!*****************************************************!*\
  !*** external "@material-ui/icons/KeyboardArrowUp" ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/KeyboardArrowUp");

/***/ }),

/***/ "@material-ui/icons/MoreVert":
/*!**********************************************!*\
  !*** external "@material-ui/icons/MoreVert" ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/MoreVert");

/***/ }),

/***/ "@material-ui/icons/PhotoSizeSelectActual":
/*!***********************************************************!*\
  !*** external "@material-ui/icons/PhotoSizeSelectActual" ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/PhotoSizeSelectActual");

/***/ }),

/***/ "@material-ui/icons/PhotoSizeSelectLarge":
/*!**********************************************************!*\
  !*** external "@material-ui/icons/PhotoSizeSelectLarge" ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/PhotoSizeSelectLarge");

/***/ }),

/***/ "@material-ui/icons/PhotoSizeSelectSmall":
/*!**********************************************************!*\
  !*** external "@material-ui/icons/PhotoSizeSelectSmall" ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/PhotoSizeSelectSmall");

/***/ }),

/***/ "@material-ui/icons/Remove":
/*!********************************************!*\
  !*** external "@material-ui/icons/Remove" ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Remove");

/***/ }),

/***/ "@material-ui/icons/RotateRight":
/*!*************************************************!*\
  !*** external "@material-ui/icons/RotateRight" ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/RotateRight");

/***/ }),

/***/ "@material-ui/icons/Search":
/*!********************************************!*\
  !*** external "@material-ui/icons/Search" ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Search");

/***/ }),

/***/ "@material-ui/icons/Settings":
/*!**********************************************!*\
  !*** external "@material-ui/icons/Settings" ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Settings");

/***/ }),

/***/ "@material-ui/icons/Visibility":
/*!************************************************!*\
  !*** external "@material-ui/icons/Visibility" ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Visibility");

/***/ }),

/***/ "@material-ui/icons/VisibilityOff":
/*!***************************************************!*\
  !*** external "@material-ui/icons/VisibilityOff" ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/VisibilityOff");

/***/ }),

/***/ "@material-ui/icons/Warning":
/*!*********************************************!*\
  !*** external "@material-ui/icons/Warning" ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@material-ui/icons/Warning");

/***/ }),

/***/ "classnames":
/*!*****************************!*\
  !*** external "classnames" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ "lodash":
/*!*************************!*\
  !*** external "lodash" ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ "lodash/debounce":
/*!**********************************!*\
  !*** external "lodash/debounce" ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("lodash/debounce");

/***/ }),

/***/ "lodash/get":
/*!*****************************!*\
  !*** external "lodash/get" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("lodash/get");

/***/ }),

/***/ "lodash/isEqual":
/*!*********************************!*\
  !*** external "lodash/isEqual" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("lodash/isEqual");

/***/ }),

/***/ "lodash/omit":
/*!******************************!*\
  !*** external "lodash/omit" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("lodash/omit");

/***/ }),

/***/ "memoize-one":
/*!******************************!*\
  !*** external "memoize-one" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("memoize-one");

/***/ }),

/***/ "moment":
/*!*************************!*\
  !*** external "moment" ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),

/***/ "prop-types":
/*!*****************************!*\
  !*** external "prop-types" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "react-calendar/dist/entry.nostyle":
/*!****************************************************!*\
  !*** external "react-calendar/dist/entry.nostyle" ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-calendar/dist/entry.nostyle");

/***/ }),

/***/ "react-color":
/*!******************************!*\
  !*** external "react-color" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-color");

/***/ }),

/***/ "react-dom":
/*!****************************!*\
  !*** external "react-dom" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ "react-dropzone":
/*!*********************************!*\
  !*** external "react-dropzone" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-dropzone");

/***/ }),

/***/ "react-event-listener":
/*!***************************************!*\
  !*** external "react-event-listener" ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-event-listener");

/***/ }),

/***/ "react-hammerjs":
/*!*********************************!*\
  !*** external "react-hammerjs" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-hammerjs");

/***/ }),

/***/ "react-media":
/*!******************************!*\
  !*** external "react-media" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-media");

/***/ }),

/***/ "react-moment-proptypes":
/*!*****************************************!*\
  !*** external "react-moment-proptypes" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-moment-proptypes");

/***/ }),

/***/ "react-pdf":
/*!****************************!*\
  !*** external "react-pdf" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-pdf");

/***/ }),

/***/ "react-text-mask":
/*!**********************************!*\
  !*** external "react-text-mask" ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-text-mask");

/***/ }),

/***/ "recompose":
/*!****************************!*\
  !*** external "recompose" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("recompose");

/***/ }),

/***/ "recompose/getDisplayName":
/*!*******************************************!*\
  !*** external "recompose/getDisplayName" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("recompose/getDisplayName");

/***/ }),

/***/ "recompose/pure":
/*!*********************************!*\
  !*** external "recompose/pure" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("recompose/pure");

/***/ }),

/***/ "slate":
/*!************************!*\
  !*** external "slate" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("slate");

/***/ }),

/***/ "slate-html-serializer":
/*!****************************************!*\
  !*** external "slate-html-serializer" ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("slate-html-serializer");

/***/ }),

/***/ "slate-react":
/*!******************************!*\
  !*** external "slate-react" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("slate-react");

/***/ }),

/***/ "uuid":
/*!***********************!*\
  !*** external "uuid" ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("uuid");

/***/ })

/******/ })));
//# sourceMappingURL=index.js.map